export const alkebulanQuestions = [
    {  "id": 1,
		"question": "Limestone in Egypt and Morocco is used for:",
		"options": ["Cement and construction", "Jewelry", "Steel alloys"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Essential material for buildings and infrastructure."
	},
	{
        "id": 2,
		"question": "Clay deposits in Morocco and Tunisia are used for:",
		"options": ["Ceramics, pottery, and bricks", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Construction and artisan industries."
	},
	{
        "id": 3,
		"question": "Oil reserves in Libya are concentrated in:",
		"options": ["Sirte Basin", "Nile Delta", "Atlas Mountains"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Largest national export; fuels economy."
	},
	{
        "id": 4,
		"question": "Saltpeter (nitrates) in Egypt is used for:",
		"options": ["Fertilizers and explosives", "Jewelry", "Steel"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Agriculture and industrial chemicals."
	},
	{
        "id": 5,
		"question": "Phosphate rock in Western Sahara supports:",
		"options": ["Global fertilizer markets", "Jewelry", "Construction"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Crucial for food production worldwide."
	},
	{
        "id": 6,
		"question": "Silica sand in Egypt is used for:",
		"options": ["Glass production and foundry molds", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "High-tech glass, solar panels, and industry."
	},
	{
        "id": 7,
		"question": "Oil and gas pipelines in Algeria export primarily to:",
		"options": ["Europe", "Asia only", "South America"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Geopolitical leverage and foreign currency."
	},
	{
        "id": 8,
		"question": "Iron smelting in Egypt historically used:",
		"options": ["Local iron ore for tools and weapons", "Diamonds", "Phosphate"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Early industrialization and defense."
	},
	{
        "id": 9,
		"question": "Oil sands in Egypt are used for:",
		"options": ["Synthetic fuels and petrochemical feedstocks", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Energy diversification."
	},
	{
        "id": 10,
		"question": "Bauxite in Morocco and Algeria is used for:",
		"options": ["Aluminum production", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Lightweight metals for transport and industry."
	},
	{
        "id": 11,
		"question": "Natural gas from the Mediterranean coast powers:",
		"options": ["Fertilizer plants and electricity generation", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial backbone and export revenue."
	},
	{
        "id": 12,
		"question": "Salt from the Qattara Depression (Egypt) is used for:",
		"options": ["Industrial chemicals and chlorine", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Base for multiple chemical industries."
	},
	{
        "id": 13,
		"question": "Iron ore exports from Morocco go mainly to:",
		"options": ["Europe and Asia for steelmaking", "North America only", "South America only"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Critical for global construction and manufacturing."
	},
	{
        "id": 14,
		"question": "Oil refining capacity in Egypt is important because:",
		"options": ["Supplies domestic fuel and petrochemicals", "Jewelry only", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial and economic stability."
	},
	{
        "id": 15,
		"question": "Northern Africa's mineral wealth is critical globally because it supplies:",
		"options": ["Fertilizers, oil, gas, iron, aluminum, and chemicals", "Only jewelry", "Coal exclusively"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Food, energy, industry, and global markets."
	},
	{
        "id": 16,
		"question": "Morocco's phosphate mines in Khouribga produce rock used for:",
		"options": ["Fertilizers for global agriculture and phosphate chemicals", "Jewelry", "Road paving"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Morocco controls 70% of the world's phosphate exports, feeding food production globally."
	},
	{
        "id": 17,
		"question": "Limestone in Egypt and Morocco is used for:",
		"options": ["Cement and construction", "Jewelry", "Steel alloys"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Essential material for buildings and infrastructure."
	},
	{
        "id": 18,
		"question": "Clay deposits in Morocco and Tunisia are used for:",
		"options": ["Ceramics, pottery, and bricks", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Construction and artisan industries."
	},
	{
        "id": 19,
		"question": "Oil reserves in Libya are concentrated in:",
		"options": ["Sirte Basin", "Nile Delta", "Atlas Mountains"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Largest national export; fuels economy."
	},
	{
        "id": 20,
		"question": "Saltpeter (nitrates) in Egypt is used for:",
		"options": ["Fertilizers and explosives", "Jewelry", "Steel"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Agriculture and industrial chemicals."
	},
	{
        "id": 21,
		"question": "Phosphate rock in Western Sahara supports:",
		"options": ["Global fertilizer markets", "Jewelry", "Construction"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Crucial for food production worldwide."
	},
	{
        "id": 22,
		"question": "Silica sand in Egypt is used for:",
		"options": ["Glass production and foundry molds", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "High-tech glass, solar panels, and industry."
	},
	{
        "id": 23,
		"question": "Oil and gas pipelines in Algeria export primarily to:",
		"options": ["Europe", "Asia only", "South America"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Geopolitical leverage and foreign currency."
	},
	{
        "id": 24,
		"question": "Iron smelting in Egypt historically used:",
		"options": ["Local iron ore for tools and weapons", "Diamonds", "Phosphate"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Early industrialization and defense."
	},
	{
        "id": 25,
		"question": "Oil sands in Egypt are used for:",
		"options": ["Synthetic fuels and petrochemical feedstocks", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Energy diversification."
	},
	{
        "id": 26,
		"question": "Bauxite in Morocco and Algeria is used for:",
		"options": ["Aluminum production", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Lightweight metals for transport and industry."
	},
	{
        "id": 27,
		"question": "Natural gas from the Mediterranean coast powers:",
		"options": ["Fertilizer plants and electricity generation", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial backbone and export revenue."
	},
	{
        "id": 28,
		"question": "Salt from the Qattara Depression (Egypt) is used for:",
		"options": ["Industrial chemicals and chlorine", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Base for multiple chemical industries."
	},
	{
        "id": 29,
		"question": "Iron ore exports from Morocco go mainly to:",
		"options": ["Europe and Asia for steelmaking", "North America only", "South America only"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Critical for global construction and manufacturing."
	},
	{
        "id": 30,
		"question": "Oil refining capacity in Egypt is important because:",
		"options": ["Supplies domestic fuel and petrochemicals", "Jewelry only", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial and economic stability."
	},
	{
        "id": 31,
		"question": "Northern Africa's mineral wealth is critical globally because it supplies:",
		"options": ["Fertilizers, oil, gas, iron, aluminum, and chemicals", "Only jewelry", "Coal exclusively"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Food, energy, industry, and global markets."
	},
	{
        "id": 32,
		"question": "Morocco's phosphate mines in Khouribga produce rock used for:",
		"options": ["Fertilizers for global agriculture and phosphate chemicals", "Jewelry", "Road paving"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Morocco controls 70% of the world's phosphate exports, feeding food production globally."
	},
	{
        "id": 33,
		"question": "Limestone in Egypt and Morocco is used for:",
		"options": ["Cement and construction", "Jewelry", "Steel alloys"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Essential material for buildings and infrastructure."
	},
	{
        "id": 34,
		"question": "Clay deposits in Morocco and Tunisia are used for:",
		"options": ["Ceramics, pottery, and bricks", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Construction and artisan industries."
	},
	{
        "id": 35,
		"question": "Oil reserves in Libya are concentrated in:",
		"options": ["Sirte Basin", "Nile Delta", "Atlas Mountains"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Largest national export; fuels economy."
	},
	{
        "id": 36,
		"question": "Saltpeter (nitrates) in Egypt is used for:",
		"options": ["Fertilizers and explosives", "Jewelry", "Steel"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Agriculture and industrial chemicals."
	},
	{
        "id": 37,
		"question": "Phosphate rock in Western Sahara supports:",
		"options": ["Global fertilizer markets", "Jewelry", "Construction"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Crucial for food production worldwide."
	},
	{
        "id": 38,
		"question": "Silica sand in Egypt is used for:",
		"options": ["Glass production and foundry molds", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "High-tech glass, solar panels, and industry."
	},
	{
        "id": 39,
		"question": "Oil and gas pipelines in Algeria export primarily to:",
		"options": ["Europe", "Asia only", "South America"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Geopolitical leverage and foreign currency."
	},
	{
        "id": 40,
		"question": "Iron smelting in Egypt historically used:",
		"options": ["Local iron ore for tools and weapons", "Diamonds", "Phosphate"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Early industrialization and defense."
	},
	{
        "id": 41,
		"question": "Oil sands in Egypt are used for:",
		"options": ["Synthetic fuels and petrochemical feedstocks", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Energy diversification."
	},
	{
        "id": 42,
		"question": "Bauxite in Morocco and Algeria is used for:",
		"options": ["Aluminum production", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Lightweight metals for transport and industry."
	},
	{
        "id": 43,
		"question": "Natural gas from the Mediterranean coast powers:",
		"options": ["Fertilizer plants and electricity generation", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial backbone and export revenue."
	},
	{
        "id": 44,
		"question": "Salt from the Qattara Depression (Egypt) is used for:",
		"options": ["Industrial chemicals and chlorine", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Base for multiple chemical industries."
	},
	{
        "id": 45,
		"question": "Iron ore exports from Morocco go mainly to:",
		"options": ["Europe and Asia for steelmaking", "North America only", "South America only"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Critical for global construction and manufacturing."
	},
	{
        "id": 46,
		"question": "Oil refining capacity in Egypt is important because:",
		"options": ["Supplies domestic fuel and petrochemicals", "Jewelry only", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial and economic stability."
	},
	{
        "id": 47,
		"question": "Northern Africa's mineral wealth is critical globally because it supplies:",
		"options": ["Fertilizers, oil, gas, iron, aluminum, and chemicals", "Only jewelry", "Coal exclusively"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Food, energy, industry, and global markets."
	},
	{
        "id": 48,
		"question": "Morocco's phosphate mines in Khouribga produce rock used for:",
		"options": ["Fertilizers for global agriculture and phosphate chemicals", "Jewelry", "Road paving"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Morocco controls 70% of the world's phosphate exports, feeding food production globally."
	},
	{
        "id": 49,
		"question": "Limestone in Egypt and Morocco is used for:",
		"options": ["Cement and construction", "Jewelry", "Steel alloys"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Essential material for buildings and infrastructure."
	},
	{
        "id": 50,
		"question": "Clay deposits in Morocco and Tunisia are used for:",
		"options": ["Ceramics, pottery, and bricks", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Construction and artisan industries."
	},
	{
        "id": 51,
		"question": "Oil reserves in Libya are concentrated in:",
		"options": ["Sirte Basin", "Nile Delta", "Atlas Mountains"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Largest national export; fuels economy."
	},
	{
        "id": 52,
		"question": "Saltpeter (nitrates) in Egypt is used for:",
		"options": ["Fertilizers and explosives", "Jewelry", "Steel"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Agriculture and industrial chemicals."
	},
	{
        "id": 53,
		"question": "Phosphate rock in Western Sahara supports:",
		"options": ["Global fertilizer markets", "Jewelry", "Construction"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Crucial for food production worldwide."
	},
	{
        "id": 54,
		"question": "Silica sand in Egypt is used for:",
		"options": ["Glass production and foundry molds", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "High-tech glass, solar panels, and industry."
	},
	{
        "id": 55,
		"question": "Oil and gas pipelines in Algeria export primarily to:",
		"options": ["Europe", "Asia only", "South America"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Geopolitical leverage and foreign currency."
	},
	{
        "id": 56,
		"question": "Iron smelting in Egypt historically used:",
		"options": ["Local iron ore for tools and weapons", "Diamonds", "Phosphate"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Early industrialization and defense."
	},
	{
        "id": 57,
		"question": "Oil sands in Egypt are used for:",
		"options": ["Synthetic fuels and petrochemical feedstocks", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Energy diversification."
	},
	{
        "id": 58,
		"question": "Bauxite in Morocco and Algeria is used for:",
		"options": ["Aluminum production", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Lightweight metals for transport and industry."
	},
	{
        "id": 59,
		"question": "Natural gas from the Mediterranean coast powers:",
		"options": ["Fertilizer plants and electricity generation", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial backbone and export revenue."
	},
	{
        "id": 60,
		"question": "Salt from the Qattara Depression (Egypt) is used for:",
		"options": ["Industrial chemicals and chlorine", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Base for multiple chemical industries."
	},
	{
        "id": 61,
		"question": "Iron ore exports from Morocco go mainly to:",
		"options": ["Europe and Asia for steelmaking", "North America only", "South America only"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Critical for global construction and manufacturing."
	},
	{
        "id": 62,
		"question": "Oil refining capacity in Egypt is important because:",
		"options": ["Supplies domestic fuel and petrochemicals", "Jewelry only", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial and economic stability."
	},
	{
        "id": 63,
		"question": "Northern Africa's mineral wealth is critical globally because it supplies:",
		"options": ["Fertilizers, oil, gas, iron, aluminum, and chemicals", "Only jewelry", "Coal exclusively"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Food, energy, industry, and global markets."
	},
	{
        "id": 64,
		"question": "Morocco's phosphate mines in Khouribga produce rock used for:",
		"options": ["Fertilizers for global agriculture and phosphate chemicals", "Jewelry", "Road paving"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Morocco controls 70% of the world's phosphate exports, feeding food production globally."
	},
	{
        "id": 65,
		"question": "Limestone in Egypt and Morocco is used for:",
		"options": ["Cement and construction", "Jewelry", "Steel alloys"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Essential material for buildings and infrastructure."
	},
	{
        "id": 66,
		"question": "Clay deposits in Morocco and Tunisia are used for:",
		"options": ["Ceramics, pottery, and bricks", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Construction and artisan industries."
	},
	{
        "id": 67,
		"question": "Oil reserves in Libya are concentrated in:",
		"options": ["Sirte Basin", "Nile Delta", "Atlas Mountains"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Largest national export; fuels economy."
	},
	{
        "id": 68,
		"question": "Saltpeter (nitrates) in Egypt is used for:",
		"options": ["Fertilizers and explosives", "Jewelry", "Steel"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Agriculture and industrial chemicals."
	},
	{
        "id": 69,
		"question": "Phosphate rock in Western Sahara supports:",
		"options": ["Global fertilizer markets", "Jewelry", "Construction"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Crucial for food production worldwide."
	},
	{
        "id": 70,
		"question": "Silica sand in Egypt is used for:",
		"options": ["Glass production and foundry molds", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "High-tech glass, solar panels, and industry."
	},
	{
        "id": 71,
		"question": "Oil and gas pipelines in Algeria export primarily to:",
		"options": ["Europe", "Asia only", "South America"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Geopolitical leverage and foreign currency."
	},
	{
        "id": 72,
		"question": "Iron smelting in Egypt historically used:",
		"options": ["Local iron ore for tools and weapons", "Diamonds", "Phosphate"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Early industrialization and defense."
	},
	{
        "id": 73,
		"question": "Oil sands in Egypt are used for:",
		"options": ["Synthetic fuels and petrochemical feedstocks", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Energy diversification."
	},
	{
        "id": 74,
		"question": "Bauxite in Morocco and Algeria is used for:",
		"options": ["Aluminum production", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Lightweight metals for transport and industry."
	},
	{
        "id": 75,
		"question": "Natural gas from the Mediterranean coast powers:",
		"options": ["Fertilizer plants and electricity generation", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial backbone and export revenue."
	},
	{
        "id": 76,
		"question": "Salt from the Qattara Depression (Egypt) is used for:",
		"options": ["Industrial chemicals and chlorine", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Base for multiple chemical industries."
	},
	{
        "id": 77,
		"question": "Iron ore exports from Morocco go mainly to:",
		"options": ["Europe and Asia for steelmaking", "North America only", "South America only"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Critical for global construction and manufacturing."
	},
	{
        "id": 78,
		"question": "Oil refining capacity in Egypt is important because:",
		"options": ["Supplies domestic fuel and petrochemicals", "Jewelry only", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial and economic stability."
	},
	{
        "id": 79,
		"question": "Northern Africa's mineral wealth is critical globally because it supplies:",
		"options": ["Fertilizers, oil, gas, iron, aluminum, and chemicals", "Only jewelry", "Coal exclusively"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Food, energy, industry, and global markets."
	},
	{
        "id": 80,
		"question": "Morocco's phosphate mines in Khouribga produce rock used for:",
		"options": ["Fertilizers for global agriculture and phosphate chemicals", "Jewelry", "Road paving"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Morocco controls 70% of the world's phosphate exports, feeding food production globally."
	},
	{
        "id": 81,
		"question": "Western Sahara phosphate reserves are used for:",
		"options": ["Fertilizer, animal feed, and phosphate-based chemicals", "Electronics", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Critical for agriculture and chemical manufacturing."
	},
	{
        "id": 82,
		"question": "Algeria's Hassi Messaoud oil field is mainly used for:",
		"options": ["Transport fuels, petrochemicals, and electricity", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Powers Algeria and exports to Europe."
	},
	{
        "id": 83,
		"question": "Libya's Sirte Basin is strategically important because:",
		"options": ["It holds over 40% of Libya's oil reserves", "It's mainly coal", "It's phosphate-rich"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Largest national revenue source; geopolitically crucial."
	},
	{
        "id": 84,
		"question": "Egypt's Western Desert oil fields are used for:",
		"options": ["Domestic fuel and petrochemical feedstock", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Powers national industry and chemical exports."
	},
	{
        "id": 85,
		"question": "Niger's uranium mines (Arlit & Akouta) are used for:",
		"options": ["Nuclear energy and medical isotopes", "Road surfacing", "Jewelry"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Supplies nuclear power and cancer treatment isotopes worldwide."
	},
	{
        "id": 86,
		"question": "Morocco's Bou Craa iron mine produces iron ore for:",
		"options": ["Steel manufacturing and construction", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Exports fuel global steel markets."
	},
	{
        "id": 87,
		"question": "Algerian natural gas fields (Hassi R'Mel) are used for:",
		"options": ["Electricity, fertilizer, LNG exports", "Jewelry", "Road paving"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Europe's energy security; fertilizer feedstock."
	},
	{
        "id": 88,
		"question": "Salt flats (Sebkhas) in Algeria and Tunisia are used for:",
		"options": ["Industrial chemicals, chlorine, and soda ash", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Base for plastics, soap, and chlorine industries."
	},
	{
        "id": 89,
		"question": "Egyptian limestone quarries (Mokattam Hills) are used for:",
		"options": ["Cement, construction, and lime", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Infrastructure backbone for buildings, bridges, and roads."
	},
	{
        "id": 90,
		"question": "Egyptian gypsum deposits are used for:",
		"options": ["Plaster, cement, and construction", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Core material for the construction industry."
	},
	{
        "id": 91,
		"question": "Silica sand in Egypt's deserts is used for:",
		"options": ["Glass production, solar panels, and foundry molds", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Critical for high-tech glass and industrial processes."
	},
	{
        "id": 92,
		"question": "Morocco's silver mines (Imiter region) are used for:",
		"options": ["Electronics, solar panels, and jewelry", "Fertilizer", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Conductive metal for electronics and energy tech."
	},
	{
        "id": 93,
		"question": "Algeria's zinc deposits are used for:",
		"options": ["Galvanized steel and batteries", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Protects steel structures; used in battery tech."
	},
	{
        "id": 94,
		"question": "Lead ores from Morocco and Tunisia are used for:",
		"options": ["Batteries, radiation shielding, and solder", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Automotive, industrial safety, and electronics."
	},
	{
        "id": 95,
		"question": "Oil sands in Egypt are processed for:",
		"options": ["Synthetic fuels and petrochemical feedstock", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Diversifies energy supply and industrial chemicals."
	},
	{
        "id": 96,
		"question": "Tantalum and niobium in Algeria are used for:",
		"options": ["Aerospace, capacitors, and electronics", "Cement", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Miniaturized, high-performance electronics and aerospace alloys."
	},
	{
        "id": 97,
		"question": "Saltpeter in Egypt is used for:",
		"options": ["Fertilizers and explosives", "Jewelry", "Road surfacing"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Agricultural and industrial chemicals."
	},
	{
        "id": 98,
		"question": "Oil pipelines in Algeria and Libya primarily export to:",
		"options": ["Europe", "Asia only", "North America only"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Key for energy exports and geopolitics."
	},
	{
        "id": 99,
		"question": "Egypt's Nile Delta natural gas is used for:",
		"options": ["Fertilizer plants, electricity, and petrochemicals", "Jewelry", "Steel"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial backbone for Egypt and neighboring countries."
	},
	{
        "id": 100,
		"question": "Phosphate processing plants in Morocco produce:",
		"options": ["Fertilizer, animal feed, and phosphoric acid", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Global food security and chemical industry."
	},
	{
        "id": 101,
		"question": "Oil refining capacity in Egypt ensures:",
		"options": ["Domestic fuel supply and petrochemical production", "Jewelry only", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Supports national economy and industrial sector."
	},
	{
        "id": 102,
		"question": "Gypsum from Tunisia is used for:",
		"options": ["Cement, plaster, and wallboard", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Construction and housing."
	},
	{
        "id": 103,
		"question": "Silica sand deposits in Morocco are used for:",
		"options": ["Glass, solar panels, and industrial molds", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "High-tech and industrial applications."
	},
	{
        "id": 104,
		"question": "Algerian oil condensates are used for:",
		"options": ["Petrochemicals, plastics, and fuels", "Jewelry", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Industrial feedstock and global exports."
	},
	{
        "id": 105,
		"question": "Egypt's iron ore deposits are used for:",
		"options": ["Steel production and heavy machinery", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "National industrialization and infrastructure."
	},
	{
        "id": 106,
		"question": "Morocco's silver is used in:",
		"options": ["Solar energy tech, electronics, and jewelry", "Fertilizer", "Cement"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Electronics, renewable energy, and industrial applications."
	},
	{
        "id": 107,
		"question": "Salt from Qattara Depression (Egypt) is used for:",
		"options": ["Industrial chemicals and chlorine", "Jewelry", "Fertilizer"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Base for chemical industries and manufacturing."
	},
	{
        "id": 108,
		"question": "Oil reserves in Libya are mainly:",
		"options": ["Light sweet crude for export", "Heavy crude only", "Gas only"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "High-demand oil globally."
	},
	{
        "id": 109,
		"question": "Northern Africa's minerals are globally strategic because they supply:",
		"options": ["Fertilizer, oil, gas, uranium, iron, aluminum, chemicals, and energy", "Only jewelry", "Coal exclusively"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Powers agriculture, energy, industry, and geopolitics worldwide."
	},
	{
        "id": 110,
		"question": "Which international mining company is one of Africa's largest gold producers, operating in Mali, Tanzania and the DRC?",
		"options": ["Barrick Gold", "Rio Tinto", "Vale"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Barrick is a major gold miner across Africa."
	},
	{
        "id": 111,
		"question": "Which South African company is a major producer of platinum group metals (PGMs)?",
		"options": ["Sibanye-Stillwater", "Newmont", "BHP Billiton"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Sibanye-Stillwater is a leading PGM and gold producer."
	},
	{
        "id": 112,
		"question": "AngloGold Ashanti is known for mining which mineral across Africa?",
		"options": ["Gold", "Coal", "Lithium"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "AngloGold Ashanti operates gold mines in several African countries."
	},
	{
        "id": 113,
		"question": "Which mining giant is developing the largest gold mine in Côte d'Ivoire and Guinea?",
		"options": ["Montage Gold", "Freeport", "Glencore"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Montage Gold is building a major gold project in West Africa."
	},
	{
        "id": 114,
		"question": "What is COMILOG famous for mining in Gabon?",
		"options": ["Manganese ore", "Diamonds", "Bauxite"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "COMILOG is one of the world's largest manganese producers."
	},
	{
        "id": 115,
		"question": "The Samira Hill Gold Mine in Niger is operated by a consortium from which regions?",
		"options": ["Canada & Morocco", "China & India", "USA & UK"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "The mine is run by a Canadian/Moroccan partnership with Nigerien ownership."
	},
	{
        "id": 116,
		"question": "Which global company dominates cobalt and copper mining in the Democratic Republic of Congo?",
		"options": ["Glencore (with partners, including Chinese and others)", "ExxonMobil", "Saudi Aramco"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Foreign and Chinese firms are heavily present in DRC mining."
	},
	{
        "id": 117,
		"question": "In 2025, Mali renewed the mining license of which company for its Loulo gold complex?",
		"options": ["Barrick Gold", "Vale", "Anglo American"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "The Malian government extended Barrick's permit after dispute resolution."
	},
	{
        "id": 118,
		"question": "Which Moroccan company is influential in mining gold, cobalt and copper across Africa?",
		"options": ["Managem Group", "Freeport", "BHP"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Managem operates in multiple African countries."
	},
	{
        "id": 119,
		"question": "Which Canadian company is known for low-cost gold mining in West Africa?",
		"options": ["B2Gold", "Barrick Gold", "AngloGold Ashanti"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "B2Gold is a key gold miner in Mali and Namibia."
	},
	{
        "id": 120,
		"question": "Morocco controls roughly 70% of the world's phosphate resources, supplying global agriculture.",
		"options": ["True", "False", "Only Africa's needs"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Morocco's phosphate is a cornerstone of global food production."
	},
	{
        "id": 121,
		"question": "Which country imports large amounts of African rare earth and lithium feedstock for processing?",
		"options": ["Australia", "Brazil", "Mexico"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Australia is investing in African rare earth supply chains."
	},
	{
        "id": 122,
		"question": "Most cobalt mined in the DRC is exported to:",
		"options": ["China for battery material processing", "Africa for local use", "South America"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "China dominates refining of cobalt and battery metals."
	},
	{
        "id": 123,
		"question": "Over 70% of the world's cobalt supply comes from which country?",
		"options": ["Democratic Republic of Congo", "Nigeria", "Botswana"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "DRC is the primary global source of cobalt."
	},
	{
        "id": 124,
		"question": "Zambia's copper exports are so large they account for about ___ of total export earnings.",
		"options": ["~70%", "10%", "0%"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Copper dominates Zambia's export economy."
	},
	{
        "id": 125,
		"question": "Which mineral exported by Guinea shapes the global energy transition through aluminum production?",
		"options": ["Bauxite", "Gold", "Salt"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Guinea's bauxite feeds global aluminum and renewable tech demand."
	},
	{
        "id": 126,
		"question": "Graphite from Africa is commonly used in:",
		"options": ["Batteries for EVs and electronics", "Jewelry", "Road paving"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Graphite is a key material in battery anodes."
	},
	{
        "id": 127,
		"question": "Which country exports minerals like manganese that are important for steel and battery tech?",
		"options": ["Gabon", "Egypt", "Tunisia"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Gabon is a leading manganese exporter."
	},
	{
        "id": 128,
		"question": "African mining exports range from $1 billion to ____ billion per country annually.",
		"options": ["$5 billion", "$100 million", "$20 million"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Multiple African countries export minerals valued in the billions."
	},
	{
        "id": 129,
		"question": "Most African mineral exports are still shipped out as:",
		"options": ["Raw materials", "Finished products", "Local end-products"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Raw export rather than processed goods remains common."
	},
	{
        "id": 130,
		"question": "Artisanal and small-scale mining in the DRC recently produced its first ____ tons of traceable cobalt.",
		"options": ["1,000", "10,000", "100"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "DRC formalized artisanal cobalt production."
	},
	{
        "id": 131,
		"question": "Artisanal gold mining contributes roughly what share of Mali's annual gold production?",
		"options": ["~6%", "50%", "0%"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Small-scale gold mining plays a significant role."
	},
	{
        "id": 132,
		"question": "Which West African country banned foreigners from trading artisanal gold to tackle illegal mining?",
		"options": ["Ghana", "Mali", "Senegal"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Ghana created GoldBod to control the gold value chain."
	},
	{
        "id": 133,
		"question": "Countries pushing to become regional mineral processing hubs aim to:",
		"options": ["Keep more value on the continent", "Export even more raw minerals", "Import materials from Europe"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Local refining keeps more of the value chain inside Africa."
	},
	{
        "id": 134,
		"question": "Efforts to formalize artisanal mining help countries achieve:",
		"options": ["Ethically traceable products", "Lower wages", "Export bans"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Traceability boosts ethical sourcing standards."
	},
	{
        "id": 135,
		"question": "Indigenous mining traditions in Africa historically centered on which mineral before industrial mining?",
		"options": ["Gold", "Uranium", "Oil"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Gold was mined long before colonial extraction. (Historical mining patterns)"
	},
	{
        "id": 136,
		"question": "Africa holds roughly what fraction of the world's critical mineral reserves?",
		"options": ["~30%", "~1%", "~90%"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Africa has major critical mineral reserves but under-captures value."
	},
	{
        "id": 137,
		"question": "Expanding local processing capacity could increase the value of minerals by up to how many times vs raw export?",
		"options": ["~10×", "~2×", "~1×"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Refining adds multiple layers of economic value."
	},
	{
        "id": 138,
		"question": "Artisanal mining often employs millions of Africans but faces which major challenge?",
		"options": ["Safety and lack of formal oversight", "High tech equipment", "Excess wealth"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Small-scale mining is dangerous without regulation."
	},
	{
        "id": 139,
		"question": "One major goal of indigenous minerals strategy is to:",
		"options": ["Build local industries and jobs", "Eliminate mining", "Export all raw materials cheaply"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Countries want to retain more wealth locally."
	},
	{
        "id": 140,
		"question": "Which state mining company in the Democratic Republic of Congo (DRC) struck a deal to sell a large share of copper output from a major Glencore-controlled mine?",
		"options": ["Gécamines", "Sonatrach", "Kenya Mines Corp"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Gécamines will market about 50% of Kamoto Copper Company's output."
	},
	{
        "id": 141,
		"question": "Which Canadian miner recently had its gold mining license in Mali renewed for another decade after disputes?",
		"options": ["Barrick Gold", "Newmont", "Kinross"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Barrick's Loulo-Gounkoto complex is Mali's largest gold producer."
	},
	{
        "id": 142,
		"question": "A UAE-linked firm acquired a majority stake in which tin mine in the DRC that produces ~7% of global supply?",
		"options": ["Bisie Mine", "Tenke Fungurume", "Kamoa-Kakula"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "International Resources Holding bought 56% of Alphamin's Bisie tin mine."
	},
	{
        "id": 143,
		"question": "Chinese firms control most of the cobalt mining operations in which country?",
		"options": ["Democratic Republic of Congo", "Ghana", "Botswana"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Chinese investors operate most major cobalt mines through joint ventures."
	},
	{
        "id": 144,
		"question": "Which Moroccan mining group is active across Africa in copper, gold, silver, and cobalt extraction?",
		"options": ["Managem Group", "Glencore", "Rio Tinto"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Managem operates in Morocco plus Gabon, DRC, Sudan, and Guinea."
	},
	{
        "id": 145,
		"question": "Which Zimbabwean mining company operates nickel, copper and cobalt mines and also runs a local smelter complex?",
		"options": ["Bindura Nickel Corporation", "Anglo American", "BHP"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "BNC produces nickel cathodes and copper-cobalt intermediates locally."
	},
	{
        "id": 146,
		"question": "In Zambia, the state-owned company ZCCM-IH owns stakes in which type of mines?",
		"options": ["Copper and cobalt", "Diamonds only", "Bauxite only"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "ZCCM-IH participates in Mopani and other copper/cobalt operations."
	},
	{
        "id": 147,
		"question": "Guinea's bauxite mining is a major global source of which industrial metal?",
		"options": ["Aluminum", "Iron", "Silver"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Guinea dominates Africa's bauxite output feeding aluminum production."
	},
	{
        "id": 148,
		"question": "Morocco's phosphate mining sector contributes roughly what share of the global phosphate resource base?",
		"options": ["~70%", "~10%", "~1%"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Morocco holds most of the world's phosphate reserves."
	},
	{
        "id": 149,
		"question": "Which global miner significantly boosted South African gold output recently, increasing dividends after gold price surges?",
		"options": ["Gold Fields", "Vale", "B2Gold"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Gold Fields reported higher output and profits."
	},
	{
        "id": 150,
		"question": "Which African country has the longest continuous sandy beach?",
		"options": ["Mozambique", "Namibia", "South Africa"],
		"answer_index": 0,
		"image_url": "",
		"explanation": "Mozambique's coastline stretches over 2,500 km, featuring long uninterrupted sandy beaches popular for sun, kitesurfing, and resorts."
	},
    
    { 
        "id": 151,
        "question": "Most cobalt mined in the DRC is refined in which country?",
        "options": ["China", "South Africa", "India"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "DRC cobalt is mainly processed in Chinese refineries."
    },
    {
        "id": 152,
        "question": "China controls significant global refining capacity for critical minerals — an estimated what proportion?",
        "options": ["~87 %", "~10 %", "~1 %"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "China dominates processing of critical minerals."
    },
        {
            "id": 153,
            "question": "Africa produces roughly what share of the world's lithium resources?",
            "options": ["~30%", "~1%", "~60%"],
            "answer_index": 0,
            "image_url": "",
            "explanation": "Africa has a large share of global lithium reserves."
        },
        {
            "id": 154,
            "question": "Guinea's Simandou iron ore project aims to supply iron to markets primarily in:",
            "options": ["Asia and Europe", "Africa only", "North America only"],
            "answer_index": 0,
            "image_url": "",
            "explanation": "Simandou is one of the world's largest iron ore developments."
        },
    {
        "id": 155,
        "question": "African manganese, a key battery ingredient, is largely exported from which country?",
        "options": ["Gabon", "Egypt", "Tunisia"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Gabon is a leading manganese producer crucial for battery tech."
    },
    {
        "id": 156,
        "question": "Zambia's copper exports — more than 700,000t annually — primarily go to:",
        "options": ["China's processing sector", "Local industry only", "South America"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Most raw copper still heads to global processors."
    },
    {
        "id": 157,
        "question": "African cobalt imports are critical for producing:",
        "options": ["Electric vehicle batteries", "Textile dye", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "EV batteries depend on cobalt."
    },
    {
        "id": 158,
        "question": "Raw phosphate rock from Morocco is mainly exported for:",
        "options": ["Global fertilizer manufacturing", "Jewelry", "Steelmaking"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Phosphate is key to fertilizers."
    },
    {
        "id": 159,
        "question": "Most African gold exports end up in refining centers in:",
        "options": ["Switzerland and Dubai", "Antarctica", "North Korea"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Swiss and Dubai refineries process bullion. (Common industry trade pattern)"
    },
    {
        "id": 160,
        "question": "Tin from the DRC's Bisie Mine supplies global markets used to make:",
        "options": ["Solder for electronics", "Cement", "Diamonds"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tin is essential in soldering."
    },
    {
        "id": 161,
        "question": "DRC's first production of traceable artisanal cobalt marks efforts to:",
        "options": ["Improve ethical supply chains", "Increase illegal exports", "Stop mining entirely"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Traceability aligns with environmental and governance standards."
    },
    {
        "id": 162,
        "question": "Replacing an outright export ban with cobalt export quotas aims to:",
        "options": ["Stabilize global supply and retain some local stock", "Allow unrestricted exports", "End taxation"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Quotas help manage prices and supply chains."
    },
    {
        "id": 163,
        "question": "In Mali, artisanal gold mining permits for foreign companies were suspended after what?",
        "options": ["Fatal mining accidents", "Discovery of diamonds", "Earthquake damage"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The move aimed to reinforce safety and national control."
    },
    {
        "id": 164,
        "question": "Communities in Ghana have formed local task forces to combat illegal gold mining known as:",
        "options": ["Galamsey", "Safari", "Artisquest"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Galamsey refers to illegal mining that harms ecosystems."
    },
    {
        "id": 165,
        "question": "Formalizing artisanal mining helps with:",
        "options": [
            "Ethical traceability and better labor conditions",
            "Export bans only",
            "Becoming wholly illegal"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Traceable mining supports ethical sourcing standards."
    },
    {
        "id": 166,
        "question": "Indigenous mining traditions in Africa were historically based on:",
        "options": [
            "Gold and iron long before colonial extraction",
            "Plastic production",
            "Rockets"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Local metallurgy predates colonization. (Historical pattern)"
    },
    {
        "id": 167,
        "question": "A major development goal across African mining sectors is to:",
        "options": [
            "Build local refining and processing capacity",
            "Export only raw materials",
            "Close mining sectors"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Processing locally captures more value."
    },
    {
        "id": 168,
        "question": "Export bans on raw lithium or cobalt — like those in Zimbabwe — are meant to:",
        "options": [
            "Force local processing",
            "Lower prices",
            "Replace mining with farming"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Value addition increases revenue."
    },
    {
        "id": 169,
        "question": "Artisanal mining often faces challenges such as:",
        "options": [
            "Safety hazards and poor regulation",
            "Excess investment",
            "Global stockpiles"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Working conditions are often unsafe."
    },
    {
        "id": 170,
        "question": "Efforts like the Africa Responsible Mineral Sourcing Initiative (ARMSI) aim to:",
        "options": [
            "Improve ethical mining, protect rights and the environment",
            "Stop all mining",
            "Increase illegal mining"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "ARMSI supports responsible sourcing and sustainability."
    },
    {
    "id": 171,
    "question": "Which African country has about 92% of its export revenues coming from diamonds, making mining almost the entire economy?",
    "options": [
        "Botswana",
        "Egypt",
        "Nigeria"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Botswana's diamond sector dominates its export economy."
},
{
    "id": 172,
    "question": "About 87% of this West African country's exports come from mineral products like gold and bauxite.",
    "options": [
        "Guinea",
        "Ghana",
        "Kenya"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Guinea relies heavily on minerals for export revenue."
},
{
    "id": 173,
    "question": "Which Sahel country has roughly 85% of export value from gold mining?",
    "options": [
        "Mali",
        "Tunisia",
        "Botswana"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Gold is Mali's dominant export product."
},
{
    "id": 174,
    "question": "In Zambia, more than 75% of export earnings come from which mineral?",
    "options": [
        "Copper",
        "Oil",
        "Diamonds"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Copper drives Zambia's export economy."
},
{
    "id": 175,
    "question": "Which African country exports large quantities of iron ore and other minerals, making mining over 50% of total exports?",
    "options": [
        "Sierra Leone",
        "Ghana",
        "Morocco"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mineral exports are the backbone of Sierra Leone's economy."
},
{
    "id": 176,
    "question": "The Democratic Republic of Congo (DRC) exports mostly copper and cobalt, accounting for about 77% of its export revenue.",
    "options": [
        "True",
        "False",
        "Only oil"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mining dominates the DRC's export profile."
},
{
    "id": 177,
    "question": "Which country's economy depends heavily on oil and gas, with energy products making up over 90% of exports?",
    "options": [
        "Libya",
        "Tunisia",
        "Botswana"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Libya is hugely dependent on oil exports."
},
{
    "id": 178,
    "question": "In Gabon, oil accounts for about what share of its GDP and exports?",
    "options": [
        "Nearly half of GDP and over 80% of exports",
        "10% of GDP, 20% exports",
        "Only agricultural exports"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Oil revenue continues to dominate Gabon's economy."
},
{
    "id": 179,
    "question": "Which of these countries relies on oil and gas for a very high portion (over 90%) of its export value?",
    "options": [
        "Algeria",
        "Mauritius",
        "Morocco"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Algeria's exports are heavily energy-dependent."
},
{
    "id": 180,
    "question": "Which African country is among those where over 90% of export revenue is linked to raw commodity exports?",
    "options": [
        "South Sudan",
        "Egypt",
        "Tunisia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "South Sudan's economy is extremely dependent on raw materials."
},
{
    "id": 181,
    "question": "In many African extractive economies, export dependence makes them especially vulnerable to:",
    "options": [
        "Global price shocks",
        "Local education gains",
        "Tourism growth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Heavy reliance on raw materials exposes countries to volatile markets."
},
{
    "id": 182,
    "question": "Which country's mining exports include diamonds, gold, and uranium, contributing significantly to both exports and GDP?",
    "options": [
        "Namibia",
        "Kenya",
        "Senegal"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mineral exports are a major source of revenue for Namibia."
},
{
    "id": 183,
    "question": "In Ghana, mining contributes about 40% of foreign exchange earnings, with gold dominating at over 90% of mineral export value.",
    "options": [
        "True",
        "False",
        "Only oil"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Gold is Ghana's key export from mining."
},
{
    "id": 184,
    "question": "Which factor is a common economic problem for countries heavily dependent on extractive exports?",
    "options": [
        "Lack of diversification",
        "High levels of manufacturing",
        "Strong local processing industries"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Dependence on raw exports often slows economic diversification."
},
{
    "id": 185,
    "question": "Which African nation's economy includes mining as only a small share of GDP despite having resources, due largely to underdeveloped extraction?",
    "options": [
        "Tanzania",
        "Botswana",
        "Guinea"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mining contributes a small share of Tanzania's GDP."
},
{
    "id": 186,
    "question": "Heavy reliance on extractive exports can lead to economic problems such as:",
    "options": [
        "External shocks from price volatility",
        "Strong diversified industry",
        "Balanced sector growth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Commodity dependence makes economies fragile."
},
{
    "id": 187,
    "question": "Which mineral export dominates Mali's economy?",
    "options": [
        "Gold",
        "Oil",
        "Coal"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Gold is Mali's primary export from mining."
},
{
    "id": 188,
    "question": "Exporting mostly raw materials rather than processed products means:",
    "options": [
        "Lower long-term economic value",
        "More local jobs in processing",
        "Diversified industrial growth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Value often leaves without local benefit."
},
{
    "id": 189,
    "question": "Countries dependent on extractive exports often struggle with:",
    "options": [
        "Infrastructure deficits and limited industry",
        "Technological export leadership",
        "Stable local manufacturing"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Heavy export dependence can slow broader development."
},
{
    "id": 190,
    "question": "In many mineral-exporting nations, mining accounts for:",
    "options": [
        "A large percentage of export revenues",
        "Little to none",
        "Only agricultural trade"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Minerals are major export earners in many African economies."
},
{
    "id": 191,
    "question": "Which country is known for very high dependence on oil and energy exports at over 90% of export value?",
    "options": [
        "Equatorial Guinea",
        "Tunisia",
        "Senegal"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Equatorial Guinea is heavily dependent on oil and gas."
},
{
    "id": 192,
    "question": "Botswana's diamond exports make up about:",
    "options": [
        "90% of its total exports",
        "20%",
        "5%"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Diamonds form the immense majority of Botswana's export economy."
},
{
    "id": 193,
    "question": "Which country's mineral export profile includes manganese and energy minerals in addition to oil?",
    "options": [
        "Gabon",
        "Rwanda",
        "Malawi"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Gabon's manganese and oil exports shape its economy."
},
{
    "id": 194,
    "question": "Countries tied to extractive exports often export their raw materials to processors in:",
    "options": [
        "Europe and Asia",
        "Only within Africa",
        "South America"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Many African mineral exports are refined abroad."
},
{
    "id": 195,
    "question": "Which African region, according to UNCTAD, has all countries commodity dependent (mining & oil)?",
    "options": [
        "Central Africa",
        "North Africa",
        "Southern Africa"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Central African states are heavily dependent on raw exports."
},
{
    "id": 196,
    "question": "Nigeria's economy is heavily supported by oil exports, but the country is starting to collaborate on mining diversification with:",
    "options": [
        "South Africa",
        "Chile",
        "Morocco only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Nigeria signed partnerships to boost mining diversification."
},
{
    "id": 197,
    "question": "Which African country plans to ban raw manganese ore exports to build local processing by 2029?",
    "options": [
        "Gabon",
        "Egypt",
        "Kenya"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Gabon is phasing out raw manganese exports to add local value."
},
{
    "id": 198,
    "question": "High dependency on resource exports can often be called:",
    "options": [
        "Commodity dependence",
        "Industrial diversification",
        "Agricultural independence"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Export reliance on raw materials is commodity dependence."
},
{
    "id": 199,
    "question": "Which oil-exporting African country had its oil exports fall in recent years, reducing export revenue?",
    "options": [
        "Nigeria",
        "Mauritius",
        "Morocco"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Nigeria saw declines in energy export volumes."
},
{
    "id": 200,
    "question": "Heavy extractive export dependency can hinder a country's economic resilience by:",
    "options": [
        "Making it vulnerable to price swings",
        "Guaranteeing stable growth",
        "Creating diversified industry"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Volatile markets hit export-heavy economies hardest."
},
{
    "id": 201,
    "question": "Which country's companies are the single largest importers of African minerals, including copper, bauxite and cobalt?",
    "options": [
        "United States",
        "China",
        "Brazil"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "China imports a significant portion of African mineral exports and operates many mining ventures across the continent."
},
{
    "id": 202,
    "question": "Many African bauxite reserves — used for aluminum — go to refineries in which non-African region?",
    "options": [
        "Asia",
        "South America",
        "Middle East"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China is a major destination for West African bauxite exports."
},
{
    "id": 203,
    "question": "The ownership of major African mining operations often includes investors or operators from:",
    "options": [
        "China, Canada, and Australia",
        "Antarctica",
        "South America only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Foreign investors from China, Canada, and Australia dominate many African mining projects."
},
{
    "id": 204,
    "question": "Which European-headquartered mining giant is known for copper and gold mining in Africa?",
    "options": [
        "Rio Tinto (UK)",
        "Petrobras (Brazil)",
        "Aramco (Saudi Arabia)"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Rio Tinto and other UK/EU firms have major African mining interests."
},
{
    "id": 205,
    "question": "The UAE's International Resources Holding acquired a majority stake in a tin mine in the DRC — expanding Gulf control over African critical minerals.",
    "options": [
        "True",
        "False",
        "Only local firms"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The UAE company bought a significant share of the Bisie tin mine in eastern Congo."
},
{
    "id": 206,
    "question": "Which country's mining companies have historically dominated gold extraction in places like Mali and Tanzania?",
    "options": [
        "Canada",
        "Japan",
        "South Korea"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Canadian gold firms like Barrick and B2Gold operate major African mines."
},
{
    "id": 207,
    "question": "Foreign mining influence in Africa includes companies from:",
    "options": [
        "UK, US, China, Canada, and Australia",
        "Antarctica only",
        "Brazil, Argentina only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Multiple developed economies' mining corporations operate extensively in Africa."
},
{
    "id": 208,
    "question": "Which country's government has been trying to attract U.S. investment for strategic mineral projects like coltan and lithium?",
    "options": [
        "Zambia",
        "Democratic Republic of Congo",
        "Senegal"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "DRC offered mineral assets to the U.S. under a cooperation pact to diversify investment."
},
{
    "id": 209,
    "question": "Chinese-backed companies dominate much of Guinea's bauxite exports, accounting for over 60% of shipments.",
    "options": [
        "True",
        "False",
        "Only European firms"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Chinese firms control a major share of Guinea's bauxite exports to Chinese aluminum producers."
},
{
    "id": 210,
    "question": "Canada's First Quantum Minerals operates major copper mines in:",
    "options": [
        "Zambia and Mauritania",
        "Spain only",
        "Iceland only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "First Quantum runs multi-mine operations including in Zambia and Mauritania."
},
{
    "id": 211,
    "question": "About 75% of African mineral exports are shipped to:",
    "options": [
        "Non-African countries",
        "Within Africa only",
        "Antarctica"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Most raw minerals leave the continent for foreign processing and manufacturing."
},
{
    "id": 212,
    "question": "Which continent receives large quantities of African cobalt and copper for refining?",
    "options": [
        "Asia",
        "South America",
        "Oceania"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Asia, particularly China, refines much of Africa's cobalt and copper."
},
{
    "id": 213,
    "question": "African bauxite exported to China is primarily used to make:",
    "options": [
        "Aluminum for construction and transport",
        "Plastic toys",
        "Wood"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Bauxite is the raw material for aluminum used in cars, planes, and buildings."
},
{
    "id": 214,
    "question": "Many African minerals are exported raw rather than processed into higher-value products.",
    "options": [
        "True",
        "False",
        "Only gold is raw exported"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Most critical minerals leave Africa unrefined, reducing local economic gain."
},
{
    "id": 215,
    "question": "African lithium and cobalt are now mostly used in battery production in:",
    "options": [
        "China and Europe",
        "North Africa only",
        "South America only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Raw transition minerals feed foreign EV and electronics supply chains."
},
{
    "id": 216,
    "question": "Gold mined in Africa often gets refined in:",
    "options": [
        "Switzerland and the UAE",
        "South Africa only",
        "Within Africa only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Switzerland and the UAE handle major refined gold markets. (common export pattern)"
},
{
    "id": 217,
    "question": "African copper exported to China often becomes:",
    "options": [
        "Electrical wires, electronics, and infrastructure metal",
        "Wood furniture",
        "Textile thread"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Copper is essential in electrification and manufacturing abroad. (global industrial use)"
},
{
    "id": 218,
    "question": "Countries like Australia import rare earth ores from Africa to:",
    "options": [
        "Process and manufacture advanced tech components",
        "Build pyramids",
        "Grow crops"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Australia is building rare earth & minerals processing capacity using African feedstock."
},
{
    "id": 219,
    "question": "Many mineral supply chains ultimately feed into tech industries in which regions?",
    "options": [
        "Asia and Europe",
        "Antarctica",
        "Only Africa"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "High tech and manufacturing hubs in Asia/Europe use African raw materials."
},
{
    "id": 220,
    "question": "The export of most raw minerals without local processing means African nations often:",
    "options": [
        "Import finished goods made from their own minerals",
        "Manufacture everything locally",
        "Recycle their own exports"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africa often buys back finished goods made from its own raw exports."
},
{
    "id": 221,
    "question": "Which non-African country is known for major foreign mining investment groups operating in Africa's cobalt, copper, and gold sectors?",
    "options": [
        "Canada",
        "Saudi Arabia",
        "Brazil"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Canada hosts many mining investors and multinationals active in Africa."
},
{
    "id": 222,
    "question": "Chinese firms operate both mining infrastructure and processing facilities far more often than many Western firms.",
    "options": [
        "True",
        "False",
        "Only African firms do"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China invests heavily in extraction and infrastructure tied to minerals."
},
{
    "id": 223,
    "question": "Foreign mining companies often operate through:",
    "options": [
        "Joint ventures with African states",
        "Only solo African owned companies",
        "Student cooperatives"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Most foreign extraction projects include partnerships with local governments."
},
{
    "id": 224,
    "question": "Which continent's investors have historically had a strong presence in African mining?",
    "options": [
        "Europe",
        "Antarctica",
        "South America only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "European investors are deeply embedded in African mining history."
},
{
    "id": 225,
    "question": "Foreign mining influence sometimes helps supply which major industry outside Africa?",
    "options": [
        "Aerospace",
        "Movie production",
        "Local farming only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Minerals like titanium, cobalt, and nickel are vital for aerospace manufacturing abroad. (industrial patterns)"
},
{
    "id": 226,
    "question": "Countries like the United States negotiate mining deals with African governments to secure strategic minerals for:",
    "options": [
        "High-tech and defense industries",
        "Tourism",
        "Only coffee"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The U.S. seeks mineral ties for tech & strategic stockpiles."
},
{
    "id": 227,
    "question": "Foreign firms extracting African minerals benefit global manufacturing most when the minerals are:",
    "options": [
        "Refined before export",
        "Buried underground",
        "Used only locally"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Refinement adds value before entering global supply chains."
},
{
    "id": 228,
    "question": "Some African nations are trying to change the pattern by requiring minerals to be:",
    "options": [
        "Processed locally before export",
        "Exported raw only",
        "Used only in traditional ceremonies"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "New policies aim to keep more value within Africa."
},
{
    "id": 229,
    "question": "Export bans on raw critical minerals are intended to spur:",
    "options": [
        "Local industrial growth",
        "Complete closure of mining",
        "Only export diamonds"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Policies target value addition and jobs at home."
},
{
    "id": 230,
    "question": "Where have some of the oldest Homo sapiens fossils (over 300,000 years old) been found?",
    "options": [
        "Morocco",
        "France",
        "India"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Jebel Irhoud fossils"
},
{
    "id": 231,
    "question": "Which African country contains Omo Kibish, one of the oldest known human fossil sites?",
    "options": [
        "Ethiopia",
        "Egypt",
        "Kenya"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 232,
    "question": "Around 70,000-60,000 years ago, early humans migrated out of Africa through:",
    "options": [
        "The Horn of Africa into Arabia",
        "South Africa to Antarctica",
        "West Africa to Brazil"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 233,
    "question": "What major climate once covered much of North Africa before it became desert?",
    "options": [
        "Grasslands, rivers, and lakes",
        "Ice sheets",
        "Volcano fields"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 234,
    "question": "Rock art in Tassili n'Ajjer (Algeria) shows:",
    "options": [
        "Cattle, people swimming, and wildlife",
        "Cars and airplanes",
        "Medieval castles"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 235,
    "question": "Which African region is called the “Cradle of Humankind”?",
    "options": [
        "Southern Africa",
        "Scandinavia",
        "North America"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 236,
    "question": "The Middle Stone Age in Africa is important because it shows:",
    "options": [
        "Early tools, art, and symbolic behavior",
        "Only farming",
        "Only metal weapons"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 237,
    "question": "Which early African innovation improved hunting dramatically?",
    "options": [
        "Stone-tipped spears",
        "Bronze cannons",
        "Gunpowder"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 238,
    "question": "Some of the earliest known jewelry (shell beads) were discovered in:",
    "options": [
        "South Africa",
        "Germany",
        "China"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 239,
    "question": "The Sahara became a desert mainly because:",
    "options": [
        "Earth's climate cycles shifted rainfall patterns",
        "A giant volcano exploded",
        "A meteor hit"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 240,
    "question": "The Nile Valley supported early settlements because:",
    "options": [
        "Annual floods enriched the soil",
        "It had snow",
        "It had oil fields"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 241,
    "question": "Which African region has some of the oldest evidence of advanced fishing tools?",
    "options": [
        "Central Africa",
        "Siberia",
        "Australia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 242,
    "question": "Early African societies 20,000 years ago mainly survived through:",
    "options": [
        "Hunting and gathering",
        "Banking",
        "Industrial factories"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 243,
    "question": "The oldest known engraved geometric patterns were found in:",
    "options": [
        "Blombos Cave (South Africa)",
        "London",
        "Rome"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 244,
    "question": "Which African animal was among the first to be domesticated in the Sahara region?",
    "options": [
        "Cattle",
        "Penguins",
        "Llamas"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 245,
    "question": "The Great Rift Valley is important in human history because:",
    "options": [
        "Many early human fossils were found there",
        "It was built by kings",
        "It contains glaciers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 246,
    "question": "Around 12,000 years ago, climate warming led to:",
    "options": [
        "Expansion of lakes and grasslands in the Sahara",
        "Ice covering Africa",
        "Total extinction of humans"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 247,
    "question": "Which early tool-making technique involved shaping stones on both sides?",
    "options": [
        "Bifacial flaking",
        "Concrete molding",
        "Plastic casting"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 248,
    "question": "The San people's ancestors are linked to some of the oldest genetic lineages in:",
    "options": [
        "Southern Africa",
        "Europe",
        "Antarctica"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 249,
    "question": "Early African coastal communities 100,000+ years ago likely relied on:",
    "options": [
        "Shellfish and marine food",
        "Wheat farming",
        "Steel tools"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 250,
    "question": "Lake Chad was once:",
    "options": [
        "Much larger and surrounded by settlements",
        "Frozen solid",
        "A volcano"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 251,
    "question": "Early African trade between groups likely involved:",
    "options": [
        "Stone, shells, and tools",
        "Paper money",
        "Oil contracts"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 252,
    "question": "The Later Stone Age in Africa shows evidence of:",
    "options": [
        "More complex tools and art",
        "Skyscrapers",
        "Airplanes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 253,
    "question": "Which factor helped humans adapt across Africa's many environments?",
    "options": [
        "Flexible tools and social cooperation",
        "Only physical strength",
        "Isolation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 254,
    "question": "Which African site contains some of the earliest evidence of controlled use of fire?",
    "options": [
        "Wonderwerk Cave (South Africa)",
        "Tokyo",
        "Paris"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 255,
    "question": "The Sahara's rock art suggests early people:",
    "options": [
        "Lived near lakes and herded animals",
        "Only crossed the desert once",
        "Built skyscrapers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 256,
    "question": "Genetic studies show modern humans share common ancestry traced back to:",
    "options": [
        "Africa",
        "Europe",
        "Antarctica"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 257,
    "question": "Before farming, African societies organized themselves through:",
    "options": [
        "Small mobile communities",
        "Empires",
        "Corporations"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 258,
    "question": "Around 10,000 years ago, climate drying in North Africa led to:",
    "options": [
        "Migration toward river valleys like the Nile",
        "Total human extinction",
        "Permanent ice age"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 259,
    "question": "The biggest historical truth from deep African history is:",
    "options": [
        "Africa is central to the story of all humanity",
        "Africa entered history late",
        "Civilization began elsewhere first"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 260,
    "question": "The oldest widely accepted Homo sapiens fossils (300,000+ years) were found in:",
    "options": [
        "Morocco",
        "Italy",
        "China"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 261,
    "question": "Which African region shows early human skulls dating back about 195,000 years?",
    "options": [
        "Omo Valley (Ethiopia)",
        "London Basin",
        "Siberia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 262,
    "question": "Genetic studies show the deepest branches of modern human DNA are found among:",
    "options": [
        "Southern African hunter-gatherers",
        "Northern Europeans",
        "Pacific Islanders"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 263,
    "question": "Which cave in South Africa shows controlled fire use nearly 1 million years ago?",
    "options": [
        "Wonderwerk Cave",
        "Lascaux Cave",
        "Blue Grotto"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 264,
    "question": "Early symbolic engraving (75,000+ years old) was discovered at:",
    "options": [
        "Blombos Cave",
        "Athens",
        "Moscow"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 265,
    "question": "Before it was desert, the Sahara was mainly:",
    "options": [
        "Grassland with rivers and lakes",
        "Ice sheet",
        "Volcano plain"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 266,
    "question": "Which climate cycle helped turn the Sahara green thousands of years ago?",
    "options": [
        "Earth's orbital shifts",
        "Industrial pollution",
        "Meteor strike"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 267,
    "question": "Early humans leaving Africa likely crossed into Arabia through:",
    "options": [
        "Bab-el-Mandeb Strait",
        "Strait of Gibraltar",
        "Cape of Good Hope"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 268,
    "question": "Which African region contains many early hominin fossils due to tectonic activity exposing layers?",
    "options": [
        "Great Rift Valley",
        "Sahara interior",
        "Congo rainforest"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 269,
    "question": "Some of the earliest bone harpoons (90,000+ years old) were found in:",
    "options": [
        "Central Africa",
        "Norway",
        "Japan"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 270,
    "question": "The Bantu expansion began roughly:",
    "options": [
        "3,000-4,000 years ago",
        "500 years ago",
        "10,000 years ago"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 271,
    "question": "The Bantu expansion spread:",
    "options": [
        "Farming, ironworking, and language",
        "Paper money",
        "Gunpowder"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 272,
    "question": "Nilotic peoples are historically linked to:",
    "options": [
        "Upper Nile regions",
        "Sahara dunes",
        "Madagascar"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 273,
    "question": "Cushitic language speakers originated mainly in:",
    "options": [
        "Horn of Africa",
        "Southern Africa",
        "Western Sahara"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 274,
    "question": "Which African island was settled by both African and Austronesian seafarers?",
    "options": [
        "Madagascar",
        "Sicily",
        "Iceland"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 275,
    "question": "Madagascar's earliest settlers arrived around:",
    "options": [
        "1,500-2,000 years ago",
        "10,000 years ago",
        "500 years ago"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 276,
    "question": "Early Saharan pastoralists are linked to rock art showing:",
    "options": [
        "Cattle culture",
        "Steel armor",
        "Cars"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 277,
    "question": "Which major African language family includes Yoruba and Igbo?",
    "options": [
        "Niger-Congo",
        "Indo-European",
        "Sino-Tibetan"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 278,
    "question": "The spread of iron technology in sub-Saharan Africa began roughly:",
    "options": [
        "2,500 years ago",
        "200 years ago",
        "10,000 years ago"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 279,
    "question": "Which ancient migration reshaped much of Central, Eastern, and Southern Africa?",
    "options": [
        "Bantu expansion",
        "Viking expansion",
        "Roman expansion"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 280,
    "question": "Some of the earliest independent iron smelting evidence in Africa comes from:",
    "options": [
        "Nigeria (Nok region)",
        "Spain",
        "India"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 281,
    "question": "Early copper mining in Africa dates back thousands of years in:",
    "options": [
        "Southern Africa",
        "Antarctica",
        "Greenland"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 282,
    "question": "The Nok culture is famous for:",
    "options": [
        "Terracotta sculptures",
        "Roman roads",
        "Viking ships"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 283,
    "question": "Long-distance trade routes across the Sahara existed because:",
    "options": [
        "Climate shifts allowed movement between regions",
        "Cars were invented",
        "Ice bridges formed"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 284,
    "question": "Which mineral was traded across ancient Africa long before colonization?",
    "options": [
        "Gold",
        "Plastic",
        "Aluminum foil"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 285,
    "question": "Salt was valuable in ancient Africa because:",
    "options": [
        "It preserved food and was essential for survival",
        "It was decorative only",
        "It powered engines"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 286,
    "question": "The earliest agriculture in parts of Africa involved crops like:",
    "options": [
        "Sorghum and millet",
        "Potatoes",
        "Corn"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 287,
    "question": "The Congo Basin's ancient forest communities specialized in:",
    "options": [
        "Forest hunting and fishing technologies",
        "Ice fishing",
        "Wheat farming"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 288,
    "question": "Which environmental shift helped push humans toward more organized farming communities?",
    "options": [
        "Drying of the Sahara",
        "Ice covering Africa",
        "Constant rainfall everywhere"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 289,
    "question": "The deepest historical truth from ultra-ancient Africa is:",
    "options": [
        "Humanity's roots, innovation, and migrations began here",
        "Africa entered history late",
        "Civilization was imported"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 290,
    "question": "Which is considered one of the earliest urban centers in West Africa (1st millennium BCE)?",
    "options": [
        "Jenné-Jeno",
        "Paris",
        "Rome"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 291,
    "question": "Jenné-Jeno is located in present-day:",
    "options": [
        "Mali",
        "Ghana",
        "Sudan"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 292,
    "question": "The Nok culture (1000 BCE-300 CE) is important because it shows early:",
    "options": [
        "Iron smelting and urban settlement",
        "Roman colonization",
        "European trade posts"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 293,
    "question": "Which ancient East African city became a major trade center linking Africa to Arabia and India?",
    "options": [
        "Aksum",
        "Berlin",
        "Lisbon"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 294,
    "question": "Aksum is located in modern-day:",
    "options": [
        "Ethiopia",
        "Kenya",
        "Chad"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 295,
    "question": "Great Zimbabwe (11th-15th century CE) is known for:",
    "options": [
        "Massive stone architecture built without mortar",
        "Roman ruins",
        "Glass skyscrapers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 296,
    "question": "Which early Sahelian urban center thrived from trans-Saharan trade?",
    "options": [
        "Gao",
        "Madrid",
        "Venice"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 297,
    "question": "The rise of early cities south of the Sahara was closely linked to:",
    "options": [
        "Trade and iron technology",
        "Ice farming",
        "Oil drilling"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 298,
    "question": "Which civilization built large earthen mounds in West Africa?",
    "options": [
        "Igbo-Ukwu region societies",
        "Vikings",
        "Persians"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 299,
    "question": "Early African cities often developed near:",
    "options": [
        "Rivers and trade routes",
        "Glaciers",
        "Deserts with no water"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 300,
    "question": "Which ocean winds made long-distance Indian Ocean trade possible?",
    "options": [
        "Monsoon winds",
        "Tornado currents",
        "Polar winds"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 301,
    "question": "Swahili Coast city-states traded with:",
    "options": [
        "Arabia, India, and Persia",
        "Antarctica",
        "South America only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 302,
    "question": "Which material was exported from East Africa across the Indian Ocean?",
    "options": [
        "Gold and ivory",
        "Coal",
        "Oil engines"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 303,
    "question": "Madagascar shows evidence of early navigation because:",
    "options": [
        "It has both African and Southeast Asian cultural roots",
        "It was empty until Europe arrived",
        "It is attached to Africa"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 304,
    "question": "Ancient Egyptian ships sailed mainly on:",
    "options": [
        "The Nile and Red Sea",
        "Atlantic Ocean",
        "Arctic Ocean"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 305,
    "question": "Which West African empire may have attempted Atlantic voyages before Columbus?",
    "options": [
        "Mali under Mansa Abu Bakr II",
        "Roman Empire",
        "Ottoman Empire"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 306,
    "question": "Swahili architecture shows influence from:",
    "options": [
        "African and Indian Ocean cultures",
        "Vikings",
        "Aztecs"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 307,
    "question": "East African dhow ships were powered by:",
    "options": [
        "Wind in triangular sails",
        "Steam engines",
        "Oil motors"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 308,
    "question": "Which African sea is central to early maritime trade?",
    "options": [
        "Red Sea",
        "Baltic Sea",
        "Black Sea"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 309,
    "question": "Ancient African maritime trade demonstrates:",
    "options": [
        "Africa was connected to global networks long before Europe dominated oceans",
        "Africa was isolated",
        "Oceans were not used"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 310,
    "question": "Which megalithic site in Kenya aligns with star systems?",
    "options": [
        "Namoratunga",
        "Stonehenge",
        "Colosseum"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 311,
    "question": "Ancient Nile societies tracked:",
    "options": [
        "Sirius star cycles to predict floods",
        "GPS satellites",
        "Electric clocks"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 312,
    "question": "Dogon traditions (Mali) are associated with knowledge of:",
    "options": [
        "Sirius star system",
        "Mars rovers",
        "Satellites"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 313,
    "question": "Prehistoric stone circles across the Sahara likely tracked:",
    "options": [
        "Solar and seasonal changes",
        "Stock markets",
        "Internet signals"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 314,
    "question": "Astronomy in early Africa was closely linked to:",
    "options": [
        "Agriculture and flooding cycles",
        "Oil drilling",
        "Industrial factories"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 315,
    "question": "Which African culture used shadow tracking to measure time?",
    "options": [
        "Nile Valley societies",
        "Vikings",
        "Romans"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 316,
    "question": "Rock art sometimes shows:",
    "options": [
        "Celestial symbols",
        "Airplanes",
        "Modern weapons"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 317,
    "question": "Prehistoric sky observation helped determine:",
    "options": [
        "Planting seasons",
        "Car prices",
        "Engine designs"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 318,
    "question": "Astronomical alignment of structures shows:",
    "options": [
        "Mathematical and observational knowledge",
        "Random building",
        "Foreign instruction"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 319,
    "question": "Early African astronomy demonstrates:",
    "options": [
        "Scientific thinking long before modern science labels",
        "Absence of knowledge",
        "Imported intelligence"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 320,
    "question": "The Senegambian stone circles are located in:",
    "options": [
        "Senegal and The Gambia",
        "Spain",
        "Germany"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 321,
    "question": "These stone circles date back approximately:",
    "options": [
        "1,000-1,500 years ago",
        "100 years ago",
        "10,000 years ago"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 322,
    "question": "Ikom monoliths are found in:",
    "options": [
        "Nigeria",
        "Morocco",
        "Ethiopia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 323,
    "question": "Many West African megaliths were likely used for:",
    "options": [
        "Burial and ritual purposes",
        "Skyscrapers",
        "Airports"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 324,
    "question": "These sites show evidence of:",
    "options": [
        "Organized labor and engineering",
        "Random stone drops",
        "Natural accidents"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 325,
    "question": "Early Saharan pastoral societies valued cattle as:",
    "options": [
        "Wealth and status",
        "Toys",
        "Decoration only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 326,
    "question": "Rock art in the Sahara often depicts:",
    "options": [
        "Large cattle herds",
        "Snowstorms",
        "Factories"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 327,
    "question": "Nilotic cultures historically measured wealth by:",
    "options": [
        "Cattle ownership",
        "Paper money",
        "Oil wells"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 328,
    "question": "Pastoral mobility allowed societies to:",
    "options": [
        "Adapt to climate change",
        "Avoid trade",
        "Freeze in place"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 329,
    "question": "Domestication of cattle in Africa began roughly:",
    "options": [
        "8,000-10,000 years ago",
        "500 years ago",
        "100 years ago"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 330,
    "question": "During the Last Glacial Maximum (about 20,000 years ago), Africa was generally:",
    "options": [
        "Cooler and drier",
        "Tropical everywhere",
        "Frozen solid"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 331,
    "question": "Lower sea levels during the Ice Age made travel between Africa and Arabia:",
    "options": [
        "Easier",
        "Impossible",
        "Unnecessary"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 332,
    "question": "Lake levels across Africa during ice ages often:",
    "options": [
        "Rose and fell dramatically",
        "Stayed constant",
        "Disappeared forever"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 333,
    "question": "Ice Age pressures likely encouraged humans to:",
    "options": [
        "Innovate tools and social cooperation",
        "Stop adapting",
        "Disappear"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 334,
    "question": "Which region remained habitable refuges during harsher climate periods?",
    "options": [
        "East African highlands",
        "Sahara core",
        "Antarctica"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 335,
    "question": "Genetic bottlenecks in human populations may have been influenced by:",
    "options": [
        "Climate stress during ice ages",
        "Social media",
        "Electricity shortages"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 336,
    "question": "Coastal migration routes were important because:",
    "options": [
        "Marine resources supported survival",
        "Ice blocked oceans",
        "There was no food inland"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 337,
    "question": "Ice Age Africa shows that humans were:",
    "options": [
        "Highly adaptable to extreme conditions",
        "Static and unchanging",
        "Technologically helpless"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 338,
    "question": "Shifts between wet and dry periods shaped:",
    "options": [
        "Human migration patterns",
        "Modern borders",
        "Oil pipelines"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 339,
    "question": "The lesson from Ice Age Africa is:",
    "options": [
        "Innovation and adaptation are ancient African strengths",
        "Survival was accidental",
        "Civilization began elsewhere"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 340,
    "question": "Around 9,000 years ago, much of the Sahara was:",
    "options": [
        "Grassland with lakes",
        "Ice covered",
        "Urban cities"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 341,
    "question": "Rock art in the central Sahara shows people:",
    "options": [
        "Swimming and herding cattle",
        "Driving chariots",
        "Mining oil"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 342,
    "question": "Early domesticated African crops included:",
    "options": [
        "Sorghum and millet",
        "Wheat from Europe",
        "Potatoes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 343,
    "question": "Pastoralism expanded across North Africa mainly because:",
    "options": [
        "Climate supported grazing lands",
        "Oil was discovered",
        "Europe demanded cattle"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 344,
    "question": "The drying of the Sahara pushed populations toward:",
    "options": [
        "Nile Valley and Sahel",
        "Antarctica",
        "Arctic"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 345,
    "question": "Which region became a major population refuge as Sahara dried?",
    "options": [
        "Lake Chad Basin",
        "Greenland",
        "Pacific Islands"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 346,
    "question": "Early Saharan societies likely organized around:",
    "options": [
        "Cattle wealth",
        "Paper money",
        "Industrial goods"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 347,
    "question": "Climate drying began around:",
    "options": [
        "5,000-6,000 years ago",
        "500 years ago",
        "100 years ago"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 348,
    "question": "Ancient Saharan lakes are proven by:",
    "options": [
        "Fossil fish remains in desert",
        "Modern cities",
        "Satellite towers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 349,
    "question": "The shift from hunting to herding in North Africa shows:",
    "options": [
        "Adaptive survival strategies",
        "Technological collapse",
        "Isolation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 350,
    "question": "One of the earliest ironworking regions in West Africa was:",
    "options": [
        "Nok region (Nigeria)",
        "Rome",
        "Japan"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 351,
    "question": "Iron tools allowed:",
    "options": [
        "Forest clearing and farming expansion",
        "Space travel",
        "Ice fishing"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 352,
    "question": "The Bantu expansion began roughly:",
    "options": [
        "3,000-4,000 years ago",
        "1,000 years ago",
        "10,000 years ago"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 353,
    "question": "The Bantu expansion spread:",
    "options": [
        "Agriculture and iron technology",
        "Roman law",
        "European currency"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 354,
    "question": "Gold mining in West Africa dates back:",
    "options": [
        "Over 2,000 years",
        "200 years",
        "50 years"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 355,
    "question": "Salt from the Sahara became valuable because:",
    "options": [
        "It preserved food and maintained health",
        "It was decorative",
        "It powered engines"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 356,
    "question": "Early trans-Saharan trade connected West Africa to:",
    "options": [
        "North Africa and Mediterranean",
        "Antarctica",
        "South America"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 357,
    "question": "The spread of iron helped population growth because it:",
    "options": [
        "Increased food production",
        "Reduced rainfall",
        "Eliminated trade"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 358,
    "question": "Which early West African site shows complex metalwork and trade?",
    "options": [
        "Igbo-Ukwu",
        "London",
        "Madrid"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 359,
    "question": "Igbo-Ukwu artifacts date roughly to:",
    "options": [
        "Around 1,000 years ago",
        "100 years ago",
        "5 years ago"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 360,
    "question": "The Kingdom of Aksum flourished around:",
    "options": [
        "100-900 CE",
        "1500 CE",
        "1800 CE"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 361,
    "question": "Aksum controlled trade between:",
    "options": [
        "Africa, Arabia, and India",
        "Europe and Antarctica",
        "Americas only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 362,
    "question": "Swahili Coast city-states grew wealthy from:",
    "options": [
        "Indian Ocean trade",
        "Oil drilling",
        "European colonization"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 363,
    "question": "Gold from West Africa influenced economies in:",
    "options": [
        "North Africa and Middle East",
        "Japan only",
        "Australia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 364,
    "question": "Which Sahelian city became an early center of trade?",
    "options": [
        "Gao",
        "Paris",
        "Oslo"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 365,
    "question": "The rise of camel caravans transformed:",
    "options": [
        "Trans-Saharan trade",
        "Arctic exploration",
        "Pacific navigation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 366,
    "question": "Camels became crucial because they:",
    "options": [
        "Survived long desert journeys",
        "Produced iron",
        "Built roads"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 367,
    "question": "By 1,000 years ago, West Africa was exporting:",
    "options": [
        "Gold, kola nuts, and ivory",
        "Oil engines",
        "Plastic"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 368,
    "question": "The drying Sahara indirectly caused:",
    "options": [
        "Creation of trade networks across it",
        "Isolation of Africa",
        "Ocean freezing"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 369,
    "question": "By 1,000 years ago, Africa had:",
    "options": [
        "Complex trade states and regional economies",
        "No trade systems",
        "No cities"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 370,
    "question": "In many Nilotic societies, cattle symbolized:",
    "options": [
        "Wealth and marriage alliances",
        "Toys",
        "Military weapons"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 371,
    "question": "Cattle-based societies developed strong traditions of:",
    "options": [
        "Oral history",
        "Printing presses",
        "Oil exports"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 372,
    "question": "The Sahel became a cultural bridge between:",
    "options": [
        "North and West Africa",
        "Europe and Antarctica",
        "China and Australia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 373,
    "question": "Pastoral mobility allowed adaptation to:",
    "options": [
        "Seasonal rainfall shifts",
        "Snowstorms",
        "Industrial collapse"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 374,
    "question": "The cultural memory of cattle wealth still influences parts of:",
    "options": [
        "East Africa",
        "Scandinavia",
        "Canada"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 375,
    "question": "By 1,000 years ago, West African states had developed:",
    "options": [
        "Tax systems",
        "Nuclear reactors",
        "Satellites"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 376,
    "question": "Oral historians in West Africa are known as:",
    "options": [
        "Griots",
        "Vikings",
        "Senators"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 377,
    "question": "Early Sahelian states relied heavily on:",
    "options": [
        "Trade taxation",
        "Oil",
        "Ice"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 378,
    "question": "The drying Sahara strengthened:",
    "options": [
        "River-based civilizations",
        "Polar routes",
        "Arctic settlements"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 379,
    "question": "Around 1,000 years ago, West Africa's gold helped:",
    "options": [
        "Fuel Mediterranean economies",
        "Build Roman roads",
        "Colonize Antarctica"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 380,
    "question": "Between 10,000 and 1,000 years ago, Africa saw:",
    "options": [
        "Agricultural, technological, and urban revolutions",
        "No development",
        "Isolation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 381,
    "question": "Ironworking allowed expansion into:",
    "options": [
        "Forest zones",
        "Arctic tundra",
        "Antarctica"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 382,
    "question": "The Sahel became powerful because it controlled:",
    "options": [
        "Gold-salt trade routes",
        "Ice",
        "Coal"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 383,
    "question": "Indian Ocean trade shows Africa was:",
    "options": [
        "Globally connected",
        "Isolated",
        "Dependent only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 384,
    "question": "Urban growth south of the Sahara shows:",
    "options": [
        "Indigenous state formation",
        "Imported governance only",
        "Absence of organization"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 385,
    "question": "The Bantu expansion reshaped:",
    "options": [
        "Language and agriculture across sub-Saharan Africa",
        "Arctic cultures",
        "European law"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 386,
    "question": "Lake-based societies thrived because of:",
    "options": [
        "Fishing and fertile soils",
        "Snow",
        "Oil"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 387,
    "question": "Cattle culture influenced:",
    "options": [
        "Social structure and identity",
        "Banking systems",
        "Factories"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 388,
    "question": "Gold mining in West Africa predates:",
    "options": [
        "European arrival",
        "African settlement",
        "Iron use"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 389,
    "question": "Between 10,000 and 1,000 years ago, Africa demonstrated:",
    "options": [
        "Continuous innovation and adaptation",
        "Stagnation",
        "Dependency"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 390,
    "question": "Around 20,000 years ago, Africa was mostly:",
    "options": [
        "Cooler and drier with habitable refuges",
        "Completely frozen",
        "Fully urbanized"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},

{
    "id": 392,
    "question": "African coastal populations survived partly by relying on:",
    "options": [
        "Marine resources",
        "Wheat farming",
        "Iron tools"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},

{
    "id": 393,
    "question": "Around 10,000 years ago, parts of the Sahara were:",
    "options": [
        "Green with lakes and wildlife",
        "Permanent desert",
        "Glaciers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},

{
    "id": 397,
    "question": "The global shift happening on multiple continents was:",
    "options": [
        "From hunting to agriculture",
        "From agriculture to oil",
        "From cities to caves"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 398,
    "question": "Around 5,000 years ago, drying of the Sahara pushed people toward:",
    "options": [
        "The Nile and Sahel",
        "Antarctica",
        "Pacific Islands"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 399,
    "question": "River valleys globally (Nile, Tigris-Euphrates, Indus) were important because they:",
    "options": [
        "Supported early civilizations",
        "Produced coal",
        "Froze over"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 400,
    "question": "Around 3,000 years ago, parts of West Africa began developing:",
    "options": [
        "Iron technology",
        "Airplanes",
        "Nuclear reactors"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 401,
    "question": "Iron technology allowed African societies to:",
    "options": [
        "Expand agriculture and settlement",
        "Build satellites",
        "Freeze deserts"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 402,
    "question": "Across continents, iron tools generally led to:",
    "options": [
        "Population growth",
        "Ice ages",
        "Global collapse"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 403,
    "question": "Around 2,000 years ago, the Kingdom of Aksum controlled trade between:",
    "options": [
        "Africa, Arabia, and India",
        "Americas and Asia",
        "Europe and Antarctica"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},


{
    "id": 406,
    "question": "Around 1,000 years ago, West African states were growing wealthy from:",
    "options": [
        "Gold-salt trade",
        "Oil drilling",
        "European factories"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 407,
    "question": "Swahili Coast cities were trading with:",
    "options": [
        "Arabia, India, and Persia",
        "Americas only",
        "Arctic regions"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 408,
    "question": "Songhai and Ghana (empire) rose because they controlled:",
    "options": [
        "Strategic trade routes",
        "Ice roads",
        "Steam engines"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 409,
    "question": "Around 1,000 years ago, Africa and Asia were connected through:",
    "options": [
        "Indian Ocean maritime networks",
        "Atlantic cable",
        "Air travel"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 410,
    "question": "When Africa developed iron technology, other continents were:",
    "options": [
        "Also entering iron-based societies",
        "Using computers",
        "In space"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 411,
    "question": "When Africa built early cities south of the Sahara, Europe was mostly:",
    "options": [
        "In medieval kingdoms",
        "Industrial",
        "Democratic republics"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 412,
    "question": "African gold played a major role in:",
    "options": [
        "Mediterranean monetary systems",
        "Arctic trade",
        "American colonization (at that time)"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 413,
    "question": "The idea that Africa was isolated before colonization is incorrect because:",
    "options": [
        "It had trans-Saharan and Indian Ocean trade networks",
        "It had no trade",
        "Oceans blocked movement"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 414,
    "question": "The global historical pattern shows that:",
    "options": [
        "Africa developed alongside other continents, not behind them",
        "Africa entered history late",
        "Civilization was imported"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": ""
},
{
    "id": 415,
    "question": "Did Sub-Saharan Africa have cities before medieval Europe?",
    "options": [
        "No, Africa was mostly villages",
        "Yes, but only after Europeans arrived",
        "Yes, long before many European urban centers"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Cities like Djenné-Djenno (c. 250 BCE) were already thriving with planned neighborhoods and trade networks when much of northern Europe was still rural. Meanwhile, places like London would decline after Roman withdrawal and shrink dramatically for centuries. West Africa had iron production, trade specialization, and dense urban clusters early on. Africa wasn't “late.” It was on its own timeline."
},
{
    "id": 416,
    "question": "Did Africans independently invent iron smelting?",
    "options": [
        "No, it came only from the Middle East",
        "Yes, in multiple regions",
        "Only in North Africa"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Sites like Nok (c. 1000 BCE) and iron-working areas in central Africa suggest independent development. Some furnaces in West Africa predate similar European examples. Iron technology spread differently across continents — Africa wasn't just copying."
},
{
    "id": 417,
    "question": "Was medieval Europe always more literate than Africa?",
    "options": [
        "Yes",
        "No",
        "They were about equal everywhere"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "In the 14th-16th centuries, Timbuktu housed tens of thousands of manuscripts. The University of Sankore attracted scholars from across the Islamic world. At the same time, literacy in much of Europe was limited to clergy and elites. Manuscript culture in West Africa was real, advanced, and global."
},
{
    "id": 418,
    "question": "Did Africans engage in long-distance ocean trade before Europeans rounded Africa?",
    "options": [
        "No",
        "Yes, across the Indian Ocean",
        "Only across the Sahara"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Swahili city-states like Kilwa Kisiwani traded gold, ivory, and textiles with Arabia, Persia, India, and China. Coins from China have been found there. This wasn't isolation — it was integration into global networks centuries before Portuguese arrival."
},
{
    "id": 419,
    "question": "Were African political systems always “tribal” and simple?",
    "options": [
        "Yes",
        "No, some were highly centralized states",
        "Only Egypt had complex government"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Kingdom of Benin had structured bureaucracy, urban planning, diplomatic missions to Europe, and sophisticated art casting. The Ethiopian Empire maintained written law codes and imperial administration for centuries. “Tribal” is a lazy word. Governance varied, just like anywhere else."
},
{
    "id": 420,
    "question": "Did Africa contribute to global mathematics?",
    "options": [
        "No",
        "Yes, including number systems and geometry",
        "Only through Egypt"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Ancient Egypt used a decimal system, while Nubia and later Islamic North Africa transmitted mathematical knowledge into Europe. The Ishango bone (20,000+ years old) may represent one of the earliest tally systems known. African contributions didn't stop at pyramids."
},
{
    "id": 421,
    "question": "Was the Sahara always a barrier?",
    "options": [
        "Yes",
        "No, it was once green and inhabited",
        "Only caravans crossed it"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "During the African Humid Period (roughly 14,500-5,000 years ago), the Sahara was grassland with lakes and settlements. Rock art in places like Tassili n'Ajjer shows cattle herders and wildlife. The desert we imagine today is relatively recent in human history."
},
{
    "id": 422,
    "question": "Were African civilizations isolated from each other?",
    "options": [
        "Yes",
        "No, trade and migration linked regions",
        "Only North Africa had connections"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Gold from West Africa fueled Mediterranean economies. The Mali Empire controlled major trade routes linking forest zones to North Africa. East Africa connected to Arabia and India. Southern Africa traded inland gold to the coast near Great Zimbabwe. Africa was internally connected long before colonial borders."
},
{
    "id": 423,
    "question": "Did Europeans “discover” African states?",
    "options": [
        "Yes",
        "No, they encountered established powers",
        "Africa had no states"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "When the Portuguese arrived in the 15th century, they met organized states: Kongo Kingdom, Benin, Ethiopia, Mali. They didn't find emptiness. They negotiated treaties. The narrative of “discovery” ignores African agency."
},
{
    "id": 424,
    "question": "Was Africa technologically stagnant before colonialism?",
    "options": [
        "Yes",
        "No",
        "It depended entirely on imports"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Metallurgy, architecture (Great Zimbabwe's dry stone engineering), terraced agriculture in Ethiopia, complex irrigation in the Sahel — innovation adapted to environment. Technology doesn't mean “steam engine.” It means solving local problems effectively. Different environments → different solutions."
},
{
    "id": 425,
    "question": "Why could European powers colonize Africa so rapidly in the 19th century?",
    "options": [
        "Africans were “uncivilized” and weak",
        "Industrialized weaponry and naval power gave Europe an advantage",
        "Africa had no political structures"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "African societies were advanced, with armies, trade networks, and cities. The imbalance came from industrialization, steamships, and modern firearms. It wasn't ignorance or lack of sophistication — it was technology mismatch created by Europe's industrial revolution."
},
{
    "id": 426,
    "question": "Why did Europeans push Africa into cash-crop economies?",
    "options": [
        "To help African farmers modernize",
        "To extract wealth for European markets",
        "Africans demanded industrial jobs"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Colonial policies prioritized export crops like cocoa, cotton, and rubber, which enriched Europe while limiting diverse local economies. Africans were producing, but for foreign profit, not internal development."
},
{
    "id": 427,
    "question": "Why were African borders drawn poorly by colonial powers?",
    "options": [
        "Africans had no say in local territories",
        "Geography was unknown",
        "Europeans wanted to preserve natural tribal lands"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "European negotiators at the Berlin Conference drew borders with no African input, splitting ethnic groups and merging rivals. This created long-term governance challenges — a deliberate tool for easier control."
},
{
    "id": 428,
    "question": "Why did the slave trade weaken African political structures before colonization?",
    "options": [
        "Africans weren't political",
        "It destabilized societies and economies",
        "Europeans taught them governance"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The transatlantic slave trade (15th-19th centuries) removed millions of young and able people, incentivized warfare to capture captives, and weakened kingdoms, making some regions more vulnerable to later European conquest."
},
{
    "id": 429,
    "question": "How did European control of currency affect African economies?",
    "options": [
        "Africans had full control of their money",
        "Colonies were forced to use currencies like the CFA franc",
        "Currency had no effect"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "West and Central African colonies used the CFA franc, tied to France, which limited monetary sovereignty. Economies were structured to serve European needs, not local development. Money stayed linked to foreign interests."
},
{
    "id": 430,
    "question": "Why did technological gaps matter in the 19th century?",
    "options": [
        "Africa had the same technology as Europe",
        "Steam engines, railroads, and firearms gave Europeans rapid mobility",
        "Technology had no impact"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "African states had strong armies and trade, but Europeans arrived with ironclad ships, repeating rifles, and rapid logistics, giving them strategic advantages. The gap was industrial, not intellectual or cultural."
},
{
    "id": 431,
    "question": "Why were African resistance movements often localized?",
    "options": [
        "Africa had no leadership",
        "Europeans exploited tribal and regional divisions",
        "Africans didn't care about independence"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Colonial powers often used divide-and-rule strategies, fostering local rivalries to prevent unified resistance. Leaders like Samori Ture fought fiercely but were limited by geopolitical fragmentation created by European manipulation."
},
{
    "id": 432,
    "question": "Why did Africa lose control of its natural resources?",
    "options": [
        "Africans didn't know the value of gold, rubber, or minerals",
        "Europeans set up mining and export systems directly controlled from Europe",
        "The land was empty"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "European companies and colonial administrations took over mining, controlling extraction, labor, and transport. African communities saw little benefit, even if the resources came from their own territories."
},
{
    "id": 433,
    "question": "Why was African knowledge often ignored by Europeans?",
    "options": [
        "Africans had no knowledge",
        "Europeans dismissed local science and engineering as “primitive”",
        "African knowledge didn't exist"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Systems like irrigation in the Sahel, metallurgy in Nok, and urban planning in Great Zimbabwe were devalued in colonial narratives. Europeans framed history to justify control — even when Africa had proven technological sophistication."
},
{
    "id": 434,
    "question": "How did global competition influence African colonization?",
    "options": [
        "Africa was the only target",
        "The scramble for colonies was driven by European rivalries and industrial needs",
        "Africa asked to be colonized"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Colonization wasn't “inevitable.” European powers sought markets, raw materials, and prestige. Africa's advanced societies were simply caught in a global race for resources, not “behind” the rest of the world."
},
{
    "id": 435,
    "question": "Which is the largest land animal on Earth today?",
    "options": [
        "Asian Elephant",
        "African Forest Elephant",
        "African Savanna Elephant"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "The African bush elephant (also called African savanna elephant) is the largest land animal on Earth. Bulls can weigh over 6,000 kg. Africa doesn't just have big animals — it has the biggest."
},
{
    "id": 436,
    "question": "Which African animal has two different species — one critically endangered and one declared extinct in the wild?",
    "options": [
        "Giraffe",
        "Rhino",
        "Hippopotamus"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Northern white rhinoceros is functionally extinct in the wild. Only two females remain alive. Its relative, the southern white rhino, survives but remains vulnerable."
},
{
    "id": 437,
    "question": "Which African animal has the highest blood pressure on Earth?",
    "options": [
        "Lion",
        "Giraffe",
        "Ostrich"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Giraffe evolved extremely high blood pressure to pump blood up its long neck to its brain. Without that adaptation, it would faint every time it lowered its head."
},
{
    "id": 438,
    "question": "What is Africa's largest reptile?",
    "options": [
        "Nile Monitor",
        "Nile Crocodile",
        "African Rock Python"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Nile crocodile can grow over 6 meters long. It has existed in near-modern form for millions of years. It is one of Africa's oldest surviving apex predators."
},
{
    "id": 439,
    "question": "Which African animal once had a striped front half but plain brown back half — and is now extinct?",
    "options": [
        "Okapi",
        "Quagga",
        "Bongo"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Quagga was a zebra subspecies hunted to extinction in the 19th century in southern Africa. It looked half-zebra, half-horse."
},
{
    "id": 440,
    "question": "Which African predator once had a much wider range — stretching into Europe and Asia?",
    "options": [
        "Cheetah",
        "African Wild Dog",
        "Lion"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "The Lion once roamed across Africa, the Middle East, India, and parts of Europe. Today, its range has dramatically shrunk due to habitat loss and hunting."
},
{
    "id": 441,
    "question": "Which giant prehistoric animal lived in North Africa during wetter periods of the Sahara?",
    "options": [
        "Woolly Mammoth",
        "Giant Buffalo (Pelorovis)",
        "Saber-Tooth Tiger"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The extinct Pelorovis roamed Africa thousands of years ago. During the “Green Sahara” period, the desert was grassland supporting massive herds."
},
{
    "id": 442,
    "question": "Which great ape is found only in Central Africa and shares about 98% of human DNA?",
    "options": [
        "Orangutan",
        "Gorilla",
        "Gibbon"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Western lowland gorilla and other gorilla species are native to Africa. Humans share about 98% of our DNA with them — Africa is literally the cradle of our biological relatives."
},
{
    "id": 443,
    "question": "Which African big cat is the fastest land animal on Earth?",
    "options": [
        "Leopard",
        "Cheetah",
        "Caracal"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Cheetah can reach speeds of up to 100-120 km/h in short bursts. It evolved on open African savannas built for speed."
},
{
    "id": 444,
    "question": "Which large African bird cannot fly but can outrun most humans?",
    "options": [
        "Secretary Bird",
        "Ostrich",
        "Crowned Crane"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Common ostrich is the world's largest bird. It can sprint at 70 km/h and delivers powerful kicks strong enough to defend against predators."
},
{
    "id": 445,
    "question": "Which of these was one of the largest carnivorous dinosaurs ever discovered — found in North Africa?",
    "options": [
        "Tyrannosaurus rex",
        "Spinosaurus",
        "Allosaurus"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Spinosaurus lived in what is now Morocco and Egypt about 95 million years ago. It may have been longer than T. rex and was semi-aquatic — built to hunt in rivers."
},
{
    "id": 446,
    "question": "Which massive prehistoric crocodile lived in the Sahara?",
    "options": [
        "Deinosuchus",
        "Sarcosuchus",
        "Kaprosuchus"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Sarcosuchus — nicknamed “SuperCroc” — could grow over 11 meters long. It lived when the Sahara was a river system."
},
{
    "id": 447,
    "question": "Which giant elephant ancestor once roamed North Africa?",
    "options": [
        "Mammuthus",
        "Deinotherium",
        "Stegodon"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Deinotherium had downward-curving tusks and was larger than modern elephants."
},
{
    "id": 448,
    "question": "During the “Green Sahara” period, which animals lived there?",
    "options": [
        "Polar bears",
        "Hippos and giraffes",
        "Penguins"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Between 5,000-10,000 years ago, the Sahara had lakes, grasslands, hippos, and crocodiles."
},
{
    "id": 449,
    "question": "Which early human species lived in Africa over 300,000 years ago?",
    "options": [
        "Homo erectus",
        "Homo sapiens",
        "Neanderthal"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Homo sapiens originated in Africa."
},
{
    "id": 450,
    "question": "Which saber-toothed predator lived in Africa?",
    "options": [
        "Smilodon",
        "Panthera leo",
        "Hyaenodon"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Smilodon fossils have been found in Africa."
},
{
    "id": 451,
    "question": "Which extinct giant buffalo once roamed Africa?",
    "options": [
        "Syncerus",
        "Pelorovis",
        "Bos primigenius"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Pelorovis was massive, with enormous horns."
},
{
    "id": 452,
    "question": "Which ancient fish fossil found in Morocco is over 400 million years old?",
    "options": [
        "Coelacanth",
        "Lungfish",
        "Arapaima"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Coelacanth is called a “living fossil.”"
},
{
    "id": 453,
    "question": "Which prehistoric hyena was much larger than modern ones?",
    "options": [
        "Crocuta crocuta",
        "Pachycrocuta",
        "Striped hyena"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Pachycrocuta was one of the largest hyenas ever."
},
{
    "id": 454,
    "question": "Which desert today hides fossils of giant ancient rivers?",
    "options": [
        "Kalahari",
        "Sahara",
        "Namib"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Sahara once had flowing rivers feeding into the Atlantic."
},
{
    "id": 455,
    "question": "Which giant ape species lived in Africa before modern humans spread widely?",
    "options": [
        "Australopithecus",
        "Gorilla",
        "Gigantopithecus"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Australopithecus walked upright millions of years ago."
},
{
    "id": 456,
    "question": "Which African site preserves early hominin fossils?",
    "options": [
        "Olduvai Gorge",
        "Stonehenge",
        "Machu Picchu"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Olduvai Gorge is one of the most important human evolution sites."
},
{
    "id": 457,
    "question": "Which snake is Africa's fastest?",
    "options": [
        "Puff Adder",
        "Black Mamba",
        "Boomslang"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Black mamba can move up to 20 km/h."
},
{
    "id": 458,
    "question": "Which snake has venom that destroys tissue?",
    "options": [
        "Puff Adder",
        "Green Mamba",
        "Python"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Puff adder has cytotoxic venom."
},
{
    "id": 459,
    "question": "Which spider is highly venomous in Southern Africa?",
    "options": [
        "Tarantula",
        "Button Spider",
        "Wolf Spider"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Black widow spider relatives exist in Africa (button spiders)."
},
{
    "id": 460,
    "question": "Which scorpion is among Africa's most dangerous?",
    "options": [
        "Emperor Scorpion",
        "Deathstalker",
        "Forest Scorpion"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Deathstalker has potent venom."
},
{
    "id": 461,
    "question": "Which African fish can electrocute prey?",
    "options": [
        "Electric eel",
        "Electric catfish",
        "Tigerfish"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Electric catfish produces electric shocks."
},
{
    "id": 462,
    "question": "Which river contains over 1,000 fish species?",
    "options": [
        "Nile",
        "Congo",
        "Niger"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Congo River has extreme biodiversity."
},
{
    "id": 463,
    "question": "Which large freshwater predator is famous in the Congo?",
    "options": [
        "Nile Perch",
        "Goliath Tigerfish",
        "Catfish"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Goliath tigerfish has massive teeth."
},
{
    "id": 464,
    "question": "Which African coastline hosts some of the world's oldest coral reefs?",
    "options": [
        "Somali Coast",
        "Kenyan Coast",
        "Moroccan Coast"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Kenyan Coast supports ancient reef systems."
},
{
    "id": 465,
    "question": "Which desert animal can survive without drinking water for years?",
    "options": [
        "Fennec Fox",
        "Camel",
        "Oryx"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Oryx can survive extreme desert heat."
},
{
    "id": 466,
    "question": "Which lizard runs on two legs when escaping?",
    "options": [
        "Agama",
        "Basilisk",
        "Monitor"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Agama sometimes sprints upright."
},
{
    "id": 467,
    "question": "Which bird is associated with wisdom and kingship in parts of West Africa?",
    "options": [
        "Eagle",
        "Vulture",
        "Crowned Crane"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African fish eagle symbolizes strength and authority."
},
{
    "id": 468,
    "question": "Which bird performs elaborate ground dances and hunts snakes?",
    "options": [
        "Secretary Bird",
        "Ibis",
        "Hornbill"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Secretarybird stomps snakes to death."
},
{
    "id": 469,
    "question": "During early human evolution (over 200,000 years ago), which continent was the center of human development?",
    "options": [
        "Europe",
        "Asia",
        "Africa"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Homo sapiens evolved in Africa. Other continents were populated later through migration."
},
{
    "id": 470,
    "question": "During the age of giant land mammals (2 million-10,000 years ago), which continent had the highest megafauna diversity?",
    "options": [
        "South America",
        "Africa",
        "Australia"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Africa retained elephants, rhinos, hippos, and large predators while many other continents lost theirs after human arrival."
},
{
    "id": 471,
    "question": "Which continent still has the highest number of large land animals over 1,000 kg?",
    "options": [
        "North America",
        "Asia",
        "Africa"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Africa still hosts elephants, rhinos, hippos, and giraffes in the wild at scale."
},
{
    "id": 472,
    "question": "During the Cretaceous Period (age of dinosaurs), North Africa was dominated by:",
    "options": [
        "Ice sheets",
        "Dense jungle and river systems",
        "Grassland savanna"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Spinosaurus lived in massive river systems across what is now the Sahara."
},
{
    "id": 473,
    "question": "Which continent kept most of its large predator species after the Ice Age?",
    "options": [
        "Europe",
        "Africa",
        "North America"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Lions, hyenas, leopards, wild dogs — Africa retained them. Europe and North America lost many apex predators."
},
{
    "id": 474,
    "question": "Which continent experienced the least Ice Age glaciation?",
    "options": [
        "Europe",
        "North America",
        "Africa"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Africa remained largely ice-free during the Last Glacial Maximum, preserving ecosystems."
},
{
    "id": 475,
    "question": "Which continent has the longest continuous human fossil record?",
    "options": [
        "Asia",
        "Africa",
        "Europe"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Olduvai Gorge and many other African sites preserve millions of years of hominin fossils."
},
{
    "id": 476,
    "question": "Which continent contains the most genetically diverse human populations today?",
    "options": [
        "Europe",
        "Africa",
        "South America"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Africa holds the deepest human genetic diversity because humanity began there."
},
{
    "id": 477,
    "question": "When humans left Africa ~60,000 years ago, what happened to genetic diversity?",
    "options": [
        "It increased",
        "It stayed the same",
        "It decreased"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Small migrating groups carried only part of Africa's total diversity."
},
{
    "id": 478,
    "question": "Which continent preserved the largest uninterrupted savanna ecosystem?",
    "options": [
        "Australia",
        "Africa",
        "South America"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The African savanna remains the largest megafauna-supported grassland ecosystem on Earth."
},
{
    "id": 479,
    "question": "Which African country contains some of the oldest Homo sapiens fossils (~300,000 years old)?",
    "options": [
        "Ethiopia",
        "Morocco",
        "Kenya"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Jebel Irhoud contains some of the earliest known Homo sapiens fossils."
},
{
    "id": 480,
    "question": "Which region contains “Mitochondrial Eve” lineages?",
    "options": [
        "Southern Africa",
        "Scandinavia",
        "Siberia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Genetic studies trace the deepest maternal lineages to African populations."
},
{
    "id": 481,
    "question": "Which hominin species lived in East Africa before Homo sapiens?",
    "options": [
        "Neanderthal",
        "Australopithecus",
        "Denisovan"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Australopithecus lived millions of years ago in Africa."
},
{
    "id": 482,
    "question": "Which continent shows the greatest Y-chromosome diversity?",
    "options": [
        "Europe",
        "Africa",
        "Asia"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Africa contains the oldest paternal lineages."
},
{
    "id": 483,
    "question": "Which early human ancestor used stone tools in East Africa 2 million years ago?",
    "options": [
        "Homo habilis",
        "Homo sapiens",
        "Homo neanderthalensis"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Homo habilis is associated with Oldowan tools."
},
{
    "id": 484,
    "question": "Which African lake region shows continuous human settlement for tens of thousands of years?",
    "options": [
        "Lake Turkana",
        "Lake Baikal",
        "Lake Titicaca"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Lake Turkana is surrounded by major fossil and archaeological sites."
},
{
    "id": 485,
    "question": "Which African population has some of the most ancient genetic lineages?",
    "options": [
        "San people",
        "Inuit",
        "Basque"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The San (Khoisan) populations of southern Africa show very ancient genetic branches."
},
{
    "id": 486,
    "question": "Which extinct African zebra subspecies disappeared in the 19th century?",
    "options": [
        "Grevy's Zebra",
        "Quagga",
        "Mountain Zebra"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Quagga was hunted to extinction."
},
{
    "id": 487,
    "question": "Which African country hosts one of the largest elephant populations today?",
    "options": [
        "Botswana",
        "Spain",
        "Canada"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Botswana holds the world's largest elephant population."
},
{
    "id": 488,
    "question": "Which conservation model originated in Southern Africa?",
    "options": [
        "Community Conservancies",
        "Arctic Wildlife Zones",
        "Urban Zoo Farming"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Community-based wildlife management programs empower local populations to protect ecosystems."
},
{
    "id": 489,
    "question": "Which African river basin contains one of the largest rainforest carbon sinks?",
    "options": [
        "Amazon Basin",
        "Congo Basin",
        "Mississippi Basin"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Congo Basin rainforest absorbs massive amounts of carbon."
},
{
    "id": 490,
    "question": "Which African species was declared extinct in the wild but survives in protected areas?",
    "options": [
        "Dodo",
        "Northern White Rhino",
        "Passenger Pigeon"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Northern white rhinoceros survives only under intense protection."
},
{
    "id": 491,
    "question": "Which African country pioneered large transfrontier conservation parks?",
    "options": [
        "South Africa",
        "Iceland",
        "Japan"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "South Africa helped create massive cross-border wildlife corridors."
},
{
    "id": 492,
    "question": "Which desert shows evidence of repeated climate change cycles affecting wildlife?",
    "options": [
        "Gobi",
        "Sahara",
        "Mojave"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Sahara shifted between wet and dry phases, dramatically changing ecosystems."
},
{
    "id": 493,
    "question": "Who was Mobutu Sese Seko and why is he controversial?",
    "options": [
        "A nationalist leader who transitioned Congo to democracy",
        "A long-running ruler who enriched himself and seized power",
        "A freedom fighter defeated by colonial powers"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Mobutu Sese Seko seized power in a 1965 coup and ruled the Democratic Republic of the Congo (renamed Zaire under him) until 1997. His regime was marked by authoritarian rule, corruption, and personal enrichment while the country's economy and infrastructure declined. He also played a role in the political struggles following independence, including against Patrice Lumumba's faction."
},
{
    "id": 494,
    "question": "Blaise Compaoré is best known in Burkina Faso for:",
    "options": [
        "Leading economic reforms to empower local farmers",
        "Overthrowing and allegedly killing his ally, Thomas Sankara",
        "Establishing a lasting democratic tradition"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Blaise Compaoré came to power in 1987 in a coup that resulted in the assassination of then-President Thomas Sankara, his former friend and comrade. Compaoré ruled for nearly 27 years, but his tenure was marred by accusations of corruption, suppression of opposition, and betrayal of Sankara's revolutionary ideals. He was ousted in 2014."
},
{
    "id": 495,
    "question": "What is Jean-Bédel Bokassa most associated with?",
    "options": [
        "Peacebuilding across Central Africa",
        "Declaring himself emperor and extreme abuses",
        "Promoting pan-African unity"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Jean-Bédel Bokassa led the Central African Republic and later declared himself Emperor of the Central African Empire. His rule (1966-1979) was notorious for extravagance, human rights abuses, and violent repression of opponents, including children. (Common historical records detail abuses under his regime.)"
},
{
    "id": 496,
    "question": "The Nabongo of Wanga refers to:",
    "options": [
        "A colonial governor",
        "The hereditary king of the Wanga people",
        "A 20th-century military dictator"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Wanga are a community in western Kenya whose leaders hold the title Nabongo. The Nabongo dynasty is one of the oldest indigenous monarchies in Kenya, with a long history of governance, trade, and diplomacy in the Great Lakes region. (Historical records of the Wanga Kingdom attest to this.)"
},
{
    "id": 497,
    "question": "Semei Kakungulu was primarily known as:",
    "options": [
        "A Ugandan king who resisted British rule",
        "A local chief and military leader allied and later pivoting roles under colonial pressure",
        "A founder of modern Uganda's constitution"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Semei Kakungulu was a notable local leader in Uganda in the late 19th and early 20th centuries. He initially allied with the British in expanding their influence, helping them against rival kingdoms, but later became disillusioned. He ended up in conflict with those same powers in his later life. (Historical texts on Uganda's colonial period reference these dynamics.)"
},
{
    "id": 498,
    "question": "Senior Chief Waruhiu wa Kung'u is remembered for:",
    "options": [
        "Leading Kenya to independence",
        "Being assassinated after resisting colonial interference",
        "Collaborating with British colonial authorities without controversy"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Waruhiu wa Kung'u was a Kenyan chief who resisted British colonial authorities and was assassinated by colonial police in the 1950s — his death became a symbol of resistance during the struggle for independence. (Kenyan independence histories note his prominence and assassination.)"
},
{
    "id": 499,
    "question": "King Tegbesu's reign is notable for:",
    "options": [
        "Ending the Dahomey state",
        "Strengthening royal authority and diplomatic ties",
        "Abolishing the Dahomey army"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "King Tegbesu ruled the Kingdom of Dahomey (in present-day Benin) in the 18th century. He is credited with consolidating royal power, maintaining diplomatic and trade connections, and stabilizing the kingdom's institutions. (West African historical records describe Tegbesu's political role.)"
},
{
    "id": 500,
    "question": "Moïse Tshombe is best known for his role as:",
    "options": [
        "A revolutionary national hero throughout Africa",
        "Leader of Katanga secession and later Prime Minister",
        "Founder of the modern Congolese democratic system"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Moïse Tshombe was a Congolese leader who declared the mineral-rich province of Katanga independent after Congo's 1960 independence, sparking a major crisis. He later served as prime minister, but his legacy is controversial due to secessionism and reliance on foreign mercenaries."
},
{
    "id": 501,
    "question": "General E. K. Kotoka is historically associated with:",
    "options": [
        "Ghana's independence movement",
        "A coup that removed a civilian government",
        "Founding Ghana's first democratic constitution"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "E. K. Kotoka was a Ghanaian military officer involved in the 1966 coup that overthrew President Kwame Nkrumah. Kotoka played a key role in the change of government, marking a pivotal shift away from Nkrumah's leadership. (Ghana's political histories detail his involvement in the coup.)"
},
{
    "id": 502,
    "question": "Félix Houphouët-Boigny is best described as:",
    "options": [
        "A radical opponent of Western influence in Africa",
        "The first president of Ivory Coast who aligned with France",
        "A leader overthrown in a popular revolution"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Félix Houphouët-Boigny was the first president of Côte d'Ivoire after independence and maintained close ties with France. He supported Western alliances during the Cold War and established a pro-France policy that influenced regional politics."
},
{
    "id": 503,
    "question": "King Behanzin is remembered for:",
    "options": [
        "Collaborating with French colonial forces",
        "Leading resistance against French colonization",
        "Being appointed by colonial authorities"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Behanzin was a powerful ruler of Dahomey who fiercely resisted French colonization in the late 19th century. His royal house symbolizes resistance, not submission — he was eventually defeated but remains a national hero. (Benin historical sources affirm his resistance against French invasion.)"
},
{
    "id": 504,
    "question": "Which describes King Lewanika's historical role?",
    "options": [
        "Opposed all foreign treaties and maintained full independence",
        "Signed agreements with British South Africa Company for protection",
        "Began Zambia's modern democratic era"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Lewanika was the Lozi king in present-day Zambia who, in the late 19th century, signed treaties with European powers (notably the British South Africa Company) seeking protection. These deals later contributed to British colonial influence in the region. (Central African colonial histories discuss these treaties.)"
},
{
    "id": 505,
    "question": "The historical significance of Buganda's conflict with Bunyoro was about:",
    "options": [
        "Trade, territory, and influence among inland kingdoms",
        "Overthrowing European colonial rule",
        "Establishing a unified Uganda in 1900"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The long rivalry between the Kingdom of Buganda and the neighboring Bunyoro Kingdom focused on expanding territory and influence in the Great Lakes region before and during early colonial times. Control over land and trade routes was central, and colonial powers later manipulated these rivalries to their advantage. (East African pre-colonial histories describe Buganda-Bunyoro dynamics.)"
},
{
    "id": 506,
    "question": "The Fante Confederacy was:",
    "options": [
        "A cooperative alliance of states resisting foreign domination",
        "A colonial administrative unit",
        "A single hereditary monarchy"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Fante Confederacy was an alliance of Fante states in what is now Ghana that formed in the 19th century to resist both Asante incursions and European trade abuses. It represents indigenous political organization rather than puppet rule. (Ghanaian historical texts note this alliance's role in resistance.)"
},
{
    "id": 507,
    "question": "Why is Teodoro Obiang Nguema Mbasogo controversial?",
    "options": [
        "He peacefully stepped down after term limits",
        "He has ruled for decades with major human rights concerns",
        "He liberated his nation from foreign powers"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Teodoro Obiang Nguema Mbasogo has been president of Equatorial Guinea since 1982. His long rule has been criticized internationally for authoritarianism, limited political freedoms, and human rights abuses, while he and his inner circle maintain tight control over the state."
},
{
    "id": 508,
    "question": "Which African country has the most UNESCO World Heritage Sites?",
    "options": [
        "Egypt",
        "Ethiopia",
        "South Africa"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Egypt leads Africa in UNESCO World Heritage Sites, including ancient monuments, deserts, and coastal heritage zones."
},
{
    "id": 509,
    "question": "Which country has the longest coastline in Africa?",
    "options": [
        "Somalia",
        "South Africa",
        "Madagascar"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Somalia has the longest coastline in mainland Africa — over 3,000 km along the Indian Ocean and Gulf of Aden."
},
{
    "id": 510,
    "question": "Which African country has over 1,000 kilometers of Mediterranean beaches?",
    "options": [
        "Tunisia",
        "Morocco",
        "Libya"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Libya has one of the longest Mediterranean coastlines in Africa, much of it undeveloped."
},
{
    "id": 511,
    "question": "Which country is home to Africa's most visited national park?",
    "options": [
        "Kenya",
        "Tanzania",
        "South Africa"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Kruger National Park in South Africa receives the highest number of visitors annually."
},
{
    "id": 512,
    "question": "Which African country has over 2,500 km of tropical coastline with coral reefs?",
    "options": [
        "Mozambique",
        "Ghana",
        "Namibia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mozambique's coastline is one of Africa's richest marine tourism zones."
},
{
    "id": 513,
    "question": "Which country hosts Africa's largest stadium by capacity?",
    "options": [
        "Nigeria",
        "South Africa",
        "Egypt"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "FNB Stadium (Soccer City) in Johannesburg holds over 90,000 spectators."
},
{
    "id": 514,
    "question": "Which country is known for having the highest sand dunes in Africa?",
    "options": [
        "Namibia",
        "Algeria",
        "Egypt"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Namibia's Namib Desert contains some of the tallest sand dunes on Earth."
},
{
    "id": 515,
    "question": "Which country is famous for mountain gorilla trekking tourism?",
    "options": [
        "Uganda",
        "Rwanda",
        "Both A and B"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Both Uganda and Rwanda host mountain gorillas in protected highland forests."
},
{
    "id": 516,
    "question": "Which country has the largest inland delta in the world?",
    "options": [
        "Botswana",
        "Sudan",
        "Chad"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Okavango Delta in Botswana is the world's largest inland delta system."
},
{
    "id": 517,
    "question": "Which African country has over 200 pyramids?",
    "options": [
        "Egypt",
        "Sudan",
        "Ethiopia"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Sudan has more pyramids than Egypt — primarily from the Kingdom of Kush."
},
{
    "id": 518,
    "question": "Which country has Africa's highest mountain?",
    "options": [
        "Ethiopia",
        "Tanzania",
        "Kenya"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Mount Kilimanjaro in Tanzania is Africa's highest peak."
},
{
    "id": 519,
    "question": "Which country is famous for the Victoria Falls (Mosi-oa-Tunya)?",
    "options": [
        "Zambia",
        "Zimbabwe",
        "Both A and B"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Victoria Falls lies on the border between Zambia and Zimbabwe."
},
{
    "id": 520,
    "question": "Which country has the most islands in Africa?",
    "options": [
        "Seychelles",
        "Madagascar",
        "Cape Verde"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Seychelles consists of 115 islands in the Indian Ocean."
},
{
    "id": 521,
    "question": "Which country is home to the largest hot desert in the world?",
    "options": [
        "Egypt",
        "Algeria",
        "Libya"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Algeria contains the largest portion of the Sahara Desert."
},
{
    "id": 522,
    "question": "Which African country has the largest wildlife migration spectacle?",
    "options": [
        "Kenya",
        "Tanzania",
        "Both A and B"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "The Great Migration moves between Kenya's Maasai Mara and Tanzania's Serengeti."
},
{
    "id": 523,
    "question": "Which country is known for having Africa's largest lake island?",
    "options": [
        "Uganda",
        "Tanzania",
        "Madagascar"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Lake Victoria contains the Ssese Islands in Uganda."
},
{
    "id": 524,
    "question": "Which African country has a snow-capped mountain near the equator?",
    "options": [
        "Kenya",
        "Ethiopia",
        "Rwanda"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mount Kenya has glaciers despite being near the equator."
},
{
    "id": 525,
    "question": "Which country has Africa's largest canyon?",
    "options": [
        "Namibia",
        "Ethiopia",
        "South Africa"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Fish River Canyon in Namibia is the largest canyon in Africa."
},
{
    "id": 526,
    "question": "Which country is famous for pink lakes caused by algae?",
    "options": [
        "Senegal",
        "Tanzania",
        "Both A and B"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Lake Retba (Senegal) and Lake Natron (Tanzania) both display pink hues due to microorganisms."
},
{
    "id": 527,
    "question": "Which country has Africa's oldest continuously inhabited city?",
    "options": [
        "Morocco",
        "Tunisia",
        "Egypt"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Fez in Morocco is considered one of Africa's oldest continuously inhabited cities."
},
{
    "id": 528,
    "question": "Which African country has the longest continuous sandy beach?",
    "options": [
        "Mozambique",
        "Namibia",
        "South Africa"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mozambique's coastline stretches over 2,500 km, featuring long uninterrupted sandy beaches popular for sun, kitesurfing, and resorts."
},
{
    "id": 529,
    "question": "Which country has over 50 officially recognized beach resorts along its coast?",
    "options": [
        "Tunisia",
        "Egypt",
        "Seychelles"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Egypt's Red Sea and Mediterranean coasts host numerous resorts catering to international tourists."
},
{
    "id": 530,
    "question": "Which African country is home to world-famous pink sand beaches?",
    "options": [
        "Mauritius",
        "Senegal",
        "Tanzania"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Lake Natron's surroundings and certain coastal areas in Tanzania feature pink sands from salt-tolerant microorganisms."
},
{
    "id": 531,
    "question": "Which country's Sodwana Bay is known for combining beaches with deep-sea diving?",
    "options": [
        "South Africa",
        "Kenya",
        "Mozambique"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Sodwana Bay is both a beach and a top diving destination for coral reefs and large marine species."
},
{
    "id": 532,
    "question": "Which African country has the most islands with accessible beaches?",
    "options": [
        "Seychelles",
        "Madagascar",
        "Comoros"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Seychelles has 115 islands, many with pristine, accessible beaches and luxury resorts."
},
{
    "id": 533,
    "question": "Which country has the longest stretch of sand dunes meeting the ocean?",
    "options": [
        "Namibia",
        "Morocco",
        "Angola"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Namibia's Skeleton Coast features massive dunes extending into the Atlantic Ocean."
},
{
    "id": 534,
    "question": "Which African city is renowned as a major beach tourism hub on the Mediterranean?",
    "options": [
        "Alexandria (Egypt)",
        "Tangier (Morocco)",
        "Dakar (Senegal)"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Alexandria has long been a Mediterranean beach hub, combining history and sun tourism."
},
{
    "id": 535,
    "question": "Which country's Diani Beach is globally recognized for coral reefs and sand length?",
    "options": [
        "Kenya",
        "Mozambique",
        "Tanzania"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Diani Beach offers over 25 km of sand and coral-rich waters, attracting snorkelers and divers."
},
{
    "id": 536,
    "question": "Which African country has the most UNESCO-listed coastal ecosystems?",
    "options": [
        "Madagascar",
        "South Africa",
        "Egypt"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Madagascar's coastal mangroves, reefs, and unique island beaches have several UNESCO recognitions."
},
{
    "id": 537,
    "question": "Which country has beaches that are major nesting grounds for endangered sea turtles?",
    "options": [
        "Gabon",
        "Morocco",
        "Tunisia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Gabon's beaches along the Atlantic are prime nesting sites for leatherback and olive ridley turtles."
},
{
    "id": 538,
    "question": "Which African country has the largest stadium by capacity?",
    "options": [
        "South Africa",
        "Nigeria",
        "Egypt"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "FNB Stadium (Soccer City) in Johannesburg holds over 90,000 spectators."
},
{
    "id": 539,
    "question": "Which African country hosted the most Africa Cup of Nations tournaments?",
    "options": [
        "Ghana",
        "Egypt",
        "Nigeria"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Egypt has hosted multiple AFCON tournaments, reflecting strong stadium infrastructure."
},
{
    "id": 540,
    "question": "Which country is famous for modern multi-purpose arenas in multiple cities?",
    "options": [
        "Morocco",
        "Kenya",
        "Algeria"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Morocco has developed arenas for football, concerts, and global events, especially in Casablanca and Rabat."
},
{
    "id": 541,
    "question": "Which country's Cape Town Stadium was built for FIFA 2010 World Cup?",
    "options": [
        "South Africa",
        "Egypt",
        "Tunisia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The stadium was a centerpiece for 2010 FIFA World Cup events and continues hosting sports and concerts."
},
{
    "id": 542,
    "question": "Which country has over 50 stadiums with capacities above 10,000?",
    "options": [
        "Nigeria",
        "South Africa",
        "Kenya"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Nigeria has a dense network of stadiums built for football and athletics across major cities."
},
{
    "id": 543,
    "question": "Which African city has a stadium located at the highest altitude?",
    "options": [
        "Addis Ababa, Ethiopia",
        "Nairobi, Kenya",
        "Harare, Zimbabwe"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Addis Ababa Stadium is over 2,300 meters above sea level, impacting sports performance."
},
{
    "id": 544,
    "question": "Which country hosts Africa's first indoor Olympic-standard arena?",
    "options": [
        "Algeria",
        "South Africa",
        "Morocco"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "South Africa pioneered indoor Olympic-standard sports facilities in major cities."
},
{
    "id": 545,
    "question": "Which country is known for beach volleyball tourism competitions?",
    "options": [
        "Kenya",
        "Morocco",
        "Egypt"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Kenya hosts major beach volleyball competitions along the Indian Ocean coast."
},
{
    "id": 546,
    "question": "Which country has the largest football academy infrastructure?",
    "options": [
        "Ghana",
        "Egypt",
        "Nigeria"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Nigeria has multiple football academies producing professional players locally and internationally."
},
{
    "id": 547,
    "question": "Which country built stadiums integrating African art and culture in architecture?",
    "options": [
        "Morocco",
        "South Africa",
        "Egypt"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Moroccan stadiums often feature architectural motifs inspired by local heritage."
},
{
    "id": 548,
    "question": "Africa's highest peak?",
    "options": [
        "Mount Kenya",
        "Mount Kilimanjaro",
        "Ras Dashen"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Mount Kilimanjaro in Tanzania is 5,895 m, attracting climbers globally."
},
{
    "id": 549,
    "question": "Africa's largest canyon?",
    "options": [
        "Fish River Canyon (Namibia)",
        "Blyde River Canyon (South Africa)",
        "Blue Nile Gorge (Ethiopia)"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Fish River Canyon spans 160 km, deeper than the Grand Canyon in some points."
},
{
    "id": 550,
    "question": "Which country has active volcanoes for tourism treks?",
    "options": [
        "Ethiopia",
        "DR Congo",
        "Both"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Ethiopia's Erta Ale and DR Congo's Nyiragongo are popular extreme trekking sites."
},
{
    "id": 551,
    "question": "Africa's largest desert for adventure tourism?",
    "options": [
        "Sahara (Algeria, Libya, Morocco)",
        "Namib (Namibia)",
        "Kalahari (Botswana)"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Sahara offers vast dunes, trekking, and camel safaris."
},
{
    "id": 552,
    "question": "Which country has equatorial glaciers?",
    "options": [
        "Kenya",
        "Ethiopia",
        "Uganda"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mount Kenya retains glaciers near the equator."
},
{
    "id": 553,
    "question": "Which country's coastal cliffs are popular extreme hiking sites?",
    "options": [
        "Morocco (Atlas and Atlantic cliffs)",
        "South Africa (Table Mountain)",
        "Both"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Both countries feature cliffs and mountains attracting hikers and climbers."
},
{
    "id": 554,
    "question": "Africa's largest lake by surface area?",
    "options": [
        "Lake Tanganyika",
        "Lake Victoria",
        "Lake Malawi"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Lake Victoria spans 68,800 km², bordering Uganda, Tanzania, and Kenya."
},
{
    "id": 555,
    "question": "Which country is famous for sandboarding and desert sports?",
    "options": [
        "Namibia",
        "Morocco",
        "Egypt"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Namibia's dunes attract adventure sports like sandboarding and desert racing."
},
{
    "id": 556,
    "question": "Africa's longest river for adventure cruises?",
    "options": [
        "Nile (Egypt, Sudan, Uganda)",
        "Congo (DRC)",
        "Zambezi (Zambia/Zimbabwe)"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "The Zambezi's rapids and Victoria Falls attract rafting, kayaking, and extreme tourism."
},
{
    "id": 557,
    "question": "Which country has deepest gorges accessible to hikers?",
    "options": [
        "Ethiopia (Blue Nile Gorge)",
        "Morocco (Todgha Gorge)",
        "South Africa (Blyde River Canyon)"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Blue Nile Gorge in Ethiopia is over 1,500 m deep, popular for trekking and photography."
},
{
    "id": 558,
    "question": "Which country is home to the world-famous Mnemba Atoll diving site?",
    "options": [
        "Mozambique",
        "Tanzania",
        "Seychelles"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Tanzania's Mnemba Atoll near Zanzibar is renowned for pristine coral reefs, manta rays, and tropical fish diversity."
},
{
    "id": 559,
    "question": "Africa's largest coral reef system is located in:",
    "options": [
        "Madagascar",
        "Red Sea (Egypt/Sudan)",
        "Mozambique"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Mozambique's Bazaruto Archipelago hosts extensive coral reefs stretching along its coastline."
},
{
    "id": 560,
    "question": "Which country has Diver's Paradise at Sodwana Bay?",
    "options": [
        "South Africa",
        "Kenya",
        "Tanzania"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Sodwana Bay National Park is South Africa's premier deep-sea diving destination, featuring reef sharks and coral gardens."
},
{
    "id": 561,
    "question": "Which country's Mafia Island is a top diving and whale shark hotspot?",
    "options": [
        "Tanzania",
        "Mozambique",
        "Seychelles"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mafia Island in Tanzania is globally recognized for whale shark encounters and protected coral reefs."
},
{
    "id": 562,
    "question": "Where is Tofo Beach, famous for manta ray and whale shark diving?",
    "options": [
        "Mozambique",
        "Kenya",
        "Madagascar"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Tofo Beach attracts divers worldwide to see whale sharks and manta rays year-round."
},
{
    "id": 563,
    "question": "Which African country is famous for Red Sea diving and shipwrecks?",
    "options": [
        "Egypt",
        "Sudan",
        "Both"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Egypt (Sharm El-Sheikh, Hurghada) and northern Sudan have world-class reefs, shipwrecks, and clear waters."
},
{
    "id": 564,
    "question": "Which country hosts Diani Reef, a hotspot for snorkeling and diving?",
    "options": [
        "Kenya",
        "Mozambique",
        "Tanzania"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Diani Reef along the Kenyan coast offers rich coral ecosystems and diverse marine life."
},
{
    "id": 565,
    "question": "Which African country has diving sites in underwater lava tubes and caves?",
    "options": [
        "Seychelles",
        "Comoros",
        "Mauritius"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Mauritius has unique underwater caves and lava tube formations popular with divers."
},
{
    "id": 566,
    "question": "Which country has the deepest scuba diving site in Africa, at nearly 40 meters?",
    "options": [
        "South Africa",
        "Egypt",
        "Madagascar"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Egypt's Red Sea dives near Ras Mohammed reach deep levels with steep drop-offs and clear visibility."
},
{
    "id": 567,
    "question": "Which African country offers marine safaris combining dolphins, whales, and snorkeling?",
    "options": [
        "South Africa",
        "Mozambique",
        "Both"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Both Mozambique and South Africa provide marine tourism combining dolphin and whale watching with diving experiences."
},
{
    "id": 568,
    "question": "Which city is called “The Pearl of the Sahara” due to historic architecture?",
    "options": [
        "Timbuktu, Mali",
        "Marrakech, Morocco",
        "Fez, Morocco"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Marrakech is famed for its palaces, souks, and medina, attracting cultural tourism globally."
},
{
    "id": 569,
    "question": "Which city is known as the ancient learning center with mud-brick mosques?",
    "options": [
        "Timbuktu, Mali",
        "Alexandria, Egypt",
        "Carthage, Tunisia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Timbuktu was a major medieval intellectual and trade hub, famous for libraries and universities."
},
{
    "id": 570,
    "question": "Which African capital city is known as a UNESCO World Heritage site for rock-hewn churches?",
    "options": [
        "Lalibela, Ethiopia",
        "Cairo, Egypt",
        "Addis Ababa, Ethiopia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Lalibela is famed for its 11 monolithic rock churches carved in the 12th century."
},
{
    "id": 571,
    "question": "Which city is called Africa's spiritual capital for voodoo and cultural festivals?",
    "options": [
        "Ouidah, Benin",
        "Cotonou, Benin",
        "Porto-Novo, Benin"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ouidah is central to Vodun religion, historic slave trade sites, and cultural tourism in Benin."
},
{
    "id": 572,
    "question": "Which North African city has Phoenician and Roman ruins as a cultural capital?",
    "options": [
        "Carthage, Tunisia",
        "Tripoli, Libya",
        "Tangier, Morocco"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Carthage showcases Punic and Roman architecture, drawing archaeological tourism."
},
{
    "id": 573,
    "question": "Which city is home to the Great Mosque of Djenné, a mud-brick masterpiece?",
    "options": [
        "Djenné, Mali",
        "Gao, Mali",
        "Mopti, Mali"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The mosque is the largest mud structure in the world and a UNESCO site."
},
{
    "id": 574,
    "question": "Which city is known as the cultural heart of the Ashanti Kingdom?",
    "options": [
        "Kumasi, Ghana",
        "Accra, Ghana",
        "Tamale, Ghana"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Kumasi preserves Ashanti royal heritage, including the Manhyia Palace and crafts."
},
{
    "id": 575,
    "question": "Which African city is known for rock paintings older than 10,000 years?",
    "options": [
        "Tadrart Acacus, Libya",
        "Marrakech, Morocco",
        "Windhoek, Namibia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Tadrart Acacus mountains hold prehistoric rock art depicting animals and human life."
},
{
    "id": 576,
    "question": "Which city is the center of Mali's cultural music festivals?",
    "options": [
        "Bamako",
        "Mopti",
        "Segou"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Segou hosts traditional music festivals celebrating griot and regional culture."
},
{
    "id": 577,
    "question": "Which city is the historic center of Swahili culture and architecture?",
    "options": [
        "Lamu, Kenya",
        "Zanzibar Town, Tanzania",
        "Mombasa, Kenya"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Stone Town in Zanzibar preserves Swahili architecture, mosques, and trading heritage."
},
{
    "id": 561,
    "question": "Which country's Mafia Island is a top diving and whale shark hotspot?",
    "options": [
        "Tanzania",
        "Mozambique",
        "Seychelles"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mafia Island in Tanzania is globally recognized for whale shark encounters and protected coral reefs."
},
{
    "id": 562,
    "question": "Where is Tofo Beach, famous for manta ray and whale shark diving?",
    "options": [
        "Mozambique",
        "Kenya",
        "Madagascar"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Tofo Beach attracts divers worldwide to see whale sharks and manta rays year-round."
},
{
    "id": 563,
    "question": "Which African country is famous for Red Sea diving and shipwrecks?",
    "options": [
        "Egypt",
        "Sudan",
        "Both"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Egypt (Sharm El-Sheikh, Hurghada) and northern Sudan have world-class reefs, shipwrecks, and clear waters."
},
{
    "id": 564,
    "question": "Which country hosts Diani Reef, a hotspot for snorkeling and diving?",
    "options": [
        "Kenya",
        "Mozambique",
        "Tanzania"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Diani Reef along the Kenyan coast offers rich coral ecosystems and diverse marine life."
},
{
    "id": 565,
    "question": "Which African country has diving sites in underwater lava tubes and caves?",
    "options": [
        "Seychelles",
        "Comoros",
        "Mauritius"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Mauritius has unique underwater caves and lava tube formations popular with divers."
},
{
    "id": 566,
    "question": "Which country has the deepest scuba diving site in Africa, at nearly 40 meters?",
    "options": [
        "South Africa",
        "Egypt",
        "Madagascar"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Egypt's Red Sea dives near Ras Mohammed reach deep levels with steep drop-offs and clear visibility."
},
{
    "id": 567,
    "question": "Which African country offers marine safaris combining dolphins, whales, and snorkeling?",
    "options": [
        "South Africa",
        "Mozambique",
        "Both"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Both Mozambique and South Africa provide marine tourism combining dolphin and whale watching with diving experiences."
},
{
    "id": 568,
    "question": "Which city is called “The Pearl of the Sahara” due to historic architecture?",
    "options": [
        "Timbuktu, Mali",
        "Marrakech, Morocco",
        "Fez, Morocco"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Marrakech is famed for its palaces, souks, and medina, attracting cultural tourism globally."
},
{
    "id": 569,
    "question": "Which city is known as the ancient learning center with mud-brick mosques?",
    "options": [
        "Timbuktu, Mali",
        "Alexandria, Egypt",
        "Carthage, Tunisia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Timbuktu was a major medieval intellectual and trade hub, famous for libraries and universities."
},
{
    "id": 570,
    "question": "Which African capital city is known as a UNESCO World Heritage site for rock-hewn churches?",
    "options": [
        "Lalibela, Ethiopia",
        "Cairo, Egypt",
        "Addis Ababa, Ethiopia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Lalibela is famed for its 11 monolithic rock churches carved in the 12th century."
},
{
    "id": 571,
    "question": "Which city is called Africa's spiritual capital for voodoo and cultural festivals?",
    "options": [
        "Ouidah, Benin",
        "Cotonou, Benin",
        "Porto-Novo, Benin"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ouidah is central to Vodun religion, historic slave trade sites, and cultural tourism in Benin."
},
{
    "id": 572,
    "question": "Which North African city has Phoenician and Roman ruins as a cultural capital?",
    "options": [
        "Carthage, Tunisia",
        "Tripoli, Libya",
        "Tangier, Morocco"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Carthage showcases Punic and Roman architecture, drawing archaeological tourism."
},
{
    "id": 573,
    "question": "Which city is home to the Great Mosque of Djenné, a mud-brick masterpiece?",
    "options": [
        "Djenné, Mali",
        "Gao, Mali",
        "Mopti, Mali"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The mosque is the largest mud structure in the world and a UNESCO site."
},
{
    "id": 574,
    "question": "Which city is known as the cultural heart of the Ashanti Kingdom?",
    "options": [
        "Kumasi, Ghana",
        "Accra, Ghana",
        "Tamale, Ghana"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Kumasi preserves Ashanti royal heritage, including the Manhyia Palace and crafts."
},
{
    "id": 575,
    "question": "Which African city is known for rock paintings older than 10,000 years?",
    "options": [
        "Tadrart Acacus, Libya",
        "Marrakech, Morocco",
        "Windhoek, Namibia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Tadrart Acacus mountains hold prehistoric rock art depicting animals and human life."
},
{
    "id": 576,
    "question": "Which city is the center of Mali's cultural music festivals?",
    "options": [
        "Bamako",
        "Mopti",
        "Segou"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Segou hosts traditional music festivals celebrating griot and regional culture."
},
{
    "id": 577,
    "question": "Which city is the historic center of Swahili culture and architecture?",
    "options": [
        "Lamu, Kenya",
        "Zanzibar Town, Tanzania",
        "Mombasa, Kenya"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Stone Town in Zanzibar preserves Swahili architecture, mosques, and trading heritage."
},
{
    "id": 578,
    "question": "Which country refines the majority of the world's cobalt — much of it mined in the DRC?",
    "options": [
        "China",
        "Brazil",
        "India"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China refines most of the world's cobalt, much of it sourced from the Democratic Republic of the Congo."
},
{
    "id": 579,
    "question": "Which country's electric vehicle industry depends heavily on lithium from Zimbabwe and Namibia?",
    "options": [
        "Germany",
        "China",
        "Argentina"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "China's EV industry relies on lithium from Zimbabwe and Namibia."
},
{
    "id": 580,
    "question": "Which Asian country imports large quantities of African copper for electronics and grid infrastructure?",
    "options": [
        "China",
        "Nepal",
        "Mongolia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China imports African copper for electronics and infrastructure."
},
{
    "id": 581,
    "question": "Which European country's battery manufacturing sector relies on African cobalt and nickel?",
    "options": [
        "Poland",
        "Sweden",
        "Portugal"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Sweden's battery sector relies on African cobalt and nickel."
},
{
    "id": 582,
    "question": "Which country imports manganese from Gabon for steel and battery production?",
    "options": [
        "China",
        "Chile",
        "Vietnam"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China imports manganese from Gabon for steel and batteries."
},
{
    "id": 583,
    "question": "African coltan (tantalum ore) is essential for smartphone production in:",
    "options": [
        "South Korea",
        "Peru",
        "Iceland"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "South Korea uses African coltan for smartphone manufacturing."
},
{
    "id": 584,
    "question": "Which country is a major destination for African rare earth minerals used in wind turbines?",
    "options": [
        "Germany",
        "Bolivia",
        "Laos"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Germany imports African rare earth minerals for wind turbines."
},
{
    "id": 585,
    "question": "The United States imports African platinum primarily for:",
    "options": [
        "Catalytic converters and clean energy tech",
        "Paper production",
        "Furniture making"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "US imports African platinum for catalytic converters and clean energy."
},
{
    "id": 586,
    "question": "Which country's semiconductor industry depends indirectly on African palladium and platinum?",
    "options": [
        "Taiwan",
        "Nepal",
        "Fiji"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Taiwan's semiconductor industry uses African palladium and platinum."
},
{
    "id": 587,
    "question": "Most cobalt used in global EV batteries ultimately feeds manufacturing hubs in:",
    "options": [
        "China",
        "Sudan",
        "Bolivia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China is the main manufacturing hub for cobalt-based EV batteries."
},
{
    "id": 588,
    "question": "African titanium exports are critical to aerospace manufacturing in:",
    "options": [
        "United States",
        "Paraguay",
        "Cambodia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "US aerospace manufacturing relies on African titanium exports."
},
{
    "id": 589,
    "question": "Which country uses African uranium for part of its nuclear energy supply?",
    "options": [
        "France",
        "Peru",
        "Thailand"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "France uses African uranium for nuclear energy."
},
{
    "id": 590,
    "question": "Namibia and Niger have historically supplied uranium to:",
    "options": [
        "France",
        "Chile",
        "Malaysia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Namibia and Niger supply uranium to France."
},
{
    "id": 591,
    "question": "African platinum group metals are essential for hydrogen fuel cell research in:",
    "options": [
        "Japan",
        "Ecuador",
        "Oman"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Japan uses African platinum group metals for hydrogen fuel cell research."
},
{
    "id": 592,
    "question": "Which country imports African chromium for stainless steel production?",
    "options": [
        "China",
        "Lebanon",
        "Iceland"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China imports African chromium for stainless steel production."
},
{
    "id": 593,
    "question": "African manganese strengthens steel used in construction industries in:",
    "options": [
        "China and India",
        "Haiti",
        "Panama"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China and India use African manganese to strengthen steel for construction."
},
{
    "id": 594,
    "question": "Which country relies heavily on African gold imports for refining and global resale?",
    "options": [
        "Switzerland",
        "Honduras",
        "Nepal"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Switzerland relies on African gold imports for refining and resale."
},
{
    "id": 595,
    "question": "Dubai (UAE) is a major refining and trading hub for African:",
    "options": [
        "Gold",
        "Bauxite",
        "Coal"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Dubai is a major hub for refining and trading African gold."
},
{
    "id": 596,
    "question": "African cobalt and nickel are essential inputs into battery production facilities in:",
    "options": [
        "South Korea",
        "Bolivia",
        "Tunisia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "South Korea uses African cobalt and nickel for battery production."
},
{
    "id": 597,
    "question": "Which European country's fertilizer industry depends heavily on Moroccan phosphate?",
    "options": [
        "Spain",
        "Serbia",
        "Albania"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Spain's fertilizer industry relies on Moroccan phosphate."
},
{
    "id": 598,
    "question": "China's steel industry depends heavily on iron ore imports, including those from:",
    "options": [
        "South Africa",
        "Nepal",
        "Paraguay"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China imports iron ore from South Africa for its steel industry."
},
{
    "id": 599,
    "question": "Which country imports African LNG (natural gas) to support its energy needs?",
    "options": [
        "Italy",
        "Laos",
        "Bolivia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Italy imports African LNG to support its energy needs."
},
{
    "id": 600,
    "question": "Which Asian country imports African thermal coal for power plants?",
    "options": [
        "India",
        "Mongolia",
        "Bhutan"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "India imports African thermal coal for power plants."
},
{
    "id": 601,
    "question": "Which country's auto industry relies on platinum from South Africa for catalytic converters?",
    "options": [
        "Germany",
        "Peru",
        "Kenya"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Germany's auto industry uses South African platinum for catalytic converters."
},
{
    "id": 602,
    "question": "African lithium exports help power battery production facilities in:",
    "options": [
        "China",
        "Sudan",
        "Belize"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China uses African lithium exports for battery production."
},
{
    "id": 603,
    "question": "Which country imports African bauxite for aluminum used in aircraft manufacturing?",
    "options": [
        "China",
        "Chile",
        "Georgia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China imports African bauxite for aluminum in aircraft manufacturing."
},
{
    "id": 604,
    "question": "Which country's renewable energy transition depends significantly on African cobalt and manganese?",
    "options": [
        "Germany",
        "Uruguay",
        "Bhutan"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Germany's renewable energy transition relies on African cobalt and manganese."
},
{
    "id": 605,
    "question": "African uranium exports have historically supported nuclear reactors in:",
    "options": [
        "France",
        "Ecuador",
        "Nepal"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "France's nuclear reactors have historically used African uranium exports."
},
{
    "id": 606,
    "question": "Which country's electronics manufacturing depends heavily on refined African copper?",
    "options": [
        "China",
        "Mongolia",
        "Afghanistan"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "China's electronics manufacturing relies on refined African copper."
},
{
    "id": 607,
    "question": "Many advanced economies depend on African critical minerals for:",
    "options": [
        "Electric vehicles, aerospace, electronics, and energy systems",
        "Only agriculture",
        "Tourism"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African minerals are essential for EVs, aerospace, electronics, and energy systems."
},
{
    "id": 608,
    "question": "Which Ethiopian emperor defeated Italy at the Battle of Adwa in 1896?",
    "options": [
        "Samori Touré",
        "Menelik II",
        "Shaka Zulu"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Menelik II led Ethiopia to victory over Italy at Adwa in 1896."
},
{
    "id": 609,
    "question": "The Battle of Adwa was important because:",
    "options": [
        "It ended slavery worldwide",
        "It showed that an African army could defeat a European colonial power",
        "It created the African Union"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Adwa proved an African army could defeat a European colonial power."
},
{
    "id": 610,
    "question": "Who led the Ashanti resistance against British expansion in present-day Ghana?",
    "options": [
        "Yaa Asantewaa",
        "Queen Amina",
        "Nzinga Mbande"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Yaa Asantewaa led the Ashanti resistance against British expansion."
},
{
    "id": 611,
    "question": "What did Samori Touré build to resist French colonization?",
    "options": [
        "A railway network",
        "A powerful West African army and empire",
        "A trading company"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Samori Touré built a powerful army and empire to resist French colonization."
},
{
    "id": 612,
    "question": "Who was the Algerian leader that fought French rule in the 1800s?",
    "options": [
        "Abdelkader",
        "Thomas Sankara",
        "Kwame Nkrumah"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Abdelkader fought French rule in Algeria in the 1800s."
},
{
    "id": 613,
    "question": "Which Kenyan movement fought British rule in the 1950s?",
    "options": [
        "Mau Mau",
        "Zulu Impi",
        "Ashanti Union"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Mau Mau movement fought British rule in Kenya in the 1950s."
},
{
    "id": 614,
    "question": "Why were many African borders drawn the way they are today?",
    "options": [
        "African kings designed them",
        "European powers drew them during the Berlin Conference (1884-85)",
        "The United Nations created them"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "European powers drew African borders at the Berlin Conference (1884-85)."
},
{
    "id": 615,
    "question": "What was the main goal of the Berlin Conference?",
    "options": [
        "To free African nations",
        "To divide Africa among European powers",
        "To end wars in Europe"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Berlin Conference aimed to divide Africa among European powers."
},
{
    "id": 616,
    "question": "Who was Patrice Lumumba?",
    "options": [
        "Congo's first Prime Minister after independence",
        "A British governor",
        "A Portuguese trader"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Patrice Lumumba was Congo's first Prime Minister after independence."
},
{
    "id": 617,
    "question": "Why was Lumumba removed from power shortly after independence?",
    "options": [
        "He resigned voluntarily",
        "Foreign interests feared losing control over Congo's minerals",
        "He moved to Europe"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Lumumba was removed because foreign interests feared losing control over Congo's minerals."
},
{
    "id": 618,
    "question": "What is the CFA franc?",
    "options": [
        "A currency used in 14 African countries",
        "A type of gold",
        "A military alliance"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The CFA franc is a currency used in 14 African countries."
},
{
    "id": 619,
    "question": "Originally, CFA stood for:",
    "options": [
        "Central Federal Africa",
        "Colonies Françaises d'Afrique (French Colonies of Africa)",
        "Continental Finance Alliance"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "CFA originally stood for Colonies Françaises d'Afrique."
},
{
    "id": 620,
    "question": "After independence, why did some African countries continue using the CFA franc?",
    "options": [
        "It was the only currency allowed",
        "Agreements tied it to France's financial system",
        "They had no banks"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Some countries continued using the CFA franc due to agreements tying it to France's financial system."
},
{
    "id": 621,
    "question": "Under the CFA system, what was required of member countries for many years?",
    "options": [
        "To store part of their foreign reserves in France",
        "To pay taxes to Europe",
        "To send workers abroad"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Member countries had to store part of their foreign reserves in France."
},
{
    "id": 622,
    "question": "Why do some Africans debate the CFA franc today?",
    "options": [
        "Because it limits full control over monetary policy",
        "Because it is printed in Asia",
        "Because it uses coins only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The CFA franc limits full control over monetary policy, sparking debate."
},
{
    "id": 623,
    "question": "What does “neo-colonialism” mean?",
    "options": [
        "New form of direct slavery",
        "Political independence but continued economic control",
        "Total freedom from foreign influence"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Neo-colonialism means political independence but continued economic control."
},
{
    "id": 624,
    "question": "Why were many African economies designed around exporting raw materials?",
    "options": [
        "Local demand was low",
        "Colonial systems focused on extraction for Europe",
        "Africans refused factories"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Colonial systems focused African economies on extraction for Europe."
},
{
    "id": 625,
    "question": "Which leader promoted Pan-African unity and independence across Africa?",
    "options": [
        "Kwame Nkrumah",
        "King Leopold II",
        "Cecil Rhodes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Kwame Nkrumah promoted Pan-African unity and independence."
},
{
    "id": 626,
    "question": "What did Thomas Sankara try to promote in Burkina Faso?",
    "options": [
        "Dependence on foreign aid",
        "Self-reliance and local production",
        "Colonial partnerships"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Sankara promoted self-reliance and local production in Burkina Faso."
},
{
    "id": 627,
    "question": "Why is economic independence important for true sovereignty?",
    "options": [
        "It allows a country to control its own policies and resources",
        "It reduces the need for schools",
        "It stops trade"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Economic independence lets a country control its own policies and resources."
},
{
    "id": 628,
    "question": "Which country in Africa was never fully colonized?",
    "options": [
        "Ethiopia",
        "Kenya",
        "Nigeria"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ethiopia was never fully colonized."
},
{
    "id": 629,
    "question": "Many colonial railways in Africa were built to:",
    "options": [
        "Connect villages for social travel",
        "Transport minerals and crops to ports",
        "Promote tourism"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Colonial railways were built to transport minerals and crops to ports."
},
{
    "id": 630,
    "question": "Why were cash crops like cocoa and cotton heavily promoted during colonial times?",
    "options": [
        "To improve African diets",
        "To supply European industries",
        "To grow local markets"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Cash crops were promoted to supply European industries."
},
{
    "id": 631,
    "question": "What happened to many African traditional industries under colonial rule?",
    "options": [
        "They expanded rapidly",
        "They were weakened or replaced by imports",
        "They were nationalized"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Traditional industries were weakened or replaced by imports under colonial rule."
},
{
    "id": 632,
    "question": "What is one way modern African countries are trying to strengthen independence?",
    "options": [
        "Regional trade groups like ECOWAS and AfCFTA",
        "Returning to colonial rule",
        "Ending all trade"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Regional trade groups like ECOWAS and AfCFTA help strengthen independence."
},
{
    "id": 633,
    "question": "What does IMF stand for?",
    "options": [
        "International Mining Force",
        "International Monetary Fund",
        "Industrial Market Federation"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "IMF stands for International Monetary Fund."
},
{
    "id": 634,
    "question": "Why do countries borrow from the IMF?",
    "options": [
        "To build theme parks",
        "To stabilize their economy during crisis",
        "To buy weapons"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Countries borrow from the IMF to stabilize their economy during crisis."
},
{
    "id": 635,
    "question": "When a country cannot repay its debt easily, what may the IMF require?",
    "options": [
        "Lower interest rates",
        "Structural reforms",
        "Free gold"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The IMF may require structural reforms if a country cannot repay its debt."
},
{
    "id": 636,
    "question": "Structural Adjustment Programs often required countries to:",
    "options": [
        "Increase government spending",
        "Reduce government spending and privatize state companies",
        "Stop trading"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Structural Adjustment Programs required reducing government spending and privatizing state companies."
},
{
    "id": 637,
    "question": "Privatization means:",
    "options": [
        "Government takes control",
        "Selling state-owned companies to private owners",
        "Ending all business"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Privatization means selling state-owned companies to private owners."
},
{
    "id": 638,
    "question": "Why did some African countries struggle under Structural Adjustment Programs?",
    "options": [
        "Public services like health and education were reduced",
        "Gold disappeared",
        "Borders changed"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Structural Adjustment Programs reduced public services like health and education."
},
{
    "id": 639,
    "question": "When a country exports raw materials but imports finished goods, it often:",
    "options": [
        "Earns more profit",
        "Loses value in trade",
        "Controls global prices"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Exporting raw materials but importing finished goods leads to losing value in trade."
},
{
    "id": 640,
    "question": "What is “resource dependency”?",
    "options": [
        "Depending mainly on exporting natural resources",
        "Depending on tourism",
        "Depending on farming only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Resource dependency means depending mainly on exporting natural resources."
},
{
    "id": 641,
    "question": "Which global institutions influence loans and financial rules for many African countries?",
    "options": [
        "IMF and World Bank",
        "FIFA",
        "NASA"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "IMF and World Bank influence loans and financial rules for many African countries."
},
{
    "id": 642,
    "question": "Why is diversifying an economy important?",
    "options": [
        "It reduces risk and builds resilience",
        "It makes currency smaller",
        "It stops imports"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Diversifying an economy reduces risk and builds resilience."
},
{
    "id": 643,
    "question": "Who led the resistance against British forces in Zimbabwe (then Rhodesia)?",
    "options": [
        "Mbuya Nehanda",
        "Samori Touré",
        "Menelik II"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mbuya Nehanda led resistance against British forces in Zimbabwe."
},
{
    "id": 644,
    "question": "Who led Guinea to independence from France in 1958 by voting “No” in a French referendum?",
    "options": [
        "Léopold Senghor",
        "Sékou Touré",
        "Félix Houphouët-Boigny"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Sékou Touré led Guinea to independence by voting 'No' in the French referendum."
},
{
    "id": 645,
    "question": "Which South African leader was imprisoned for 27 years?",
    "options": [
        "Julius Nyerere",
        "Nelson Mandela",
        "Agostinho Neto"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Nelson Mandela was imprisoned for 27 years in South Africa."
},
{
    "id": 646,
    "question": "Who led Angola's independence movement against Portugal?",
    "options": [
        "Agostinho Neto",
        "Kwame Nkrumah",
        "Haile Selassie"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Agostinho Neto led Angola's independence movement against Portugal."
},
{
    "id": 647,
    "question": "Who led Tanzania toward independence and promoted African socialism (Ujamaa)?",
    "options": [
        "Julius Nyerere",
        "Abdelkader",
        "Thomas Sankara"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Julius Nyerere led Tanzania toward independence and promoted Ujamaa."
},
{
    "id": 648,
    "question": "Which Nigerian queen led military campaigns in the 16th century?",
    "options": [
        "Queen Amina",
        "Yaa Asantewaa",
        "Nzinga Mbande"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Queen Amina led military campaigns in Nigeria in the 16th century."
},
{
    "id": 649,
    "question": "Who resisted Portuguese rule in Angola in the 1600s?",
    "options": [
        "Nzinga Mbande",
        "Ellen Johnson Sirleaf",
        "Sam Nujoma"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Nzinga Mbande resisted Portuguese rule in Angola in the 1600s."
},
{
    "id": 650,
    "question": "Which Namibian leader fought South African apartheid rule?",
    "options": [
        "Sam Nujoma",
        "Menelik II",
        "Nkrumah"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Sam Nujoma fought South African apartheid rule in Namibia."
},
{
    "id": 651,
    "question": "Which Mozambican leader fought Portuguese colonial rule?",
    "options": [
        "Eduardo Mondlane",
        "Patrice Lumumba",
        "Senghor"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Eduardo Mondlane fought Portuguese colonial rule in Mozambique."
},
{
    "id": 652,
    "question": "What united many African independence movements?",
    "options": [
        "Desire for foreign control",
        "Self-determination and sovereignty",
        "Trade monopolies"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Self-determination and sovereignty united African independence movements."
},
{
    "id": 653,
    "question": "What is Pan-Africanism?",
    "options": [
        "A belief in African unity and cooperation",
        "A type of currency",
        "A colonial treaty"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Pan-Africanism is a belief in African unity and cooperation."
},
{
    "id": 654,
    "question": "Who was one of the early thinkers of Pan-Africanism?",
    "options": [
        "W.E.B. Du Bois",
        "King Leopold II",
        "Vasco da Gama"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "W.E.B. Du Bois was an early thinker of Pan-Africanism."
},
{
    "id": 655,
    "question": "Which 1963 organization later became the African Union?",
    "options": [
        "Organization of African Unity (OAU)",
        "United Nations Africa",
        "ECOWAS"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Organization of African Unity (OAU) later became the African Union."
},
{
    "id": 656,
    "question": "What replaced the OAU in 2002?",
    "options": [
        "African Union (AU)",
        "Arab League",
        "NATO"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The African Union replaced the OAU in 2002."
},
{
    "id": 657,
    "question": "What is AfCFTA?",
    "options": [
        "African Continental Free Trade Area",
        "African Currency Federation",
        "Atlantic Financial Council"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "AfCFTA stands for African Continental Free Trade Area."
},
{
    "id": 658,
    "question": "AfCFTA aims to:",
    "options": [
        "Increase trade between African countries",
        "Reduce African exports",
        "Divide markets"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "AfCFTA aims to increase trade between African countries."
},
{
    "id": 659,
    "question": "Why is intra-African trade important?",
    "options": [
        "It strengthens local industries",
        "It weakens currencies",
        "It increases dependency"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Intra-African trade strengthens local industries."
},
{
    "id": 660,
    "question": "Which Ethiopian capital hosts the African Union headquarters?",
    "options": [
        "Addis Ababa",
        "Nairobi",
        "Lagos"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Addis Ababa hosts the African Union headquarters."
},
{
    "id": 661,
    "question": "Why do some leaders push for a common African passport?",
    "options": [
        "To promote easier movement across African countries",
        "To restrict travel",
        "To end tourism"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "A common African passport would promote easier movement across African countries."
},
{
    "id": 662,
    "question": "What is one key challenge facing African unity?",
    "options": [
        "Geography",
        "Political differences and economic imbalance",
        "Lack of history"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Political differences and economic imbalance are key challenges for African unity."
},
{
    "id": 663,
    "question": "What was apartheid?",
    "options": [
        "A system of racial segregation in South Africa",
        "A peace treaty",
        "A farming method"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Apartheid was a system of racial segregation in South Africa."
},
{
    "id": 664,
    "question": "Apartheid officially began in South Africa in:",
    "options": [
        "1910",
        "1948",
        "1963"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Apartheid officially began in South Africa in 1948."
},
{
    "id": 665,
    "question": "Under apartheid, Black South Africans were:",
    "options": [
        "Given equal political rights",
        "Forced to live in separate areas with fewer rights",
        "Made leaders of government"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Black South Africans were forced to live in separate areas with fewer rights under apartheid."
},
{
    "id": 666,
    "question": "What were “Bantustans”?",
    "options": [
        "Independent countries",
        "Areas where Black South Africans were forced to live",
        "Military camps"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Bantustans were areas where Black South Africans were forced to live."
},
{
    "id": 667,
    "question": "Which global factor helped end apartheid?",
    "options": [
        "International sanctions and boycotts",
        "European colonization",
        "Discovery of oil"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "International sanctions and boycotts helped end apartheid."
},
{
    "id": 668,
    "question": "Apartheid officially ended in:",
    "options": [
        "1984",
        "1994",
        "2002"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Apartheid officially ended in 1994."
},
{
    "id": 669,
    "question": "The Rwanda genocide involved conflict mainly between which groups?",
    "options": [
        "Zulu and Xhosa",
        "Hutu and Tutsi",
        "Hausa and Yoruba"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Rwanda genocide involved conflict mainly between Hutu and Tutsi."
},
{
    "id": 670,
    "question": "During colonial rule, which European power controlled Rwanda and influenced ethnic divisions?",
    "options": [
        "Britain",
        "Belgium",
        "Portugal"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Belgium controlled Rwanda and influenced ethnic divisions during colonial rule."
},
{
    "id": 671,
    "question": "How did colonial rule increase division in Rwanda?",
    "options": [
        "By creating ethnic ID cards",
        "By promoting one group over another",
        "Both A and B"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Colonial rule increased division in Rwanda by creating ethnic ID cards and promoting one group over another."
},
{
    "id": 672,
    "question": "Approximately how long did the 1994 genocide last?",
    "options": [
        "About 100 days",
        "5 years",
        "20 years"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The 1994 genocide lasted about 100 days."
},
{
    "id": 673,
    "question": "The Democratic Republic of Congo is rich in:",
    "options": [
        "Sand",
        "Cobalt, coltan, and diamonds",
        "Wheat"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Democratic Republic of Congo is rich in cobalt, coltan, and diamonds."
},
{
    "id": 674,
    "question": "The Congo wars involved:",
    "options": [
        "Only one country",
        "Multiple African countries",
        "No foreign involvement"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Congo wars involved multiple African countries."
},
{
    "id": 675,
    "question": "Why were minerals a major factor in the Congo conflicts?",
    "options": [
        "They are used in electronics and batteries",
        "They are used for painting",
        "They are decorative only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Minerals were a major factor in the Congo conflicts because they are used in electronics and batteries."
},
{
    "id": 676,
    "question": "The Congo wars are sometimes called:",
    "options": [
        "Africa's World War",
        "The Desert Conflict",
        "The Atlantic War"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Congo wars are sometimes called Africa's World War."
},
{
    "id": 677,
    "question": "The Nigerian Civil War began when which region attempted to secede?",
    "options": [
        "Northern Region",
        "Western Region",
        "Eastern Region (Biafra)"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "The Nigerian Civil War began when the Eastern Region (Biafra) attempted to secede."
},
{
    "id": 678,
    "question": "Oil played what role in the Nigeria-Biafra war?",
    "options": [
        "No role",
        "It was a key strategic resource",
        "It ended the war immediately"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Oil was a key strategic resource in the Nigeria-Biafra war."
},
{
    "id": 679,
    "question": "Which outside powers supplied arms or support during the Nigerian Civil War?",
    "options": [
        "Various Cold War powers",
        "No one",
        "Only African Union"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Various Cold War powers supplied arms or support during the Nigerian Civil War."
},
{
    "id": 680,
    "question": "Angola gained independence from which country?",
    "options": [
        "Britain",
        "Portugal",
        "France"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Angola gained independence from Portugal."
},
{
    "id": 681,
    "question": "After independence, Angola's civil war became linked to:",
    "options": [
        "The Cold War",
        "The Olympics",
        "Tourism competition"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Angola's civil war became linked to the Cold War after independence."
},
{
    "id": 682,
    "question": "Which global powers were involved indirectly in Angola?",
    "options": [
        "United States and Soviet Union",
        "Australia and Japan",
        "Canada and Mexico"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The United States and Soviet Union were involved indirectly in Angola."
},
{
    "id": 683,
    "question": "Sudan's long civil war was partly based on:",
    "options": [
        "Differences in religion and political power",
        "Farming disputes",
        "Weather"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Sudan's civil war was partly based on differences in religion and political power."
},
{
    "id": 684,
    "question": "South Sudan became independent in:",
    "options": [
        "1994",
        "2011",
        "2005"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "South Sudan became independent in 2011."
},
{
    "id": 685,
    "question": "Oil was a major factor in the Sudan conflicts.",
    "options": [
        "True",
        "False",
        "Only partly"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Oil was a major factor in the Sudan conflicts."
},
{
    "id": 686,
    "question": "What resource fueled conflict in Sierra Leone?",
    "options": [
        "Gold",
        "Cocoa",
        "Diamonds"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Diamonds fueled conflict in Sierra Leone."
},
{
    "id": 687,
    "question": "The term “blood diamonds” refers to:",
    "options": [
        "Colored gems",
        "Diamonds mined in war zones to fund conflict",
        "Synthetic stones"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Blood diamonds are diamonds mined in war zones to fund conflict."
},
{
    "id": 688,
    "question": "Liberia's civil war affected neighboring countries because:",
    "options": [
        "Trade stopped",
        "Armed groups crossed borders",
        "It didn't affect anyone"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Liberia's civil war affected neighbors because armed groups crossed borders."
},
{
    "id": 689,
    "question": "Many African wars after independence were influenced by:",
    "options": [
        "Cold War rivalries",
        "Football competition",
        "Farming festivals"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Cold War rivalries influenced many African wars after independence."
},
{
    "id": 690,
    "question": "What does “proxy war” mean?",
    "options": [
        "A direct fight between two superpowers",
        "A conflict where bigger powers support opposing sides indirectly",
        "A trade agreement"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "A proxy war is a conflict where bigger powers support opposing sides indirectly."
},
{
    "id": 691,
    "question": "Why do natural resources sometimes increase conflict risk?",
    "options": [
        "They attract competition for control",
        "They are heavy",
        "They expire quickly"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Natural resources increase conflict risk because they attract competition for control."
},
{
    "id": 692,
    "question": "What is one key lesson from many of these conflicts?",
    "options": [
        "Strong institutions and unity reduce instability",
        "Resources automatically bring peace",
        "Geography causes war"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Strong institutions and unity reduce instability."
},
{
    "id": 693,
    "question": "Which African organization replaced the OAU in 2002 to strengthen peace and cooperation?",
    "options": [
        "African Union (AU)",
        "Arab League",
        "Commonwealth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The African Union replaced the OAU in 2002 to strengthen peace and cooperation."
},
{
    "id": 694,
    "question": "The African Union headquarters is located in:",
    "options": [
        "Nairobi",
        "Addis Ababa",
        "Cairo"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The African Union headquarters is in Addis Ababa."
},
{
    "id": 695,
    "question": "What is one major goal of the African Union?",
    "options": [
        "Divide borders",
        "Promote peace and security",
        "Control world trade"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "A major goal of the African Union is to promote peace and security."
},
{
    "id": 696,
    "question": "ECOWAS mainly represents which region?",
    "options": [
        "East Africa",
        "West Africa",
        "Southern Africa"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "ECOWAS mainly represents West Africa."
},
{
    "id": 697,
    "question": "ECOWAS has done what during political crises in West Africa?",
    "options": [
        "Sent peacekeeping forces",
        "Ignored conflicts",
        "Closed all borders permanently"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "ECOWAS has sent peacekeeping forces during political crises in West Africa."
},
{
    "id": 698,
    "question": "SADC works mainly in which region?",
    "options": [
        "North Africa",
        "Central Africa",
        "Southern Africa"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "SADC works mainly in Southern Africa."
},
{
    "id": 699,
    "question": "IGAD helps manage peace efforts in:",
    "options": [
        "The Horn of Africa",
        "The Sahara",
        "The Atlantic Coast"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "IGAD helps manage peace efforts in the Horn of Africa."
},
{
    "id": 700,
    "question": "After apartheid, South Africa created which commission to promote healing?",
    "options": [
        "National Mining Board",
        "Truth and Reconciliation Commission",
        "Border Reform Agency"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "South Africa created the Truth and Reconciliation Commission to promote healing after apartheid."
},
{
    "id": 701,
    "question": "The goal of the Truth and Reconciliation Commission was to:",
    "options": [
        "Restart apartheid",
        "Reveal truth and encourage forgiveness",
        "Hide past crimes"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Truth and Reconciliation Commission aimed to reveal truth and encourage forgiveness."
},
{
    "id": 702,
    "question": "Which religious leader chaired the Truth and Reconciliation Commission?",
    "options": [
        "Desmond Tutu",
        "Haile Selassie",
        "Julius Nyerere"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Desmond Tutu chaired the Truth and Reconciliation Commission."
},
{
    "id": 703,
    "question": "In Liberia, women organized peaceful protests to help end civil war. Who led this movement?",
    "options": [
        "Ellen Johnson Sirleaf",
        "Leymah Gbowee",
        "Wangari Maathai"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Leymah Gbowee led peaceful protests to help end Liberia's civil war."
},
{
    "id": 704,
    "question": "What method did Liberian women use to pressure leaders into peace talks?",
    "options": [
        "Armed rebellion",
        "Peaceful sit-ins and protests",
        "Trade embargo"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Liberian women used peaceful sit-ins and protests to pressure leaders into peace talks."
},
{
    "id": 705,
    "question": "Leymah Gbowee later received:",
    "options": [
        "Nobel Peace Prize",
        "Olympic Medal",
        "AU Presidency"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Leymah Gbowee received the Nobel Peace Prize."
},
{
    "id": 706,
    "question": "After 1994, Rwanda used local community courts called:",
    "options": [
        "Sharia Courts",
        "Gacaca Courts",
        "Federal Tribunals"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Rwanda used Gacaca Courts for local justice and reconciliation after 1994."
},
{
    "id": 707,
    "question": "The goal of Gacaca courts was to:",
    "options": [
        "Punish only leaders",
        "Promote justice and reconciliation locally",
        "Close schools"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Gacaca courts aimed to promote justice and reconciliation locally."
},
{
    "id": 708,
    "question": "Today Rwanda is often recognized for:",
    "options": [
        "Instability",
        "Rapid economic and social rebuilding",
        "Isolation from Africa"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Rwanda is recognized for rapid economic and social rebuilding."
},
{
    "id": 709,
    "question": "Mozambique's long civil war ended in 1992 through:",
    "options": [
        "Military victory only",
        "A negotiated peace agreement",
        "Foreign takeover"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Mozambique's civil war ended through a negotiated peace agreement in 1992."
},
{
    "id": 710,
    "question": "The Rome General Peace Accords helped end war in:",
    "options": [
        "Angola",
        "Mozambique",
        "Chad"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "The Rome General Peace Accords helped end war in Mozambique."
},
{
    "id": 711,
    "question": "African Union peacekeeping missions have been deployed in:",
    "options": [
        "Somalia",
        "Antarctica",
        "Canada"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African Union peacekeeping missions have been deployed in Somalia."
},
{
    "id": 712,
    "question": "The AU mission in Somalia was called:",
    "options": [
        "AMISOM",
        "NATO-SOM",
        "AFRISAFE"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The AU mission in Somalia was called AMISOM."
},
{
    "id": 713,
    "question": "African countries often contribute troops to UN peacekeeping missions.",
    "options": [
        "True",
        "False",
        "Only North African countries"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African countries often contribute troops to UN peacekeeping missions."
},
{
    "id": 714,
    "question": "Many African countries supported anti-apartheid movements by:",
    "options": [
        "Imposing sanctions",
        "Sending troops to support apartheid",
        "Cutting diplomatic ties with liberation movements"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Many African countries supported anti-apartheid movements by imposing sanctions."
},
{
    "id": 715,
    "question": "Tanzania supported liberation movements from:",
    "options": [
        "Southern Africa",
        "Europe",
        "North America"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Tanzania supported liberation movements from Southern Africa."
},
{
    "id": 716,
    "question": "Zambia allowed liberation groups to operate from its territory despite risks.",
    "options": [
        "True",
        "False",
        "Only partly"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Zambia allowed liberation groups to operate from its territory despite risks."
},
{
    "id": 717,
    "question": "Which concept encourages African countries to solve African problems internally?",
    "options": [
        "Isolationism",
        "African solutions to African problems",
        "External control"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "African solutions to African problems encourages internal problem-solving."
},
{
    "id": 718,
    "question": "AfCFTA promotes:",
    "options": [
        "Trade between African countries",
        "More foreign control",
        "Ending exports"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "AfCFTA promotes trade between African countries."
},
{
    "id": 719,
    "question": "Intra-African trade helps:",
    "options": [
        "Strengthen regional industries",
        "Increase dependency",
        "Reduce cooperation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Intra-African trade helps strengthen regional industries."
},
{
    "id": 720,
    "question": "African regional banks help fund:",
    "options": [
        "Infrastructure projects",
        "Colonial expansion",
        "Military occupation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African regional banks help fund infrastructure projects."
},
{
    "id": 721,
    "question": "Agenda 2063 is:",
    "options": [
        "A military plan",
        "Africa's long-term development vision",
        "A colonial treaty"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Agenda 2063 is Africa's long-term development vision."
},
{
    "id": 722,
    "question": "A key lesson from African peace efforts is:",
    "options": [
        "Dialogue and unity can reduce conflict",
        "Conflict is unavoidable",
        "Resources prevent peace"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Dialogue and unity can reduce conflict."
},
{
    "id": 723,
    "question": "Robert Mugabe ruled Zimbabwe for approximately how many years?",
    "options": [
        "10 years",
        "20 years",
        "Nearly 37 years"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Robert Mugabe ruled Zimbabwe for nearly 37 years."
},
{
    "id": 724,
    "question": "Why is long rule without strong checks and balances risky?",
    "options": [
        "It reduces corruption automatically",
        "It can weaken democracy and accountability",
        "It improves opposition parties"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Long rule without strong checks and balances can weaken democracy and accountability."
},
{
    "id": 725,
    "question": "Which Libyan leader ruled for over 40 years before being overthrown in 2011?",
    "options": [
        "Muammar Gaddafi",
        "Gamal Abdel Nasser",
        "Anwar Sadat"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Muammar Gaddafi ruled Libya for over 40 years before being overthrown in 2011."
},
{
    "id": 726,
    "question": "One criticism of one-party or military rule is that it:",
    "options": [
        "Encourages open debate",
        "Limits political competition",
        "Strengthens independent courts"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "One-party or military rule often limits political competition."
},
{
    "id": 727,
    "question": "A military coup is when:",
    "options": [
        "Citizens vote in an election",
        "The military takes control of government by force",
        "A country changes its anthem"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "A military coup is when the military takes control of government by force."
},
{
    "id": 728,
    "question": "After independence, many African coups were influenced by:",
    "options": [
        "Football rivalries",
        "Cold War rivalries",
        "Climate change"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Many African coups after independence were influenced by Cold War rivalries."
},
{
    "id": 729,
    "question": "Patrice Lumumba was removed from power shortly after Congo's independence in 1960. One major reason historians cite is:",
    "options": [
        "Weather conditions",
        "Cold War tensions and mineral interests",
        "Language policy"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Lumumba was removed due to Cold War tensions and mineral interests."
},
{
    "id": 730,
    "question": "Thomas Sankara promoted self-reliance and anti-corruption policies in Burkina Faso. He was:",
    "options": [
        "Removed in a military coup",
        "Re-elected repeatedly",
        "Exiled voluntarily"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Thomas Sankara was removed in a military coup."
},
{
    "id": 731,
    "question": "Why is it difficult to label historical leaders simply as “good” or “evil”?",
    "options": [
        "Because history has multiple perspectives and consequences",
        "Because facts do not exist",
        "Because leaders never make mistakes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "History has multiple perspectives and consequences, making it difficult to label leaders simply as 'good' or 'evil'."
},
{
    "id": 732,
    "question": "International military interventions usually require:",
    "options": [
        "UN approval or international law coverage",
        "Only moral outrage",
        "Only news coverage"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "International military interventions usually require UN approval or international law coverage."
},
{
    "id": 733,
    "question": "Which African country had a NATO-led intervention in 2011?",
    "options": [
        "Nigeria",
        "Libya",
        "Ghana"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Libya had a NATO-led intervention in 2011."
},
{
    "id": 734,
    "question": "Why did Libya get targeted in 2011?",
    "options": [
        "Because its leader threatened foreign financial and resource interests",
        "Because it had a democratic election",
        "Because it had no oil"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Libya was targeted in 2011 because its leader threatened foreign financial and resource interests."
},
{
    "id": 735,
    "question": "Nigeria's EndSARS protests (2020) were largely ignored internationally because:",
    "options": [
        "The country was large and strategically important",
        "Protests were peaceful",
        "Nigeria requested intervention"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Nigeria's EndSARS protests were largely ignored internationally because the country was large and strategically important."
},
{
    "id": 736,
    "question": "External intervention is more likely when:",
    "options": [
        "The country is small, weak, or isolated",
        "The population is educated",
        "The country has strong internal governance"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "External intervention is more likely when the country is small, weak, or isolated."
},
{
    "id": 737,
    "question": "Why did Gaddafi fund African unity programs?",
    "options": [
        "To strengthen Africa's independence from foreign powers",
        "To buy foreign weapons",
        "To join the European Union"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Gaddafi funded African unity programs to strengthen Africa's independence from foreign powers."
},
{
    "id": 738,
    "question": "Which African organization aims to prevent conflicts and protect sovereignty?",
    "options": [
        "African Union (AU)",
        "NATO",
        "IMF"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The African Union aims to prevent conflicts and protect sovereignty."
},
{
    "id": 739,
    "question": "Regional coalitions like ECOWAS or SADC primarily work to:",
    "options": [
        "Maintain African stability and mediate conflicts",
        "Enforce foreign currency rules",
        "Sell African resources abroad"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Regional coalitions like ECOWAS or SADC work to maintain African stability and mediate conflicts."
},
{
    "id": 740,
    "question": "Internal African cooperation can prevent foreign intervention because:",
    "options": [
        "Strong alliances make unilateral attacks risky",
        "It hides the population from news",
        "It reduces natural resources"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Strong alliances make unilateral attacks risky and help prevent foreign intervention."
},
{
    "id": 741,
    "question": "African leaders sometimes avoid public criticism because:",
    "options": [
        "Criticism can weaken internal stability and invite foreign pressure",
        "They dislike the media",
        "Criticism increases oil"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Criticism can weaken internal stability and invite foreign pressure."
},
{
    "id": 742,
    "question": "Countries rich in oil or minerals often attract foreign interest. True or False?",
    "options": [
        "True",
        "False",
        "Only when exports exceed 10%"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Countries rich in oil or minerals often attract foreign interest."
},
{
    "id": 743,
    "question": "The Niger Delta conflicts were mainly about:",
    "options": [
        "Oil pollution and local resource control",
        "Internet access",
        "Voting rights"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Niger Delta conflicts were mainly about oil pollution and local resource control."
},
{
    "id": 744,
    "question": "Why is foreign intervention less likely when citizens protest over resources?",
    "options": [
        "The country's size, army, and regional influence make intervention costly",
        "The protests are always fictional",
        "Citizens are not media-savvy"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Foreign intervention is less likely when a country's size, army, and regional influence make intervention costly."
},
{
    "id": 745,
    "question": "Strong internal legal systems help:",
    "options": [
        "Protect citizens without foreign interference",
        "Remove natural resources",
        "Invite more intervention"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Strong internal legal systems help protect citizens without foreign interference."
},
{
    "id": 746,
    "question": "When African leaders coordinate resource management with neighbors:",
    "options": [
        "It strengthens bargaining power internationally",
        "It loses all autonomy",
        "It reduces local education"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Coordinating resource management with neighbors strengthens bargaining power internationally."
},
{
    "id": 747,
    "question": "International media sometimes exaggerates events to justify action. True or False?",
    "options": [
        "True",
        "False",
        "Only in Europe"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "International media sometimes exaggerates events to justify action."
},
{
    "id": 748,
    "question": "Foreign powers prefer interventions when:",
    "options": [
        "Local governments are politically isolated or unpopular internationally",
        "Leaders are highly respected by their citizens",
        "There are mountains"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Foreign powers prefer interventions when local governments are politically isolated or unpopular internationally."
},
{
    "id": 749,
    "question": "Media coverage alone is not enough to trigger foreign military intervention. True or False?",
    "options": [
        "True",
        "False",
        "Only in North Africa"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Media coverage alone is not enough to trigger foreign military intervention."
},
{
    "id": 750,
    "question": "African sovereignty can be protected if:",
    "options": [
        "Internal governance is stable, transparent, and strong",
        "Citizens protest continuously",
        "Media reports widely"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African sovereignty can be protected if internal governance is stable, transparent, and strong."
},
{
    "id": 751,
    "question": "Why do some African leaders act tough on foreign powers?",
    "options": [
        "To maintain national independence and discourage intervention",
        "To attract more foreign investment",
        "To get media awards"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Some African leaders act tough on foreign powers to maintain national independence and discourage intervention."
},
{
    "id": 752,
    "question": "Which factor contributed to Libya's vulnerability to foreign intervention?",
    "options": [
        "Personal rule without broad internal alliances",
        "Large population",
        "Peaceful protests"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Personal rule without broad internal alliances contributed to Libya's vulnerability to foreign intervention."
},
{
    "id": 753,
    "question": "Why were Niger Delta activists vulnerable despite clear injustices?",
    "options": [
        "The Nigerian state was militarily strong and regionally influential",
        "They had too many resources",
        "There was international media"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Niger Delta activists were vulnerable because the Nigerian state was militarily strong and regionally influential."
},
{
    "id": 754,
    "question": "African leaders who coordinate regionally are:",
    "options": [
        "Harder to remove by foreign powers",
        "Easier to remove",
        "Ignored"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African leaders who coordinate regionally are harder to remove by foreign powers."
},
{
    "id": 755,
    "question": "Which strategy protects citizens from foreign exploitation?",
    "options": [
        "Transparency in resource use and strong regional alliances",
        "Silent protests",
        "Ignoring foreign companies"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Transparency in resource use and strong regional alliances protect citizens from foreign exploitation."
},
{
    "id": 756,
    "question": "A state can maintain independence from external pressures if it:",
    "options": [
        "Strengthens institutions, civil oversight, and alliances",
        "Relies entirely on foreign funding",
        "Removes all governance"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "A state can maintain independence from external pressures by strengthening institutions, civil oversight, and alliances."
},
{
    "id": 757,
    "question": "Leaders removed because of external pressure were often:",
    "options": [
        "Threatening foreign economic or political interests",
        "Only focusing on education",
        "Too friendly with allies"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Leaders removed because of external pressure were often threatening foreign economic or political interests."
},
{
    "id": 758,
    "question": "African unity projects (like African banks or unions) can:",
    "options": [
        "Reduce foreign intervention risk",
        "Increase it",
        "Only impact trade"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African unity projects can reduce foreign intervention risk."
},
{
    "id": 759,
    "question": "One way African nations can prevent selective foreign attacks:",
    "options": [
        "Strengthen regional defense and economic independence",
        "Give up sovereignty",
        "Hide resources"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Strengthening regional defense and economic independence can prevent selective foreign attacks."
},
{
    "id": 760,
    "question": "The biggest lesson from African sovereignty history is:",
    "options": [
        "Strong internal systems matter more than external opinions",
        "Media decides everything",
        "Population size guarantees protection"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Strong internal systems matter more than external opinions."
},
{
    "id": 761,
    "question": "Which ancient African civilization built the first known system of irrigation for large-scale agriculture?",
    "options": [
        "Nubia",
        "Ancient Egypt",
        "Mali Empire"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Ancient Egypt built the first known system of irrigation for large-scale agriculture."
},
{
    "id": 762,
    "question": "The Sankore University in Timbuktu (Mali) was famous for:",
    "options": [
        "Writing early medical encyclopedias and astronomy texts",
        "Building large pyramids",
        "Mining gold exclusively"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Sankore University in Timbuktu was famous for writing early medical encyclopedias and astronomy texts."
},
{
    "id": 763,
    "question": "Who developed iron smelting technology independently in Africa around 500 BC?",
    "options": [
        "Nok people (Nigeria)",
        "Zulu Empire",
        "Berbers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Nok people of Nigeria developed iron smelting technology independently around 500 BC."
},
{
    "id": 764,
    "question": "The Benin Bronzes show advanced knowledge in:",
    "options": [
        "Lost-wax casting metalworking",
        "Papermaking",
        "Steam engines"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Benin Bronzes show advanced knowledge in lost-wax casting metalworking."
},
{
    "id": 765,
    "question": "The Dogon people of Mali were historically knowledgeable about:",
    "options": [
        "Stars and the Sirius star system",
        "Quantum mechanics",
        "Electricity"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Dogon people of Mali were knowledgeable about stars and the Sirius star system."
},
{
    "id": 766,
    "question": "Ancient Africans made advanced prosthetic devices. Which was one of the oldest?",
    "options": [
        "A wooden toe from Egypt (c. 950-710 BC)",
        "Iron leg from Mali (c. 1200 AD)",
        "Bronze hand from Ghana (c. 500 AD)"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "A wooden toe from Egypt (c. 950-710 BC) is one of the oldest prosthetic devices."
},
{
    "id": 767,
    "question": "The Adinkra symbols of Ghana were used for:",
    "options": [
        "Communication, teaching, and recording knowledge",
        "Making musical instruments",
        "Irrigation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Adinkra symbols of Ghana were used for communication, teaching, and recording knowledge."
},
{
    "id": 768,
    "question": "Which African kingdom is known for producing high-quality glass beads using advanced chemistry?",
    "options": [
        "Ife (Nigeria)",
        "Mali",
        "Congo"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ife (Nigeria) is known for producing high-quality glass beads using advanced chemistry."
},
{
    "id": 769,
    "question": "Africa's Nsukka meteorite in Nigeria contributed to understanding:",
    "options": [
        "Iron-rich meteorites and ancient metallurgy",
        "Solar energy",
        "Modern computers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africa's Nsukka meteorite in Nigeria contributed to understanding iron-rich meteorites and ancient metallurgy."
},
{
    "id": 770,
    "question": "Which ancient African tool is considered the oldest known geometrically shaped stone tool?",
    "options": [
        "Acheulean hand axes (North Africa)",
        "Bronze swords (Egypt)",
        "Wooden plow (Mali)"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Acheulean hand axes (North Africa) are the oldest known geometrically shaped stone tools."
},
{
    "id": 771,
    "question": "Who in Africa historically made mathematical advances in geometry and algebra centuries before Europe?",
    "options": [
        "Ancient Egyptians and Nubians",
        "Zulus only",
        "Khoisan"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Egyptians and Nubians made mathematical advances in geometry and algebra centuries before Europe."
},
{
    "id": 772,
    "question": "Which African innovation was used to track river levels and measure water flow?",
    "options": [
        "Nilometers in Egypt",
        "Bronze clocks in Mali",
        "Iron wells in Zimbabwe"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Nilometers in Egypt were used to track river levels and measure water flow."
},
{
    "id": 773,
    "question": "Ancient Africans developed advanced astronomy tools to:",
    "options": [
        "Predict floods and planting seasons",
        "Build pyramids without labor",
        "Navigate airplanes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Africans developed astronomy tools to predict floods and planting seasons."
},
{
    "id": 774,
    "question": "Which African society is credited with early leather tanning and textile dyeing chemistry?",
    "options": [
        "Nubia",
        "Ghana",
        "Morocco"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Nubia is credited with early leather tanning and textile dyeing chemistry."
},
{
    "id": 775,
    "question": "Africans invented unique water clocks for timekeeping. Where?",
    "options": [
        "Egypt",
        "Mali",
        "Benin"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africans invented unique water clocks for timekeeping in Egypt."
},
{
    "id": 776,
    "question": "Which ancient African city had libraries with tens of thousands of manuscripts on science, law, and medicine?",
    "options": [
        "Timbuktu (Mali)",
        "Cairo (Egypt)",
        "Addis Ababa (Ethiopia)"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Timbuktu (Mali) had libraries with tens of thousands of manuscripts on science, law, and medicine."
},
{
    "id": 777,
    "question": "Which African invention improved metal tools and farming implements independently of Europe?",
    "options": [
        "Iron smelting in Nok and Meroë",
        "Bronze smelting in Ghana",
        "Steel mills in Congo"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Iron smelting in Nok and Meroë improved metal tools and farming implements independently of Europe."
},
{
    "id": 778,
    "question": "African early medicine practices included:",
    "options": [
        "Herbal remedies and surgery in Ancient Egypt and Nubia",
        "Only spiritual healing",
        "Synthetic pharmaceuticals"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African early medicine practices included herbal remedies and surgery in Ancient Egypt and Nubia."
},
{
    "id": 779,
    "question": "Which African culture developed advanced mapping and navigation skills using stars and rivers?",
    "options": [
        "Dogon (Mali) and Swahili coastal traders",
        "Zulu only",
        "Berbers only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Dogon (Mali) and Swahili coastal traders developed advanced mapping and navigation skills using stars and rivers."
},
{
    "id": 780,
    "question": "Which African empire built mud-brick universities and libraries that rivaled Europe?",
    "options": [
        "Mali Empire (Timbuktu)",
        "Oyo Empire",
        "Benin Empire"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Mali Empire (Timbuktu) built mud-brick universities and libraries that rivaled Europe."
},
{
    "id": 781,
    "question": "The Egyptians developed early solar calendars. What was their main purpose?",
    "options": [
        "Agriculture and religious festivals",
        "Entertainment",
        "Modern banking"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Egyptians developed early solar calendars for agriculture and religious festivals."
},
{
    "id": 782,
    "question": "Africans invented advanced terracotta and pottery technology. Which culture is famous?",
    "options": [
        "Nok (Nigeria)",
        "Zulu",
        "Moroccan"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Nok (Nigeria) is famous for advanced terracotta and pottery technology."
},
{
    "id": 783,
    "question": "Which African invention contributed to early navigation along rivers and coasts?",
    "options": [
        "Canoe and dugout technology",
        "Iron wheels",
        "Hot-air balloons"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Canoe and dugout technology contributed to early navigation along rivers and coasts."
},
{
    "id": 784,
    "question": "Africans were among the first to smelt and use copper in which civilization?",
    "options": [
        "Nubia and Egypt",
        "Mali only",
        "Congo only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africans were among the first to smelt and use copper in Nubia and Egypt."
},
{
    "id": 785,
    "question": "Which African people had advanced architecture with terraced cities and stone walls?",
    "options": [
        "Great Zimbabwe",
        "Benin City",
        "Timbuktu"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Great Zimbabwe had advanced architecture with terraced cities and stone walls."
},
{
    "id": 786,
    "question": "Africa contributed to early surgical instruments. Which civilization is famous?",
    "options": [
        "Ancient Egypt",
        "Mali",
        "Congo"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Egypt is famous for early surgical instruments."
},
{
    "id": 787,
    "question": "Africans developed math-based record systems. Which group?",
    "options": [
        "Ancient Egyptians using hieroglyphic numerals",
        "Zulu only",
        "Hausa only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Egyptians developed math-based record systems using hieroglyphic numerals."
},
{
    "id": 788,
    "question": "Which African innovation was used to transport water efficiently in dry regions?",
    "options": [
        "Qanats and canals in Egypt and Nubia",
        "Canals in Mali",
        "Dams in Nigeria only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Qanats and canals in Egypt and Nubia were used to transport water efficiently in dry regions."
},
{
    "id": 789,
    "question": "Africa contributed to early textile dyeing chemistry. Which dye was commonly used?",
    "options": [
        "Indigo",
        "Madder",
        "Synthetic blue"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Indigo was commonly used in early African textile dyeing chemistry."
},
{
    "id": 790,
    "question": "Africans developed advanced glass-making techniques in which kingdom?",
    "options": [
        "Ife (Nigeria)",
        "Mali",
        "Kongo"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ife (Nigeria) is known for advanced glass-making techniques."
},
{
    "id": 791,
    "question": "Ancient Egyptians used a number system based on:",
    "options": [
        "Base 10 (decimal)",
        "Base 60",
        "Base 12"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Ancient Egyptians used a base 60 number system, influencing time and geometry."
},
{
    "id": 792,
    "question": "Which African civilization built the first known sailboats capable of ocean travel?",
    "options": [
        "Ancient Egyptians",
        "Mali Empire",
        "Zulu Kingdom"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Egyptians built the first known sailboats capable of ocean travel."
},
{
    "id": 793,
    "question": "African sailors from which region were early Indian Ocean explorers?",
    "options": [
        "Swahili Coast",
        "Ghana",
        "Benin"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Swahili Coast sailors explored the Indian Ocean centuries before Europeans."
},
{
    "id": 794,
    "question": "Africans were among the first to map the stars for navigation. Which group?",
    "options": [
        "Dogon (Mali)",
        "Zulu",
        "Yoruba"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Dogon people of Mali mapped stars for navigation, including Sirius B."
},
{
    "id": 795,
    "question": "Ancient Africans used geometry to align buildings with the sun. Where?",
    "options": [
        "Egypt",
        "Congo",
        "Mali"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Egyptians used geometry to align buildings like pyramids with the sun."
},
{
    "id": 796,
    "question": "Africa contributed to early chemistry for medicine and dyes. Which civilizations?",
    "options": [
        "Nubia and Egypt",
        "Mali and Ghana",
        "Zulu only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Nubia and Egypt contributed to early chemistry for medicine and dyes."
},
{
    "id": 797,
    "question": "The Antikythera-like devices in Africa were used for:",
    "options": [
        "Predicting solar events and agriculture cycles",
        "Making pottery",
        "Measuring rainfall"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Early astronomical calendars in Egypt and Nubia predicted solar events and agriculture cycles."
},
{
    "id": 798,
    "question": "African metallurgy included smelting which metals independently of Europe?",
    "options": [
        "Iron, gold, copper",
        "Silver only",
        "Tin only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African metallurgy included smelting iron, gold, and copper independently of Europe."
},
{
    "id": 799,
    "question": "Africans were early ocean explorers. Which technology helped them?",
    "options": [
        "Advanced canoes, sails, and coastal navigation techniques",
        "Steam engines",
        "Hot-air balloons"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Advanced canoes, sails, and navigation techniques helped African ocean explorers."
},
{
    "id": 800,
    "question": "Which African kingdom had libraries and observatories that influenced science?",
    "options": [
        "Mali (Timbuktu)",
        "Benin",
        "Zulu"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mali (Timbuktu) had libraries and observatories that influenced science."
},
{
    "id": 801,
    "question": "Africans developed early surgical instruments. Where?",
    "options": [
        "Ancient Egypt",
        "Mali",
        "Great Zimbabwe"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Egypt developed early surgical instruments like scalpels and forceps."
},
{
    "id": 802,
    "question": "Ancient African engineers used water clocks and nilometers to:",
    "options": [
        "Measure time and predict floods",
        "Create art",
        "Make pyramids invisible"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Water clocks and nilometers were used to measure time and predict floods."
},
{
    "id": 803,
    "question": "Africans developed algebraic and geometric methods. Who?",
    "options": [
        "Egyptians and Nubians",
        "Zulu only",
        "Berbers only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Egyptians and Nubians developed algebraic and geometric methods."
},
{
    "id": 804,
    "question": "Africans used animal behavior for early science observation. Which example?",
    "options": [
        "Tracking Nile fish migrations to predict floods",
        "Training lions for entertainment",
        "Using camels for poetry"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Tracking Nile fish migrations to predict floods is an example of early science observation."
},
{
    "id": 805,
    "question": "African mathematicians contributed to fractions and rational numbers. Where?",
    "options": [
        "Egypt",
        "Mali",
        "Congo"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Egyptian mathematicians contributed to fractions and rational numbers."
},
{
    "id": 806,
    "question": "The Swahili traders contributed to:",
    "options": [
        "Mapping coastlines and creating port cities along Africa-Asia trade routes",
        "Making pyramids",
        "Iron smelting only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Swahili traders mapped coastlines and created port cities along Africa-Asia trade routes."
},
{
    "id": 807,
    "question": "Africans tamed river navigation for trade. Which rivers?",
    "options": [
        "Niger, Nile, Congo",
        "Thames and Rhine",
        "Amazon only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africans tamed river navigation for trade on the Niger, Nile, and Congo rivers."
},
{
    "id": 808,
    "question": "Africans developed textile chemistry using:",
    "options": [
        "Indigo dye",
        "Synthetic dye",
        "Coal tar only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africans developed textile chemistry using indigo dye."
},
{
    "id": 809,
    "question": "Ancient African astronomers could predict flooding of the Nile using:",
    "options": [
        "Star positions and seasonal calendars",
        "Moon cheese",
        "Lightning"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient African astronomers predicted Nile flooding using star positions and seasonal calendars."
},
{
    "id": 810,
    "question": "Africans independently invented decimal and base-60 calculations for:",
    "options": [
        "Astronomy, architecture, and trade",
        "Playing games only",
        "Storytelling"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africans invented decimal and base-60 calculations for astronomy, architecture, and trade."
},
{
    "id": 811,
    "question": "Which ancient African civilization used advanced fraction notation for trade and measurement?",
    "options": [
        "Nubia",
        "Ancient Egypt",
        "Mali Empire"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Ancient Egypt used advanced fraction notation for trade and measurement."
},
{
    "id": 812,
    "question": "The ancient Egyptians recorded fractions using symbols like:",
    "options": [
        "Unit fractions (1/2, 1/3, 1/4…)",
        "Roman numerals",
        "Alphabet letters only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Egyptians recorded fractions using unit fractions (1/2, 1/3, 1/4…)."
},
{
    "id": 813,
    "question": "Which African system helped structure timekeeping and agricultural calendars?",
    "options": [
        "Egyptian solar calendar",
        "Mali lunar calendar",
        "Ife geometric calendar"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Egyptian solar calendar structured timekeeping and agricultural calendars."
},
{
    "id": 814,
    "question": "Egyptian scribes used base-10 alongside what other important number technique?",
    "options": [
        "Geometric algebra",
        "Binary code",
        "Complex calculus"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Egyptian scribes used base-10 and geometric algebra."
},
{
    "id": 815,
    "question": "Which African culture developed numerical symbols long before Europe?",
    "options": [
        "Egyptians",
        "Zulu",
        "Hausa"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Egyptians developed numerical symbols long before Europe."
},
{
    "id": 816,
    "question": "African merchants used weighing systems to ensure fair trade in:",
    "options": [
        "Timbuktu",
        "Great Zimbabwe",
        "Swahili ports"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "African merchants used weighing systems for fair trade in Swahili ports."
},
{
    "id": 817,
    "question": "The Dogon people of Mali were historically known for their:",
    "options": [
        "Astronomy knowledge",
        "Gunpowder production",
        "Coal mining"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Dogon people of Mali were known for their astronomy knowledge."
},
{
    "id": 818,
    "question": "Early African mathematicians developed geometry for:",
    "options": [
        "Architecture and agriculture",
        "Virtual reality",
        "Digital computing"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Early African mathematicians developed geometry for architecture and agriculture."
},
{
    "id": 819,
    "question": "Egyptians used nilometers to measure:",
    "options": [
        "Nile River water levels",
        "Desert sand density",
        "Wind speed"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Egyptians used nilometers to measure Nile River water levels."
},
{
    "id": 820,
    "question": "African counting systems often tracked:",
    "options": [
        "Trade, time, and balance",
        "Telephones",
        "Satellites"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African counting systems tracked trade, time, and balance."
},
{
    "id": 821,
    "question": "Which African innovation helped determine planting seasons?",
    "options": [
        "Solar and star calendars",
        "Mechanical clocks",
        "Digital calculators"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Solar and star calendars helped determine planting seasons."
},
{
    "id": 822,
    "question": "Egypt's measurement systems influenced later:",
    "options": [
        "Geometry in Europe",
        "Chess",
        "Musical notation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Egypt's measurement systems influenced geometry in Europe."
},
{
    "id": 823,
    "question": "Which coastal region was known for early African ocean traders?",
    "options": [
        "Swahili Coast",
        "Sahara",
        "Congo Basin"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Swahili Coast was known for early African ocean traders."
},
{
    "id": 824,
    "question": "Swahili sailors traded as far as:",
    "options": [
        "India and Arabia",
        "Antarctica",
        "Scandinavia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Swahili sailors traded as far as India and Arabia."
},
{
    "id": 825,
    "question": "African seafarers developed:",
    "options": [
        "Advanced canoes and sails",
        "Steam engines",
        "Submarines"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African seafarers developed advanced canoes and sails."
},
{
    "id": 826,
    "question": "Which African island was a base for Indian Ocean navigation?",
    "options": [
        "Madagascar",
        "Zanzibar Archipelago",
        "Canary Islands"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Zanzibar Archipelago was a base for Indian Ocean navigation."
},
{
    "id": 827,
    "question": "Early African navigators tracked stars to:",
    "options": [
        "Find direction at sea",
        "Compose songs",
        "Predict thunderstorms only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Early African navigators tracked stars to find direction at sea."
},
{
    "id": 828,
    "question": "The Swahili language spread because of:",
    "options": [
        "Indian Ocean trade networks",
        "Roman conquest",
        "Chinese silk routes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Swahili language spread because of Indian Ocean trade networks."
},
{
    "id": 829,
    "question": "African explorers navigated rivers such as:",
    "options": [
        "Nile, Congo, and Niger",
        "Rhine and Danube",
        "Mississippi"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African explorers navigated the Nile, Congo, and Niger rivers."
},
{
    "id": 830,
    "question": "African sailors built outrigger canoes to:",
    "options": [
        "Stabilize large vessels",
        "Race ships only",
        "Store gold"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African sailors built outrigger canoes to stabilize large vessels."
},
{
    "id": 831,
    "question": "Zanzibar was widely known as a:",
    "options": [
        "Major trade port",
        "Desert oasis",
        "Mining camp"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Zanzibar was widely known as a major trade port."
},
{
    "id": 832,
    "question": "Africans traded with China as early as:",
    "options": [
        "Medieval times",
        "19th century",
        "Only after 1900"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africans traded with China as early as medieval times."
},
{
    "id": 833,
    "question": "Swahili city-states helped connect Africa with:",
    "options": [
        "Asia's markets",
        "Europe's colonies only",
        "South American jungles"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Swahili city-states helped connect Africa with Asia's markets."
},
{
    "id": 834,
    "question": "African sailors often used:",
    "options": [
        "Star maps",
        "Electricity",
        "Satellite navigation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African sailors often used star maps."
},
{
    "id": 835,
    "question": "The Nok culture in Nigeria is known for:",
    "options": [
        "Early ironworking",
        "Bronze clocks",
        "Digital computers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Nok culture in Nigeria is known for early ironworking."
},
{
    "id": 836,
    "question": "Africans independently invented:",
    "options": [
        "Iron smelting in West Africa",
        "Printed books in the 14th century",
        "Electric cars"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africans independently invented iron smelting in West Africa."
},
{
    "id": 837,
    "question": "Great Zimbabwe's stone walls show knowledge of:",
    "options": [
        "Structural engineering",
        "Plastic molding",
        "Glass fiber"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Great Zimbabwe's stone walls show knowledge of structural engineering."
},
{
    "id": 838,
    "question": "The Benin Bronzes were made using:",
    "options": [
        "Lost-wax casting",
        "Bronze melting at sea",
        "Laser cutting"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Benin Bronzes were made using lost-wax casting."
},
{
    "id": 839,
    "question": "African metals were used in:",
    "options": [
        "Tools, weapons, and ornamentation",
        "Space shuttles",
        "Televisions"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African metals were used in tools, weapons, and ornamentation."
},
{
    "id": 840,
    "question": "Merchants in West Africa used calibrated weights for:",
    "options": [
        "Trading gold and kola nuts",
        "Cooking only",
        "Measuring rainfall"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Merchants in West Africa used calibrated weights for trading gold and kola nuts."
},
{
    "id": 841,
    "question": "Ancient Egyptian metalworkers used:",
    "options": [
        "Copper and bronze",
        "Uranium only",
        "Aluminum only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Egyptian metalworkers used copper and bronze."
},
{
    "id": 842,
    "question": "African glass beads were made using:",
    "options": [
        "Chemical glassmaking methods",
        "Plastic molds",
        "Stone carving"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African glass beads were made using chemical glassmaking methods."
},
{
    "id": 843,
    "question": "Ancient Africa contributed to early:",
    "options": [
        "Chemistry and metal alloys",
        "Nuclear reactors",
        "Quantum mechanics"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Africa contributed to early chemistry and metal alloys."
},
{
    "id": 844,
    "question": "African metallurgy improved:",
    "options": [
        "Farming tools' strength",
        "Spice flavor",
        "Dance rhythms"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African metallurgy improved farming tools' strength."
},
{
    "id": 845,
    "question": "African smiths controlled fire and temperatures using:",
    "options": [
        "Bellows and furnaces",
        "Solar panels",
        "Ice and salt"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African smiths controlled fire and temperatures using bellows and furnaces."
},
{
    "id": 846,
    "question": "African metals were internationally traded through:",
    "options": [
        "Sahara and coastal routes",
        "Only local villages",
        "Hidden caves only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African metals were internationally traded through Sahara and coastal routes."
},
{
    "id": 847,
    "question": "Ancient Egyptian doctors performed:",
    "options": [
        "Early surgery and wound care",
        "Only spiritual healing",
        "No medical practices"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Egyptian doctors performed early surgery and wound care."
},
{
    "id": 848,
    "question": "Some of the earliest prosthetic devices were found in:",
    "options": [
        "Ancient Egypt",
        "Mali",
        "Kongo"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Some of the earliest prosthetic devices were found in Ancient Egypt."
},
{
    "id": 849,
    "question": "Egyptians used early healing plants and herbal medicines for:",
    "options": [
        "Treating infections",
        "Only cooking",
        "Magic spells only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Egyptians used early healing plants and herbal medicines for treating infections."
},
{
    "id": 850,
    "question": "African advances in anatomy helped with:",
    "options": [
        "Bone setting and wound treatment",
        "Video games only",
        "Satellite imagery"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African advances in anatomy helped with bone setting and wound treatment."
},
{
    "id": 851,
    "question": "African medical knowledge spread through:",
    "options": [
        "Trade and scholarly exchange",
        "Televisions",
        "Only oral storytelling with no application"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African medical knowledge spread through trade and scholarly exchange."
},
{
    "id": 852,
    "question": "African astronomers could predict:",
    "options": [
        "Seasonal river flooding",
        "Earthquakes only",
        "Internet speeds"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African astronomers could predict seasonal river flooding."
},
{
    "id": 853,
    "question": "The Swahili developed early:",
    "options": [
        "Shipbuilding techniques",
        "Printing presses",
        "Satellites"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Swahili developed early shipbuilding techniques."
},
{
    "id": 854,
    "question": "African science in libraries like Timbuktu included studies in:",
    "options": [
        "Astronomy, medicine, law, mathematics",
        "Only pottery",
        "Only poetry"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African science in libraries like Timbuktu included astronomy, medicine, law, and mathematics."
},
{
    "id": 855,
    "question": "African towns like Kano and Gao were known for:",
    "options": [
        "Metalworking and textiles",
        "Only farming",
        "Only fishing"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Kano and Gao were known for metalworking and textiles."
},
{
    "id": 856,
    "question": "Africa's earliest scientific books were written in:",
    "options": [
        "Arabic and local scripts",
        "Chinese only",
        "Latin only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africa's earliest scientific books were written in Arabic and local scripts."
},
{
    "id": 857,
    "question": "African scholars translated knowledge between:",
    "options": [
        "Europe, Arabia, and India",
        "Only tribal groups",
        "Only oral stories"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scholars translated knowledge between Europe, Arabia, and India."
},
{
    "id": 858,
    "question": "African explorers shared knowledge through:",
    "options": [
        "Universities, trade routes, and caravans",
        "Internet videos",
        "Telephone"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African explorers shared knowledge through universities, trade routes, and caravans."
},
{
    "id": 859,
    "question": "African markets in cities like Kano used early:",
    "options": [
        "Banking systems and credit",
        "Only barter",
        "Teleportation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African markets in cities like Kano used early banking systems and credit."
},
{
    "id": 860,
    "question": "African traders used cowrie shells for:",
    "options": [
        "Money in some regions",
        "Building houses",
        "Only decorating clothing"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African traders used cowrie shells for money in some regions."
},
{
    "id": 861,
    "question": "African caravans connected West African gold to:",
    "options": [
        "North African salt and Mediterranean trade",
        "South American sugar",
        "Chinese silk"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African caravans connected West African gold to North African salt and Mediterranean trade."
},
{
    "id": 862,
    "question": "African scientists helped develop:",
    "options": [
        "Early geometry",
        "Modern airplanes",
        "Space rockets"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scientists helped develop early geometry."
},
{
    "id": 863,
    "question": "African economic knowledge included:",
    "options": [
        "Risk calculation for trade routes",
        "Only sharing jokes",
        "Cooking only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African economic knowledge included risk calculation for trade routes."
},
{
    "id": 864,
    "question": "African scholars debated and recorded:",
    "options": [
        "Legal systems and ethics",
        "Only farming songs",
        "Only war songs"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scholars debated and recorded legal systems and ethics."
},
{
    "id": 865,
    "question": "African caravan routes crossed which desert?",
    "options": [
        "Sahara",
        "Gobi",
        "Arctic"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African caravan routes crossed the Sahara desert."
},
{
    "id": 866,
    "question": "African science influenced:",
    "options": [
        "European Renaissance through knowledge transfer",
        "Only local artists",
        "Only oral poetry"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African science influenced the European Renaissance through knowledge transfer."
},
{
    "id": 867,
    "question": "African scholars used early libraries to:",
    "options": [
        "Preserve and build knowledge systematically",
        "Hide treasure",
        "Only decorate walls"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scholars used early libraries to preserve and build knowledge systematically."
},
{
    "id": 868,
    "question": "Ancient African scientists wrote about:",
    "options": [
        "Medicine, astronomy, law, and mathematics",
        "Only games",
        "Only proverbs"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient African scientists wrote about medicine, astronomy, law, and mathematics."
},
{
    "id": 869,
    "question": "Africa's scientific legacy continued through:",
    "options": [
        "Trade networks, universities, and scholars",
        "Only dance",
        "Farming songs"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africa's scientific legacy continued through trade networks, universities, and scholars."
},
{
    "id": 870,
    "question": "The biggest lesson from African science is:",
    "options": [
        "Africa was an origin of original innovation",
        "Africa copied everything",
        "Africa had no science"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africa was an origin of original innovation."
},
{
    "id": 871,
    "question": "Which African group used string knot systems similar to mathematical records?",
    "options": [
        "Ashanti",
        "Dogon",
        "Yoruba"
    ],
    "answer_index": 1,
    "image_url": "",
    "explanation": "Dogon used string knot systems similar to mathematical records."
},
{
    "id": 872,
    "question": "The Zulu stick charts were used for:",
    "options": [
        "Wind and wave patterns navigation",
        "Tribal storytelling",
        "Ritual dances"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Zulu stick charts were used for wind and wave patterns navigation."
},
{
    "id": 873,
    "question": "Africans used checkerboard geometry to plan:",
    "options": [
        "Urban street layouts",
        "Dance routines",
        "Animal tracking"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Africans used checkerboard geometry to plan urban street layouts."
},
{
    "id": 874,
    "question": "Which African society developed advanced boundary markers for land measurement?",
    "options": [
        "Herero",
        "Ashanti",
        "Igbo"
    ],
    "answer_index": 2,
    "image_url": "",
    "explanation": "Igbo developed advanced boundary markers for land measurement."
},
{
    "id": 875,
    "question": "Which ancient African water measurement device was used to predict the Nile flood?",
    "options": [
        "Nilometer",
        "Periscope",
        "Sextant"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Nilometer was used to predict the Nile flood."
},
{
    "id": 876,
    "question": "The Ancient Egyptian Mastaba tombs show knowledge of:",
    "options": [
        "Proportions and geometry",
        "Nuclear physics",
        "Computers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mastaba tombs show knowledge of proportions and geometry."
},
{
    "id": 877,
    "question": "Some African potters used mathematical symmetry to produce perfect spheres.",
    "options": [
        "True",
        "False",
        "Only parabolic shapes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Some African potters used mathematical symmetry to produce perfect spheres."
},
{
    "id": 878,
    "question": "Which African structure used advanced math for acoustics?",
    "options": [
        "Great Mosque of Djenné",
        "Sahara Pyramids",
        "Great Wall of Tunisia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Great Mosque of Djenné used advanced math for acoustics."
},
{
    "id": 879,
    "question": "African traders used counting boards similar to early abaci.",
    "options": [
        "True",
        "False",
        "Only in myth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African traders used counting boards similar to early abaci."
},
{
    "id": 880,
    "question": "Which African astronomical calendar aligned with the Orion constellation?",
    "options": [
        "Dogon of Mali",
        "Swahili",
        "Xhosa"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Dogon of Mali astronomical calendar aligned with the Orion constellation."
},
{
    "id": 881,
    "question": "Ancient Africans measured angles in structures using:",
    "options": [
        "Geometry and sighting rods",
        "Lasers",
        "Compasses made of gold"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Africans measured angles using geometry and sighting rods."
},
{
    "id": 882,
    "question": "Tracking seasonal change in Africa helped early farmers predict:",
    "options": [
        "Rainfall and harvest cycles",
        "International trade",
        "Sailboats"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Tracking seasonal change helped early farmers predict rainfall and harvest cycles."
},
{
    "id": 883,
    "question": "Which African traders used monsoon wind patterns to sail to India?",
    "options": [
        "Swahili",
        "Hausa",
        "Zulu"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Swahili traders used monsoon wind patterns to sail to India."
},
{
    "id": 884,
    "question": "African sailors charted coastlines by:",
    "options": [
        "Star positions",
        "Satellite GPS",
        "Green lasers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African sailors charted coastlines by star positions."
},
{
    "id": 885,
    "question": "The Bantu migrations spread iron technology and navigation skills across:",
    "options": [
        "Central, East & Southern Africa",
        "Europe",
        "Australia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Bantu migrations spread iron technology and navigation skills across Central, East & Southern Africa."
},
{
    "id": 886,
    "question": "African ship builders improved hull stability using:",
    "options": [
        "Outrigger canoes",
        "Propellers",
        "Balloons"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African ship builders improved hull stability using outrigger canoes."
},
{
    "id": 887,
    "question": "The first known African sailors to cross open water were from:",
    "options": [
        "The Swahili Coast",
        "Sahara",
        "Kalahari"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The first known African sailors to cross open water were from the Swahili Coast."
},
{
    "id": 888,
    "question": "African navigators used which celestial feature to guide direction at night?",
    "options": [
        "The Southern Cross",
        "The Big Dipper only",
        "Sun spots only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African navigators used the Southern Cross to guide direction at night."
},
{
    "id": 889,
    "question": "Which African ocean-going vehicle pre-dated European ships?",
    "options": [
        "Dhows built on the East coast",
        "Viking longships",
        "Japanese junks"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Dhows built on the East coast pre-dated European ships."
},
{
    "id": 890,
    "question": "Early African sailors recorded tidal knowledge to protect harbors.",
    "options": [
        "True",
        "False",
        "Only in legends"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Early African sailors recorded tidal knowledge to protect harbors."
},
{
    "id": 891,
    "question": "African fishermen used natural indicators (birds and waves) to find fish schools.",
    "options": [
        "True",
        "False",
        "Only seasons"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African fishermen used natural indicators like birds and waves to find fish schools."
},
{
    "id": 892,
    "question": "Which African island became a hub for Indian Ocean trade?",
    "options": [
        "Zanzibar",
        "Mauritius",
        "Sicily"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Zanzibar became a hub for Indian Ocean trade."
},
{
    "id": 893,
    "question": "The Swahili-Congo shoreline was rich in what resource that boosted maritime trade?",
    "options": [
        "Iron",
        "Coal",
        "Uranium"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Swahili-Congo shoreline was rich in iron, boosting maritime trade."
},
{
    "id": 894,
    "question": "African navigators measured distance by:",
    "options": [
        "Sun angle and star positions",
        "Wi-Fi signals",
        "Sound waves"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African navigators measured distance by sun angle and star positions."
},
{
    "id": 895,
    "question": "African herders developed early disease-resistant cattle breeds.",
    "options": [
        "True",
        "False",
        "Only in legend"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African herders developed early disease-resistant cattle breeds."
},
{
    "id": 896,
    "question": "Which African region is known for some of the earliest domesticated crop varieties?",
    "options": [
        "Ethiopia",
        "Greenland",
        "Iceland"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ethiopia is known for some of the earliest domesticated crop varieties."
},
{
    "id": 897,
    "question": "African scientists documented medicinal plants used for:",
    "options": [
        "Malaria and infections",
        "Only spices",
        "Only food"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scientists documented medicinal plants used for malaria and infections."
},
{
    "id": 898,
    "question": "Indigenous African farmers practiced:",
    "options": [
        "Crop rotation to maintain soil health",
        "Only single crop farming",
        "No farming"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Indigenous African farmers practiced crop rotation to maintain soil health."
},
{
    "id": 899,
    "question": "African pastoralists developed tools to track herd health.",
    "options": [
        "True",
        "False",
        "Only in cartoons"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African pastoralists developed tools to track herd health."
},
{
    "id": 900,
    "question": "African forests are studied for early ecosystem balance knowledge.",
    "options": [
        "True",
        "False",
        "Only recent science"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African forests are studied for early ecosystem balance knowledge."
},
{
    "id": 901,
    "question": "African ecologists studied termite mound chemistry and airflow.",
    "options": [
        "True",
        "False",
        "Only folklore"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African ecologists studied termite mound chemistry and airflow."
},
{
    "id": 902,
    "question": "African wetland dwellers used natural water purification knowledge.",
    "options": [
        "True",
        "False",
        "Only rituals"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African wetland dwellers used natural water purification knowledge."
},
{
    "id": 903,
    "question": "African savanna hunters understood seasonal wildlife patterns.",
    "options": [
        "True",
        "False",
        "Only dreams"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African savanna hunters understood seasonal wildlife patterns."
},
{
    "id": 904,
    "question": "African botanical gardens preserved knowledge of:",
    "options": [
        "Native medicinal plants",
        "Only flowers",
        "Only fruits"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African botanical gardens preserved knowledge of native medicinal plants."
},
{
    "id": 905,
    "question": "African communities used fire to manage grassland ecosystems.",
    "options": [
        "True",
        "False",
        "Only by accident"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African communities used fire to manage grassland ecosystems."
},
{
    "id": 906,
    "question": "African early science included bee behavior studies for pollination.",
    "options": [
        "True",
        "False",
        "Only stories"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African early science included bee behavior studies for pollination."
},
{
    "id": 907,
    "question": "Ancient Africans developed natural adhesives from:",
    "options": [
        "Tree resins",
        "Plastic",
        "Synthetic glue"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Africans developed natural adhesives from tree resins."
},
{
    "id": 908,
    "question": "African cloth dyers used natural indigo to:",
    "options": [
        "Create deep blue textiles",
        "Color ships",
        "Light fires"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African cloth dyers used natural indigo to create deep blue textiles."
},
{
    "id": 909,
    "question": "African communities refined glass from:",
    "options": [
        "Silica sands",
        "Tree bark",
        "Only clay"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African communities refined glass from silica sands."
},
{
    "id": 910,
    "question": "Which African people are known for bronze casting technology?",
    "options": [
        "Benin",
        "Tutsi",
        "Tuareg"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Benin people are known for bronze casting technology."
},
{
    "id": 911,
    "question": "African metalworkers controlled furnace temperatures using:",
    "options": [
        "Bellows",
        "Electronics",
        "Solar panels only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African metalworkers controlled furnace temperatures using bellows."
},
{
    "id": 912,
    "question": "African blacksmith guilds trained apprentices in:",
    "options": [
        "Metallurgy and tool crafting",
        "Music only",
        "Cooking only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African blacksmith guilds trained apprentices in metallurgy and tool crafting."
},
{
    "id": 913,
    "question": "African engineering included advanced stone quarrying at:",
    "options": [
        "Great Zimbabwe",
        "Sahara dunes",
        "Lake Malawi"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African engineering included advanced stone quarrying at Great Zimbabwe."
},
{
    "id": 914,
    "question": "African early engineers built granaries with airflow systems to preserve grain.",
    "options": [
        "True",
        "False",
        "Only myths"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African early engineers built granaries with airflow systems to preserve grain."
},
{
    "id": 915,
    "question": "African craftspeople mixed natural dyes using:",
    "options": [
        "Plant extracts and minerals",
        "Radio waves",
        "Pure gold"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African craftspeople mixed natural dyes using plant extracts and minerals."
},
{
    "id": 916,
    "question": "African early builders used geometric rope measurements",
    "options": [
        "True",
        "False",
        "Modern tools only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African early builders used geometric rope measurements."
},
{
    "id": 917,
    "question": "African ceiling and roof systems used:",
    "options": [
        "Interlocking timber and reed techniques",
        "Steel beams only",
        "Synthetic plastics"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African ceiling and roof systems used interlocking timber and reed techniques."
},
{
    "id": 918,
    "question": "African basket weavers used mathematical patterns for strength.",
    "options": [
        "True",
        "False",
        "Only symbols"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African basket weavers used mathematical patterns for strength."
},
{
    "id": 919,
    "question": "African scholars in Timbuktu wrote advanced:",
    "options": [
        "Law and astronomy texts",
        "Only letters",
        "Only songs"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scholars in Timbuktu wrote advanced law and astronomy texts."
},
{
    "id": 920,
    "question": "African libraries preserved ancient medical texts.",
    "options": [
        "True",
        "False",
        "Only stories"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African libraries preserved ancient medical texts."
},
{
    "id": 921,
    "question": "African astronomers studied star cycles to:",
    "options": [
        "Plan planting and religious events",
        "Only tell stories",
        "Find buried treasure"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African astronomers studied star cycles to plan planting and religious events."
},
{
    "id": 922,
    "question": "African schools taught math, law, and medicine centuries ago.",
    "options": [
        "True",
        "False",
        "Only recently"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African schools taught math, law, and medicine centuries ago."
},
{
    "id": 923,
    "question": "African texts were written in languages including:",
    "options": [
        "Arabic and local scripts",
        "Latin only",
        "Greek only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African texts were written in Arabic and local scripts."
},
{
    "id": 924,
    "question": "African trade centers were also centers of learning.",
    "options": [
        "True",
        "False",
        "Only marketplaces"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African trade centers were also centers of learning."
},
{
    "id": 925,
    "question": "African scholars debated logic and rhetoric similar to Greek traditions.",
    "options": [
        "True",
        "False",
        "Only legends"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scholars debated logic and rhetoric similar to Greek traditions."
},
{
    "id": 926,
    "question": "African scholars influenced science in the medieval world.",
    "options": [
        "True",
        "False",
        "Only Europe"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scholars influenced science in the medieval world."
},
{
    "id": 927,
    "question": "African scientific manuscripts covered topics beyond religion.",
    "options": [
        "True",
        "False",
        "Only poetry"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scientific manuscripts covered topics beyond religion."
},
{
    "id": 928,
    "question": "African students traveled across kingdoms to learn.",
    "options": [
        "True",
        "False",
        "Only at home"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African students traveled across kingdoms to learn."
},
{
    "id": 929,
    "question": "African knowledge systems contributed to global ideas about:",
    "options": [
        "Law, astronomy, medicine, and trade",
        "Only farming",
        "Only music"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African knowledge systems contributed to global ideas about law, astronomy, medicine, and trade."
},
{
    "id": 930,
    "question": "The deepest lesson from African science is:",
    "options": [
        "African innovation was diverse and global",
        "Africa only copied others",
        "Africa was isolated"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African innovation was diverse and global."
},
{
    "id": 931,
    "question": "Which ancient African civilization performed early forms of surgery and wound care?",
    "options": [
        "Ancient Egypt",
        "Mali Empire",
        "Zulu Kingdom"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Egypt performed early forms of surgery and wound care."
},
{
    "id": 932,
    "question": "The earliest known prosthetic device (a wooden toe) was found in:",
    "options": [
        "Egypt",
        "Nigeria",
        "Ethiopia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The earliest known prosthetic device (a wooden toe) was found in Egypt."
},
{
    "id": 933,
    "question": "African herbalists used plants to treat fever long before modern antibiotics. This practice is an early form of:",
    "options": [
        "Pharmacology",
        "Astrology",
        "Astrology"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Treating fever with plants is an early form of pharmacology."
},
{
    "id": 934,
    "question": "The ancient Egyptians recorded medical textbooks on papyrus. One such book is known as:",
    "options": [
        "Ebers Papyrus",
        "Rosetta Papyrus",
        "Kano Papyrus"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Ebers Papyrus is a famous ancient Egyptian medical textbook."
},
{
    "id": 935,
    "question": "Which ancient African practice involved cleaning wounds with honey for its antiseptic properties?",
    "options": [
        "True",
        "False",
        "Myth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Cleaning wounds with honey for its antiseptic properties is an ancient African practice."
},
{
    "id": 936,
    "question": "African surgeons in ancient times recognized the pulse to measure health and disease. This is an early form of:",
    "options": [
        "Diagnostics",
        "Painting",
        "Ritual only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Recognizing the pulse to measure health and disease is an early form of diagnostics."
},
{
    "id": 937,
    "question": "African healers documented injuries of bones and joints and developed early:",
    "options": [
        "Orthopedic techniques",
        "Balloon art",
        "Music therapy"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African healers developed early orthopedic techniques."
},
{
    "id": 938,
    "question": "Which African herbal remedy has been studied for anti-malarial properties?",
    "options": [
        "Artemisia in Ethiopia",
        "Cocoa leaves",
        "Coffee beans"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Artemisia in Ethiopia has been studied for anti-malarial properties."
},
{
    "id": 939,
    "question": "Ancient African medical knowledge spread through:",
    "options": [
        "Trade and scholarship",
        "Only temples",
        "Only animals"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient African medical knowledge spread through trade and scholarship."
},
{
    "id": 940,
    "question": "African fishers and hunters contributed to early knowledge of:",
    "options": [
        "Wound infection and treatment",
        "Internet",
        "Rockets"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African fishers and hunters contributed to early knowledge of wound infection and treatment."
},
{
    "id": 941,
    "question": "African healers used animal parts to understand anatomy. This is an early form of:",
    "options": [
        "Comparative anatomy",
        "Painting",
        "Dancing"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Using animal parts to understand anatomy is an early form of comparative anatomy."
},
{
    "id": 942,
    "question": "Which African region is known for documenting medicinal plant use extensively?",
    "options": [
        "West and East Africa",
        "Sahara only",
        "Kalahari only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "West and East Africa are known for extensively documenting medicinal plant use."
},
{
    "id": 943,
    "question": "African medical texts sometimes included:",
    "options": [
        "Surgery, injury care, and herbal doses",
        "Only myths",
        "Only recipes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African medical texts sometimes included surgery, injury care, and herbal doses."
},
{
    "id": 944,
    "question": "African healers studied seasonal diseases based on:",
    "options": [
        "Climate and ecology",
        "Myth only",
        "Astrology only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African healers studied seasonal diseases based on climate and ecology."
},
{
    "id": 945,
    "question": "African bone setting often included natural splints made of:",
    "options": [
        "Tree bark and fibers",
        "Plastic",
        "Metal tools only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African bone setting often included natural splints made of tree bark and fibers."
},
{
    "id": 946,
    "question": "Early African medical understanding helped prevent infection through:",
    "options": [
        "Clean water and herbal applications",
        "Noise",
        "Dance only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Early African medical understanding helped prevent infection through clean water and herbal applications."
},
{
    "id": 947,
    "question": "African communities used leech therapy in early times.",
    "options": [
        "True",
        "False",
        "Myth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African communities used leech therapy in early times."
},
{
    "id": 948,
    "question": "Early African medicine included diet prescriptions for wellness.",
    "options": [
        "True",
        "False",
        "Only rituals"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Early African medicine included diet prescriptions for wellness."
},
{
    "id": 949,
    "question": "African healers shared knowledge orally and in written manuscripts.",
    "options": [
        "True",
        "False",
        "Only written"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African healers shared knowledge orally and in written manuscripts."
},
{
    "id": 950,
    "question": "African dental knowledge included cleaning teeth with plant extracts.",
    "options": [
        "True",
        "False",
        "Myth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African dental knowledge included cleaning teeth with plant extracts."
},
{
    "id": 951,
    "question": "Which African healer studied bone fractures extensively?",
    "options": [
        "Practitioners in ancient Nubia",
        "Only war chiefs",
        "Only children"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Practitioners in ancient Nubia studied bone fractures extensively."
},
{
    "id": 918,
    "question": "African basket weavers used mathematical patterns for strength.",
    "options": [
        "True",
        "False",
        "Only symbols"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African basket weavers used mathematical patterns for strength."
},
{
    "id": 919,
    "question": "African scholars in Timbuktu wrote advanced:",
    "options": [
        "Law and astronomy texts",
        "Only letters",
        "Only songs"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scholars in Timbuktu wrote advanced law and astronomy texts."
},
{
    "id": 920,
    "question": "African libraries preserved ancient medical texts.",
    "options": [
        "True",
        "False",
        "Only stories"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African libraries preserved ancient medical texts."
},
{
    "id": 921,
    "question": "African astronomers studied star cycles to:",
    "options": [
        "Plan planting and religious events",
        "Only tell stories",
        "Find buried treasure"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African astronomers studied star cycles to plan planting and religious events."
},
{
    "id": 922,
    "question": "African schools taught math, law, and medicine centuries ago.",
    "options": [
        "True",
        "False",
        "Only recently"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African schools taught math, law, and medicine centuries ago."
},
{
    "id": 923,
    "question": "African texts were written in languages including:",
    "options": [
        "Arabic and local scripts",
        "Latin only",
        "Greek only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African texts were written in Arabic and local scripts."
},
{
    "id": 924,
    "question": "African trade centers were also centers of learning.",
    "options": [
        "True",
        "False",
        "Only marketplaces"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African trade centers were also centers of learning."
},
{
    "id": 925,
    "question": "African scholars debated logic and rhetoric similar to Greek traditions.",
    "options": [
        "True",
        "False",
        "Only legends"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scholars debated logic and rhetoric similar to Greek traditions."
},
{
    "id": 926,
    "question": "African scholars influenced science in the medieval world.",
    "options": [
        "True",
        "False",
        "Only Europe"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scholars influenced science in the medieval world."
},
{
    "id": 927,
    "question": "African scientific manuscripts covered topics beyond religion.",
    "options": [
        "True",
        "False",
        "Only poetry"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African scientific manuscripts covered topics beyond religion."
},
{
    "id": 928,
    "question": "African students traveled across kingdoms to learn.",
    "options": [
        "True",
        "False",
        "Only at home"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African students traveled across kingdoms to learn."
},
{
    "id": 929,
    "question": "African knowledge systems contributed to global ideas about:",
    "options": [
        "Law, astronomy, medicine, and trade",
        "Only farming",
        "Only music"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African knowledge systems contributed to global ideas about law, astronomy, medicine, and trade."
},
{
    "id": 930,
    "question": "The deepest lesson from African science is:",
    "options": [
        "African innovation was diverse and global",
        "Africa only copied others",
        "Africa was isolated"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African innovation was diverse and global."
},
{
    "id": 931,
    "question": "Which ancient African civilization performed early forms of surgery and wound care?",
    "options": [
        "Ancient Egypt",
        "Mali Empire",
        "Zulu Kingdom"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient Egypt performed early forms of surgery and wound care."
},
{
    "id": 932,
    "question": "The earliest known prosthetic device (a wooden toe) was found in:",
    "options": [
        "Egypt",
        "Nigeria",
        "Ethiopia"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The earliest known prosthetic device (a wooden toe) was found in Egypt."
},
{
    "id": 933,
    "question": "African herbalists used plants to treat fever long before modern antibiotics. This practice is an early form of:",
    "options": [
        "Pharmacology",
        "Astrology",
        "Astrology"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Treating fever with plants is an early form of pharmacology."
},
{
    "id": 934,
    "question": "The ancient Egyptians recorded medical textbooks on papyrus. One such book is known as:",
    "options": [
        "Ebers Papyrus",
        "Rosetta Papyrus",
        "Kano Papyrus"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Ebers Papyrus is a famous ancient Egyptian medical textbook."
},
{
    "id": 935,
    "question": "Which ancient African practice involved cleaning wounds with honey for its antiseptic properties?",
    "options": [
        "True",
        "False",
        "Myth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Cleaning wounds with honey for its antiseptic properties is an ancient African practice."
},
{
    "id": 936,
    "question": "African surgeons in ancient times recognized the pulse to measure health and disease. This is an early form of:",
    "options": [
        "Diagnostics",
        "Painting",
        "Ritual only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Recognizing the pulse to measure health and disease is an early form of diagnostics."
},
{
    "id": 937,
    "question": "African healers documented injuries of bones and joints and developed early:",
    "options": [
        "Orthopedic techniques",
        "Balloon art",
        "Music therapy"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African healers developed early orthopedic techniques."
},
{
    "id": 938,
    "question": "Which African herbal remedy has been studied for anti-malarial properties?",
    "options": [
        "Artemisia in Ethiopia",
        "Cocoa leaves",
        "Coffee beans"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Artemisia in Ethiopia has been studied for anti-malarial properties."
},
{
    "id": 939,
    "question": "Ancient African medical knowledge spread through:",
    "options": [
        "Trade and scholarship",
        "Only temples",
        "Only animals"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Ancient African medical knowledge spread through trade and scholarship."
},
{
    "id": 940,
    "question": "African fishers and hunters contributed to early knowledge of:",
    "options": [
        "Wound infection and treatment",
        "Internet",
        "Rockets"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African fishers and hunters contributed to early knowledge of wound infection and treatment."
},
{
    "id": 941,
    "question": "African healers used animal parts to understand anatomy. This is an early form of:",
    "options": [
        "Comparative anatomy",
        "Painting",
        "Dancing"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Using animal parts to understand anatomy is an early form of comparative anatomy."
},
{
    "id": 942,
    "question": "Which African region is known for documenting medicinal plant use extensively?",
    "options": [
        "West and East Africa",
        "Sahara only",
        "Kalahari only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "West and East Africa are known for extensively documenting medicinal plant use."
},
{
    "id": 943,
    "question": "African medical texts sometimes included:",
    "options": [
        "Surgery, injury care, and herbal doses",
        "Only myths",
        "Only recipes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African medical texts sometimes included surgery, injury care, and herbal doses."
},
{
    "id": 944,
    "question": "African healers studied seasonal diseases based on:",
    "options": [
        "Climate and ecology",
        "Myth only",
        "Astrology only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African healers studied seasonal diseases based on climate and ecology."
},
{
    "id": 945,
    "question": "African bone setting often included natural splints made of:",
    "options": [
        "Tree bark and fibers",
        "Plastic",
        "Metal tools only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African bone setting often included natural splints made of tree bark and fibers."
},
{
    "id": 946,
    "question": "Early African medical understanding helped prevent infection through:",
    "options": [
        "Clean water and herbal applications",
        "Noise",
        "Dance only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Early African medical understanding helped prevent infection through clean water and herbal applications."
},
{
    "id": 947,
    "question": "African communities used leech therapy in early times.",
    "options": [
        "True",
        "False",
        "Myth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African communities used leech therapy in early times."
},
{
    "id": 948,
    "question": "Early African medicine included diet prescriptions for wellness.",
    "options": [
        "True",
        "False",
        "Only rituals"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Early African medicine included diet prescriptions for wellness."
},
{
    "id": 949,
    "question": "African healers shared knowledge orally and in written manuscripts.",
    "options": [
        "True",
        "False",
        "Only written"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African healers shared knowledge orally and in written manuscripts."
},
{
    "id": 950,
    "question": "African dental knowledge included cleaning teeth with plant extracts.",
    "options": [
        "True",
        "False",
        "Myth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African dental knowledge included cleaning teeth with plant extracts."
},
{
    "id": 951,
    "question": "Which African healer studied bone fractures extensively?",
    "options": [
        "Practitioners in ancient Nubia",
        "Only war chiefs",
        "Only children"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Practitioners in ancient Nubia studied bone fractures extensively."
},
{
    "id": 952,
    "question": "Early African babies' nutrition was guided by:",
    "options": [
        "Local knowledge of herbs and food combinations",
        "Random foods",
        "Only water"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Early African babies' nutrition was guided by local knowledge of herbs and food combinations."
},
{
    "id": 953,
    "question": "African knowledge of disease spread was based on:",
    "options": [
        "Observation of symptoms and patterns",
        "Only myths",
        "Only songs"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African knowledge of disease spread was based on observation of symptoms and patterns."
},
{
    "id": 954,
    "question": "African herbal sciences contributed to later:",
    "options": [
        "Modern pharmacy",
        "Painting only",
        "Dance rituals only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African herbal sciences contributed to later modern pharmacy."
},
{
    "id": 955,
    "question": "African midwives had extensive knowledge of childbirth care.",
    "options": [
        "True",
        "False",
        "Myth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African midwives had extensive knowledge of childbirth care."
},
{
    "id": 956,
    "question": "African healers used plant combinations to treat skin infections.",
    "options": [
        "True",
        "False",
        "Myth"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African healers used plant combinations to treat skin infections."
},
{
    "id": 957,
    "question": "African medical knowledge was sometimes recorded in:",
    "options": [
        "Manuscripts and oral texts",
        "Only palm trees",
        "Only stone tablets"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African medical knowledge was sometimes recorded in manuscripts and oral texts."
},
{
    "id": 958,
    "question": "Early African prevention strategies included:",
    "options": [
        "Bathing and clean living",
        "Only salt",
        "Only color patterns"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Early African prevention strategies included bathing and clean living."
},
{
    "id": 959,
    "question": "African healers recognized the difference between:",
    "options": [
        "Viral vs bacterial symptoms",
        "Only spiritual causes",
        "Only dreams"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African healers recognized the difference between viral vs bacterial symptoms."
},
{
    "id": 960,
    "question": "One of the deepest lessons from ancient African medicine is:",
    "options": [
        "Observation and nature solve many health mysteries",
        "Only gods heal",
        "Only stories matter"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Observation and nature solve many health mysteries."
},
{
    "id": 961,
    "question": "Which West African empire is famous for mud-brick mosques and urban planning?",
    "options": [
        "Mali Empire",
        "Axum",
        "Kongo Kingdom"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Mali Empire is famous for mud-brick mosques and urban planning."
},
{
    "id": 962,
    "question": "The Great Mosque of Djenné was built using:",
    "options": [
        "Sun-dried mud bricks",
        "Stone only",
        "Timber only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Great Mosque of Djenné was built using sun-dried mud bricks."
},
{
    "id": 963,
    "question": "Which Central African kingdom constructed massive fortified palaces using local stones?",
    "options": [
        "Kingdom of Kongo",
        "Swahili city-states",
        "Hausa city-states"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Kingdom of Kongo constructed massive fortified palaces using local stones."
},
{
    "id": 964,
    "question": "Which Southern African site is famous for dry-stone walls without mortar?",
    "options": [
        "Great Zimbabwe",
        "Lalibela",
        "Axum"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Great Zimbabwe is famous for dry-stone walls without mortar."
},
{
    "id": 965,
    "question": "Great Zimbabwe's walls were primarily built for:",
    "options": [
        "Defense and social hierarchy",
        "Water storage",
        "Religious ceremonies only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Great Zimbabwe's walls were primarily built for defense and social hierarchy."
},
{
    "id": 966,
    "question": "The Hausa city-states in Nigeria innovated in:",
    "options": [
        "Walled city architecture with intricate gates",
        "Pyramids",
        "Floating islands"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Hausa city-states in Nigeria innovated in walled city architecture with intricate gates."
},
{
    "id": 967,
    "question": "The Benin Kingdom is known for:",
    "options": [
        "Bronze plaques and palace defenses",
        "Stone pyramids",
        "Wooden huts only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Benin Kingdom is known for bronze plaques and palace defenses."
},
{
    "id": 968,
    "question": "Which African engineering innovation was used to irrigate fields in Ethiopia?",
    "options": [
        "Terraced farming",
        "Aqueducts",
        "Wells with pumps only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Terraced farming was used to irrigate fields in Ethiopia."
},
{
    "id": 969,
    "question": "The Swahili city-states engineered ports using:",
    "options": [
        "Coral stone and natural breakwaters",
        "Concrete",
        "Bamboo bridges only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Swahili city-states engineered ports using coral stone and natural breakwaters."
},
{
    "id": 970,
    "question": "Which African civilization is famous for rock-hewn churches?",
    "options": [
        "Lalibela, Ethiopia",
        "Great Zimbabwe",
        "Mali"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Lalibela, Ethiopia is famous for rock-hewn churches."
},
{
    "id": 971,
    "question": "The Ewe people of West Africa developed:",
    "options": [
        "Suspension bridges from vines",
        "Aqueducts",
        "Stone pyramids"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Ewe people of West Africa developed suspension bridges from vines."
},
{
    "id": 972,
    "question": "In Central Africa, Mbanza Kongo featured:",
    "options": [
        "Stone walls, defensive moats, and urban layouts",
        "Floating gardens",
        "Pyramids"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mbanza Kongo featured stone walls, defensive moats, and urban layouts."
},
{
    "id": 973,
    "question": "The Ifé people of Nigeria are known for:",
    "options": [
        "Terra-cotta and bronze head sculptures",
        "Stone pyramids",
        "Mud walls only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Ifé people of Nigeria are known for terra-cotta and bronze head sculptures."
},
{
    "id": 974,
    "question": "Which African innovation allowed rainwater harvesting in Sahelian cities?",
    "options": [
        "Earthen dams and cisterns",
        "Stone aqueducts",
        "Modern pumps only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Earthen dams and cisterns allowed rainwater harvesting in Sahelian cities."
},
{
    "id": 975,
    "question": "The Fante and Akan people built:",
    "options": [
        "Forts along the Gold Coast for trade",
        "Floating islands",
        "Pyramids"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Fante and Akan people built forts along the Gold Coast for trade."
},
{
    "id": 976,
    "question": "Which North African kingdom had engineered roads and bridges before Roman arrival?",
    "options": [
        "Axum",
        "Mali",
        "Zulu"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Axum had engineered roads and bridges before Roman arrival."
},
{
    "id": 977,
    "question": "Which Southern African civilization used stone enclosures for cattle and trade?",
    "options": [
        "Mapungubwe",
        "Benin",
        "Hausa"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mapungubwe used stone enclosures for cattle and trade."
},
{
    "id": 978,
    "question": "African engineers in medieval times optimized:",
    "options": [
        "Mud, stone, and timber for earthquake resistance",
        "Concrete towers only",
        "Metal skyscrapers only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African engineers optimized mud, stone, and timber for earthquake resistance."
},
{
    "id": 979,
    "question": "Which African city had advanced drainage systems to prevent flooding?",
    "options": [
        "Kano, Nigeria",
        "Timbuktu only",
        "Lalibela only"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Kano, Nigeria had advanced drainage systems to prevent flooding."
},
{
    "id": 980,
    "question": "The Bambara in Mali built:",
    "options": [
        "Granaries with airflow systems to prevent spoilage",
        "Floating homes",
        "Wooden pyramids"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Bambara in Mali built granaries with airflow systems to prevent spoilage."
},
{
    "id": 981,
    "question": "Which African society created fortified trading posts along rivers?",
    "options": [
        "Swahili city-states",
        "Yoruba",
        "Herero"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Swahili city-states created fortified trading posts along rivers."
},
{
    "id": 982,
    "question": "African urban planning included:",
    "options": [
        "Streets oriented by cardinal directions",
        "Random paths",
        "Only circular villages"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African urban planning included streets oriented by cardinal directions."
},
{
    "id": 983,
    "question": "Which African structure required mathematical precision to fit stones without mortar?",
    "options": [
        "Great Zimbabwe",
        "Timbuktu",
        "Axum obelisks"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Great Zimbabwe required mathematical precision to fit stones without mortar."
},
{
    "id": 984,
    "question": "The Igbo Ukwu artifacts show knowledge of:",
    "options": [
        "Alloy metallurgy and intricate metalworking",
        "Only wood carving",
        "Only ceramics"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Igbo Ukwu artifacts show knowledge of alloy metallurgy and intricate metalworking."
},
{
    "id": 985,
    "question": "African builders designed fortified walls to:",
    "options": [
        "Protect trade centers and royal compounds",
        "Only mark boundaries",
        "Only religious purposes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African builders designed fortified walls to protect trade centers and royal compounds."
},
{
    "id": 986,
    "question": "Which African kingdom built moats and defensive ditches around capitals?",
    "options": [
        "Kongo",
        "Mali",
        "Zulu"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Kongo built moats and defensive ditches around capitals."
},
{
    "id": 987,
    "question": "African mining towns engineered:",
    "options": [
        "Water channels and storage for ore processing",
        "Only tents",
        "Only caves"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African mining towns engineered water channels and storage for ore processing."
},
{
    "id": 988,
    "question": "Which African city used coral stone architecture to survive the coastal climate?",
    "options": [
        "Kilwa Kisiwani",
        "Kano",
        "Mapungubwe"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Kilwa Kisiwani used coral stone architecture to survive the coastal climate."
},
{
    "id": 989,
    "question": "African construction often relied on seasonal labor patterns to:",
    "options": [
        "Coordinate large building projects efficiently",
        "Build for magic",
        "Only ritual purposes"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African construction relied on seasonal labor patterns to coordinate large building projects efficiently."
},
{
    "id": 990,
    "question": "One of the biggest lessons from African engineering:",
    "options": [
        "Indigenous knowledge adapted to local environment solves complex problems",
        "Only imported knowledge works",
        "Only myths explain construction"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Indigenous knowledge adapted to local environment solves complex problems."
},
{
    "id": 991,
    "question": "Which African desert produces dust that fertilizes the Amazon rainforest?",
    "options": [
        "Sahara",
        "Kalahari",
        "Namib"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Sahara produces dust that fertilizes the Amazon rainforest."
},
{
    "id": 992,
    "question": "Which African river is known for unique fish biodiversity and supporting millions of people?",
    "options": [
        "Congo River",
        "Nile River",
        "Limpopo River"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Congo River is known for unique fish biodiversity and supporting millions of people."
},
{
    "id": 993,
    "question": "The Okavango Delta in Botswana is unique because:",
    "options": [
        "It floods seasonally but forms an inland delta",
        "It flows into the sea",
        "It is dry all year"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Okavango Delta floods seasonally but forms an inland delta."
},
{
    "id": 994,
    "question": "Which African forest is considered the second-largest tropical rainforest in the world?",
    "options": [
        "Congo Basin",
        "Amazon",
        "Madagascar dry forest"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Congo Basin is the second-largest tropical rainforest in the world."
},
{
    "id": 995,
    "question": "The Baobab tree is important because:",
    "options": [
        "It stores water and provides food in dry seasons",
        "It produces gold",
        "It attracts snow"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Baobab tree stores water and provides food in dry seasons."
},
{
    "id": 996,
    "question": "Which African coastal ecosystem is crucial for protecting fisheries and buffering storms?",
    "options": [
        "Mangrove forests",
        "Coral deserts",
        "Grasslands"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Mangrove forests are crucial for protecting fisheries and buffering storms."
},
{
    "id": 997,
    "question": "The Namib Desert is unique because:",
    "options": [
        "It has some of the world's tallest sand dunes shaped by wind",
        "It is covered in glaciers",
        "It floods every year"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Namib Desert has some of the world's tallest sand dunes shaped by wind."
},
{
    "id": 998,
    "question": "African pastoralists historically rotated herds to:",
    "options": [
        "Prevent overgrazing and maintain soil fertility",
        "Find gold",
        "Build roads"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African pastoralists rotated herds to prevent overgrazing and maintain soil fertility."
},
{
    "id": 999,
    "question": "Which African island has remained isolated, preserving unique species?",
    "options": [
        "Madagascar",
        "Sicily",
        "Mauritius"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Madagascar has remained isolated, preserving unique species."
},
{
    "id": 1000,
    "question": "African wetlands are crucial because they:",
    "options": [
        "Purify water and support wildlife",
        "Only serve as trading posts",
        "Only produce sand"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African wetlands purify water and support wildlife."
},
{
    "id": 1001,
    "question": "The Kalahari Desert is home to which sustainable hunter-gatherer group?",
    "options": [
        "San people",
        "Zulu warriors",
        "Yoruba farmers"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The San people are a sustainable hunter-gatherer group in the Kalahari Desert."
},
{
    "id": 1002,
    "question": "African rivers create fertile plains because of:",
    "options": [
        "Seasonal flooding depositing nutrient-rich silt",
        "Rainwater only",
        "Only underground springs"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African rivers create fertile plains because of seasonal flooding depositing nutrient-rich silt."
},
{
    "id": 1003,
    "question": "Which African practice maintains soil fertility without chemical fertilizers?",
    "options": [
        "Crop rotation and intercropping",
        "Mining",
        "Only burning forests"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Crop rotation and intercropping maintain soil fertility without chemical fertilizers."
},
{
    "id": 1004,
    "question": "Which African lake is pink due to high salt content and algae?",
    "options": [
        "Lake Natron (Tanzania)",
        "Lake Chad",
        "Lake Victoria"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Lake Natron in Tanzania is pink due to high salt content and algae."
},
{
    "id": 1005,
    "question": "African coastal dunes prevent:",
    "options": [
        "Inland desert expansion",
        "River flooding",
        "Tornado formation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African coastal dunes prevent inland desert expansion."
},
{
    "id": 1006,
    "question": "The Virunga Mountains are important for:",
    "options": [
        "Volcanoes and endangered mountain gorillas",
        "Ski resorts",
        "Desert storms"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Virunga Mountains are important for volcanoes and endangered mountain gorillas."
},
{
    "id": 1007,
    "question": "Which African tree species produces edible fruit and lives for thousands of years?",
    "options": [
        "Baobab",
        "Coconut",
        "Oak"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Baobab tree produces edible fruit and lives for thousands of years."
},
{
    "id": 1008,
    "question": "African savanna ecosystems are maintained by:",
    "options": [
        "Fire, herbivores, and seasonal rainfall",
        "Only humans",
        "Only snow"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African savanna ecosystems are maintained by fire, herbivores, and seasonal rainfall."
},
{
    "id": 1009,
    "question": "Which African river system has the largest hydroelectric potential?",
    "options": [
        "Congo River",
        "Niger River",
        "Zambezi"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Congo River system has the largest hydroelectric potential."
},
{
    "id": 1010,
    "question": "African desert plants survive drought using:",
    "options": [
        "Deep roots and water-storing trunks",
        "Wings to fly",
        "Storing clouds"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African desert plants survive drought using deep roots and water-storing trunks."
},
{
    "id": 1011,
    "question": "Which African ecosystem hosts the largest migration of land animals?",
    "options": [
        "Serengeti (Tanzania/Kenya)",
        "Sahara",
        "Namib"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Serengeti hosts the largest migration of land animals."
},
{
    "id": 1012,
    "question": "African mangroves also protect:",
    "options": [
        "Coastal communities from storms",
        "Only birds",
        "Only minerals"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African mangroves protect coastal communities from storms."
},
{
    "id": 1013,
    "question": "Which African island is known for lemur biodiversity?",
    "options": [
        "Madagascar",
        "Zanzibar",
        "Mauritius"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Madagascar is known for lemur biodiversity."
},
{
    "id": 1014,
    "question": "African wetlands like Sudd in South Sudan help:",
    "options": [
        "Reduce floods and store carbon",
        "Only transport goods",
        "Only produce sand"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African wetlands like Sudd help reduce floods and store carbon."
},
{
    "id": 1015,
    "question": "African farmers in the Sahel adapted to low rainfall by:",
    "options": [
        "Planting drought-resistant millet and sorghum",
        "Only wheat",
        "Only rice"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African farmers in the Sahel adapted to low rainfall by planting drought-resistant millet and sorghum."
},
{
    "id": 1016,
    "question": "Which African desert is home to unique fog-dependent plants?",
    "options": [
        "Namib",
        "Sahara",
        "Kalahari"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "The Namib Desert is home to unique fog-dependent plants."
},
{
    "id": 1017,
    "question": "African coral reefs support:",
    "options": [
        "Fisheries and coastal protection",
        "Desert expansion",
        "Volcano formation"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African coral reefs support fisheries and coastal protection."
},
{
    "id": 1018,
    "question": "Which African practice reduces soil erosion in hilly regions?",
    "options": [
        "Terracing",
        "Burning all trees",
        "Concrete paving"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Terracing reduces soil erosion in hilly regions."
},
{
    "id": 1019,
    "question": "African sustainable forest management included:",
    "options": [
        "Controlled harvesting and sacred groves",
        "Only cutting all trees",
        "Mining"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "African sustainable forest management included controlled harvesting and sacred groves."
},
{
    "id": 1020,
    "question": "The deepest lesson from African environmental science:",
    "options": [
        "Adaptation and local knowledge sustain life in harsh climates",
        "Only imported solutions work",
        "Africa is only desert"
    ],
    "answer_index": 0,
    "image_url": "",
    "explanation": "Adaptation and local knowledge sustain life in harsh climates."
},
    {
        "id": 1021,
        "question": "The concept of “Ma'at” in ancient Kemet represents:",
        "options": ["Chaos and war", "Truth, balance, and justice", "Royal power"],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1022,
        "question": "In many traditional African societies, a leader who ruled without listening to the people was often:",
        "options":[ "Praised as strong", "Removed or corrected by elders", "Given more power"],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1023,
        "question": "Which philosopher criticized colonialism for damaging the minds of the colonized?",
        "options":[ "Frantz Fanon", "Aristotle", "Vasco da Gama"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Fanon argued that colonialism not only exploited resources but also harmed the psychological well-being of colonized people, creating a sense of inferiority."
    },
    {
        "id": 1024,
        "question": "Foreign involvement in African mineral extraction is often tied to:",
        "options":[ "Global supply chains and industrial demand", "Only local markets", "Space exploration"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Outside nations link African minerals to global manufacturing and tech sectors."
    },
    {
        "id": 1025,
        "question": "“Ethnophilosophy” is the idea that:",
        "options": [
            "Only Europeans can do philosophy",
            "Philosophy exists in African cultures, proverbs, and traditions",
            "Philosophy must be written in Latin"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1026,
        "question": "The Akan concept of “Sankofa” teaches that:",
        "options": [
            "The past does not matter",
            "It is wrong to question history",
            "We must learn from the past to move forward"
        ],
        "answer_index": 2,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1027,
        "question": "In Ubuntu thinking, harming another person is wrong mainly because:",
        "options": [
            "It weakens the community",
            "It breaks a written law",
            "It reduces military power"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1028,
        "question": "Before colonial courts were introduced, many African communities resolved disputes through:",
        "options": [
            "Community dialogue and mediation",
            "Long prison sentences",
            "Foreign judges"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1029,
        "question": "The idea that knowledge can be preserved through oral tradition means:",
        "options": [
            "Knowledge only exists in books",
            "Stories, proverbs, and elders can carry deep wisdom",
            "Writing is the only valid way to think"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1030,
        "question": "The philosopher Kwasi Wiredu encouraged Africans to:",
        "options": [
            "Think critically using their own languages and concepts",
            "Reject all modern science",
            "Copy European systems exactly"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1031,
        "question": "Which idea best challenges the claim that philosophy began only in Europe?",
        "options": [
            "African societies had no moral systems",
            "African civilizations developed complex ethical systems long before colonial rule",
            "Philosophy requires colonization"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1032,
        "question": "What does the name \"Ghana\" refer to?",
        "options": [
            "A type of river",
            "An ancient West African empire",
            "A mountain range"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1033,
        "question": "The name \"Nigeria\" was created during colonial times and comes from:",
        "options": [
            "A local king's name",
            "The Niger River",
            "An African word for unity"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1034,
        "question": "The green color on Nigeria's flag represents:",
        "options": [
            "Military power",
            "Forests and agriculture",
            "Oil wealth"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1035,
        "question": "The red, gold, and green colors used by many African countries were first popularized by:",
        "options": [
            "Ethiopia",
            "France",
            "Portugal"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1036,
        "question": "The name \"Kenya\" comes from:",
        "options": [
            "A European explorer",
            "Mount Kenya (Kirinyaga)",
            "A type of animal"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1037,
        "question": "The black star on Ghana's flag represents:",
        "options": [
            "Gold resources",
            "African freedom and unity",
            "A famous battle"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1038,
        "question": "The name \"Zimbabwe\" comes from:",
        "options": [
            "A European trading company",
            "A Shona phrase meaning \"great houses of stone\"",
            "A river"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1039,
        "question": "The crescent and star on Algeria's flag are symbols commonly associated with:",
        "options": [
            "Agriculture",
            "Islam",
            "Mining"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1040,
        "question": "The name \"South Africa\" mainly describes:",
        "options": [
            "Its culture",
            "Its position on the continent",
            "Its main language"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1041,
        "question": "Why do many African flags include green?",
        "options": [
            "It represents the continent's natural land and resources",
            "It represents winter",
            "It represents snow"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1042,
        "question": "What was the former name of Burkina Faso before 1984?",
        "options": [
            "Upper Volta",
            "French Sudan",
            "Gold Coast"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1043,
        "question": "The name \"Burkina Faso\" means:",
        "options": [
            "Land of Gold",
            "Land of Upright People",
            "River Nation"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1044,
        "question": "The name \"Ethiopia\" comes from an ancient Greek term meaning:",
        "options": [
            "Land of Coffee",
            "Land of Burnt Faces",
            "Land of Mountains"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1045,
        "question": "Which African country changed its name from Swaziland in 2018?",
        "options": [
            "Lesotho",
            "Eswatini",
            "Botswana"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1046,
        "question": "The name \"Namibia\" comes from:",
        "options": [
            "A colonial governor",
            "The Namib Desert",
            "A river in Europe"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1047,
        "question": "The blue stripe on the flag of The Gambia represents:",
        "options": [
            "Peace",
            "The Gambia River",
            "The Atlantic Ocean"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1048,
        "question": "The star on Cameroon's flag represents:",
        "options": [
            "Oil wealth",
            "Unity of the country",
            "A volcano"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1049,
        "question": "The name \"Zambia\" is derived from:",
        "options": [
            "The Zambezi River",
            "A Portuguese explorer",
            "A mineral"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1050,
        "question": "Which African country's name means \"lion's mountains\" in Portuguese?",
        "options": [
            "Sierra Leone",
            "Angola",
            "Mozambique"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1051,
        "question": "Which of these countries was not renamed after independence?",
        "options": [
            "Ghana",
            "Côte d'Ivoire",
            "Zimbabwe"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1052,
        "question": "What was Ghana called during British rule?",
        "options": [
            "Gold Coast",
            "Upper Guinea",
            "Ashanti Colony"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1053,
        "question": "The country now known as Malawi was once called:",
        "options": [
            "Nyasaland",
            "Rhodesia",
            "Tanganyika"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1054,
        "question": "Zimbabwe was once known as:",
        "options": [
            "Northern Rhodesia",
            "Southern Rhodesia",
            "Bechuanaland"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1055,
        "question": "Zambia was formerly:",
        "options": [
            "Northern Rhodesia",
            "South West Africa",
            "Basutoland"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1056,
        "question": "Benin used to be called:",
        "options": [
            "Dahomey",
            "Togoland",
            "French Sudan"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1057,
        "question": "The Democratic Republic of the Congo was once called:",
        "options": [
            "Belgian West Africa",
            "Zaire",
            "Central Guinea"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1058,
        "question": "Botswana was formerly:",
        "options": [
            "Basutoland",
            "Bechuanaland",
            "Swaziland"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1059,
        "question": "Lesotho was once known as:",
        "options": [
            "Basutoland",
            "Ovamboland",
            "Nyasaland"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1060,
        "question": "Tanzania was formed from the union of:",
        "options": [
            "Tanganyika and Zanzibar",
            "Kenya and Uganda",
            "Sudan and Eritrea"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1061,
        "question": "Which country kept its name before and after colonial rule?",
        "options": [
            "Ethiopia",
            "Ghana",
            "Zambia"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1062,
        "question": "The red in many African flags often represents:",
        "options": [
            "Sunlight",
            "The struggle and sacrifice for freedom",
            "Farming"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1063,
        "question": "The black in many Pan-African flags represents:",
        "options": [
            "Oil",
            "African people",
            "Night"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1064,
        "question": "The star on Senegal's flag represents:",
        "options": [
            "Unity and hope",
            "Military strength",
            "Gold"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1065,
        "question": "The wheel on Rwanda's old flag symbolized:",
        "options": [
            "Agriculture",
            "Industrial development",
            "Time"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1066,
        "question": "The spear and shield on Kenya's flag represent:",
        "options": [
            "Tourism",
            "Traditional defense and heritage",
            "Trade"
        ],  
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1067,
        "question": "The sun on Namibia's flag represents:",
        "options": [
            "Desert heat",
            "Energy and life",
            "Gold"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1068,
        "question": "The cedar tree on Lebanon's flag is famous, but which African country features a tree?",
        "options": [
            "Gabon",
            "Equatorial Guinea",
            "Niger"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1069,
        "question": "The star on Somalia's flag represents:",
        "options": [
            "Five regions where Somali people live",
            "Five oceans",
            "Five mountains"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1070,
        "question": "The triangle in Eritrea's flag symbolizes:",
        "options": [
            "Oil",
            "The liberation movement",
            "The Nile"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1071,
        "question": "Which African country's flag has no red, green, or black?",
        "options": [
            "Nigeria",
            "Botswana",
            "Ghana"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1072,
        "question": "Nigeria moved its capital from Lagos to:",
        "options": [
            "Kano",
            "Abuja",
            "Ibadan"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1073,
        "question": "Tanzania's official capital is:",
        "options": [
            "Dar es Salaam",
            "Dodoma",
            "Arusha"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1074,
        "question": "Côte d'Ivoire's official capital is:",
        "options": [
            "Abidjan",
            "Yamoussoukro",
            "Dakar"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1075,
        "question": "South Africa has:",
        "options": [
            "One capital",
            "Two capitals",
            "Three capitals"
        ],
        "answer_index": 2,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1076,
        "question": "Which city is South Africa's administrative capital?",
        "options": [
            "Cape Town",
            "Pretoria",
            "Johannesburg"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1077,
        "question": "Malawi's capital moved from Zomba to:",
        "options": [
            "Lilongwe",
            "Blantyre",
            "Mzuzu"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1078,
        "question": "Egypt's capital is:",
        "options": [
            "Alexandria",
            "Cairo",
            "Giza"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1079,
        "question": "Which capital was purpose-built to be more central and neutral?",
        "options": [
            "Lagos",
            "Abuja",
            "Mombasa"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1080,
        "question": "Addis Ababa is the capital of:",
        "options": [
            "Eritrea",
            "Ethiopia",
            "Somalia"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": ""
    },
    {
        "id": 1081,
        "question": "Which country's capital is located on an island?",
        "options": [
            "Madagascar",
            "Kenya",
            "Chad"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Antananarivo, Madagascar's capital, is located in the highlands of the island nation, making it unique among African capitals."
    },
    {
        "id": 1082,
        "question": "How many recognized sovereign countries are in Africa?",
        "options": [
            "52",
            "54",
            "56"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Africa has 54 internationally recognized sovereign states, making it the continent with the second-highest number of countries after Asia. All are members of the United Nations."
    },
    {
        "id": 1083,
        "question": "Which of these is considered a sovereign country in Africa?",
        "options": [
            "Western Sahara",
            "Somaliland",
            "Morocco"
        ],
        "answer_index": 2,
        "image_url": "",
        "explanation": "Morocco is a fully recognized sovereign nation. Western Sahara and Somaliland are disputed territories without full international recognition."
    },
    {
        "id": 1084,
        "question": "Africa has the second-largest number of countries after:",
        "options": [
            "Asia",
            "Europe",
            "South America"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Asia has 48 countries while Africa has 54, making it the continent with the most nations globally."
    },
    {
        "id": 1085,
        "question": "Which African country is not a member of the African Union?",
        "options": [
            "Morocco",
            "South Sudan",
            "None — all 54 are members"
        ],
        "answer_index": 2,
        "image_url": "",
        "explanation": "All 54 recognized African nations are members of the African Union. Morocco rejoined in 2017 after a 33-year absence, making membership universal."
    },
    {
        "id": 1086,
        "question": "The newest internationally recognized country in Africa is:",
        "options": [
            "Eritrea",
            "South Sudan",
            "Namibia"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "South Sudan gained independence on July 9, 2011, becoming Africa's newest country after separating from Sudan following a civil war and referendum."
    },
    {
        "id": 1087,
        "question": "Eritrea gained independence in:",
        "options": [
            "1960",
            "1993",
            "2005"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Eritrea became independent on May 24, 1993, after a 30-year armed struggle for independence from Ethiopia, making it Africa's most recent country before South Sudan."
    },
    {
        "id": 1088,
        "question": "South Sudan gained independence in:",
        "options": [
            "1999",
            "2005",
            "2011"
        ],
        "answer_index": 2,
        "image_url": "",
        "explanation": "South Sudan became the world's newest country on July 9, 2011, following the Second Sudanese Civil War and a 2005 Comprehensive Peace Agreement."
    },
    {
        "id": 1089,
        "question": "The African Union headquarters is located in:",
        "options": [
            "Nairobi",
            "Addis Ababa",
            "Cairo"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The African Union Commission is headquartered in Addis Ababa, Ethiopia, chosen as a symbol of African leadership and nationalism since the OAU (Organization of African Unity) was founded there in 1963."
    },
    {
        "id": 1090,
        "question": "Africa is divided into how many commonly recognized regions?",
        "options": [
            "4",
            "5",
            "6"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Africa is commonly divided into 5 regions: North Africa, West Africa, East Africa, Central Africa, and Southern Africa, each with distinct geographical, cultural, and political characteristics."
    },
    {
        "id": 1091,
        "question": "Which country is both in Africa and partly considered Middle Eastern?",
        "options": [
            "Egypt",
            "Ghana",
            "Zambia"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Egypt is geographically in Africa but culturally and politically bridges North Africa and the Middle East. The Sinai Peninsula crosses into Western Asia, giving it transcontinental significance."
    },
    {
        "id": 1092,
        "question": "Ghana gained independence in:",
        "options": [
            "1957",
            "1963",
            "1945"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana became independent on March 6, 1957, as the first sub-Saharan African nation to gain independence, inspiring other African independence movements."
    },
    {
        "id": 1093,
        "question": "Nigeria gained independence in:",
        "options": [
            "1957",
            "1960",
            "1963"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Nigeria gained independence on October 1, 1960, from British colonial rule. As Africa's most populous country, Nigeria's independence was significant for the continent."
    },
    {
        "id": 1094,
        "question": "Kenya gained independence in:",
        "options": [
            "1963",
            "1960",
            "1952"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kenya achieved independence on December 12, 1963, ending British colonial rule. Jomo Kenyatta became its first president and shaped the nation's early development."
    },
    {
        "id": 1095,
        "question": "Algeria gained independence in:",
        "options": [
            "1958",
            "1962",
            "1975"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Algeria won independence on July 5, 1962, after a brutal 8-year war (Algerian War of Independence) against French colonial rule, one of the bloodiest decolonization conflicts."
    },
    {
        "id": 1096,
        "question": "Angola gained independence in:",
        "options": [
            "1975",
            "1960",
            "1989"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Angola gained independence on November 11, 1975, from Portugal, but faced a prolonged civil war lasting 27 years that delayed its development and stability."
    },
    {
        "id": 1097,
        "question": "Mozambique gained independence in:",
        "options": [
            "1962",
            "1975",
            "1980"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Mozambique became independent on June 25, 1975, after armed struggle against Portuguese colonial rule. The country suffered a subsequent 16-year civil war."
    },
    {
        "id": 1098,
        "question": "Zimbabwe gained independence in:",
        "options": [
            "1965",
            "1980",
            "1970"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Zimbabwe achieved independence on April 18, 1980, ending Rhodesian white minority rule after a bitter liberation war led by forces including ZANU-PF and ZAPU."
    },
    {
        "id": 1099,
        "question": "Namibia gained independence in:",
        "options": [
            "1985",
            "1990",
            "1979"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Namibia gained independence on March 21, 1990, from South African rule, ending decades of apartheid occupation and becoming a symbol of African liberation."
    },
    {
        "id": 1100,
        "question": "South Africa's first democratic election was in:",
        "options": [
            "1994",
            "1985",
            "2001"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "South Africa's first democratic elections were held on April 27, 1994, ending apartheid. Nelson Mandela was elected president, marking the end of systematic racial segregation."
    },
    {
        "id": 1101,
        "question": "Which country gained independence first?",
        "options": [
            "Ghana",
            "Nigeria",
            "Kenya"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana gained independence in 1957, three years before Nigeria (1960) and six years before Kenya (1963), making it the pioneer of sub-Saharan African independence."
    },
    {
        "id": 1102,
        "question": "Nigeria's national motto is:",
        "options": [
            "Freedom and Justice",
            "Unity and Faith, Peace and Progress",
            "One People, One Nation"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Nigeria's national motto 'Unity and Faith, Peace and Progress' reflects the nation's aspirations for unity among its diverse 250+ ethnic groups and pursuit of national development."
    },
    {
        "id": 1103,
        "question": "Kenya's national motto is:",
        "options": [
            "Harambee",
            "Uhuru",
            "Umoja"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "'Harambee' means 'pull together' in Swahili, emphasizing national unity and collective effort. It was popularized by Jomo Kenyatta as a call for development and cooperation."
    },
    {
        "id": 1104,
        "question": "Ghana's national motto is:",
        "options": [
            "Freedom and Justice",
            "God and Country",
            "Unity and Strength"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana's national motto 'Freedom and Justice' represents the nation's values of liberty and fairness, central to Ghanaian identity since independence."
    },
    {
        "id": 1105,
        "question": "Tanzania's national motto is:",
        "options": [
            "Work and Unity",
            "Uhuru na Umoja (Freedom and Unity)",
            "Peace and Development"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Tanzania's official motto 'Uhuru na Umoja' (Freedom and Unity) reflects the nation's commitment to independence and national cohesion among its diverse population."
    },
    {
        "id": 1106,
        "question": "South Africa's national motto (in Khoisan language) means:",
        "options": [
            "One People, One Future",
            "Unity in Diversity",
            "Freedom Forever"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "'Ubuntu ngumuntu ngabantu' means 'Unity in Diversity' and reflects the post-apartheid South African values of inclusion and interconnectedness across racial groups."
    },
    {
        "id": 1107,
        "question": "Rwanda's national motto is:",
        "options": [
            "Unity, Work, Patriotism",
            "God and Freedom",
            "Strength Through Struggle"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "'Unity, Work, Patriotism' represents Rwanda's national priorities for post-genocide reconciliation, economic development, and national pride in rebuilding."
    },
    {
        "id": 1108,
        "question": "Ethiopia's motto emphasizes:",
        "options": [
            "Unity",
            "Diversity",
            "Strength"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Ethiopia's constitution emphasizes diversity and respect for different ethnic and cultural identities, reflecting the nation's commitment to pluralism among its many ethnic groups."
    },
    {
        "id": 1109,
        "question": "Senegal's national motto is:",
        "options": [
            "One People, One Goal, One Faith",
            "Faith and Work",
            "Freedom and Light"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "'One People, One Goal, One Faith' reflects Senegal's values of national unity and Islamic tradition, central to Senegalese identity and culture."
    },
    {
        "id": 1110,
        "question": "Zambia's national motto is:",
        "options": [
            "Peace and Progress",
            "One Zambia, One Nation",
            "God and People"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "'One Zambia, One Nation' was coined by founding president Kenneth Kaunda to promote unity among Zambia's 70+ ethnic groups after independence."
    },
    {
        "id": 1111,
        "question": "Botswana's national motto is:",
        "options": [
            "Pula (Rain)",
            "Modimo",
            "Kagiso"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "'Pula' means 'rain' in Setswana, symbolizing abundance and life in this semi-arid nation. It reflects the people's prayer for prosperity and blessings."
    },
    {
        "id": 1112,
        "question": "The Mali Empire became wealthy mainly because it controlled:",
        "options": [
            "Diamond mines in the south",
            "Trans-Saharan gold and salt trade routes",
            "Atlantic shipping lanes"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Mali's wealth came from controlling trans-Saharan trade routes, particularly the gold and salt trade. Gold flowed north to North Africa and Europe, bringing immense wealth."
    },
    {
        "id": 1113,
        "question": "Mansa Musa is famous for:",
        "options": [
            "Discovering new land",
            "His pilgrimage to Mecca that displayed immense wealth",
            "Inventing paper"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Mansa Musa's 1324 pilgrimage to Mecca was legendary for its grandeur, with reports of 60,000 people and 80 camels carrying gold. He became an Islamic scholar and builder of mosques."
    },
    {
        "id": 1114,
        "question": "The Songhai Empire's capital was:",
        "options": [
            "Timbuktu",
            "Gao",
            "Kano"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Gao was the capital of the Songhai Empire (1464-1591), which succeeded Mali and became the largest West African empire, extending from the Atlantic to modern-day Nigeria."
    },
    {
        "id": 1115,
        "question": "Great Zimbabwe is best known for:",
        "options": [
            "Wooden palaces",
            "Massive stone structures built without mortar",
            "Roman-style roads"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Great Zimbabwe (1100-1450 CE) featured massive dry-stone walls and structures with no mortar, demonstrating sophisticated engineering. It was the capital of a powerful empire controlling gold trade."
    },
    {
        "id": 1116,
        "question": "The Kingdom of Kush was located in:",
        "options": [
            "Present-day Sudan",
            "Present-day Ghana",
            "Present-day Kenya"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kush was an ancient kingdom in the Nile Valley (modern Sudan), lasting from around 2500 BCE to 350 CE. It was a powerful neighbor to ancient Egypt, sometimes tributary, sometimes independent."
    },
    {
        "id": 1117,
        "question": "The Benin Kingdom (in present-day Nigeria) was known for:",
        "options": [
            "Bronze artworks and advanced city walls",
            "Ice harvesting",
            "Paper currency"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Benin Kingdom (1440-1898) produced world-renowned Benin bronze plaques and sculptures. It featured sophisticated city walls and achieved high artistic and administrative excellence."
    },
    {
        "id": 1118,
        "question": "The Aksumite Empire (Axum) was located in:",
        "options": [
            "West Africa",
            "East Africa (modern Ethiopia/Eritrea)",
            "Southern Africa"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Aksum (100-940 CE) was one of the ancient world's great powers, in present-day Ethiopia and Eritrea. It was a major trade hub and the second empire to adopt Christianity officially."
    },
    {
        "id": 1119,
        "question": "The Kingdom of Kongo was located in:",
        "options": [
            "Central Africa",
            "North Africa",
            "Southern Europe"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Kingdom of Kongo (1390-1914) was a powerful Central African state in present-day Democratic Republic of Congo. It had a sophisticated government system and trade networks."
    },
    {
        "id": 1120,
        "question": "The Zulu Kingdom rose to prominence under:",
        "options": [
            "Shaka Zulu",
            "Cetshwayo I",
            "Moshoeshoe I"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Shaka Zulu (1787-1828) revolutionized Zulu military organization, introducing the short spear and disciplined regiments. He expanded the Zulu Kingdom into one of Southern Africa's most powerful states."
    },
    {
        "id": 1121,
        "question": "The Ethiopian Empire is historically significant because:",
        "options": [
            "It had no writing system",
            "It maintained independence for most of its history",
            "It had no organized army"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Ethiopia maintained independence throughout most of its history, avoiding colonization except for a brief Italian occupation (1936-1941). It was the only African nation to have its own written script, Ge'ez."
    },
    {
        "id": 1122,
        "question": "The Oyo Empire was known for:",
        "options": [
            "A strong cavalry military system",
            "Naval dominance",
            "Desert trade only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Oyo Empire (1400-1896) in present-day Nigeria was famous for its powerful cavalry army and sophisticated political system. It dominated West African trade and politics for centuries."
    },
    {
        "id": 1123,
        "question": "The Kanem-Bornu Empire was located near:",
        "options": [
            "Lake Victoria",
            "Lake Chad",
            "The Nile Delta"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Kanem-Bornu (700-1900) was one of Africa's longest-lasting empires, located in the Sahel region near Lake Chad. It was a major Islamic center and trade hub connecting trans-Saharan routes."
    },
    {
        "id": 1124,
        "question": "The Mutapa (Mwene Mutapa) Empire controlled:",
        "options": [
            "Gold trade in Southern Africa",
            "Mediterranean ports",
            "Indian Ocean piracy"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Mutapa Empire (1430-1760) in Southern Africa controlled vast territories and dominated gold trade through the Indian Ocean. It was a major regional power until Portuguese colonial expansion."
    },
    {
        "id": 1125,
        "question": "The Almoravid movement began in:",
        "options": [
            "North-West Africa",
            "Central Africa",
            "Southern Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Almoravid dynasty (1040-1147) emerged from the Sahara (modern Mauritania) and expanded into Morocco, Spain, and West Africa, becoming a major Islamic empire."
    },
    {
        "id": 1126,
        "question": "The Kingdom of Dahomey was located in:",
        "options": [
            "Present-day Benin",
            "Present-day Tanzania",
            "Present-day Somalia"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Dahomey (1625-1894) was a powerful West African kingdom in present-day Benin, known for its sophisticated government, female warriors, and strong military organization."
    },
    {
        "id": 1127,
        "question": "The Hausa city-states were known for:",
        "options": [
            "Desert nomadism only",
            "Trade, scholarship, and city governance",
            "Island fishing"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Hausa city-states (Niger/Nigeria region) were major centers of commerce, Islamic scholarship, and governance. They controlled important trans-Saharan and regional trade routes."
    },
    {
        "id": 1128,
        "question": "The Luba and Lunda kingdoms were located in:",
        "options": [
            "Central Africa",
            "West Africa",
            "North Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Luba and Lunda kingdoms (1500s-1800s) in Central Africa (Congo region) were highly organized with sophisticated administrative systems and extensive trading networks."
    },
    {
        "id": 1129,
        "question": "The Empire of Ghana (Wagadou) existed before:",
        "options": [
            "The Mali Empire",
            "The Zulu Kingdom",
            "The Songhai Empire"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana (Wagadou) Empire (700-1000 CE) predated Mali and controlled trans-Saharan trade. It was the first great empire of West Africa, controlling gold and salt trade."
    },
    {
        "id": 1130,
        "question": "The Swahili city-states thrived because of:",
        "options": [
            "Indian Ocean trade",
            "Arctic trade",
            "Roman conquest"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Swahili city-states (Zanzibar, Mombasa, Kilwa) flourished through Indian Ocean trade, connecting East Africa with Arabia, India, and beyond. They became wealthy maritime commercial hubs."
    },
    {
        "id": 1131,
        "question": "Which of these empires was Christian long before European colonization?",
        "options": [
            "Mali",
            "Aksum",
            "Songhai"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Aksumite Empire adopted Christianity in the 4th century CE, making it one of Christianity's earliest major centers outside the Mediterranean, predating European Christian expansion by over a thousand years."
    },
    {
        "id": 1132,
        "question": "The largest ethnic group in Nigeria is:",
        "options": [
            "Yoruba",
            "Igbo",
            "Hausa-Fulani"
        ],
        "answer_index": 2,
        "image_url": "",
        "explanation": "The Hausa-Fulani ethnic group comprises about 29% of Nigeria's population. Nigeria has over 250 ethnic groups, making it one of the world's most ethnically diverse nations."
    },
    {
        "id": 1133,
        "question": "The Zulu people are mainly found in:",
        "options": [
            "Ghana",
            "South Africa",
            "Kenya"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Zulu people primarily inhabit South Africa's KwaZulu-Natal province. They have a rich history of military excellence and cultural tradition under leaders like Shaka Zulu."
    },
    {
        "id": 1134,
        "question": "The Berbers are indigenous to:",
        "options": [
            "North Africa",
            "Central Africa",
            "Southern Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Berbers (Amazigh) are the indigenous people of North Africa (Morocco, Algeria, Tunisia, Libya). They have inhabited this region for thousands of years with their own languages and culture."
    },
    {
        "id": 1135,
        "question": "The Maasai are known for:",
        "options": [
            "Desert farming",
            "Pastoralism and cattle herding",
            "Fishing in the Nile"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Maasai people of Kenya and Tanzania are famously pastoral, with cattle being central to their economy, culture, and social structure. They maintain semi-nomadic lifestyles herding livestock."
    },
    {
        "id": 1136,
        "question": "The Shona people built:",
        "options": [
            "Timbuktu University",
            "Great Zimbabwe",
            "Aksum Obelisks"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Shona people of Zimbabwe built the spectacular Great Zimbabwe (1100-1450 CE), a series of massive stone structures without mortar, demonstrating advanced architectural knowledge."
    },
    {
        "id": 1137,
        "question": "The largest African language family is:",
        "options": [
            "Niger-Congo",
            "Afro-Asiatic",
            "Nilo-Saharan"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Niger-Congo is Africa's largest language family, containing over 1,500 languages spoken by more than 700 million people across sub-Saharan Africa."
    },
    {
        "id": 1138,
        "question": "Swahili is part of which language family?",
        "options": [
            "Niger-Congo",
            "Bantu (subset of Niger-Congo)",
            "Afro-Asiatic"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Swahili is a Bantu language, part of the larger Niger-Congo family. It's spoken across East Africa and is notable for its Arabic loanwords due to historical Arab-Swahili trade connections."
    },
    {
        "id": 1139,
        "question": "Arabic in North Africa belongs to which language family?",
        "options": [
            "Afro-Asiatic",
            "Niger-Congo",
            "Khoisan"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Arabic is part of the Afro-Asiatic language family, which also includes Hebrew, Amharic, and Somali. It became dominant in North Africa after the Islamic expansion in the 7th century."
    },
    {
        "id": 1140,
        "question": "The Khoisan languages are known for:",
        "options": [
            "Tonal melodies",
            "Click consonants",
            "Long vowels"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Khoisan languages, spoken by indigenous peoples in Southern Africa, are unique for their distinctive click consonants, which are also found in some neighboring Bantu languages."
    },
    {
        "id": 1141,
        "question": "Hausa is part of which language family?",
        "options": [
            "Niger-Congo",
            "Afro-Asiatic (Chadic)",
            "Nilo-Saharan"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Hausa belongs to the Chadic group within the Afro-Asiatic language family. It's spoken by millions in northern Nigeria and Niger and is a major trans-Saharan trade language."
    },
    {
        "id": 1142,
        "question": "The trans-Saharan trade connected West Africa to:",
        "options": [
            "Asia only",
            "North Africa and the Mediterranean",
            "South America"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Trans-Saharan trade routes connected West African empires like Mali and Songhai to North Africa, the Mediterranean, and beyond. Gold, salt, and slaves were major commodities traded northward for luxury goods."
    },
    {
        "id": 1143,
        "question": "Great Zimbabwe's wealth came mainly from:",
        "options": [
            "Gold trade",
            "Oil",
            "Wheat exports"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Great Zimbabwe controlled the gold trade in Southern Africa between 1100-1450 CE. Gold was exported to the Indian Ocean trade, bringing wealth that funded the construction of its massive stone structures."
    },
    {
        "id": 1144,
        "question": "The Hausa city-states thrived on:",
        "options": [
            "Trade and crafts",
            "Mining salt only",
            "Fishing alone"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Hausa city-states (Katsina, Kano, Daura) prospered through trade and craftsmanship. They controlled crucial routes for trans-Saharan commerce and produced fine textiles, leather, and metalwork."
    },
    {
        "id": 1145,
        "question": "The Ashanti Empire controlled trade in:",
        "options": [
            "Cocoa and gold",
            "Diamonds only",
            "Spices"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Ashanti Empire (1670-1900 CE) in present-day Ghana made gold its primary commodity, controlling rich gold deposits. Later, cocoa production became equally important for their economy."
    },
    {
        "id": 1146,
        "question": "Coastal Swahili city-states traded with:",
        "options": [
            "India, Arabia, and China",
            "Europe only",
            "West Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Swahili city-states like Kilwa, Mombasa, and Zanzibar were maritime hubs connecting East Africa to the Indian Ocean trade network, exchanging gold, ivory, and slaves for spices and manufactured goods from Asia."
    },
    {
        "id": 1147,
        "question": "Shaka Zulu is famous for:",
        "options": [
            "Introducing the short spear (iklwa) and disciplined army",
            "Building pyramids",
            "Trans-Saharan caravans"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Shaka Zulu (1787-1828) revolutionized Zulu warfare by introducing the short, broad-bladed spear (iklwa) for close combat and organizing regiments into age-grade military units, creating a formidable imperial army."
    },
    {
        "id": 1148,
        "question": "The Benin Kingdom defended its city with:",
        "options": [
            "Massive walls and moats",
            "Gunpowder weapons only",
            "Naval fleets"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The ancient city of Benin had sophisticated defensive systems including massive earthen walls and moats surrounding it. These structures protected the city for centuries and are still visible today."
    },
    {
        "id": 1149,
        "question": "The Hausa kingdoms were organized around:",
        "options": [
            "Guilds and warrior classes",
            "Farming only",
            "Merchant caravans"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Hausa society was organized into craft guilds (dye wells, metalwork, etc.) and military warrior classes. This hierarchical system facilitated trade specialization and military organization."
    },
    {
        "id": 1150,
        "question": "The Oyo Empire's army relied heavily on:",
        "options": [
            "Cavalry",
            "Elephant divisions",
            "Naval power"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Oyo Empire (1400-1896) was renowned for its powerful cavalry force, which gave it military superiority across the Yoruba region and allowed it to dominate West African politics for 500 years."
    },
    {
        "id": 1151,
        "question": "Pre-colonial Ethiopian armies were known for:",
        "options": [
            "Firearms and organized infantry",
            "Airplanes",
            "Submarines"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ethiopian armies were famous for their well-organized infantry, cavalry, and use of firearms acquired through trade. This allowed Ethiopia to defeat Italian invasion forces at the Battle of Adwa in 1896."
    },
    {
        "id": 1152,
        "question": "The Niger River was crucial for:",
        "options": [
            "Inland trade and agriculture in West Africa",
            "Gold mining in North Africa",
            "Desert caravans only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Niger River, Africa's third-longest river, enabled transportation of goods across West African empires and supported agriculture through its seasonal floods, making it vital for Mali, Songhai, and other nations."
    },
    {
        "id": 1153,
        "question": "The city of Timbuktu became wealthy because of:",
        "options": [
            "Location near gold and salt routes",
            "Oil reserves",
            "Atlantic ports"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Timbuktu (Mali) sat at the intersection of trans-Saharan trade routes, controlling the flow of gold from southern regions and salt from northern deserts. It became a legendary center of Islamic scholarship and commerce."
    },
    {
        "id": 1154,
        "question": "The Congo River basin provided:",
        "options": [
            "Trade routes and fertile land",
            "Desert grazing",
            "Ice harvesting"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo River basin supported the Luba and Lunda kingdoms with ecological riches—dense forests, game, and the river itself as a trade highway. It remains a vital resource for Central African peoples."
    },
    {
        "id": 1155,
        "question": "The Sahara Desert influenced African trade by:",
        "options": [
            "Limiting movement but enabling camel caravans",
            "Making navigation easy",
            "Creating rivers"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "While the Sahara's harsh terrain limited direct trade, it became a conduit for trans-Saharan commerce via camel caravans. The desert's challenges created monopoly advantages for merchants controlling caravan routes."
    },
    {
        "id": 1156,
        "question": "The Swahili Coast was important for:",
        "options": [
            "Indian Ocean trade networks",
            "Trans-Saharan trade",
            "Mediterranean trade only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Swahili Coast (modern Tanzania, Kenya, Mozambique) was a crucial Indian Ocean hub, with city-states that traded across the Arabian Sea, Indian Ocean, and beyond to Southeast Asia."
    },
    {
        "id": 1157,
        "question": "Who was the famous ruler of the Mali Empire during its golden age?",
        "options": [
            "Mansa Musa",
            "Shaka Zulu",
            "Osei Tutu"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Mansa Musa ruled Mali from 1312-1337, overseeing its peak prosperity. His legendary pilgrimage to Mecca demonstrated Mali's wealth and brought Islamic scholars back to establish Timbuktu as a center of learning."
    },
    {
        "id": 1158,
        "question": "The Ashanti Empire in present-day Ghana was founded by:",
        "options": [
            "Osei Tutu",
            "Samori Touré",
            "Sundiata Keita"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Osei Tutu founded the Ashanti Empire around 1670, uniting Ashanti city-states under a centralized system with the Golden Stool as a symbol of sovereignty and spiritual authority."
    },
    {
        "id": 1159,
        "question": "The Yoruba people's traditional ruler is called:",
        "options": [
            "Oba",
            "Emir",
            "Chief"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "An 'Oba' is the traditional title for Yoruba rulers in Nigeria and Benin. Obas serve as both political and spiritual leaders, often regarded as semi-divine figures in Yoruba culture."
    },
    {
        "id": 1160,
        "question": "Which tribe is known for its bronze artistry in Benin (Nigeria)?",
        "options": [
            "Igbo",
            "Edo (Benin)",
            "Fulani"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Edo people of Benin are renowned for their exquisite bronze plaques and sculptures, considered some of Africa's most sophisticated artwork. These works depicted their royal court and history."
    },
    {
        "id": 1161,
        "question": "The Hausa and Fulani traditionally had leaders called:",
        "options": [
            "Oba",
            "Emir",
            "Sultan"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Hausa and Fulani leaders in Nigeria and Niger use the title 'Emir,' reflecting Islamic tradition. The most famous is the Emir of Kano, whose position dates back centuries."
    },
    {
        "id": 1162,
        "question": "The Maasai are primarily:",
        "options": [
            "Pastoralists",
            "Fishermen",
            "Farmers"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Maasai are East Africa's iconic pastoralists, organizing their entire society around cattle herding. Their warrior (morani) culture and distinctive red clothing are internationally recognized."
    },
    {
        "id": 1163,
        "question": "Shaka Zulu's military innovations were adopted by which group?",
        "options": [
            "Xhosa",
            "Zulu",
            "Ndebele"
        ],
        "answer_index": 2,
        "image_url": "",
        "explanation": "Shaka's military innovations spread to neighboring peoples. The Ndebele, who fled Zulu expansion, adopted and adapted Shaka's tactics under their own leaders, carrying Zulu military concepts to what is now Zimbabwe."
    },
    {
        "id": 1164,
        "question": "Ethiopia's Solomonic dynasty claims descent from:",
        "options": [
            "Pharaohs of Egypt",
            "King Solomon and the Queen of Sheba",
            "Roman Emperors"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Ethiopia's emperors claimed descent from Solomon and the Queen of Sheba (Makeda), a legendary Biblical union. This claim gave Ethiopian rulers religious legitimacy and connected them to Judeo-Christian heritage."
    },
    {
        "id": 1165,
        "question": "The Kikuyu in Kenya traditionally organized villages under:",
        "options": [
            "Councils of elders",
            "Kings only",
            "Foreign governors"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kikuyu society was organized into age-sets (irika) and councils of elders who made decisions through consensus. This democratic system remained strong even during colonial rule."
    },
    {
        "id": 1166,
        "question": "The Somali clan system emphasizes:",
        "options": [
            "Hierarchy of elders and lineage",
            "City-state governance",
            "Monarchs"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Somali society is organized around clan lineages and pastoral networks. Elders from major clans make decisions through consultation, reflecting a lineage-based political structure spanning centuries."
    },
    {
        "id": 1167,
        "question": "The Kingdom of Kongo had rulers called:",
        "options": [
            "Mani Kongo",
            "Oba",
            "Emir"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The 'Mani Kongo' (King of Kongo) ruled the Kingdom of Kongo in Central Africa. The most famous was Afonso I, who converted to Christianity and maintained relations with Portugal."
    },
    {
        "id": 1168,
        "question": "The Luba and Lunda kingdoms were ruled by:",
        "options": [
            "Kings with structured courts and succession systems",
            "Military generals only",
            "Merchant councils"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Luba and Lunda kingdoms had centralized monarchies with formalized succession systems. Their kings, called 'Mwene' or similar titles, ruled through hierarchical courts with titled nobility."
    },
    {
        "id": 1169,
        "question": "Which Central African kingdom was known for advanced art and ceremonial masks?",
        "options": [
            "Benin",
            "Kuba",
            "Ashanti"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Kuba Kingdom (Congo region) produced renowned ceremonial masks and royal sculptures. Kuba arts, particularly raffia cloth and wood carving, reached sophisticated levels of craftsmanship."
    },
    {
        "id": 1170,
        "question": "Pre-colonial Congo and Luba trade often included:",
        "options": [
            "Salt, copper, raffia cloth",
            "Rice and wheat",
            "Tea and silk"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Luba territories produced copper (highly valued), salt, and raffia cloth. These goods were traded across Central Africa for luxuries and necessities, making Luba lands economically vital."
    },
    {
        "id": 1171,
        "question": "The Fang people (Gabon and Cameroon) are famous for:",
        "options": [
            "Sculpture and reliquary figures",
            "Bronze casting",
            "Stone architecture"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Fang peoples created intricate reliquary figures (byeri) to honor ancestors, along with striking wooden sculptures. These artworks are considered masterpieces of Central African sculptural tradition."
    },
    {
        "id": 1172,
        "question": "The Ndebele are known for:",
        "options": [
            "Painted homes and beadwork",
            "Bronze sculptures",
            "Stone cities"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ndebele people are famous for their distinctive geometric mural paintings on homes and intricate beadwork. Their art style is instantly recognizable and represents a vibrant cultural tradition."
    },
    {
        "id": 1173,
        "question": "The Zulu social system included:",
        "options": [
            "Age-grade regiments for military service",
            "Nomadic herding only",
            "Guild-based governance"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Shaka reorganized Zulu society into age-grade regiments (impi) where young men trained, served, and advanced through military ranks. This system was revolutionary and made the Zulu formidable militarily."
    },
    {
        "id": 1174,
        "question": "The San people (Bushmen) traditionally:",
        "options": [
            "Hunter-gatherers with deep knowledge of the land",
            "Pastoralists",
            "Farmers"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The San are Southern Africa's indigenous hunter-gatherers, with thousands of years of accumulated knowledge about desert ecology. They maintained this lifestyle until colonial expansions displaced them."
    },
    {
        "id": 1175,
        "question": "The Shona people's chiefs were responsible for:",
        "options": [
            "Land distribution and spiritual guidance",
            "Gold trading only",
            "Mining rights"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Shona chiefs (madzishe) controlled land distribution and acted as spiritual intermediaries with ancestors. Chieftaincy was hereditary and held significant religious and political authority."
    },
    {
        "id": 1176,
        "question": "The Venda people are known for:",
        "options": [
            "Music, dance, and initiation ceremonies",
            "Desert caravans",
            "Maritime trade"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Venda culture emphasizes music and dance, with famous initiation ceremonies for youth. The Domba dance and other performances are central to Venda spiritual and social life."
    },
    {
        "id": 1177,
        "question": "The Berbers (Amazigh) traditionally lived in:",
        "options": [
            "North Africa's mountains and deserts",
            "West Africa's forests",
            "Southern Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Berbers inhabited the Atlas Mountains, Sahara, and Mediterranean coasts of North Africa. Both nomadic (Tuareg) and settled Berber groups adapted to diverse environments."
    },
    {
        "id": 1178,
        "question": "The Tuareg of the Sahara are famous for:",
        "options": [
            "Nomadic trade and silver jewelry",
            "Stone castles",
            "Rice farming"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tuareg are famous as 'Blue People' (from indigo dye), nomadic traders controlling trans-Saharan caravans. They're renowned for intricate silver jewelry and distinctive leather crafts."
    },
    {
        "id": 1179,
        "question": "Ancient Egypt's pharaohs were:",
        "options": [
            "Both political and religious leaders",
            "Military only",
            "Merchants only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Egyptian pharaohs held absolute power as both political rulers and divine representatives. Egyptians believed pharaohs embodied gods and mediated between divine and human spheres."
    },
    {
        "id": 1180,
        "question": "The Nubian Kingdoms had rulers called:",
        "options": [
            "Kandake (Queens) and Pharaohs",
            "Oba",
            "Emir"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nubian rulers used titles including 'Kandake' (Queen) and male parallels. Notably, Nubian queens sometimes wielded independent power, a contrast to their Egyptian neighbors."
    },
    {
        "id": 1181,
        "question": "The Sanhaja, Zenata, and other Berber groups influenced:",
        "options": [
            "Trans-Saharan trade routes",
            "Indian Ocean trade",
            "Atlantic trade"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "These Berber groups controlled trans-Saharan routes, trading salt, gold, and goods across the Sahara. They were instrumental in connecting West African empires to North Africa and Mediterranean trade."
    },
    {
        "id": 1182,
        "question": "The Ishango Bone from Central Africa is believed to show:",
        "options": [
            "Early mathematics and counting",
            "Musical notation",
            "Map coordinates"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Ishango Bone (20,000 years old, from modern-day DRC) features notches arranged in groups, suggesting early numerical understanding or calendrical recording, making it evidence of African mathematical thought."
    },
    {
        "id": 1183,
        "question": "The Great Zimbabwe structures demonstrate knowledge of:",
        "options": [
            "Stone architecture without mortar",
            "Bronze casting",
            "Pyramid building like Egypt"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Great Zimbabwe's massive stone walls used sophisticated dry-stone techniques without mortar, demonstrating advanced engineering and architectural knowledge developed independently in Southern Africa."
    },
    {
        "id": 1184,
        "question": "Ancient Egyptian engineers used mathematics to:",
        "options": [
            "Build pyramids and temples precisely",
            "Navigate oceans",
            "Produce steel"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Egyptian engineers employed sophisticated geometry and mathematics to construct pyramids with extraordinary precision. The Great Pyramid's measurements demonstrate their mathematical sophistication."
    },
    {
        "id": 1185,
        "question": "West African iron-smelting technology appeared:",
        "options": [
            "Around the same time as in Europe, or earlier",
            "Only after colonization",
            "In the 20th century"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Sub-Saharan Africa developed iron-smelting independently around 3rd-2nd century BCE in some regions, roughly contemporary with or preceding European iron technology, showing technological sophistication."
    },
    {
        "id": 1186,
        "question": "The Dogon people of Mali have traditional knowledge about:",
        "options": [
            "Astronomy, including Sirius star system",
            "Navigation of Atlantic Ocean",
            "Volcano engineering"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Dogon possess detailed astronomical knowledge, including awareness of Sirius's companion star invisible to the naked eye. Scholars debate whether this knowledge is ancient or acquired later."
    },
    {
        "id": 1187,
        "question": "Ancient African societies domesticated which crops first?",
        "options": [
            "Sorghum, millet, yams",
            "Wheat and barley",
            "Corn and potatoes"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Sub-Saharan Africa independently domesticated sorghum, millet, and yams thousands of years ago, forming the basis of African agriculture. These crops sustained civilizations and remain dietary staples."
    },
    {
        "id": 1188,
        "question": "The Fulani and Maasai contributed to:",
        "options": [
            "Pastoral systems and cattle breeding",
            "Industrial machinery",
            "Deep-sea fishing"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Fulani and Maasai developed sophisticated pastoral systems for managing cattle herds in African savannas. Their selective breeding and herding knowledge represents centuries of accumulated expertise."
    },
    {
        "id": 1189,
        "question": "Terraced farming in Ethiopia and Cameroon shows:",
        "options": [
            "Advanced soil management techniques",
            "Random planting",
            "Irrigation only from colonial systems"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African farmers developed terraced farming systems to prevent erosion and maximize water retention in mountainous regions. These techniques represent sophisticated environmental adaptation and land management knowledge."
    },
    {
        "id": 1190,
        "question": "The Tichitt culture (Mauritania) built:",
        "options": [
            "Stone settlements for agriculture",
            "Wooden skyscrapers",
            "Desert ports"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Tichitt culture (3500-500 BCE) built stone-walled villages in the Mauritanian Sahel for pastoral agriculture. These settlements show evidence of organized community planning and construction."
    },
    {
        "id": 1191,
        "question": "African farmers developed drought-resistant crops because:",
        "options": [
            "They experimented over centuries",
            "Imported European seeds",
            "Ignored climate"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African farmers adapted crops to local climates through millennia of observation and selective seed-saving. Pearl millet and sorghum are examples of crops refined for semi-arid African environments."
    },
    {
        "id": 1192,
        "question": "Traditional African medicine often uses:",
        "options": [
            "Knowledge of local plants and herbs",
            "Only imported drugs",
            "No treatment at all"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African traditional medicine relies on extensive botanical knowledge accumulated over centuries. Many modern pharmaceutical drugs derive from African plants like quinine and artemisinin."
    },
    {
        "id": 1193,
        "question": "The Dogon and other West African societies knew how to:",
        "options": [
            "Treat malaria with herbal remedies",
            "Only perform surgery",
            "Use synthetic chemicals"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "West African societies developed herbal treatments for malaria and other diseases using local plant knowledge. Traditional remedies often provided effective symptom management before modern medicine."
    },
    {
        "id": 1194,
        "question": "Ancient Egyptians contributed to medicine by:",
        "options": [
            "Writing medical texts, performing surgery, and documenting diseases",
            "Building only monuments",
            "Mining only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Egyptian papyri contain detailed medical texts describing surgical procedures, treatments, and disease classifications. Egyptian physicians were respected throughout the ancient world for their medical knowledge."
    },
    {
        "id": 1195,
        "question": "African herbal knowledge was passed through:",
        "options": [
            "Oral tradition and apprenticeship with elders",
            "Printed books only",
            "European universities"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African medical knowledge was preserved through master-apprentice systems and oral tradition. This system maintained botanical and healing knowledge across generations without written documentation."
    },
    {
        "id": 1196,
        "question": "Many African communities practiced hygiene by:",
        "options": [
            "Bathing, using medicinal plants, and sanitation techniques",
            "Ignoring water sources",
            "Importing foreign systems only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African communities developed sophisticated hygiene practices including ritual bathing, waste management, and use of antimicrobial plants. These practices prevented disease spread long before germ theory."
    },
    {
        "id": 1197,
        "question": "The Swahili city-states used which technology to thrive in Indian Ocean trade?",
        "options": [
            "Maritime navigation and dhow ships",
            "Submarines",
            "Steam engines"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Swahili merchants used dhow sailing ships and sophisticated maritime navigation knowledge to traverse the Indian Ocean. This technology enabled centuries of prosperous trade connections."
    },
    {
        "id": 1198,
        "question": "The Berbers and Tuareg developed:",
        "options": [
            "Camel caravans across the Sahara",
            "Trains",
            "Airplanes"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Berbers and Tuareg developed sophisticated camel caravan systems for trans-Saharan commerce. Their knowledge of desert routes, water sources, and camel management was unmatched."
    },
    {
        "id": 1199,
        "question": "Gold and salt trade in West Africa depended on:",
        "options": [
            "Knowledge of routes, seasonal patterns, and local geography",
            "European maps only",
            "Rivers only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "West African traders possessed detailed knowledge of desert and savanna routes, seasonal water availability, and regional geography. This geographical knowledge enabled predictable, profitable trade."
    },
    {
        "id": 1200,
        "question": "Ancient African traders used which tools for measurement?",
        "options": [
            "Weights, scales, and standardized gold bars",
            "Paper currency only",
            "Digital systems"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African traders used standardized weights and scales to ensure fair trade. Gold dust was measured against standard weights, enabling consistent commercial transactions across regions."
    },
    {
        "id": 1201,
        "question": "Timbuktu scholars contributed to:",
        "options": [
            "Astronomy, mathematics, and medicine",
            "Only agriculture",
            "Only military strategies"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Timbuktu became a renowned center of Islamic learning with scholars studying mathematics, astronomy, medicine, and law. Thousands of manuscripts still exist, proving the city's intellectual sophistication."
    },
    {
        "id": 1202,
        "question": "The largest desert in Africa is:",
        "options": [
            "Kalahari",
            "Sahara",
            "Namib"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Sahara Desert covers approximately 9 million km² (3.5 million square miles), making it the world's largest hot desert, spanning from the Atlantic Ocean to the Red Sea."
    },
    {
        "id": 1203,
        "question": "The Sahara Desert covers approximately:",
        "options": [
            "3.5 million km²",
            "9 million km²",
            "1.2 million km²"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Sahara covers about 9 million km², spanning across North Africa from Mauritania to Egypt. It's the size of the United States and represents one of Earth's most dramatic landscapes."
    },
    {
        "id": 1204,
        "question": "The longest river in Africa is:",
        "options": [
            "Congo",
            "Nile",
            "Niger"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Nile River is 6,650 km long, making it Africa's and the world's longest river. It flows through 11 countries including Egypt, Sudan, and Uganda, shaping civilizations for millennia."
    },
    {
        "id": 1205,
        "question": "Lake Victoria, Africa's largest lake by surface area, borders:",
        "options": [
            "Kenya, Uganda, Tanzania",
            "Ghana, Nigeria, Cameroon",
            "South Africa, Botswana, Namibia"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lake Victoria, shared by Kenya, Uganda, and Tanzania, covers 68,870 km² and is the world's second-largest freshwater lake. It's vital for fishing and regional trade."
    },
    {
        "id": 1206,
        "question": "Africa's highest peak is:",
        "options": [
            "Mount Kenya",
            "Mount Kilimanjaro",
            "Table Mountain"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Mount Kilimanjaro in Tanzania reaches 5,895 meters (19,341 feet), making it Africa's highest mountain. Despite its equatorial location, it features glaciers and distinct ecological zones."
    },
    {
        "id": 1207,
        "question": "The Kingdom of Ghana existed roughly between:",
        "options": [
            "300-1200 CE",
            "1200-1500 CE",
            "800-1600 CE"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Ghana Empire (Wagadou) flourished between 700-1000 CE (with some estimates to 1200). It was the earliest empire in the West African savanna and controlled crucial gold-salt trade routes."
    },
    {
        "id": 1208,
        "question": "Mali Empire reached its height under Mansa Musa in:",
        "options": [
            "1307-1332 CE",
            "1200-1250 CE",
            "1400-1450 CE"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Mansa Musa reigned 1312-1337, taking Mali to its zenith. His 1324 pilgrimage to Mecca is considered one of history's greatest journeys, showcasing Mali's wealth and power."
    },
    {
        "id": 1209,
        "question": "The Songhai Empire fell to Moroccan invasion in:",
        "options": [
            "1492",
            "1591",
            "1650"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Songhai Empire fell in 1591 when Moroccan forces invaded under Ahmad al-Mansur. This invasion ended West Africa's great imperial era and disrupted trans-Saharan trade networks."
    },
    {
        "id": 1210,
        "question": "The Great Zimbabwe civilization thrived roughly between:",
        "options": [
            "1100-1450 CE",
            "900-1100 CE",
            "1500-1700 CE"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Great Zimbabwe flourished from approximately 1100-1450 CE. At its peak, it was a major trading center and the capital of a large empire controlling Southern African gold trade."
    },
    {
        "id": 1211,
        "question": "The Berlin Conference that divided Africa among European powers happened in:",
        "options": [
            "1884-1885",
            "1870-1872",
            "1900-1901"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Berlin Conference (1884-1885) formalized European colonization of Africa. European powers divided Africa into colonies without African consultation, creating borders that persist today."
    },
    {
        "id": 1212,
        "question": "Before becoming a desert, parts of the Sahara were:",
        "options": [
            "Fertile grasslands with rivers and lakes",
            "Mountains",
            "Ice sheets"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Sahara was a fertile grassland during the African Humid Period (around 9,000-5,000 years ago). Archaeological sites show evidence of lakes, rivers, and rich wildlife."
    },
    {
        "id": 1213,
        "question": "The Sahara contains large deposits of:",
        "options": [
            "Phosphorus-rich dust that fertilizes the Amazon rainforest",
            "Oil only",
            "Diamonds only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Saharan dust, rich in phosphorus and iron, travels thousands of kilometers across the Atlantic, providing nutrients to Amazon rainforest soils. This demonstrates Africa's global ecological impact."
    },
    {
        "id": 1214,
        "question": "Phosphorus from Saharan dust travels to the Amazon via:",
        "options": [
            "Winds across the Atlantic Ocean",
            "Underground rivers",
            "Animal migration"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Trade winds carry dust particles from the Sahara across the Atlantic to South America. This annual dust transport provides millions of tons of nutrients to Amazon ecosystems."
    },
    {
        "id": 1215,
        "question": "The Sahara's desertification accelerated around:",
        "options": [
            "5000-3000 BCE",
            "1500 BCE",
            "1000 CE"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Sahara's major desertification occurred during the African Humid Period's end, around 5000-3000 BCE. Climate changes and human activities accelerated the transformation to desert."
    },
    {
        "id": 1216,
        "question": "The Niger River is important because:",
        "options": [
            "It supported ancient civilizations like Mali and Songhai",
            "It only flows through deserts",
            "It is used solely for modern shipping"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Niger River enabled the rise and sustainability of West African empires. Its floods supported agriculture, and its waters provided trade routes, making it Africa's third-longest river vital to the region."
    },
    {
        "id": 1217,
        "question": "The Kalahari Desert spans which countries?",
        "options": [
            "Botswana, Namibia, South Africa",
            "Algeria, Libya, Egypt",
            "Kenya, Tanzania, Uganda"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Kalahari Desert covers approximately 900,000 km² across Southern Africa. Despite being classified as a desert, it's semi-arid with grasslands and supports diverse wildlife."
    },
    {
        "id": 1218,
        "question": "The Congo Basin rainforest is roughly the size of:",
        "options": [
            "Western Europe",
            "South America",
            "India"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo Basin rainforest covers approximately 3.7 million km², making it the world's second-largest tropical rainforest after the Amazon. It's crucial for global climate and biodiversity."
    },
    {
        "id": 1219,
        "question": "Africa is the second-largest continent after:",
        "options": [
            "Asia",
            "Europe",
            "South America"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa covers 30.4 million km², making it the second-largest continent after Asia's 44.6 million km². Africa's size is often underestimated due to map projection distortions."
    },
    {
        "id": 1220,
        "question": "The Sahara is approximately how wide at its broadest point?",
        "options": [
            "1,500 km",
            "5,000 km",
            "8,000 km"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Sahara is approximately 4,800-5,000 km wide (2,990-3,110 miles) at its broadest point, stretching from the Atlantic Ocean to the Red Sea across North Africa."
    },
    {
        "id": 1221,
        "question": "Lake Tanganyika is significant because:",
        "options": [
            "It is the world's second deepest freshwater lake",
            "It is Africa's largest lake by area",
            "It is completely dry half the year"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lake Tanganyika is 1,470 meters deep, making it the world's second-deepest freshwater lake after Baikal. It's shared by Tanzania, DRC, Zambia, and Burundi and contains unique fish species."
    },
    {
        "id": 1222,
        "question": "The Sahel is:",
        "options": [
            "A semi-arid transition zone south of the Sahara",
            "A rainforest",
            "A mountain range"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Sahel (Arabic for 'shore') is a savanna belt from Senegal to Somalia, separating the Sahara from sub-Saharan Africa. It's characterized by sparse vegetation and frequent droughts."
    },
    {
        "id": 1223,
        "question": "The Atlas Mountains are mainly located in:",
        "options": [
            "Morocco, Algeria, Tunisia",
            "Nigeria, Ghana, Togo",
            "Kenya, Tanzania, Uganda"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Atlas Mountains form a 2,400 km chain across North Africa. Mount Toubkal in Morocco (4,167m) is the range's highest peak and Africa's tallest mountain outside the East African highlands."
    },
    {
        "id": 1224,
        "question": "The Nile's source is considered to be:",
        "options": [
            "Lake Victoria",
            "Lake Chad",
            "Congo River"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Nile's primary source is Lake Victoria in East Africa. The White Nile flows 4,130 km north through multiple countries before joining the Blue Nile in Khartoum and reaching the Mediterranean."
    },
    {
        "id": 1225,
        "question": "African deserts contribute to global ecology because:",
        "options": [
            "Dust fertilizes far-away ecosystems like the Amazon",
            "They block all rainfall from reaching the ocean",
            "They absorb ocean currents"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African desert dust, particularly from the Sahara, travels globally via atmospheric circulation. This dust provides essential phosphorus and iron nutrients to distant rainforests and ocean ecosystems."
    },
    {
        "id": 1226,
        "question": "Which river system is entirely within the tropics and supports dense rainforest?",
        "options": [
            "Congo",
            "Nile",
            "Zambezi"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo River basin, entirely within tropical Africa, supports the world's second-largest rainforest. The river itself is Africa's largest by water volume, flowing 4,700 km through the Congo basin."
    },
    {
        "id": 1227,
        "question": "The famous pink lake in Tanzania is called:",
        "options": [
            "Lake Natron",
            "Lake Victoria",
            "Lake Chad"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lake Natron's pink color comes from salt-loving algae and carotenoid pigments. It's also famous for millions of flamingos that feed on the algae, creating an otherworldly landscape."
    },
    {
        "id": 1228,
        "question": "Madagascar has been isolated from mainland Africa for roughly:",
        "options": [
            "10 million years",
            "88 million years",
            "50 thousand years"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Madagascar separated from Africa approximately 88 million years ago when continental drift created the Mozambique Channel. This isolation led to unique species like lemurs evolving nowhere else on Earth."
    },
    {
        "id": 1229,
        "question": "Africa sits entirely on:",
        "options": [
            "One tectonic plate",
            "Two tectonic plates",
            "Three tectonic plates"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The African Plate is one large tectonic plate underlying Africa, surrounding coastal regions, and Madagascar. This unified plate tectonics contributes to Africa's geological stability."
    },
    {
        "id": 1230,
        "question": "Lake Retba (Pink Lake) in Senegal gets its pink color from:",
        "options": [
            "Microalgae",
            "Minerals from mining",
            "Volcano activity"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lake Retba's pink color comes from Dunaliella salina algae that produce carotenoid pigments. The lake's high salinity supports these specialized organisms, creating a unique ecosystem."
    },
    {
        "id": 1231,
        "question": "The Danakil Depression in Ethiopia is famous because:",
        "options": [
            "It's one of the hottest and lowest places on Earth",
            "It's the highest mountain range",
            "It's a large freshwater lake"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Danakil Depression, 125 meters below sea level, is Earth's hottest place with average temperatures of 34°C. Its geothermal features and colorful salt flats create an alien landscape."
    },
    {
        "id": 1232,
        "question": "Mount Kilimanjaro is unique because:",
        "options": [
            "It's a free-standing mountain not part of a range",
            "It's an underwater volcano",
            "It's part of the Himalayas"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kilimanjaro is a massive shield volcano that rises 5,895m as a free-standing peak without being part of a mountain range. Its isolated prominence makes it distinctly iconic."
    },
    {
        "id": 1233,
        "question": "Africa's largest hot desert (Sahara) stretches across approximately:",
        "options": [
            "9 million km²",
            "3 million km²",
            "1 million km²"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Sahara covers 9 million km² (3.5 million sq mi), making it the world's largest hot desert. It spans nearly one-third of the African continent."
    },
    {
        "id": 1234,
        "question": "Lake Natron in Tanzania is a key breeding ground for:",
        "options": [
            "Lesser flamingos",
            "Crocodiles only",
            "Penguins"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Approximately 75% of East Africa's flamingos breed at Lake Natron. The lake's harsh conditions exclude predators, providing safe nesting ground for millions of lesser flamingos."
    },
    {
        "id": 1235,
        "question": "The Congo Basin rainforest is special because:",
        "options": [
            "It's the world's second-largest tropical rainforest",
            "It's a desert",
            "It's made entirely of bamboo"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo rainforest covers 3.7 million km² and contains 10% of Earth's biodiversity. It's crucial for global climate regulation and carbon storage."
    },
    {
        "id": 1236,
        "question": "The Great Rift Valley shows:",
        "options": [
            "Africa splitting along tectonic plates",
            "A huge river only",
            "Ice-age glaciers"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Great Rift Valley stretches 6,400 km from Lebanon to Mozambique, marking where the African Plate is slowly splitting. This geological process is creating new ocean floor."
    },
    {
        "id": 1237,
        "question": "Namibia's Skeleton Coast is famous for:",
        "options": [
            "Shipwrecks and desert fog",
            "Volcanoes",
            "Tropical rainforests"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Skeleton Coast's fog-shrouded, shipwreck-strewn shore has claimed countless vessels. The desert meets the ocean in dramatic fashion, creating an inhospitable but spectacular landscape."
    },
    {
        "id": 1238,
        "question": "Africa has which unique ecological feature due to Madagascar's isolation?",
        "options": [
            "Endemic species like lemurs and baobabs",
            "Polar bears",
            "Kangaroos"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Madagascar's 88-million-year isolation allowed species like lemurs, fossas, and unique plants to evolve found nowhere else. 90% of Madagascar's wildlife is endemic, making it a biodiversity hotspot."
    },
    {
        "id": 1239,
        "question": "The Okavango Delta in Botswana is unusual because:",
        "options": [
            "It floods inland, creating a lush oasis in the desert",
            "It's entirely dry",
            "It's a volcanic crater"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Okavango River floods the Kalahari Desert instead of reaching an ocean, creating an inland delta with 15,000 km² of wetlands. This provides habitat for diverse wildlife in the desert."
    },
    {
        "id": 1240,
        "question": "Africa's tectonic activity caused:",
        "options": [
            "Volcanoes, rift valleys, and earthquakes",
            "Hurricanes",
            "Tornadoes only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African plate tectonics created dramatic landscapes including the Great Rift Valley, East African volcanoes like Kilimanjaro, and geothermal features like the Danakil Depression."
    },
    {
        "id": 1241,
        "question": "The Simien Mountains in Ethiopia are known for:",
        "options": [
            "Endemic wildlife like the gelada monkey",
            "Coral reefs",
            "Sand dunes only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Simien Mountains host unique wildlife including gelada monkeys (which eat grass and have distinctive chests), walia ibex, and hamadryas baboons found nowhere else on Earth."
    },
    {
        "id": 1242,
        "question": "Africa's oldest desert is:",
        "options": [
            "Namib Desert (~55 million years old)",
            "Sahara (~10,000 years old)",
            "Kalahari (~1,000 years old)"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Namib is Earth's oldest continuously arid desert, having remained dry for approximately 55 million years. Its extreme age makes it a unique laboratory for studying desert evolution."
    },
    {
        "id": 1243,
        "question": "Africa is the only continent where:",
        "options": [
            "Rainforests, deserts, savannahs, and high mountains coexist within the same plate",
            "Only deserts exist",
            "Only mountains exist"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa's incredible ecological diversity—from tropical rainforests to hyperarid deserts to high mountains—all exists on a single tectonic plate, making it unique among continents."
    },
    {
        "id": 1244,
        "question": "Dust from the Sahara helps fertilize:",
        "options": [
            "The Amazon rainforest",
            "North America only",
            "Antarctica"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "An estimated 182 million tons of Saharan dust travels annually across the Atlantic, providing essential phosphorus and iron to Amazon soils. This demonstrates Africa's planetary influence."
    },
    {
        "id": 1245,
        "question": "The Congo River Basin contributes to:",
        "options": [
            "Global oxygen production",
            "Salt flats",
            "Desertification"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo Basin's 3.7 million km² of rainforest produces approximately 10% of Earth's oxygen. This makes it vital for global climate regulation and air quality."
    },
    {
        "id": 1246,
        "question": "Africa's Baobab trees are known as:",
        "options": [
            "\"The tree of life\" for storing water and food",
            "Poisonous only",
            "Rocks"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Baobabs can store up to 120,000 liters of water in their trunks, earning them the 'tree of life' title. They provide food, water, and shelter across African savannas."
    },
    {
        "id": 1247,
        "question": "The Danakil Depression produces:",
        "options": [
            "Salt, sulfur, and mineral-rich landscapes",
            "Gold only",
            "Forests"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Danakil Depression's geothermal features produce colorful mineral deposits including sulfur and salt. It's one of Earth's most alien-like landscapes with active volcanic and geothermal activity."
    },
    {
        "id": 1248,
        "question": "Africa's plate tectonics create:",
        "options": [
            "Rift valleys, volcanic mountains, and lakes",
            "Ice sheets",
            "Only deserts"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The African Plate's movement creates dramatic geological features including the Great Rift Valley, volcanic mountains, and deep lakes, shaping Africa's landscape."
    },
    {
        "id": 1249,
        "question": "Approximately how many distinct ethnic groups (tribes) exist in Africa?",
        "options": [
            "Over 3,000",
            "Around 500",
            "Around 100"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa has over 3,000 recognized ethnic groups with distinct languages, cultures, and traditions. This extraordinary diversity reflects Africa's complex history and human adaptation."
    },
    {
        "id": 1250,
        "question": "Nigeria alone has roughly how many tribes?",
        "options": [
            "Over 250",
            "50",
            "10"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria contains over 250 ethnic groups, making it one of the world's most diverse nations. This diversity is reflected in Nigeria's 500+ languages and varied cultural practices."
    },
    {
        "id": 1251,
        "question": "Which tribe in Nigeria is famous for intricate bronze art and ancient city walls?",
        "options": [
            "Edo (Benin)",
            "Igbo",
            "Fulani"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Edo (Benin) people created the famous Benin bronze plaques and sculptures, considered world-class artworks. The Benin City walls protected the capital for centuries."
    },
    {
        "id": 1252,
        "question": "Which West African tribe is famous for wealthy gold trade and empire-building in medieval times?",
        "options": [
            "Mandinka (Mali)",
            "Zulu",
            "Berber"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Mandinka established and controlled the Mali Empire, one of Africa's greatest empires. They controlled trans-Saharan gold trade and built Timbuktu into a world-class center."
    },
    {
        "id": 1253,
        "question": "Which East African tribe is famous for living in harmony with wildlife and cattle herding?",
        "options": [
            "Maasai",
            "Hausa",
            "San"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Maasai maintain a pastoral lifestyle in East African savannas, living alongside wildlife in national parks. Their conservation practices and cultural traditions are globally recognized."
    },
    {
        "id": 1254,
        "question": "Which Southern African tribe is known for painting colorful geometric designs on homes?",
        "options": [
            "Ndebele",
            "Shona",
            "Zulu"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ndebele people create distinctive geometric murals on their houses using bold patterns and colors. This artistic tradition represents Ndebele cultural identity and resistance."
    },
    {
        "id": 1255,
        "question": "Which Central African tribe is famous for ceremonial masks and sculptures?",
        "options": [
            "Kuba",
            "Fulani",
            "Oromo"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Kuba Kingdom produced exquisite wooden masks and royal sculptures. Kuba artisans are renowned for their raffia cloth weaving and sophisticated carving techniques."
    },
    {
        "id": 1256,
        "question": "Which East African tribe has a unique language with click consonants?",
        "options": [
            "San (Bushmen)",
            "Maasai",
            "Kikuyu"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "San languages feature distinctive click consonants, making them unique among human languages. These sounds represent thousands of years of isolated linguistic development."
    },
    {
        "id": 1257,
        "question": "Which West African tribe is known for highly organized age-grade systems and city governance?",
        "options": [
            "Hausa",
            "Ashanti",
            "Zulu"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Hausa organized society into age-sets and occupational guilds, creating sophisticated governance systems. Hausa city-states (Kano, Katsina) were Islamic learning centers."
    },
    {
        "id": 1258,
        "question": "Which African island's people developed lemur-friendly agriculture and unique baobab ecosystems due to long isolation?",
        "options": [
            "Madagascar (Malagasy)",
            "Comoros",
            "Seychelles"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Madagascar's 88-million-year isolation created unique ecosystems. Malagasy people developed agricultural practices compatible with lemurs and other endemic species."
    },
    {
        "id": 1259,
        "question": "Ethiopia has approximately how many ethnic groups?",
        "options": [
            "Over 80",
            "20",
            "5"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ethiopia has 80+ ethnic groups with distinct languages and cultures. The Amhara and Oromo are the largest, but dozens of other groups maintain unique traditions."
    },
    {
        "id": 1260,
        "question": "South Africa officially recognizes how many ethnic groups (tribes/languages)?",
        "options": [
            "11 official languages representing major tribes",
            "3",
            "25"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "South Africa has 11 official languages representing major ethnic groups including Zulu, Xhosa, Sotho, and others. This multilingual policy reflects post-apartheid commitment to inclusivity."
    },
    {
        "id": 1261,
        "question": "Which tribe in West Africa is famous for kente weaving and royal cloth?",
        "options": [
            "Ashanti (Ghana)",
            "Yoruba",
            "Berber"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ashanti kente cloth is a world-renowned handwoven fabric with complex patterns. Originally reserved for royalty, kente represents Ashanti cultural heritage and artistry."
    },
    {
        "id": 1262,
        "question": "Which East African tribe is known for rituals involving jumping dances and warrior ceremonies?",
        "options": [
            "Maasai",
            "Somali",
            "Amhara"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Maasai warriors (morani) perform the adumu jump dance, where warriors bounce vertically from standing position. This demonstrates strength and is central to Maasai warrior culture."
    },
    {
        "id": 1263,
        "question": "Which Southern African tribe is famous for stone-walled cities like Great Zimbabwe?",
        "options": [
            "Shona",
            "Ndebele",
            "San"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Shona built Great Zimbabwe (1100-1450 CE) using dry-stone construction. They developed sophisticated architecture without mortar, demonstrating advanced engineering."
    },
    {
        "id": 1264,
        "question": "Which Nigerian tribe is famous for Igbo-Ukwu bronze work dating back to 9th century?",
        "options": [
            "Igbo",
            "Hausa",
            "Yoruba"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Igbo-Ukwu archaeological site revealed sophisticated lost-wax bronze casting techniques from the 9th century. This demonstrates advanced metallurgical knowledge predating European contact."
    },
    {
        "id": 1265,
        "question": "Which tribe in Mali is famous for Timbuktu scholarship and manuscript libraries?",
        "options": [
            "Songhai",
            "Berber",
            "Fulani"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Songhai controlled Timbuktu, which became a center of Islamic learning. Thousands of manuscripts (Timbuktu Manuscripts) preserved scholarly works in mathematics, astronomy, and theology."
    },
    {
        "id": 1266,
        "question": "Which tribe in Senegal is famous for Lake Retba (Pink Lake) rituals and salt harvesting?",
        "options": [
            "Lebou",
            "Wolof",
            "Serer"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Lebou people have harvested salt from Lake Retba for centuries using traditional methods. The salt trade remains important to Lebou economy and culture."
    },
    {
        "id": 1267,
        "question": "Which tribe in Cameroon is known for Kuba royal masks and court ceremonies?",
        "options": [
            "Kuba",
            "Fulani",
            "Bamileke"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Kuba Kingdom maintained elaborate court ceremonies with distinctive royal masks. Kuba art represents some of Central Africa's most sophisticated artistic traditions."
    },
    {
        "id": 1268,
        "question": "Which East African tribe has ritual scarification patterns for identity and beauty?",
        "options": [
            "Maasai",
            "Kikuyu",
            "Somali"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Maasai women and men wear distinctive beaded jewelry and scarification patterns identifying age-sets and status. These practices remain central to Maasai identity and coming-of-age rituals."
    },
    {
        "id": 1269,
        "question": "How many major ethnic groups are in Ghana?",
        "options": [
            "About 10",
            "50",
            "3"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana has about 10 major ethnic groups including Ashanti, Ewe, Fante, and Dagbani. This diversity has generally been managed through multi-ethnic cooperation."
    },
    {
        "id": 1270,
        "question": "Which Nigerian tribe is famous for Yoruba traditional religion and city-states like Ife and Oyo?",
        "options": [
            "Yoruba",
            "Igbo",
            "Hausa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Yoruba developed sophisticated city-states with complex government, art, and spiritual traditions. Yoruba religion influenced diaspora religions in the Caribbean and Americas."
    },
    {
        "id": 1271,
        "question": "Which tribe in Mali is known for griot storytelling and oral history preservation?",
        "options": [
            "Mandinka",
            "Zulu",
            "Berber"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Mandinka griots (jeli) preserved history through structured oral tradition passed down through generations. Griots maintained royal genealogies and historical narratives."
    },
    {
        "id": 1272,
        "question": "Which tribe in South Africa is known for Zulu military regiments and Shaka Zulu innovations?",
        "options": [
            "Zulu",
            "Ndebele",
            "Xhosa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Under Shaka Zulu, the Zulu nation developed revolutionary military organization creating age-grade regiments (impi). These innovations made the Zulu a dominant Southern African power."
    },
    {
        "id": 1273,
        "question": "Which tribe in Nigeria is famous for Igbo masquerades (Mmanwu) and cultural festivals?",
        "options": [
            "Igbo",
            "Yoruba",
            "Hausa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Igbo masquerades represent deities and ancestors, central to Igbo spiritual and social life. Mmanwu festivals display elaborate masks and costumes celebrating Igbo heritage."
    },
    {
        "id": 1274,
        "question": "Who led the Ashanti against British forces in the Anglo-Ashanti wars?",
        "options": [
            "Prempeh I",
            "Samori Touré",
            "Shaka Zulu"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Prempeh I resisted British colonial expansion in the 1880s-1890s. Though eventually exiled, he symbolized Ashanti resistance and was restored as paramount chief in 1935."
    },
    {
        "id": 1275,
        "question": "Samori Touré was famous for:",
        "options": [
            "Creating a disciplined army to resist French colonization in West Africa",
            "Negotiating European trade deals peacefully",
            "Leading the Zulu regiments"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Samori Touré (1830-1900) built the Wassoulou Empire and resisted French colonization for 16 years. His military innovations and strategic retreats earned him respect as a freedom fighter."
    },
    {
        "id": 1276,
        "question": "The Battle of Adwa (1896) saw which African leader defeat an invading European power?",
        "options": [
            "Menelik II (Ethiopia)",
            "Patrice Lumumba",
            "Shaka Zulu"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Emperor Menelik II decisively defeated Italian forces at Adwa, making Ethiopia a symbol of African independence. The victory earned Ethiopia international recognition and prevented colonization."
    },
    {
        "id": 1277,
        "question": "Which Yoruba leader resisted British expansion in Nigeria during the late 19th century?",
        "options": [
            "Oba Ovonramwen",
            "Queen Amina",
            "Samori Touré"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Oba Ovonramwen of Benin resisted British colonial forces in the 1890s. Though militarily defeated, he became a symbol of Yoruba/Edo resistance to colonialism."
    },
    {
        "id": 1278,
        "question": "The Fulani leader who resisted French colonial forces in West Africa was:",
        "options": [
            "Samori Touré",
            "Menelik II",
            "Shaka Zulu"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "While Samori Touré was ethnically Mandinka, he controlled territories including Fulani lands and had Fulani supporters. He's remembered as a pan-West African resistance figure."
    },
    {
        "id": 1279,
        "question": "Which Somali leader led resistance against Italian colonization?",
        "options": [
            "Sayyid Mohammed Abdullah Hassan",
            "Menelik II",
            "Shaka Zulu"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Sayyid Mohammed Abdullah Hassan led 20+ years of guerrilla warfare against Italian colonizers (1899-1920). The British and Italians called him the 'Mad Mullah' due to his religious fervor."
    },
    {
        "id": 1280,
        "question": "Who was the Ethiopian emperor during the Battle of Adwa?",
        "options": [
            "Menelik II",
            "Haile Selassie",
            "Lij Iyasu"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Emperor Menelik II reigned 1889-1913 and orchestrated the decisive victory at Adwa. His reign modernized Ethiopia and preserved its independence during the colonial scramble."
    },
    {
        "id": 1281,
        "question": "Which Kenyan group resisted British colonization fiercely in the late 19th-early 20th century?",
        "options": [
            "Maasai",
            "Kikuyu",
            "Zulu"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Both Maasai and Kikuyu resisted, but Kikuyu organized sustained armed uprisings. Later, the Mau Mau rebellion (1952-1960) led by Kikuyu was pivotal in Kenya's independence."
    },
    {
        "id": 1282,
        "question": "The Ethiopian army used which strategy at Adwa?",
        "options": [
            "Superior knowledge of terrain and large coordinated forces",
            "Naval bombardment",
            "Poison gas"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Menelik II leveraged Ethiopian geography and mobilized 100,000+ troops against Italian invasion. This coordinated military response overwhelmed the Italian force of 17,000."
    },
    {
        "id": 1283,
        "question": "Queen Amina of Zazzau (Nigeria) is famous for:",
        "options": [
            "Expanding her territory through warfare in the 16th century",
            "Leading peaceful trade negotiations",
            "Teaching schools"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Queen Amina (1533-1610) expanded Zazzau territories through military campaigns, controlling trade routes and increasing the state's wealth and power during her 34-year reign."
    },
    {
        "id": 1284,
        "question": "Which West African country is the largest gold producer in Africa?",
        "options": [
            "Ghana",
            "Nigeria",
            "Mali"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana produces over 50 million ounces of gold annually, making it Africa's leading gold producer. Gold mining contributes significantly to Ghana's economy and exports."
    },
    {
        "id": 1285,
        "question": "Nigeria is famous for which natural resource that powers its economy and energy sector?",
        "options": [
            "Crude oil",
            "Diamonds",
            "Uranium"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria produces millions of barrels of crude oil daily, making it Africa's leading oil producer. Oil revenues fund the government though economic diversification is needed."
    },
    {
        "id": 1286,
        "question": "Which mineral is Mali especially known for besides gold?",
        "options": [
            "Phosphate",
            "Copper",
            "Nickel"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Mali's phosphate deposits are among Africa's largest. Phosphate is a crucial fertilizer component used in agriculture globally."
    },
    {
        "id": 1287,
        "question": "Which West African country is the largest bauxite producer, used to make aluminum?",
        "options": [
            "Guinea",
            "Senegal",
            "Ivory Coast"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Guinea holds the world's largest bauxite reserves. Bauxite mining is central to Guinea's economy, refined globally into aluminum for aircraft and consumer products."
    },
    {
        "id": 1288,
        "question": "Ivory Coast is the world's top producer of which mineral?",
        "options": [
            "Manganese",
            "Uranium",
            "Tantalum"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ivory Coast produces significant manganese, though its primary export is cocoa. Manganese is essential for steel production, batteries, and industrial alloys."
    },
    {
        "id": 1289,
        "question": "Liberia and Sierra Leone are known for:",
        "options": [
            "Diamonds",
            "Copper",
            "Iron ore"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Both countries are diamond producers, though Sierra Leone's 'blood diamonds' history reflects conflicts over diamond mining during the civil war."
    },
    {
        "id": 1290,
        "question": "Senegal has phosphate reserves primarily used for:",
        "options": [
            "Fertilizers",
            "Jewelry",
            "Solar panels"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Senegal's phosphate phosphates are processed into fertilizers for global agricultural markets, supporting crop production worldwide."
    },
    {
        "id": 1291,
        "question": "Nigeria also produces lead and zinc, which are used for:",
        "options": [
            "Batteries, alloys, and galvanization",
            "Jewelry only",
            "Fuel"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lead and zinc are critical metals used in batteries for electric vehicles, brass alloys, and protective galvanization coating for steel structures."
    },
    {
        "id": 1292,
        "question": "Tantalum, used in electronics like smartphones and computers, is mined in:",
        "options": [
            "Nigeria and Sierra Leone",
            "Ghana only",
            "Mali only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tantalum is extracted from coltan ore in West Africa. This metal is essential for capacitors in computers, phones, and military equipment."
    },
    {
        "id": 1293,
        "question": "Which mineral is crucial for steel production and found in Guinea, Liberia, and Sierra Leone?",
        "options": [
            "Iron ore",
            "Copper",
            "Coal"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "These West African countries have significant iron ore deposits. Iron ore is smelted into steel for construction, manufacturing, and industrial applications."
    },
    {
        "id": 1294,
        "question": "Which West African country produces cobalt, essential for batteries and electric vehicles?",
        "options": [
            "Ghana",
            "Senegal",
            "Nigeria"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana produces cobalt, a critical metal for lithium-ion batteries. As electric vehicle demand grows, cobalt becomes increasingly valuable."
    },
    {
        "id": 1295,
        "question": "Which mineral mined in Sierra Leone is used in electronics and aerospace alloys?",
        "options": [
            "Rutile (Titanium dioxide)",
            "Bauxite",
            "Gold"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Rutile ore yields titanium dioxide, essential for aerospace alloys, paints, and high-performance ceramics used in extreme-temperature applications."
    },
    {
        "id": 1296,
        "question": "Which West African country produces coltan, essential for capacitors in mobile phones?",
        "options": [
            "Nigeria",
            "Mali",
            "Senegal"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria produces coltan (columbite-tantalite), essential for electronics. Coltan is a conflict mineral in some African regions, raising ethical sourcing concerns."
    },
    {
        "id": 1297,
        "question": "Phosphate mined in Mali and Senegal is exported primarily for:",
        "options": [
            "Agriculture (fertilizer)",
            "Jewelry",
            "Electronics"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Phosphate is processed into fertilizers essential for global food production. This mineral directly supports agricultural yields feeding billions."
    },
    {
        "id": 1298,
        "question": "Which West African mineral is used in steel, batteries, and alloy production, and is abundant in Guinea and Ivory Coast?",
        "options": [
            "Manganese",
            "Copper",
            "Lithium"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Manganese is essential for steel production, dry-cell batteries, and aluminum alloys. Its extraction and processing are major industries in West Africa."
    },
    {
        "id": 1299,
        "question": "Nigeria's oil is mainly exported as:",
        "options": [
            "Crude petroleum for energy and plastics",
            "Refined gold bars",
            "Coal"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria exports crude oil to refineries worldwide. Petroleum is transformed into fuel, plastics, chemicals, and other petrochemical products."
    },
    {
        "id": 1300,
        "question": "Which West African country has significant natural gas reserves used for electricity and fertilizer production?",
        "options": [
            "Nigeria",
            "Ghana",
            "Senegal"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria's natural gas reserves are used domestically for power generation and fertilizer manufacturing, with significant export potential."
    },
    {
        "id": 1301,
        "question": "Coal is mined in which West African country, mainly for power generation?",
        "options": [
            "Nigeria",
            "Ghana",
            "Mali"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria has coal deposits used for thermal power plants. Though less prominent than oil and gas, coal provides domestic energy security."
    },
    {
        "id": 1302,
        "question": "Which mineral is mined in Ghana and used for electronics and batteries?",
        "options": [
            "Cobalt",
            "Iron",
            "Manganese"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana's cobalt is increasingly important for lithium-ion batteries powering electric vehicles and renewable energy storage systems."
    },
    {
        "id": 1303,
        "question": "West African diamond exports are primarily used for:",
        "options": [
            "Jewelry and industrial cutting tools",
            "Currency",
            "Electronics"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Diamonds are valued for jewelry and industrial applications. Industrial diamonds are used in cutting, grinding, and drilling tools for mining and construction."
    },
    {
        "id": 1304,
        "question": "Which West African country produces limestone extensively for cement production?",
        "options": [
            "Ghana",
            "Mali",
            "Liberia"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana's limestone deposits supply cement factories. Cement is essential for construction, roads, and infrastructure development."
    },
    {
        "id": 1305,
        "question": "Which country is a significant exporter of kaolin, used in ceramics, paper coatings, and cosmetics?",
        "options": [
            "Nigeria",
            "Senegal",
            "Sierra Leone"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria exports kaolin (china clay) used in ceramics, paper coatings, pharmaceuticals, and cosmetics. This mineral has diverse industrial applications."
    },
    {
        "id": 1306,
        "question": "Which mineral mined in Burkina Faso is used in ceramics, pharmaceuticals, and detergents?",
        "options": [
            "Gypsum",
            "Phosphate",
            "Bauxite"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Gypsum is used in drywall, ceramics, and pharmaceutical formulations. Its versatility makes it valuable across construction and chemical industries."
    },
    {
        "id": 1307,
        "question": "Which country is known for feldspar, essential in glass-making and porcelain?",
        "options": [
            "Nigeria",
            "Ghana",
            "Mali"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria's feldspar is used in glass manufacturing and ceramic production. Feldspar reduces melting temperatures, making glass and pottery production more efficient."
    },
    {
        "id": 1308,
        "question": "Which West African mineral is highly conductive and used in electrical wiring and is mined in Ghana and Ivory Coast?",
        "options": [
            "Copper",
            "Iron",
            "Bauxite"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Copper is essential for electrical transmission lines, motors, and renewable energy infrastructure. Its conductivity makes it invaluable for electrification."
    },
    {
        "id": 1309,
        "question": "Which West African country produces nickel, used in stainless steel and rechargeable batteries?",
        "options": [
            "Nigeria",
            "Senegal",
            "Ghana"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria produces nickel used in stainless steel alloys and battery technology. As battery demand grows, nickel becomes increasingly valuable."
    },
    {
        "id": 1310,
        "question": "Which West African country mines mica, used in electronics, paint, and insulation?",
        "options": [
            "Nigeria",
            "Mali",
            "Ivory Coast"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria's mica is used in electrical insulation, cosmetics, and decorative paints. Its transparency and heat resistance make it valuable in electronics."
    },
    {
        "id": 1311,
        "question": "Which mineral mined in Sierra Leone is used in tantalum capacitors for smartphones, computers, and cameras?",
        "options": [
            "Coltan",
            "Rutile",
            "Bauxite"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Coltan (columbite-tantalite) is a conflict mineral mainly extracted from the Congo. However, Sierra Leone has deposits used for electronics manufacturing."
    },
    {
        "id": 1312,
        "question": "Which West African mineral is used in fertilizer, water treatment, and flame retardants, and is mined in Mali and Senegal?",
        "options": [
            "Phosphate",
            "Gold",
            "Bauxite"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Phosphate has diverse applications from agriculture (fertilizer) to flame retardants and water treatment chemicals, making it economically important."
    },
    {
        "id": 1313,
        "question": "Which West African country exports magnetite, used in steelmaking and heavy industry?",
        "options": [
            "Liberia",
            "Nigeria",
            "Ghana"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Liberia has significant magnetite (iron oxide) deposits used directly in steelmaking. Iron from this mineral feeds global steel production."
    },
    {
        "id": 1314,
        "question": "Which West African country produces tantalum and tin used in electronics and aerospace alloys?",
        "options": [
            "Nigeria",
            "Ghana",
            "Ivory Coast"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria produces both tantalum and tin, essential for electronics, aerospace, and automotive industries. These metals are critical for advanced manufacturing."
    },
    {
        "id": 1315,
        "question": "Which mineral mined in Ghana is used in solar panels and high-tech ceramics?",
        "options": [
            "Rutile (Titanium dioxide)",
            "Gold",
            "Manganese"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Rutile-derived titanium dioxide is used in solar cells, ceramics, and pigments. Its properties make it essential for renewable energy technologies."
    },
    {
        "id": 1316,
        "question": "Which mineral mined in Nigeria is used in glass, paint, and rubber industries?",
        "options": [
            "Silica sand",
            "Gypsum",
            "Limestone"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Silica sand is essential for glass manufacturing, foundry operations, and industrial coatings. Its purity and grain size determine its value."
    },
    {
        "id": 1317,
        "question": "Which West African country produces vermiculite, used in insulation, fireproofing, and horticulture?",
        "options": [
            "Ghana",
            "Nigeria",
            "Senegal"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana produces vermiculite, a lightweight mineral used in horticultural growing media, fireproofing, and thermal insulation in construction."
    },
    {
        "id": 1318,
        "question": "Which mineral mined in Sierra Leone is used to harden steel and produce special alloys?",
        "options": [
            "Bauxite",
            "Manganese",
            "Copper"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Manganese hardens steel and produces specialty alloys. Sierra Leone's manganese deposits contribute to global steel production."
    },
    {
        "id": 1319,
        "question": "Kenya's East African Rift Valley contains:",
        "options": [
            "Soda ash and salt deposits",
            "Gold only",
            "Diamonds"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kenya's soda ash deposits from Lake Magadi are world-class. Soda ash is essential for glass-making, detergents, and chemical manufacturing."
    },
    {
        "id": 1320,
        "question": "Tanzania is the world's leading producer of which gemstone?",
        "options": [
            "Tanzanite",
            "Diamonds",
            "Rubies"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tanzanite, found only in Tanzania near Kilimanjaro, is a rare blue gemstone valued in jewelry. All tanzanite comes from this single location, making it incredibly precious."
    },
    {
        "id": 1321,
        "question": "Which East African country produces ruby and sapphire gemstones?",
        "options": [
            "Tanzania/Kenya",
            "Uganda",
            "Somalia"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tanzania produces high-quality rubies and sapphires in the Morogoro region. These gemstones command premium prices in international jewelry markets."
    },
    {
        "id": 1322,
        "question": "Uganda is known for producing which valuable mineral?",
        "options": [
            "Rare earth elements and phosphate",
            "Gold only",
            "Platinum"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Uganda has significant phosphate deposits and rare earth elements critical for electronics and renewable technologies."
    },
    {
        "id": 1323,
        "question": "Ethiopia produces salt from:",
        "options": [
            "The Danakil Depression (Afar region)",
            "Rivers only",
            "Mountains"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Danakil salt flats are among the world's harshest environments, yet still yield salt through evaporation in this geothermal hotspot."
    },
    {
        "id": 1324,
        "question": "Which East African country is a major producer of limestones and cement?",
        "options": [
            "Kenya",
            "Tanzania",
            "Uganda"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kenya's limestone deposits support major cement production facilities essential for East Africa's infrastructure development."
    },
    {
        "id": 1325,
        "question": "Wangari Maathai (Kenya) is famous for:",
        "options": [
            "Environmental activism and the Green Belt Movement",
            "Space travel",
            "Electronics manufacturing"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Wangari Maathai won the Nobel Peace Prize for environmental activism. The Green Belt Movement has planted over 50 million trees across Africa."
    },
    {
        "id": 1326,
        "question": "Philip Emeagwali (Nigeria) contributed to:",
        "options": [
            "Supercomputer technology",
            "Railroads",
            "Medicine only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Philip Emeagwali developed algorithms for massively parallel computing. His innovations advance high-performance computing used in scientific research and AI."
    },
    {
        "id": 1327,
        "question": "Modern African scientists have contributed to:",
        "options": [
            "Disease research, renewable energy, and AI",
            "Only mining",
            "Only construction"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African researchers work in biotechnology, cancer research, renewable energy, and artificial intelligence, advancing global scientific knowledge."
    },
    {
        "id": 1328,
        "question": "African engineers in the 20th century helped design:",
        "options": [
            "Dams, bridges, and urban infrastructure",
            "Desert caravans only",
            "Ice roads"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African engineers built massive infrastructure projects like the Aswan Dam and numerous bridges connecting cities and regions."
    },
    {
        "id": 1329,
        "question": "Africa's tech hubs, like in Nairobi and Lagos, focus on:",
        "options": [
            "Software, mobile banking, AI, and innovation",
            "Only agriculture",
            "Only oil refining"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nairobi's 'Silicon Savanna' and Lagos's tech scene are hubs for African software development, fintech innovation, and artificial intelligence research."
    },
    {
        "id": 1330,
        "question": "Which North African country is the largest phosphate producer in Africa and the world?",
        "options": [
            "Morocco",
            "Egypt",
            "Tunisia"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Morocco is the world's largest phosphate producer, with deposits central to global fertilizer supply. Phosphate is essential for world food security."
    },
    {
        "id": 1331,
        "question": "Egypt's Suez Canal is critical because:",
        "options": [
            "It connects the Mediterranean and Red Sea, controlling global trade",
            "It only carries African goods",
            "It's purely for tourism"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Suez Canal handles 12% of global trade, making Egypt strategically important for international commerce and energy security."
    },
    {
        "id": 1332,
        "question": "Libya historically was famous for:",
        "options": [
            "Crude oil reserves funding the nation",
            "Only agriculture",
            "Textile manufacturing"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Libya has significant oil reserves that funded development. However, political instability since 2011 has disrupted production and economic development."
    },
    {
        "id": 1333,
        "question": "Algeria controls the Sahara's:",
        "options": [
            "Largest natural gas reserves in Africa",
            "Only gold deposits",
            "All diamond mines"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Algeria has the fourth-largest natural gas reserves globally. Gas exports are vital to Algeria's economy and European energy supply."
    },
    {
        "id": 1334,
        "question": "Which North African country mines substantial iron ore for regional steel production?",
        "options": [
            "Morocco",
            "Tunisia",
            "Algeria"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Morocco's iron ore deposits support regional steel production and manufacturing. Mining is a significant part of Morocco's mineral economy."
    },
    {
        "id": 1335,
        "question": "Tunisia produces:",
        "options": [
            "Phosphate and olive oil",
            "Only gold",
            "Diamonds"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tunisia is a significant phosphate producer and the world's largest olive oil exporter. These products are central to Tunisia's economy."
    },
    {
        "id": 1336,
        "question": "Egypt produces which mineral for glass and ceramics?",
        "options": [
            "Feldspar",
            "Bauxite",
            "Manganese"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Egypt's feldspar deposits supply glass and ceramic industries. These minerals are processed into raw materials for manufacturing."
    },
    {
        "id": 1337,
        "question": "Oil shale deposits in Morocco are used for:",
        "options": [
            "Synthetic fuels and energy",
            "Jewelry",
            "Road construction"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Morocco's oil shale can be processed into synthetic fuel. This represents an alternative energy source for future fuel independence."
    },
    {
        "id": 1338,
        "question": "Salt flats (Sebkhas) in Algeria and Tunisia are used for:",
        "options": [
            "Chemical industry and chlorine production",
            "Jewelry",
            "Fertilizer"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Salt from North African depression lakes is used in chemical manufacturing, chlorine production, and industrial processes."
    },
    {
        "id": 1339,
        "question": "Gypsum from Egypt is used for:",
        "options": [
            "Cement, plaster, and construction materials",
            "Jewelry",
            "Fertilizer"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Egypt's gypsum deposits supply drywall, plaster, and construction materials essential for building development across North Africa and beyond."
    },
    {
        "id": 1340,
        "question": "Petroleum gas liquids (LPG, condensate) from Libya are used for:",
        "options": [
            "Cooking fuel, petrochemicals, and energy",
            "Jewelry",
            "Cement"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Libya's LPG and condensate are used domestically for cooking and heating, with exports supplying global petrochemical markets."
    },
    {
        "id": 1341,
        "question": "Which North African region has extensive copper deposits used for electronics?",
        "options": [
            "Morocco and Algeria",
            "Egypt only",
            "Tunisia only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Morocco and Algeria have significant copper deposits used in electronics, electrical systems, and renewable energy infrastructure."
    },
    {
        "id": 1342,
        "question": "How many languages are spoken in Africa?",
        "options": [
            "Over 2,000",
            "Around 500",
            "Around 100"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa has over 2,000 languages, making it the world's most linguistically diverse continent. This diversity reflects Africa's ethnic and cultural complexity."
    },
    {
        "id": 1343,
        "question": "Which African language is spoken by the most people?",
        "options": [
            "Swahili",
            "Arabic",
            "Yoruba"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Arabic is spoken by over 170 million Africans across North Africa, making it the continent's most widely spoken language."
    },
    {
        "id": 1344,
        "question": "Swahili is spoken primarily in:",
        "options": [
            "East Africa (Kenya, Tanzania, Uganda, DRC)",
            "West Africa",
            "Southern Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Swahili is the lingua franca of East Africa, spoken by over 150 million people. It's a Bantu language with significant Arabic vocabulary from trade."
    },
    {
        "id": 1345,
        "question": "The Nilo-Saharan language family includes:",
        "options": [
            "Kanuri, Dinka, and Maasai languages",
            "Only Bantu languages",
            "Only Niger-Congo"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nilo-Saharan languages are spoken from Nigeria across the Sahel and East Africa. They represent a distinct language family with diverse grammatical structures."
    },
    {
        "id": 1346,
        "question": "Somali belongs to which language family?",
        "options": [
            "Afro-Asiatic (Cushitic)",
            "Niger-Congo",
            "Nilo-Saharan"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Somali is part of the Cushitic group within Afro-Asiatic, spoken by over 20 million people in the Horn of Africa."
    },
    {
        "id": 1347,
        "question": "Which African language is most widely used in education and government?",
        "options": [
            "English and French (colonial legacies)",
            "African languages only",
            "Mandarin"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "English and French remain official languages in many African nations, a legacy of colonization. However, many countries are promoting African language revival."
    },
    {
        "id": 1348,
        "question": "Amharic is the official language of:",
        "options": [
            "Ethiopia",
            "Eritrea",
            "Kenya"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Amharic is Ethiopia's official language, written in the Ge'ez script. It's spoken by over 30 million people and reflects Ethiopia's ancient Christian heritage."
    },
    {
        "id": 1349,
        "question": "Which African country has 11 official languages?",
        "options": [
            "South Africa",
            "Nigeria",
            "Kenya"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "South Africa's 11 official languages (Zulu, Xhosa, Afrikaans, etc.) reflect post-apartheid commitment to linguistic equality and cultural recognition."
    },
    {
        "id": 1350,
        "question": "Lingala is spoken primarily in:",
        "options": [
            "Central Africa (DRC, Congo)",
            "West Africa",
            "East Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lingala is the lingua franca of the Democratic Republic of Congo and Congo. It evolved from trade languages along the Congo River."
    },
    {
        "id": 1351,
        "question": "Which African country officially recognizes Indigenous San languages?",
        "options": [
            "Botswana and Namibia",
            "South Africa only",
            "Zimbabwe"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Botswana and Namibia have worked to preserve San languages, recognizing these unique click languages as part of Africa's linguistic heritage."
    },
    {
        "id": 1352,
        "question": "Semitic languages in Africa include:",
        "options": [
            "Amharic, Tigrinya, and Arabic",
            "Only Bantu languages",
            "Only Niger-Congo"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Semitic languages are spoken in the Horn of Africa (Ethiopia, Eritrea) and North Africa (Arabic). These ancient languages link Africa to Middle Eastern linguistic traditions."
    },
    {
        "id": 1353,
        "question": "How many people speak Yoruba?",
        "options": [
            "Over 40 million",
            "5 million",
            "1 million"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Yoruba is spoken by over 40 million people in Nigeria and diaspora communities. It's a tonal language with complex grammatical structures."
    },
    {
        "id": 1354,
        "question": "Which African language family has the most speakers?",
        "options": [
            "Afro-Asiatic (mainly Arabic speakers)",
            "Niger-Congo",
            "Nilo-Saharan"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Afro-Asiatic languages, particularly Arabic, have over 170 million speakers. When combined with major African languages, Niger-Congo is also massive."
    },
    {
        "id": 1355,
        "question": "Arabic is spoken as a first or second language by:",
        "options": [
            "Over 150 million Africans",
            "50 million only",
            "10 million only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Arabic dominates North Africa and is increasingly spoken as a second language in sub-Saharan Africa due to Islamic education and trade networks."
    },
    {
        "id": 1356,
        "question": "Which African language is used as a lingua franca in West Africa?",
        "options": [
            "Dioula and Hausa",
            "Yoruba only",
            "Wolof only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Dioula and Hausa serve as trade languages across West Africa, enabling commerce and communication between different ethnic groups."
    },
    {
        "id": 1357,
        "question": "Ge'ez script, an ancient African writing system, is preserved in:",
        "options": [
            "Ethiopia and Eritrea",
            "Egypt only",
            "West Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ge'ez is one of Africa's oldest scripts, used for ancient Ethiopian texts and church services. It's a unique contribution to human writing systems."
    },
    {
        "id": 1358,
        "question": "The Bamum script (Cameroon) was created by:",
        "options": [
            "King Njoya in the 19th century",
            "French colonists",
            "Arab traders"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "King Njoya created the Bamum script to write his language, demonstrating African indigenous innovation in literacy and written communication."
    },
    {
        "id": 1359,
        "question": "Meroe script was used to write which ancient language?",
        "options": [
            "Nubian (Kingdom of Kush)",
            "Egyptian",
            "Greek"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Meroe script was developed in the Nubian Kingdom to write their language. Discovered texts show Nubian literacy and intellectual traditions."
    },
    {
        "id": 1360,
        "question": "The oldest known African writing system is:",
        "options": [
            "Ge'ez script (~200 CE)",
            "Egyptian hieroglyphics (~3200 BCE)",
            "Bamum script (~1896 CE)"
        ],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Egyptian hieroglyphics (3200 BCE) are among the world's oldest writing systems, demonstrating Africa's pioneering role in literacy and civilization."
    },
    {
        "id": 1361,
        "question": "Which African language has the most native speakers in Africa?",
        "options": [
            "Swahili, Yoruba, or Igbo",
            "Arabic or English",
            "Zulu only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Swahili (~20 million native speakers), Yoruba (~40 million), and Igbo (~30 million) are among Africa's most-spoken indigenous languages."
    },
    {
        "id": 1362,
        "question": "Which African city was a major center of Islamic scholarship and Arabic linguistic study?",
        "options": [
            "Timbuktu (Mali)",
            "Cairo (Egypt)",
            "Kano (Nigeria)"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Timbuktu was renowned for Islamic learning where Arabic was studied deeply. Manuscripts reveal sophisticated linguistic and theological scholarship."
    },
    {
        "id": 1363,
        "question": "The Tuareg people speak:",
        "options": [
            "Tamasheq (a Berber language)",
            "Only Arabic",
            "Only French"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tamasheq is the Tuareg language, part of Berber linguistic traditions. Tuareg use a unique script called Tifinagh for writing."
    },
    {
        "id": 1364,
        "question": "Tigrinya is spoken primarily in:",
        "options": [
            "Eritrea and Ethiopia",
            "Kenya and Tanzania",
            "West Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tigrinya is spoken by over 7 million people in Eritrea and northern Ethiopia. It's written in the Ge'ez script and represents Horn of Africa linguistic heritage."
    },
    {
        "id": 1365,
        "question": "How many people are affected by tropical diseases in Africa annually?",
        "options": [
            "Hundreds of millions",
            "Thousands only",
            "Just a few"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Malaria, sleeping sickness, and other tropical diseases affect hundreds of millions of Africans annually, driving medical research and public health efforts."
    },
    {
        "id": 1366,
        "question": "Africa's population is currently:",
        "options": [
            "Over 1.4 billion people",
            "500 million",
            "800 million"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa has over 1.4 billion people, making it the second-most populous continent. Population growth is rapid, with median age around 19 years."
    },
    {
        "id": 1367,
        "question": "Which African country has the largest population?",
        "options": [
            "Nigeria (over 200 million)",
            "Ethiopia (over 120 million)",
            "Egypt (over 100 million)"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria's population exceeds 220 million, making it Africa's most populous nation and one of the world's ten most populous countries."
    },
    {
        "id": 1368,
        "question": "Africa's urbanization rate is:",
        "options": [
            "Growing rapidly, with cities doubling in size",
            "Completely stable",
            "Decreasing"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African urbanization is the fastest in the world. Lagos, Cairo, and Kinshasa are megacities facing housing, transportation, and infrastructure challenges."
    },
    {
        "id": 1369,
        "question": "Which African city is the largest by population?",
        "options": [
            "Lagos (Nigeria)",
            "Cairo (Egypt)",
            "Kinshasa (DRC)"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lagos has a metropolitan population exceeding 15 million, making it Africa's largest city. It's a major economic and cultural hub."
    },
    {
        "id": 1370,
        "question": "What percentage of Africa's population is under 25 years old?",
        "options": [
            "Over 60%",
            "40%",
            "20%"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa is extremely young, with over 60% under 25. This demographic dividend offers opportunities for economic growth if development is prioritized."
    },
    {
        "id": 1371,
        "question": "Which African countries have the fastest population growth rates?",
        "options": [
            "Niger, Nigeria, and Chad",
            "Egypt and South Africa",
            "Kenya and Ethiopia"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Niger is the fastest-growing nation globally with over 3.8% annual growth. Nigeria and Chad also experience rapid population expansion."
    },
    {
        "id": 1372,
        "question": "Africa's life expectancy has improved due to:",
        "options": [
            "Better healthcare, vaccines, and disease prevention",
            "No improvements",
            "Policy changes only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African life expectancy has increased from ~47 years (1990) to ~65 years (2023) due to vaccination programs, antiretroviral therapy, and healthcare investments."
    },
    {
        "id": 1373,
        "question": "Africa accounts for approximately what percentage of global population?",
        "options": [
            "About 18%",
            "5%",
            "10%"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "With 1.4 billion people, Africa represents roughly 18% of Earth's population. This percentage is projected to increase as Africa's population grows."
    },
    {
        "id": 1374,
        "question": "The Sahel region contains what percentage of Africa's population?",
        "options": [
            "About 20%",
            "50%",
            "70%"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Sahel (semi-arid belt south of Sahara) contains roughly 20% of Africa's population despite having limited water resources."
    },
    {
        "id": 1375,
        "question": "Africa's median age is:",
        "options": [
            "19 years (very young continent)",
            "35 years",
            "45 years"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa's median age of 19 years is the world's lowest, indicating an extremely young population with vast human capital for development."
    },
    {
        "id": 1376,
        "question": "Which African country has the highest infant mortality rate?",
        "options": [
            "Sierra Leone and Mali",
            "South Africa only",
            "Kenya only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Sierra Leone and Mali have among the highest infant mortality rates globally, despite improvements. Access to prenatal and maternal care remains challenging."
    },
    {
        "id": 1377,
        "question": "Africa's labor force participation rate is:",
        "options": [
            "Very high in agriculture and informal sectors",
            "Low across all sectors",
            "Concentrated in government"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Most Africans work in agriculture or informal economies. Formal employment is limited, with many engaged in subsistence farming or street vending."
    },
    {
        "id": 1378,
        "question": "What is Africa's current gross domestic product (GDP)?",
        "options": [
            "Over $3 trillion",
            "$1 trillion",
            "$500 billion"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa's combined GDP exceeds $3 trillion, making it economically significant globally. However, wealth distribution is highly unequal."
    },
    {
        "id": 1379,
        "question": "Which African country has the largest economy?",
        "options": [
            "Nigeria",
            "South Africa",
            "Egypt"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria's GDP exceeds $450 billion, making it Africa's largest economy, driven by oil production and growing sectors."
    },
    {
        "id": 1380,
        "question": "Africa's internet penetration is:",
        "options": [
            "Growing rapidly, especially mobile internet",
            "Stagnant",
            "Declining"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African internet usage is growing fastest in the world. Mobile internet is primary access mode, with over 600 million internet users."
    },
    {
        "id": 1381,
        "question": "Which African country leads in mobile money innovation?",
        "options": [
            "Kenya (M-Pesa)",
            "Nigeria only",
            "South Africa only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kenya's M-Pesa revolutionized mobile banking, enabling millions to access financial services without bank accounts. It's a model adopted across Africa."
    },
    {
        "id": 1382,
        "question": "Africa's renewable energy potential is:",
        "options": [
            "Enormous, with vast solar and wind resources",
            "Limited",
            "Non-existent"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa receives more sunshine than any continent and has excellent wind resources. Renewable energy development could transform the continent's energy security."
    },
    {
        "id": 1383,
        "question": "Which African nation leads in renewable energy adoption?",
        "options": [
            "Ethiopia (hydropower), Kenya (geothermal)",
            "Nigeria only",
            "South Africa only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ethiopia generates most electricity from hydropower, while Kenya uses extensive geothermal energy. Both are leaders in renewable energy adoption."
    },
    {
        "id": 1384,
        "question": "Africa's agricultural output feeds:",
        "options": [
            "1 billion+ people across Africa and diaspora",
            "Only Africans",
            "No one (all imported)"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Agriculture employs over 60% of Africans and is central to food security. Coffee, cocoa, and other crops feed billions globally."
    },
    {
        "id": 1385,
        "question": "Which African crop is exported globally and grown widely?",
        "options": [
            "Cacao (chocolate), coffee, and tea",
            "Only rice",
            "Only wheat"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa produces majority of global cacao and significant coffee/tea. These crops generate billions in export revenue and employ millions."
    },
    {
        "id": 1386,
        "question": "Africa's contribution to global trade is:",
        "options": [
            "Growing, but still underrepresented",
            "Declining",
            "Non-existent"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa represents about 3% of global trade despite its size. Intra-African trade is increasing, creating new economic opportunities."
    },
    {
        "id": 1387,
        "question": "The African Continental Free Trade Area (AfCFTA) aims to:",
        "options": [
            "Increase intra-African trade and integration",
            "Isolate Africa",
            "Reduce cooperation"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "AfCFTA, launched in 2021, aims to create a single African market of 1.4 billion people, boosting intra-African trade and industrialization."
    },
    {
        "id": 1388,
        "question": "Which African region has the highest GDP?",
        "options": [
            "Southern Africa (including South Africa)",
            "North Africa",
            "West Africa (including Nigeria)"
        ],
        "answer_index": 2,
        "image_url": "",
        "explanation": "West Africa's combined GDP, dominated by Nigeria, exceeds $700 billion, making it Africa's most economically productive region."
    },
    {
        "id": 1389,
        "question": "Africa's foreign direct investment (FDI) comes primarily from:",
        "options": [
            "China, US, Europe, and Gulf countries",
            "Only Europe",
            "Only within Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "China is now Africa's largest investor after Europe, investing in infrastructure, manufacturing, and resource extraction across the continent."
    },
    {
        "id": 1390,
        "question": "Which African nations are BRICS members?",
        "options": [
            "South Africa",
            "Nigeria and Kenya",
            "None"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "South Africa is BRICS' only African member, representing the continent in this emerging economies bloc alongside Brazil, Russia, India, and China."
    },
    {
        "id": 1391,
        "question": "Africa's debt levels are:",
        "options": [
            "Rising, requiring careful fiscal management",
            "Negligible",
            "Zero"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African debt has risen to over $700 billion, with concerns about debt sustainability. Many nations face challenges servicing external debt."
    },
    {
        "id": 1392,
        "question": "Which African country has the lowest poverty rate?",
        "options": [
            "South Africa or Mauritius",
            "Nigeria",
            "DRC"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "South Africa and Mauritius have among Africa's lowest poverty rates due to industrialization and social safety nets, though inequality remains high."
    },
    {
        "id": 1393,
        "question": "Africa's Gini coefficient (income inequality) is:",
        "options": [
            "Among the world's highest",
            "Very low",
            "Moderate"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa's Gini coefficient indicates severe income inequality. Wealth is concentrated among small elites while millions live in poverty."
    },
    {
        "id": 1394,
        "question": "Access to clean water in Africa stands at approximately:",
        "options": [
            "70% (improving but challenges remain)",
            "100%",
            "30%"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "About 70% of Africans have improved water access, up from 50% in 2000. However, 400+ million still lack safe drinking water."
    },
    {
        "id": 1395,
        "question": "Africa's school enrollment rates are:",
        "options": [
            "Improving but gender gaps persist",
            "Declining",
            "100% everywhere"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Primary enrollment has risen significantly, but secondary and higher education access remain limited. Girls face barriers including early marriage."
    },
    {
        "id": 1396,
        "question": "Which African nation has the highest literacy rate?",
        "options": [
            "Equatorial Guinea, South Africa, Zimbabwe",
            "Nigeria",
            "Chad"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Several Southern African nations have literacy rates above 90%, while Saharan nations face significant literacy challenges below 40%."
    },
    {
        "id": 1397,
        "question": "Africa's healthcare spending as percentage of GDP is:",
        "options": [
            "4-6% (below world average)",
            "15%",
            "Less than 1%"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African healthcare spending is below global average of 9%, contributing to limited infrastructure and health outcomes despite disease burden."
    },
    {
        "id": 1398,
        "question": "The WHO estimates Africa's disease burden from:",
        "options": [
            "Infectious diseases (malaria, TB, HIV)",
            "Only non-communicable diseases",
            "Only heart disease"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Infectious diseases (malaria, TB, HIV/AIDS) account for massive disease burden in Africa. Non-communicable diseases are rising but infectious diseases dominate."
    },
    {
        "id": 1399,
        "question": "Africa's forest coverage is:",
        "options": [
            "About 17% of land, but declining",
            "70%",
            "Less than 5%"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African forests cover ~17% of continent but deforestation rates are among world's highest. Congo rainforest faces particular pressure."
    },
    {
        "id": 1400,
        "question": "Which African country has the largest remaining rainforest?",
        "options": [
            "Democratic Republic of Congo",
            "Nigeria",
            "Cameroon"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "DRC contains majority of Congo rainforest, Africa's second-largest tropical forest. Its deforestation threatens global climate and biodiversity."
    },
    {
        "id": 1401,
        "question": "Africa's wildlife diversity includes:",
        "options": [
            "5-10% of Earth's species",
            "50%",
            "Less than 1%"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa harbors 5-10% of Earth's species, with exceptional endemism (species found nowhere else). Conservation is critical for global biodiversity."
    },
    {
        "id": 1402,
        "question": "Which African nations lead in wildlife conservation?",
        "options": [
            "Botswana, Kenya, Tanzania, South Africa",
            "Only Egypt",
            "Only Nigeria"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Southern and East African nations have pioneered wildlife conservation through national parks and anti-poaching efforts protecting iconic species."
    },
    {
        "id": 1403,
        "question": "The 'Big Five' African animals are:",
        "options": [
            "Lion, leopard, rhino, elephant, buffalo",
            "Only large animals",
            "Only predators"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The 'Big Five' refers to dangerous game animals hunted historically. Today they're protected in national parks, attracting safari tourism."
    },
    {
        "id": 1404,
        "question": "African elephant populations have:",
        "options": [
            "Declined 66% since 1990 due to poaching",
            "Increased",
            "Remained stable"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Elephant poaching for ivory has devastated populations. Conservation efforts in some countries have stabilized populations locally."
    },
    {
        "id": 1405,
        "question": "Which African animal is critically endangered?",
        "options": [
            "Black rhino, Sumatran rhino, African wild dog",
            "Lion",
            "Zebra"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Black rhinos number only ~5,500, making them critically endangered. Breeding programs and protection efforts aim to save the species."
    },
    {
        "id": 1406,
        "question": "Africa's protected areas cover approximately:",
        "options": [
            "15-17% of the continent",
            "50%",
            "Less than 5%"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Protected areas cover 15-17% of African land, including national parks, game reserves, and conservation areas protecting ecosystems."
    },
    {
        "id": 1407,
        "question": "The Trans Kalahari Highway connects:",
        "options": [
            "Southern Africa (Namibia to South Africa)",
            "North Africa",
            "West Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Trans Kalahari Highway is a major trade route in Southern Africa, improving regional connectivity and economic integration."
    },
    {
        "id": 1408,
        "question": "Africa's road quality is:",
        "options": [
            "Improving but many unpaved, especially rural roads",
            "All paved",
            "Completely poor"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Only ~20% of African roads are paved. Many nations are investing in road infrastructure to boost trade and connectivity."
    },
    {
        "id": 1409,
        "question": "Which African country has the most developed rail network?",
        "options": [
            "South Africa",
            "Egypt",
            "Nigeria"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "South Africa has Africa's most extensive and modern railway system, inherited from colonial development and continually improving."
    },
    {
        "id": 1410,
        "question": "Africa's aviation industry is:",
        "options": [
            "Growing rapidly with new airlines",
            "Declining",
            "Non-existent"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African aviation is expanding with new airlines and airports. Regional connectivity is improving, though long-distance flights require connections."
    },
    {
        "id": 1411,
        "question": "Which African country has the best ports?",
        "options": [
            "South Africa (Cape Town, Durban)",
            "Egypt (Alexandria)",
            "Nigeria (Lagos)"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "South Africa's ports are among Africa's most developed. Durban is one of world's busiest ports, handling regional and global trade."
    },
    {
        "id": 1412,
        "question": "Africa's maritime trade routes are:",
        "options": [
            "Critical for global commerce, especially around Cape of Good Hope",
            "Insignificant",
            "Only local"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Cape Route around South Africa is critical for East-West global trade. Piracy and maritime security remain concerns in some regions."
    },
    {
        "id": 1413,
        "question": "The establishment of the African Development Bank reflects:",
        "options": [
            "Africa's commitment to joint economic development",
            "Only colonial history",
            "Purely political goals"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The African Development Bank, founded 1964, finances infrastructure and development projects across Africa, supporting regional integration."
    },
    {
        "id": 1414,
        "question": "Africa's trade agreements with major powers include:",
        "options": [
            "US-AGOA, EPA (EU), partnerships with China",
            "None",
            "Only with Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa has major trade agreements: US AGOA, EU Economic Partnership Agreements, and growing partnerships with China and other powers."
    },
    {
        "id": 1415,
        "question": "Which African organization promotes regional integration?",
        "options": [
            "ECOWAS (West), EAC (East), SADC (Southern)",
            "Only the African Union",
            "None"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Regional organizations like ECOWAS, EAC, and SADC promote trade, security, and cooperation within Africa's major regions."
    },
    {
        "id": 1416,
        "question": "African nations' participation in global institutions includes:",
        "options": [
            "UN, WTO, IMF, World Bank representation",
            "Minimal",
            "None"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African nations participate in global institutions but arguments persist about adequate representation and voice in decision-making."
    },
    {
        "id": 1417,
        "question": "The African diaspora's contribution to homeland is:",
        "options": [
            "Billions in remittances annually",
            "Nothing",
            "Minimal"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African diaspora sends over $80 billion annually in remittances, supporting families and economies. Brain drain remains a concern."
    },
    {
        "id": 1418,
        "question": "South Africa's economy relies most heavily on:",
        "options": [
            "Mining, manufacturing, and services",
            "Only agriculture",
            "Only tourism"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "South Africa's diverse economy is driven by mining (gold, diamonds), advanced manufacturing, and service sectors."
    },
    {
        "id": 1419,
        "question": "Which African nation has significant shale gas reserves?",
        "options": [
            "South Africa (Karoo basin)",
            "Kenya",
            "Nigeria only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "South Africa's Karoo basin has vast shale gas reserves, though extraction remains controversial due to environmental concerns."
    },
    {
        "id": 1420,
        "question": "Africa's technology startups are valued at:",
        "options": [
            "Over $45 billion collectively",
            "$5 billion",
            "$1 billion"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African tech startups collectively valued at $45+ billion as of 2023, with fintech, software, and e-commerce leading innovation sectors."
    },
    {
        "id": 1421,
        "question": "The Union of South Africa was established in:",
        "options": [
            "1910",
            "1945",
            "1961"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Union of South Africa was established in 1910, uniting British colonies. It later became the Republic of South Africa in 1961."
    },
    {
        "id": 1422,
        "question": "The Pan-African Conference was held in:",
        "options": [
            "1900 (London)",
            "1945 (New York)",
            "1955 (Ghana)"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The 1900 Pan-African Conference in London brought together African intellectuals and activists, establishing early Pan-African unity ideals."
    },
    {
        "id": 1423,
        "question": "Which conference established the Organization of African Unity (OAU)?",
        "options": [
            "Addis Ababa Summit (1963)",
            "Lagos Conference (1960)",
            "Cairo Meeting (1955)"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Addis Ababa Summit (1963) established the OAU, now the African Union, with the goal of promoting unity and cooperation among African states."
    },
    {
        "id": 1424,
        "question": "The Bandung Conference (1955) was significant for Africa because:",
        "options": [
            "It launched the Non-Aligned Movement supporting decolonization",
            "It united all African nations only",
            "It established trade routes"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Bandung brought together African and Asian nations opposing colonialism and Cold War alignments, giving voice to independence movements."
    },
    {
        "id": 1425,
        "question": "Which Pan-Africanist leader championed African unity across the diaspora?",
        "options": [
            "Marcus Garvey",
            "Haile Selassie",
            "Kwame Nkrumah"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Marcus Garvey (1887-1940) promoted 'Back to Africa' movements and Pan-Africanism alongside diaspora communities in America and the Caribbean."
    },
    {
        "id": 1426,
        "question": "The Scramble for Africa resulted in:",
        "options": [
            "European control of Africa by 1914",
            "African nations maintaining independence",
            "Shared rule between Europeans and Africans"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Between 1880-1914, European powers colonized virtually all Africa except Ethiopia and Liberia, dividing continent with arbitrary borders."
    },
    {
        "id": 1427,
        "question": "The Berlin Conference (1884-1885) established:",
        "options": [
            "Rules for European colonial conquest and partition",
            "Peace between nations",
            "Trade relationships"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Berlin Conference established European colonial boundaries in Africa without African participation, leading to artificial borders and conflicts."
    },
    {
        "id": 1428,
        "question": "Which African leader used guerrilla warfare to resist colonialists effectively?",
        "options": [
            "Samori Touré",
            "Only settlers resisted",
            "No one resisted"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Samori Touré pioneered guerrilla tactics in West Africa (1882-1898), becoming a model for anti-colonial resistance across Africa."
    },
    {
        "id": 1429,
        "question": "The Haitian Revolution inspired:",
        "options": [
            "Pan-African liberation movements",
            "Only European revolutions",
            "Asian independence"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Haitian Revolution (1791-1804) inspired diaspora Africans and African leaders to envision independence and challenge European domination."
    },
    {
        "id": 1430,
        "question": "African independence movements accelerated after:",
        "options": [
            "World War II (1945+)",
            "World War I only",
            "1980s"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "World War II weakened European powers and empowered African nationalists. By 1960, 17 African nations gained independence in 'Africa Year.'"
    },
    {
        "id": 1431,
        "question": "Julius Nyerere of Tanzania pioneered:",
        "options": [
            "Ujamaa (African socialism)",
            "Authoritarian rule",
            "Colonial cooperation"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nyerere developed Ujamaa (familyhood), an African socialist ideology emphasizing community, equality, and self-reliance post-independence."
    },
    {
        "id": 1432,
        "question": "Kwame Nkrumah's legacy includes:",
        "options": [
            "Pan-Africanism and Ghana's independence leadership",
            "Colonial cooperation only",
            "Isolation of African nations"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nkrumah led Ghana to independence (1957) and championed Pan-Africanism, though authoritarian later years contradicted democratic ideals."
    },
    {
        "id": 1433,
        "question": "The Mau Mau Uprising (1952-1960) occurred in:",
        "options": [
            "Kenya",
            "Nigeria",
            "Tanzania"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Mau Mau Uprising was a Kikuyu-led rebellion against British colonialism in Kenya, earning independence through armed struggle and negotiation."
    },
    {
        "id": 1434,
        "question": "The Congo Crisis of 1960 involved:",
        "options": [
            "Conflict between factions and foreign intervention",
            "Peaceful transition",
            "Continued colonialism"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo Crisis saw Cold War powers intervene in post-independence DRC, with Patrice Lumumba's assassination marking African independence's violent challenges."
    },
    {
        "id": 1435,
        "question": "The Zanzibar Revolution (1964) resulted in:",
        "options": [
            "Union with Tanganyika (Tanzania)",
            "Independence from all nations",
            "Colonial return"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Zanzibar Revolution overthrew the sultanate, eventually uniting with Tanganyika to form Tanzania in 1964."
    },
    {
        "id": 1436,
        "question": "Apartheid in South Africa was officially ended in:",
        "options": [
            "1994",
            "1980",
            "2000"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Apartheid ended in 1994 with Nelson Mandela's election. The system of racial segregation had structured South African society since 1948."
    },
    {
        "id": 1437,
        "question": "The Rhodesian UDI (Unilateral Declaration of Independence) in 1965 represented:",
        "options": [
            "Illegal colonial rebellion against Britain",
            "Legitimate independence",
            "International approval"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Rhodesia's illegal declaration sparked civil war (1966-1979) between white settlers and Black nationalist movements, ending with Zimbabwean independence."
    },
    {
        "id": 1438,
        "question": "The Biafran War (1967-1970) was fought over:",
        "options": [
            "Secession and ethnic conflict in Nigeria",
            "Trade disputes",
            "Border issues only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Biafran War saw Nigeria's eastern region attempt secession, resulting in widespread starvation and establishing international humanitarian aid importance."
    },
    {
        "id": 1439,
        "question": "The All-African Peoples Conference (1958) in Accra included:",
        "options": [
            "African leaders planning independence strategies",
            "European officials only",
            "Asian powers"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Accra Conference brought African nationalists together to coordinate independence movements and anti-colonial strategies."
    },
    {
        "id": 1440,
        "question": "African nations' Non-Aligned Movement participation reflected:",
        "options": [
            "Rejection of Cold War superpower alignment",
            "Support for all alliances",
            "Colonial preference"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African nations in the Non-Aligned Movement sought independent foreign policy during Cold War, balancing superpower interests without full alignment."
    },
    {
        "id": 1441,
        "question": "Africa's Millennium Development Goals reflected:",
        "options": [
            "Commitment to poverty reduction and human development",
            "Rejection of development",
            "Isolation from global goals"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African nations endorsed the MDGs (2000-2015) and Sustainable Development Goals, committing to addressing poverty, health, education, and environmental challenges."
	}
    ,{
        "id": 1442,
        "question": "The 'Pink Flamingo Lake' ecosystem depends on:",
        "options": [
            "Salt-loving algae",
            "Freshwater fish only",
            "Penguins"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lake Nakuru in Kenya supports massive flamingo populations because of abundant salt-loving algae which the birds feed on."
    },
    {
        "id": 1443,
        "question": "Africa's oldest desert is:",
        "options": [
            "Namib Desert (~55 million years old)",
            "Sahara (~10,000 years old)",
            "Kalahari (~1,000 years old)"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Namib Desert is the world's oldest desert at approximately 55 million years old, home to unique adapted species like the Welwitschia plant."
    },
    {
        "id": 1444,
        "question": "Africa is the only continent where:",
        "options": [
            "Rainforests, deserts, savannahs, and high mountains coexist within the same plate",
            "Only deserts exist",
            "Only mountains exist"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa's incredible biodiversity comes from having every major biome type on a single tectonic plate."
    },
    {
        "id": 1445,
        "question": "Dust from the Sahara helps fertilize:",
        "options": [
            "The Amazon rainforest",
            "North America only",
            "Antarctica"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Saharan dust carries nutrients across the Atlantic Ocean, fertilizing the Amazon rainforest and demonstrating global ecological connections."
	}
    ,{
        "id": 1446,
        "question": "The Congo River Basin contributes to:",
        "options": [
            "Global oxygen production",
            "Salt flats",
            "Desertification"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo Basin is the world's second largest rainforest, playing a major role in global oxygen production and carbon storage."
    },
    {
        "id": 1447,
        "question": "Africa's Baobab trees are known as:",
        "options": [
            "The tree of life for storing water and food",
            "Poisonous only",
            "Rocks"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Baobab trees store water in their trunks and provide food, making them vital for survival in arid regions."
    },
    {
        "id": 1448,
        "question": "The Danakil Depression produces:",
        "options": [
            "Salt, sulfur, and mineral-rich landscapes",
            "Gold only",
            "Forests"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Danakil Depression in Ethiopia is famous for its salt flats, sulfur springs, and unique mineral formations."
    },
    {
        "id": 1449,
        "question": "Africa's plate tectonics create:",
        "options": [
            "Rift valleys, volcanic mountains, and lakes",
            "Ice sheets",
            "Only deserts"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tectonic activity in Africa forms rift valleys, volcanoes, and lakes, shaping the continent's landscape."
    },
    {
        "id": 1450,
        "question": "The Maasai people are mainly found in:",
        "options": [
            "Kenya and Tanzania",
            "Nigeria and Ghana",
            "South Africa and Botswana"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Maasai are a Nilotic ethnic group known for their distinctive culture, living in Kenya and northern Tanzania."
    },
    {
        "id": 1451,
        "question": "The Zulu people are primarily in:",
        "options": [
            "South Africa",
            "Kenya",
            "Mali"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Zulu are the largest ethnic group in South Africa, known for their history and cultural influence."
    },
    {
        "id": 1452,
        "question": "The Berbers (Amazigh) live mainly in:",
        "options": [
            "Morocco, Algeria, Tunisia",
            "Sudan and Egypt",
            "Ghana and Togo"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Berbers, or Amazigh, are indigenous to North Africa, especially Morocco, Algeria, and Tunisia."
    },
    {
        "id": 1453,
        "question": "The San (Bushmen) people are indigenous to:",
        "options": [
            "Botswana, Namibia, and South Africa",
            "Ethiopia and Eritrea",
            "Senegal and Mali"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The San are among the oldest peoples of southern Africa, skilled in tracking and survival."
    },
    {
        "id": 1454,
        "question": "The Fulani (Fula) people are spread across:",
        "options": [
            "Nigeria, Senegal, Mali, Cameroon",
            "South Africa only",
            "Egypt and Libya"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Fulani are a large, widely dispersed West African ethnic group, known for cattle herding."
    },
    {
        "id": 1455,
        "question": "The Yoruba people are mostly found in:",
        "options": [
            "Nigeria, Benin, Togo",
            "Kenya and Uganda",
            "Ethiopia and Somalia"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Yoruba are a major West African ethnic group, mainly in Nigeria, Benin, and Togo."
    },
    {
        "id": 1456,
        "question": "The Igbo people are mainly in:",
        "options": [
            "Southeastern Nigeria",
            "Morocco",
            "South Africa"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Igbo are one of Nigeria's largest ethnic groups, concentrated in the southeast."
    },
    {
        "id": 1457,
        "question": "The Shona people are found in:",
        "options": [
            "Zimbabwe and Mozambique",
            "Ghana and Nigeria",
            "Kenya and Tanzania"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Shona are the largest ethnic group in Zimbabwe, also present in Mozambique."
    },
    {
        "id": 1458,
        "question": "The Amhara people are primarily in:",
        "options": [
            "Ethiopia",
            "Chad",
            "Cameroon"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Amhara are a major ethnic group in Ethiopia, with a long history and cultural influence."
    },
    {
        "id": 1459,
        "question": "The Hausa people are mainly in:",
        "options": [
            "Northern Nigeria and Niger",
            "South Africa",
            "Mali only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Hausa are one of the largest ethnic groups in West Africa, especially in northern Nigeria and Niger."
    },
    {
        "id": 1460,
        "question": "The Tuareg people are found in:",
        "options": [
            "Mali, Niger, Algeria, Libya",
            "Kenya and Tanzania",
            "Egypt only"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Tuareg are nomadic Berber people of the Sahara, found in Mali, Niger, Algeria, and Libya."
    },
    {
        "id": 1461,
        "question": "The Oromo people are primarily in:",
        "options": [
            "Ethiopia",
            "South Africa",
            "Ghana"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Oromo are the largest ethnic group in Ethiopia, with a distinct language and culture."
    },
    {
        "id": 1462,
        "question": "The Ndebele people are mostly in:",
        "options": [
            "Zimbabwe and South Africa",
            "Sudan and Egypt",
            "Morocco"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Ndebele are known for their colorful homes and are found in Zimbabwe and South Africa."
    },
    {
        "id": 1463,
        "question": "The Wolof people are mainly in:",
        "options": [
            "Senegal",
            "Nigeria",
            "Kenya"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Wolof are the largest ethnic group in Senegal, with a major influence on the country's culture."
    },
    {
        "id": 1464,
        "question": "The Baganda people are primarily in:",
        "options": [
            "Uganda",
            "Tanzania",
            "Rwanda"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Baganda are the largest ethnic group in Uganda, centered around the Buganda kingdom."
    },
    {
        "id": 1465,
        "question": "The Kikuyu people are mainly in:",
        "options": [
            "Kenya",
            "Uganda",
            "Tanzania"
        ],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Kikuyu are the largest ethnic group in Kenya, playing a key role in the country's history."
    },
    {
        "id": 1466,
        "question": "The Berom people are mostly in:",
        "options": ["Nigeria", "South Africa", "Morocco"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Berom are an ethnic group indigenous to the Jos Plateau in central Nigeria."
    },
    {
        "id": 1467,
        "question": "The Ewe people are found in:",
        "options": ["Ghana and Togo", "Ethiopia and Sudan", "Mali and Niger"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Ewe are a major ethnic group in Ghana and Togo, known for their music and dance traditions."
    },
    {
        "id": 1468,
        "question": "The Tswana people are primarily in:",
        "options": ["Botswana and South Africa", "Kenya", "Morocco"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Tswana are the largest ethnic group in Botswana and are also found in South Africa."
    },
    {
        "id": 1469,
        "question": "The Mandinka people are mostly in:",
        "options": ["Mali, Senegal, The Gambia", "Nigeria and Cameroon", "Egypt and Sudan"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Mandinka are a West African ethnic group with a rich history of empire-building and oral tradition."
    },
    {
        "id": 1470,
        "question": "The Fang people are mainly found in:",
        "options": ["Gabon, Cameroon, Equatorial Guinea", "Kenya and Tanzania", "Nigeria only"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Fang are a Central African ethnic group, especially in Gabon, Cameroon, and Equatorial Guinea."
    },
    {
        "id": 1471,
        "question": "The Berbers in the Sahara are known for living in:",
        "options": ["Morocco, Algeria, Libya", "Chad only", "Mali only"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Saharan Berbers are indigenous to North Africa, especially Morocco, Algeria, and Libya."
    },
    {
        "id": 1472,
        "question": "The Xhosa people are primarily in:",
        "options": ["South Africa", "Ghana", "Sudan"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Xhosa are a major ethnic group in South Africa, known for their language and traditions."
    },
    {
        "id": 1473,
        "question": "The Tonga people live mainly in:",
        "options": ["Zambia and Zimbabwe", "Ethiopia", "Morocco"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Tonga are an ethnic group in southern Zambia and northern Zimbabwe."
    },
    {
        "id": 1474,
        "question": "The Kanuri people are mostly found in:",
        "options": ["Northeastern Nigeria, Niger, Chad", "South Africa", "Senegal"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Kanuri are a major ethnic group in the Lake Chad region of northeastern Nigeria, Niger, and Chad."
    },
    {
        "id": 1475,
        "question": "Approximately how many distinct ethnic groups (tribes) exist in Africa?",
        "options": ["Over 3,000", "Around 500", "Around 100"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa is home to over 3,000 distinct ethnic groups, making it the most culturally diverse continent."
    },
    {
        "id": 1476,
        "question": "Nigeria alone has roughly how many tribes?",
        "options": ["Over 250", "50", "10"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria is one of the most ethnically diverse countries, with over 250 tribes."
    },
    {
        "id": 1477,
        "question": "Which tribe in Nigeria is famous for intricate bronze art and ancient city walls?",
        "options": ["Edo (Benin)", "Igbo", "Fulani"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Edo (Benin) are renowned for their bronze art and the ancient Benin City walls."
    },
    {
        "id": 1478,
        "question": "Which West African tribe is known for wealthy gold trade and empire-building in medieval times?",
        "options": ["Mandinka (Mali)", "Zulu", "Berber"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Mandinka of Mali were central to the Mali Empire, famous for gold trade and wealth."
    },
    {
        "id": 1479,
        "question": "Which East African tribe is famous for living in harmony with wildlife and cattle herding?",
        "options": ["Maasai", "Hausa", "San"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Maasai are known for their pastoral lifestyle and coexistence with wildlife in East Africa."
    },
    {
        "id": 1480,
        "question": "Which Southern African tribe is known for painting colorful geometric designs on homes?",
        "options": ["Ndebele", "Shona", "Zulu"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Ndebele of Southern Africa are famous for their vibrant house paintings."
    },
    {
        "id": 1481,
        "question": "Which Central African tribe is famous for ceremonial masks and sculptures?",
        "options": ["Kuba", "Fulani", "Oromo"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Kuba people of Central Africa are renowned for their ceremonial masks and wood carvings."
    },
    {
        "id": 1482,
        "question": "Which East African tribe has a unique language with click consonants?",
        "options": ["San (Bushmen)", "Maasai", "Kikuyu"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The San (Bushmen) languages are known for their click consonants."
    },
    {
        "id": 1483,
        "question": "Which West African tribe is known for highly organized age-grade systems and city governance?",
        "options": ["Hausa", "Ashanti", "Zulu"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Hausa have a long tradition of city-states and age-grade social organization."
    },
    {
        "id": 1484,
        "question": "Which African island's people developed lemur-friendly agriculture and unique baobab ecosystems due to long isolation?",
        "options": ["Madagascar (Malagasy)", "Comoros", "Seychelles"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Malagasy of Madagascar developed unique agricultural and ecological practices."
    },
    {
        "id": 1485,
        "question": "Ethiopia has approximately how many ethnic groups?",
        "options": ["Over 80", "20", "5"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ethiopia is home to over 80 distinct ethnic groups."
    },
    {
        "id": 1486,
        "question": "South Africa officially recognizes how many ethnic groups (tribes/languages)?",
        "options": ["11 official languages representing major tribes", "3", "25"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "South Africa has 11 official languages, each linked to a major ethnic group."
    },
    {
        "id": 1487,
        "question": "Which tribe in West Africa is famous for kente weaving and royal cloth?",
        "options": ["Ashanti (Ghana)", "Yoruba", "Berber"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Ashanti of Ghana are renowned for kente cloth and royal regalia."
    },
    {
        "id": 1488,
        "question": "Which East African tribe is known for rituals involving jumping dances and warrior ceremonies?",
        "options": ["Maasai", "Somali", "Amhara"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Maasai are famous for their jumping dances and warrior traditions."
    },
    {
        "id": 1489,
        "question": "Which Southern African tribe is famous for stone-walled cities like Great Zimbabwe?",
        "options": ["Shona", "Ndebele", "San"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Shona built Great Zimbabwe, a UNESCO World Heritage site."
    },
    {
        "id": 1490,
        "question": "Which Nigerian tribe is famous for Igbo-Ukwu bronze work dating back to 9th century?",
        "options": ["Igbo", "Hausa", "Yoruba"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Igbo are known for ancient bronze work at Igbo-Ukwu."
    },
    {
        "id": 1491,
        "question": "Which tribe in Mali is famous for Timbuktu scholarship and manuscript libraries?",
        "options": ["Songhai", "Berber", "Fulani"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Songhai Empire was a center of learning, especially in Timbuktu."
    },
    {
        "id": 1492,
        "question": "Which tribe in Senegal is famous for Lake Retba (Pink Lake) rituals and salt harvesting?",
        "options": ["Lebou", "Wolof", "Serer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Lebou people are known for their connection to Lake Retba and salt harvesting."
    },
    {
        "id": 1493,
        "question": "Which tribe in Cameroon is known for Kuba royal masks and court ceremonies?",
        "options": ["Kuba", "Fulani", "Bamileke"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Kuba are famous for royal masks and elaborate court rituals."
    },
    {
        "id": 1494,
        "question": "Which East African tribe has ritual scarification patterns for identity and beauty?",
        "options": ["Maasai", "Kikuyu", "Somali"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Maasai are known for ritual scarification as a cultural marker."
    },
    {
        "id": 1495,
        "question": "How many major ethnic groups are in Ghana?",
        "options": ["About 10", "50", "3"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana has about 10 major ethnic groups, including Akan, Mole-Dagbani, Ewe, and Ga-Dangme."
    },
    {
        "id": 1496,
        "question": "Who led the Ashanti against British forces in the Anglo-Ashanti wars?",
        "options": ["Prempeh I", "Samori Touré", "Shaka Zulu"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Prempeh I resisted British attempts to annex Ashanti territory and defend their sovereignty."
    },
    {
        "id": 1497,
        "question": "Samori Touré was famous for:",
        "options": ["Creating a disciplined army to resist French colonization in West Africa", "Negotiating European trade deals peacefully", "Leading the Zulu regiments"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Samori Touré built a professional army and resisted French colonization in West Africa."
    },
    {
        "id": 1498,
        "question": "The Battle of Adwa (1896) saw which African leader defeat an invading European power?",
        "options": ["Menelik II (Ethiopia)", "Patrice Lumumba", "Shaka Zulu"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Menelik II led Ethiopia to victory over Italy at Adwa, symbolizing African independence."
    },
    {
        "id": 1499,
        "question": "Which Yoruba leader resisted British expansion in Nigeria during the late 19th century?",
        "options": ["Oba Ovonramwen", "Queen Amina", "Samori Touré"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Oba Ovonramwen of Benin resisted British colonial expansion in Nigeria."
    },
    {
        "id": 1500,
        "question": "The Fulani leader who resisted French colonial forces in West Africa was:",
        "options": ["Samori Touré", "Menelik II", "Shaka Zulu"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Samori Touré, though not Fulani, led resistance in West Africa; Fulani leaders also resisted French expansion."
    },
    {
        "id": 1501,
        "question": "Which Somali leader led resistance against Italian colonization?",
        "options": ["Sayyid Mohammed Abdullah Hassan", "Menelik II", "Shaka Zulu"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Sayyid Mohammed Abdullah Hassan led the Dervish movement against Italian and British forces in Somalia."
    },
    {
        "id": 1502,
        "question": "Which Kenyan group resisted British colonization fiercely in the late 19th-early 20th century?",
        "options": ["Maasai", "Kikuyu", "Zulu"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Kikuyu organized notable uprisings and land resistance movements against British rule."
    },
    {
        "id": 1503,
        "question": "The Ethiopian army used which strategy at Adwa?",
        "options": ["Superior knowledge of terrain and large coordinated forces", "Naval bombardment", "Poison gas"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ethiopian forces at Adwa used superior knowledge of terrain and coordinated attacks to defeat Italy."
    },
    {
        "id": 1504,
        "question": "Queen Amina of Zazzau (Nigeria) is famous for:",
        "options": ["Expanding her territory through warfare in the 16th century", "Leading peaceful trade negotiations", "Teaching schools"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Queen Amina expanded Zazzau's territory and was a renowned warrior queen."
    },
    {
        "id": 1505,
        "question": "Shaka Zulu is famous for:",
        "options": ["Reforming military tactics and defending Zulu lands", "Negotiating treaties with the British peacefully", "Building stone cities"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Shaka Zulu revolutionized military tactics and defended Zulu territory."
    },
    {
        "id": 1506,
        "question": "Which battle is legendary for Zulu resistance against the British in 1879?",
        "options": ["Battle of Isandlwana", "Battle of Adwa", "Battle of Omdurman"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Battle of Isandlwana was a major Zulu victory over British forces in 1879."
    },
    {
        "id": 1507,
        "question": "The Ndebele under King Lobengula resisted:",
        "options": ["British colonization in Zimbabwe", "French colonization", "Portuguese colonization"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "King Lobengula led the Ndebele in resistance against British colonization in Zimbabwe."
    },
    {
        "id": 1508,
        "question": "Which Southern African group used guerrilla tactics against European settlers during the 19th century?",
        "options": ["Xhosa", "Ashanti", "Tuareg"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Xhosa used guerrilla tactics to resist European colonization in Southern Africa."
    },
    {
        "id": 1509,
        "question": "Which leader resisted Portuguese colonial forces in Mozambique?",
        "options": ["Ngungunyane (Gungunhana)", "Menelik II", "Samori Touré"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ngungunyane (Gungunhana) led resistance against Portuguese rule in Mozambique."
    },
    {
        "id": 1510,
        "question": "Which Central African kingdom resisted Belgian colonization in the late 19th century?",
        "options": ["Kingdom of Kongo under King Alfonso I", "Mali Empire", "Zulu Kingdom"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Kingdom of Kongo, under King Alfonso I, resisted Belgian colonization."
    },
    {
        "id": 1511,
        "question": "The Malagasy (Madagascar) resisted French colonization under:",
        "options": ["Queen Ranavalona I and II", "Shaka Zulu", "Menelik II"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Queens Ranavalona I and II led resistance against French colonization in Madagascar."
    },
    {
        "id": 1512,
        "question": "Which Central African tribe used forts and rivers to slow European conquest?",
        "options": ["Luba and Lunda", "San", "Maasai"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Luba and Lunda used natural defenses to resist European conquest in Central Africa."
    },
    {
        "id": 1513,
        "question": "Who led resistance in Angola against Portuguese colonization in the 19th century?",
        "options": ["Queen Nzinga (historical, earlier but famous for resistance strategies)", "Menelik II", "Shaka Zulu"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Queen Nzinga of Angola is renowned for her resistance strategies against Portuguese colonization."
    },
    {
        "id": 1514,
        "question": "Which island group resisted colonization for centuries while maintaining unique culture?",
        "options": ["Comoros and Madagascar", "Canary Islands", "Azores"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Comoros and Madagascar resisted colonization and preserved unique cultures."
    },
    {
        "id": 1515,
        "question": "Which West African leader built a professional army to resist French colonization and used scorched-earth tactics?",
        "options": ["Samori Touré", "Menelik II", "Shaka Zulu"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Samori Touré built a professional army and used scorched-earth tactics against the French."
    },
    {
        "id": 1516,
        "question": "The Battle of Isandlwana in 1879 demonstrated:",
        "options": ["That indigenous African forces could defeat modern European armies", "European naval superiority", "Peaceful treaty enforcement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Zulu victory at Isandlwana showed that African forces could defeat European armies."
    },
    {
        "id": 1517,
        "question": "Queen Amina's exploits include:",
        "options": ["Expanding her territory and training a cavalry army", "Founding schools", "Trading spices only"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Queen Amina expanded her territory and trained a cavalry army in Nigeria."
    },
    {
        "id": 1518,
        "question": "Menelik II's victory at Adwa helped Ethiopia:",
        "options": ["Maintain independence while most of Africa was colonized", "Become a colony", "Lose territory"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Menelik II's victory at Adwa allowed Ethiopia to remain independent during the colonial era."
    },
    {
        "id": 1519,
        "question": "African resistance often used:",
        "options": ["Knowledge of terrain, guerrilla tactics, and diplomacy", "Only passive surrender", "Nuclear weapons"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "African resistance movements used terrain, guerrilla tactics, and diplomacy."
    },
    {
        "id": 1520,
        "question": "What is the largest country in Africa by land area?",
        "options": ["Algeria", "Democratic Republic of Congo", "Sudan"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Algeria is the largest country in Africa by land area."
    },
    {
        "id": 1521,
        "question": "Which is the smallest African country by land area?",
        "options": ["Seychelles", "Gambia", "Swaziland"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Seychelles is the smallest African country by land area."
    },
    {
        "id": 1522,
        "question": "Africa's longest river is the Nile. Which is the second longest?",
        "options": ["Congo River", "Niger River", "Zambezi River"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo River is the second longest river in Africa after the Nile."
    },
    {
        "id": 1523,
        "question": "Mount Kilimanjaro is a:",
        "options": ["Free-standing volcanic mountain", "Part of a mountain range", "Submerged volcano"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Mount Kilimanjaro is the world's tallest free-standing volcanic mountain."
    },
    {
        "id": 1524,
        "question": "The Sahara Desert covers roughly:",
        "options": ["9 million km²", "3 million km²", "1.5 million km²"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Sahara Desert covers about 9 million square kilometers."
    },
    {
        "id": 1525,
        "question": "Which desert is considered the oldest in the world, around 55 million years old?",
        "options": ["Namib", "Kalahari", "Sahara"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Namib Desert is the oldest desert in the world, about 55 million years old."
    },
    {
        "id": 1526,
        "question": "Which plateau covers much of southern Africa and includes parts of Botswana, Zimbabwe, and South Africa?",
        "options": ["Highveld", "Sahel", "Ethiopian Highlands"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Highveld plateau covers much of southern Africa."
    },
    {
        "id": 1527,
        "question": "The Drakensberg Mountains are mainly in:",
        "options": ["South Africa and Lesotho", "Morocco and Algeria", "Kenya and Tanzania"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Drakensberg Mountains are located in South Africa and Lesotho."
    },
    {
        "id": 1528,
        "question": "Africa lies mostly on which tectonic plate?",
        "options": ["African Plate", "Eurasian Plate", "Arabian Plate"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa lies mostly on the African tectonic plate."
    },
    {
        "id": 1529,
        "question": "The Great Rift Valley stretches from:",
        "options": ["Lebanon to Mozambique", "Egypt to South Africa", "Morocco to Kenya"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Great Rift Valley stretches from Lebanon to Mozambique."
    },
    {
        "id": 1530,
        "question": "Lake Tanganyika is remarkable because it is:",
        "options": ["The world's second deepest freshwater lake", "Africa's largest lake by surface area", "Completely dry in the dry season"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lake Tanganyika is the world's second deepest freshwater lake."
    },
    {
        "id": 1531,
        "question": "Which river flows entirely within the tropics and supports dense rainforest?",
        "options": ["Congo", "Nile", "Niger"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo River flows entirely within the tropics and supports dense rainforest."
    },
    {
        "id": 1532,
        "question": "Which lake is Africa's largest by surface area?",
        "options": ["Lake Victoria (Nyanza)", "Lake Chad", "Lake Tanganyika"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lake Victoria is Africa's largest lake by surface area."
    },
    {
        "id": 1533,
        "question": "The Niger River forms an inland delta in which country?",
        "options": ["Mali", "Nigeria", "Guinea"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Niger River forms an inland delta in Mali."
    },
    {
        "id": 1534,
        "question": "Which African river is known as the “lifeline of West Africa”?",
        "options": ["Niger River", "Congo River", "Zambezi River"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Niger River is known as the lifeline of West Africa."
    },
    {
        "id": 1535,
        "question": "Madagascar separated from mainland Africa approximately how many years ago?",
        "options": ["88 million years", "10 million years", "50 thousand years"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Madagascar separated from Africa about 88 million years ago."
    },
    {
        "id": 1536,
        "question": "The pink Lake Natron in Tanzania gets its color from:",
        "options": ["Salt-loving algae", "Mineral mining", "Volcano activity"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lake Natron's pink color comes from salt-loving algae."
    },
    {
        "id": 1537,
        "question": "Which African island has the world's tallest volcano in the Indian Ocean?",
        "options": ["Réunion (not African politically, but near Madagascar)", "Mauritius", "Seychelles"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Réunion has the world's tallest volcano in the Indian Ocean."
    },
    {
        "id": 1538,
        "question": "The Okavango Delta in Botswana is unique because:",
        "options": ["It floods inland, creating a lush oasis in the desert", "It's entirely dry most of the year", "It's a salt flat"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Okavango Delta floods inland, creating a lush oasis in the desert."
    },
    {
        "id": 1539,
        "question": "Africa's Danakil Depression is notable for being:",
        "options": ["One of the hottest and lowest places on Earth", "Covered in dense forest", "A huge glacier"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Danakil Depression is one of the hottest and lowest places on Earth."
    },
    {
        "id": 1540,
        "question": "The Sahel is:",
        "options": ["A semi-arid transition zone south of the Sahara", "A rainforest", "A mountain range"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Sahel is a semi-arid transition zone south of the Sahara."
    },
    {
        "id": 1541,
        "question": "Africa's Congo Basin contributes approximately what fraction of the planet's tropical rainforest?",
        "options": ["Second largest in the world", "Largest in the world", "Smallest tropical rainforest"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo Basin is the world's second largest tropical rainforest."
    },
    {
        "id": 1542,
        "question": "Africa has how many major climatic zones?",
        "options": ["Five - desert, savannah, rainforest, Mediterranean, highland", "Two - desert and rainforest only", "Three - savannah, desert, tundra"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa has five major climatic zones."
    },
    {
        "id": 1543,
        "question": "The Sahara desert dust fertilizes which rainforest thousands of kilometers away?",
        "options": ["Amazon", "Congo", "Borneo"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Sahara dust fertilizes the Amazon rainforest."
    },
    {
        "id": 1544,
        "question": "Africa is the only continent with which combination of ecosystems on a single plate?",
        "options": ["Deserts, rainforests, savannahs, high mountains, lakes", "Only deserts", "Only savannahs and rivers"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Africa is the only continent with deserts, rainforests, savannahs, high mountains, and lakes on a single plate."
    },
    {
        "id": 1545,
        "question": "Which West African country is the largest gold producer in Africa?",
        "options": ["Ghana", "Nigeria", "Mali"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana is Africa's largest gold producer, fueling jewelry, electronics, and investment markets globally."
    },
    {
        "id": 1546,
        "question": "Which country is known for feldspar, essential in glass-making and porcelain?",
        "options": ["Nigeria", "Ghana", "Mali"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria is known for feldspar, used in glass and porcelain industries."
    },
    {
        "id": 1547,
        "question": "Which West African mineral is highly conductive and used in electrical wiring and is mined in Ghana and Ivory Coast?",
        "options": ["Copper", "Iron", "Bauxite"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Copper from Ghana and Ivory Coast is used in electrical wiring due to its high conductivity."
    },
    {
        "id": 1548,
        "question": "Which West African country produces nickel, used in stainless steel and rechargeable batteries?",
        "options": ["Nigeria", "Senegal", "Ghana"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria produces nickel, important for stainless steel and batteries."
    },
    {
        "id": 1549,
        "question": "Which West African country mines mica, used in electronics, paint, and insulation?",
        "options": ["Nigeria", "Mali", "Ivory Coast"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria mines mica, used in electronics and insulation."
    },
    {
        "id": 1550,
        "question": "Which mineral mined in Sierra Leone is used in tantalum capacitors for smartphones, computers, and cameras?",
        "options": ["Coltan", "Rutile", "Bauxite"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Coltan from Sierra Leone is used in tantalum capacitors for electronics."
    },
    {
        "id": 1551,
        "question": "Which West African mineral is used in fertilizer, water treatment, and flame retardants, and is mined in Mali and Senegal?",
        "options": ["Phosphate", "Gold", "Bauxite"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Phosphate from Mali and Senegal is used in fertilizer and water treatment."
    },
    {
        "id": 1552,
        "question": "Which West African country exports magnetite, used in steelmaking and heavy industry?",
        "options": ["Liberia", "Nigeria", "Ghana"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Liberia exports magnetite for steelmaking."
    },
    {
        "id": 1553,
        "question": "Which West African country produces tantalum and tin used in electronics and aerospace alloys?",
        "options": ["Nigeria", "Ghana", "Ivory Coast"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria produces tantalum and tin for electronics and aerospace."
    },
    {
        "id": 1554,
        "question": "Which mineral mined in Ghana is used in solar panels and high-tech ceramics?",
        "options": ["Rutile (Titanium dioxide)", "Gold", "Manganese"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Rutile from Ghana is used in solar panels and ceramics."
    },
    {
        "id": 1555,
        "question": "Which mineral mined in Nigeria is used in glass, paint, and rubber industries?",
        "options": ["Silica sand", "Gypsum", "Limestone"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Silica sand from Nigeria is used in glass, paint, and rubber."
    },
    {
        "id": 1556,
        "question": "Which West African country produces vermiculite, used in insulation, fireproofing, and horticulture?",
        "options": ["Ghana", "Nigeria", "Senegal"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ghana produces vermiculite for insulation and horticulture."
    },
    {
        "id": 1557,
        "question": "Which mineral mined in Sierra Leone is used to harden steel and produce special alloys?",
        "options": ["Bauxite", "Manganese", "Copper"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Manganese from Sierra Leone is used to harden steel."
    },
    {
        "id": 1558,
        "question": "Nigeria's bitumen deposits are used for:",
        "options": ["Road construction and waterproofing", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Bitumen in Nigeria is used for road construction and waterproofing."
    },
    {
        "id": 1559,
        "question": "Which West African country has significant barite reserves, used in drilling mud for oil exploration?",
        "options": ["Nigeria", "Ghana", "Mali"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria has significant barite reserves for oil drilling."
    },
    {
        "id": 1560,
        "question": "Which West African country produces graphite, used in batteries, lubricants, and pencils?",
        "options": ["Nigeria", "Ghana", "Senegal"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria produces graphite for batteries and lubricants."
    },
    {
        "id": 1561,
        "question": "Which West African mineral is essential for titanium production, used in aerospace, pigments, and high-strength alloys?",
        "options": ["Rutile", "Bauxite", "Phosphate"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Rutile is essential for titanium production in aerospace and pigments."
    },
    {
        "id": 1562,
        "question": "Which West African country has salt flats that provide sodium for chemical industries and food preservation?",
        "options": ["Senegal", "Ghana", "Mali"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Senegal's salt flats provide sodium for industry and food."
    },
    {
        "id": 1563,
        "question": "Which mineral mined in Ghana and Ivory Coast is used to produce alumina and then aluminum?",
        "options": ["Bauxite", "Manganese", "Gold"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Bauxite from Ghana and Ivory Coast is refined into alumina and aluminum."
    },
    {
        "id": 1564,
        "question": "Which West African mineral is used in abrasives, ceramics, and refractory bricks, found in Nigeria?",
        "options": ["Feldspar", "Phosphate", "Copper"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Feldspar from Nigeria is used in ceramics and abrasives."
    },
    {
        "id": 1565,
        "question": "Which West African country mines selenium, used in glass, electronics, and photocells?",
        "options": ["Nigeria", "Senegal", "Mali"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria mines selenium for glass and electronics."
    },
    {
        "id": 1566,
        "question": "Which mineral mined in Sierra Leone is used for high-temperature applications and aerospace coatings?",
        "options": ["Rutile (Titanium dioxide)", "Phosphate", "Copper"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Rutile from Sierra Leone is used in aerospace coatings."
    },
    {
        "id": 1567,
        "question": "Which West African mineral is critical for fertilizer, sugar refining, and water purification and mined in Mali?",
        "options": ["Phosphate", "Gypsum", "Limestone"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Phosphate from Mali is used in fertilizer and water purification."
    },
    {
        "id": 1568,
        "question": "Nigeria has reserves of lithium, which is critical for:",
        "options": ["Rechargeable batteries for electric vehicles and electronics", "Jewelry and ornaments", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lithium in Nigeria is critical for rechargeable batteries."
    },
    {
        "id": 1569,
        "question": "Tantalum (Coltan) from Nigeria and Sierra Leone is used in:",
        "options": ["Capacitors for smartphones, laptops, and high-frequency electronics", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tantalum from coltan is used in capacitors for electronics."
    },
    {
        "id": 1570,
        "question": "Which West African country is a significant vanadium producer, used to strengthen steel and in vanadium redox batteries?",
        "options": ["Nigeria", "Ghana", "Senegal"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria produces vanadium for steel and batteries."
    },
    {
        "id": 1571,
        "question": "Cobalt, mined in small quantities in Ghana, is used for:",
        "options": ["Lithium-ion batteries and jet turbine alloys", "Glass and ceramics", "Water purification"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Cobalt from Ghana is used in batteries and jet turbine alloys."
    },
    {
        "id": 1572,
        "question": "Which West African country has significant gallium reserves, a key element for LEDs, semiconductors, and solar panels?",
        "options": ["Nigeria", "Mali", "Senegal"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria has gallium reserves for LEDs and semiconductors."
    },
    {
        "id": 1573,
        "question": "Limestone and dolomite in Ghana and Nigeria are used for:",
        "options": ["Cement, steel flux, and chemical industry", "Jewelry", "Electronics"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Limestone and dolomite are used for cement and steel flux."
    },
    {
        "id": 1574,
        "question": "Barite, mined in Nigeria, is essential for:",
        "options": ["Drilling mud in oil and gas exploration", "Cosmetics", "Food coloring"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Barite from Nigeria is used in drilling mud for oil and gas."
    },
    {
        "id": 1575,
        "question": "Gypsum, mined in Burkina Faso and Nigeria, is used for:",
        "options": ["Plaster, cement, and fertilizers", "Glass", "Steel"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Gypsum is used for plaster, cement, and fertilizers."
    },
    {
        "id": 1576,
        "question": "Kaolin (china clay) from Nigeria is used in:",
        "options": ["Ceramics, paper coating, paint, and cosmetics", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kaolin from Nigeria is used in ceramics and paper coating."
    },
    {
        "id": 1577,
        "question": "Which West African mineral is used in fertilizers, animal feed, and water treatment?",
        "options": ["Phosphate", "Gold", "Silver"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Phosphate is used in fertilizers, animal feed, and water treatment."
    },
    {
        "id": 1578,
        "question": "Bitumen deposits in Nigeria are used for:",
        "options": ["Road construction and waterproofing", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Bitumen in Nigeria is used for road construction and waterproofing."
    },
    {
        "id": 1579,
        "question": "Coal mined in Nigeria is primarily used for:",
        "options": ["Power generation and steel production", "Electronics", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Coal from Nigeria is used for power generation and steel."
    },
    {
        "id": 1580,
        "question": "Which West African country has offshore oil reserves used for fuel, plastics, and chemicals?",
        "options": ["Nigeria", "Mali", "Burkina Faso"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria has offshore oil reserves for fuel and chemicals."
    },
    {
        "id": 1581,
        "question": "Nigeria's natural gas is used for:",
        "options": ["Electricity generation, fertilizer, and petrochemical production", "Jewelry", "Glass"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nigeria's natural gas is used for electricity and fertilizer."
    },
    {
        "id": 1582,
        "question": "Which mineral is extracted in Ghana for use in solar panels and pigments?",
        "options": ["Rutile (Titanium dioxide)", "Phosphate", "Copper"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Rutile from Ghana is used in solar panels and pigments."
    },
    {
        "id": 1583,
        "question": "Niobium, mined in Nigeria, is used in:",
        "options": ["Superalloys for jet engines and superconducting technologies", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Niobium from Nigeria is used in superalloys and superconductors."
    },
    {
        "id": 1584,
        "question": "Graphite from Nigeria is used in:",
        "options": ["Lithium-ion batteries, lubricants, and pencils", "Gold plating", "Ceramics"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Graphite from Nigeria is used in batteries and lubricants."
    },
    {
        "id": 1585,
        "question": "Feldspar, mined in Nigeria and Ghana, is essential for:",
        "options": ["Glassmaking, ceramics, and enamel", "Fertilizer", "Electronics"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Feldspar from Nigeria and Ghana is used in glass and ceramics."
    },
    {
        "id": 1586,
        "question": "Vermiculite, mined in Ghana, is used for:",
        "options": ["Insulation, fireproofing, and soil conditioning", "Jewelry", "Fuel"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Vermiculite from Ghana is used for insulation and soil."
    },
    {
        "id": 1587,
        "question": "Silica sand, mined across Nigeria and Ghana, is used for:",
        "options": ["Glass, foundry molds, and hydraulic fracturing", "Jewelry", "Batteries"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Silica sand is used for glass and foundry molds."
    },
    {
        "id": 1588,
        "question": "The Obuasi Gold Mine in Ghana is famous for:",
        "options": ["High-grade gold production for jewelry and electronics", "Coal production", "Phosphate mining"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Obuasi Gold Mine is known for high-grade gold."
    },
    {
        "id": 1589,
        "question": "The Segilola Gold Project in Nigeria focuses on:",
        "options": ["Modern gold extraction for global markets", "Copper smelting", "Iron ore"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Segilola Gold Project is Nigeria's modern gold mine."
    },
    {
        "id": 1590,
        "question": "The Bongouanou phosphate cluster in Ivory Coast is used for:",
        "options": ["Fertilizers to boost agriculture", "Ceramics", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Bongouanou phosphate is used for fertilizers."
    },
    {
        "id": 1591,
        "question": "Kraft bauxite in Guinea (though bordering West Africa) is used to:",
        "options": ["Produce alumina and then aluminum for airplanes and cans", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kraft bauxite is refined into alumina and aluminum."
    },
    {
        "id": 1592,
        "question": "Rutile mining in Ghana feeds into:",
        "options": ["Titanium dioxide for paints, aerospace alloys, and solar panels", "Jewelry", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Rutile from Ghana is used for titanium dioxide in paints and solar panels."
    },
    {
        "id": 1593,
        "question": "Gallium, found as a by-product of bauxite processing in Guinea and Ghana, is critical for:",
        "options": ["High-speed semiconductors and 5G technology", "Jewelry", "Cement production"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Gallium nitride (GaN) powers radar, satellites, and fast chargers."
    },
    {
        "id": 1594,
        "question": "Indium, sometimes recovered during zinc processing in West Africa, is essential for:",
        "options": ["Touchscreens and LCD displays", "Fertilizer", "Road construction"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Indium tin oxide (ITO) enables touchscreens and LCDs."
    },
    {
        "id": 1595,
        "question": "Niobium deposits in Nigeria are strategically important because they are used for:",
        "options": ["Superconducting magnets and jet engine alloys", "Cosmetics", "Paint"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Niobium strengthens steel for pipelines, rockets, and MRI machines."
    },
    {
        "id": 1596,
        "question": "The Katanga Supergroup in the DRC is important because it hosts:",
        "options": ["The majority of the world's economically viable cobalt reserves", "Only gold deposits", "Mostly coal"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Katanga Supergroup contains most of the world's viable cobalt reserves, making the DRC a strategic supplier."
    },
    {
        "id": 1597,
        "question": "Industrial diamonds from the DRC are especially strategic because they are used in:",
        "options": ["Precision drilling for oil, aerospace machining, and military equipment", "Jewelry markets only", "Road paving"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Industrial diamonds are used for precision drilling and machining in oil, aerospace, and military industries."
    },
    {
        "id": 1598,
        "question": "The Inga hydropower site on the Congo River has the theoretical capacity to:",
        "options": ["Power much of Sub-Saharan Africa", "Supply only one city", "Produce oil"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Inga hydropower site could power much of Sub-Saharan Africa if fully developed."
    },
    {
        "id": 1599,
        "question": "Cobalt refining is mostly done outside the DRC. Why is this significant?",
        "options": ["Raw materials are exported while value-added processing happens abroad", "Cobalt cannot be refined locally", "Cobalt cannot be transported"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Most cobalt is exported raw, with value-added processing done abroad, reducing local economic benefit."
    },
    {
        "id": 1600,
        "question": "Most Central African cobalt leaves through ports in:",
        "options": ["Southern Africa (via Zambia) or the Atlantic coast", "North Africa", "Europe directly"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Cobalt is transported through Southern Africa or the Atlantic coast, affecting leverage and logistics."
    },
    {
        "id": 1601,
        "question": "Copper-cobalt ores require smelting and chemical refining to become:",
        "options": ["Battery-grade materials", "Jewelry immediately", "Fuel"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Copper-cobalt ores must be refined to become battery-grade materials."
    },
    {
        "id": 1602,
        "question": "Rare earth elements found in parts of Burundi and eastern DRC are strategically important because they enable:",
        "options": ["Permanent magnets for EV motors and wind turbines", "Cement", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Rare earth elements are vital for permanent magnets in EVs and wind turbines."
    },
    {
        "id": 1603,
        "question": "Coltan ores in the Kivu region must be processed to extract:",
        "options": ["Tantalum pentoxide", "Crude oil", "Coal"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Coltan must be processed to extract tantalum pentoxide for electronics."
    },
    {
        "id": 1604,
        "question": "If Central Africa developed full local refining capacity, the biggest economic shift would be:",
        "options": ["Moving from raw exporter to industrial manufacturer", "Producing more jewelry", "Ending mining"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Local refining would shift Central Africa from raw exporter to industrial manufacturer."
    },
    {
        "id": 1605,
        "question": "The Congo Basin stores massive carbon in its peatlands. This matters because:",
        "options": ["It affects global climate stability", "It produces fuel directly", "It mines gold"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Congo Basin's peatlands are major carbon sinks, affecting global climate stability."
    },
    {
        "id": 1606,
        "question": "Oil from Angola is primarily offshore. Offshore oil is harder to control because it requires:",
        "options": ["Advanced drilling technology", "Hand tools", "No infrastructure"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Offshore oil requires advanced drilling technology and infrastructure."
    },
    {
        "id": 1607,
        "question": "Uranium from Shinkolobwe was historically significant because it powered:",
        "options": ["The first nuclear weapons program", "Coal plants", "Solar panels"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Uranium from Shinkolobwe powered the first nuclear weapons program."
    },
    {
        "id": 1608,
        "question": "Copper is called the 'metal of electrification' because:",
        "options": ["Electricity infrastructure depends heavily on it", "It fuels engines", "It makes fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Copper is essential for electricity infrastructure and grid expansion."
    },
    {
        "id": 1609,
        "question": "The true strategic power of Central Africa lies in:",
        "options": ["Controlling inputs to the global energy transition", "Tourism alone", "Agriculture only"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Central Africa controls key inputs for EVs, renewables, and electronics."
    },
    {
        "id": 1610,
        "question": "What is the indigenous Luo name for Nam Lolwe (Lake Victoria)?",
        "options": ["Ukerewe", "Nam Lolwe", "Nyanza"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Nam Lolwe is the indigenous Luo name for Lake Victoria."
    },
    {
        "id": 1611,
        "question": "Nam Lolwe (Lake Victoria) feeds which major river system?",
        "options": ["Congo River", "Niger River", "Nile River"],
        "answer_index": 2,
        "image_url": "",
        "explanation": "Lake Victoria feeds the Nile River system."
    },
    {
        "id": 1612,
        "question": "Which East African country is a continental leader in geothermal energy production?",
        "options": ["Kenya", "Somalia", "Rwanda"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kenya is a continental leader in geothermal energy production."
    },
    {
        "id": 1613,
        "question": "The East African Rift is splitting the continent into which two tectonic plates?",
        "options": ["African & Eurasian Plates", "Nubian & Somali Plates", "Arabian & Pacific Plates"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The East African Rift is splitting Africa into the Nubian and Somali Plates."
    },
    {
        "id": 1614,
        "question": "Which country hosts the Grand Ethiopian Renaissance Dam?",
        "options": ["Sudan", "Ethiopia", "Uganda"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Ethiopia hosts the Grand Ethiopian Renaissance Dam."
    },
    {
        "id": 1615,
        "question": "The Danakil Depression in Ethiopia contains vast deposits of:",
        "options": ["Potash", "Uranium", "Bauxite"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Danakil Depression contains vast deposits of potash."
    },
    {
        "id": 1616,
        "question": "Which gemstone found near Mount Kilimanjaro exists only in Tanzania?",
        "options": ["Sapphire", "Tanzanite", "Emerald"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Tanzanite is found only near Mount Kilimanjaro in Tanzania."
    },
    {
        "id": 1617,
        "question": "Which East African country has major offshore natural gas reserves in the Indian Ocean?",
        "options": ["Mozambique", "Eritrea", "Djibouti"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Mozambique has major offshore natural gas reserves in the Indian Ocean."
    },
    {
        "id": 1618,
        "question": "The Albertine Graben oil fields are mainly located in:",
        "options": ["Kenya", "Uganda", "Ethiopia"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Albertine Graben oil fields are mainly in Uganda."
    },
    {
        "id": 1619,
        "question": "Which country sits at the Bab el-Mandeb strait, controlling access to the Red Sea?",
        "options": ["Djibouti", "Tanzania", "Rwanda"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Djibouti controls access to the Red Sea at the Bab el-Mandeb strait."
    },
    {
        "id": 1620,
        "question": "Lake Natron in Tanzania is rich in:",
        "options": ["Lithium", "Soda ash", "Copper"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Lake Natron in Tanzania is rich in soda ash."
    },
    {
        "id": 1621,
        "question": "Which East African country is considered the birthplace of Arabica coffee?",
        "options": ["Ethiopia", "Kenya", "Burundi"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ethiopia is considered the birthplace of Arabica coffee."
    },
    {
        "id": 1622,
        "question": "The Afar Depression is one of the lowest places on Earth. It is mainly in:",
        "options": ["South Sudan", "Ethiopia", "Somalia"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The Afar Depression is mainly in Ethiopia."
    },
    {
        "id": 1623,
        "question": "Nam Lolwe (Lake Victoria) is the largest tropical lake in the world by:",
        "options": ["Depth", "Surface area", "Volume"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Lake Victoria is the largest tropical lake by surface area."
    },
    {
        "id": 1624,
        "question": "Which East African country has significant nickel deposits used in EV batteries?",
        "options": ["Burundi", "Rwanda", "Somalia"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Burundi has significant nickel deposits used in EV batteries."
    },
    {
        "id": 1625,
        "question": "If the East African Rift continues widening for millions of years, it will likely form a:",
        "options": ["Mountain chain", "New ocean basin", "Desert plateau"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "The East African Rift will likely form a new ocean basin if it continues widening."
    },
    {
        "id": 1626,
        "question": "The Mwanza region is a major gold-producing area in:",
        "options": ["Tanzania", "Uganda", "Kenya"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Mwanza region in Tanzania is a major gold-producing area."
    },
    {
        "id": 1627,
        "question": "South Sudan's economy heavily depends on:",
        "options": ["Coffee", "Oil", "Diamonds"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "South Sudan's economy heavily depends on oil."
    },
    {
        "id": 1628,
        "question": "The East African Crude Oil Pipeline (EACOP) connects Uganda to the coast of:",
        "options": ["Kenya", "Somalia", "Tanzania"],
        "answer_index": 2,
        "image_url": "",
        "explanation": "EACOP connects Uganda to the coast of Tanzania."
    },
    {
        "id": 1629,
        "question": "Which country is one of the world's leading exporters of high-quality black tea?",
        "options": ["Kenya", "Eritrea", "Djibouti"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kenya is a leading exporter of high-quality black tea."
    },
    {
        "id": 1630,
        "question": "Rare earth elements are increasingly explored in Tanzania and Burundi because they are vital for:",
        "options": ["Plastic production", "Renewable energy technology", "Cement making"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Rare earth elements in Tanzania and Burundi are vital for renewable energy technology."
    },
    {
        "id": 1631,
        "question": "Which East African country has one of Africa's longest coastlines along the Indian Ocean?",
        "options": ["Uganda", "Tanzania", "Rwanda"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "Tanzania has one of Africa's longest coastlines along the Indian Ocean."
    },
    {
        "id": 1632,
        "question": "Nam Lolwe (Lake Victoria) supports one of the world's largest:",
        "options": ["Inland fisheries", "Coral reef systems", "Salt basins"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lake Victoria supports one of the world's largest inland fisheries."
    },
    {
        "id": 1633,
        "question": "Which country's highland rivers give it enormous hydroelectric potential?",
        "options": ["Ethiopia", "Somalia", "Burundi"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ethiopia's highland rivers give it enormous hydroelectric potential."
    },
    {
        "id": 1634,
        "question": "The fertile volcanic soils of East Africa are primarily formed by:",
        "options": ["Coral erosion", "Rift Valley volcanism", "River flooding alone"],
        "answer_index": 1,
        "image_url": "",
        "explanation": "East Africa's fertile soils are formed by Rift Valley volcanism."
    },
    {
        "id": 1635,
        "question": "Steel strengthening and energy storage batteries in South Africa rely on:",
        "options": ["Vanadium", "Cement", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Vanadium is used for steel strengthening and energy storage batteries, including vanadium redox batteries."
    },
    {
        "id": 1636,
        "question": "Manganese in South Africa is used for:",
        "options": ["Steel production and battery technology", "Fertilizer", "Glass production"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Manganese strengthens steel and is emerging in EV battery cathodes."
    },
    {
        "id": 1637,
        "question": "Titanium in South Africa is used for:",
        "options": ["Aerospace components, pigments, and implants", "Jewelry only", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Titanium is lightweight, strong, and corrosion-resistant, used in aerospace and medical implants."
    },
    {
        "id": 1638,
        "question": "Cobalt in the Copperbelt (Zambia/Zimbabwe border) is used for:",
        "options": ["EV batteries and high-tech alloys", "Fertilizer", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Cobalt stabilizes lithium-ion battery performance and is used in high-tech alloys."
    },
    {
        "id": 1639,
        "question": "Iron ore in South Africa is used for:",
        "options": ["Steel production and industrial machinery", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Iron ore is a raw material for infrastructure and machinery."
    },
    {
        "id": 1640,
        "question": "Phosphate in Namibia is used for:",
        "options": ["Fertilizer production", "Electronics", "Road paving"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Phosphate supports agriculture and food production."
    },
    {
        "id": 1641,
        "question": "Copper in Zambia and Botswana is primarily used for:",
        "options": ["Electrical wiring, motors, and renewable energy", "Fuel", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Copper is essential for electrification and industrial machinery."
    },
    {
        "id": 1642,
        "question": "Lithium in Zimbabwe is used for:",
        "options": ["Batteries for EVs and grid storage", "Fertilizer", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lithium supports the energy transition, powering EVs and grid storage."
    },
    {
        "id": 1643,
        "question": "Vanadium-titanium magnetite in South Africa is used for:",
        "options": ["Steel alloys and energy storage", "Cement", "Road construction"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Vanadium-titanium magnetite is used for high-strength steel and advanced battery technology."
    },
    {
        "id": 1644,
        "question": "Tantalum mined in Rwanda/Zimbabwe is used for:",
        "options": ["Capacitors in electronics", "Cement", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tantalum is critical for smartphones, computers, and aerospace capacitors."
    },
    {
        "id": 1645,
        "question": "Industrial diamonds from Kimberley (South Africa) are used for:",
        "options": ["Cutting, drilling, and precision machining", "Jewelry only", "Road paving"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Industrial diamonds are core for mining, oil, and manufacturing."
    },
    {
        "id": 1646,
        "question": "Gold tailings in South Africa are now being processed to recover:",
        "options": ["Uranium and residual gold", "Fertilizer", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Gold tailings are processed to recover uranium and residual gold, adding economic value."
    },
    {
        "id": 1647,
        "question": "Platinum group metals in South Africa are vital for:",
        "options": ["Catalysts, fuel cells, and green hydrogen production", "Road paving", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Platinum group metals are key for emissions reduction and renewable energy tech."
    },
    {
        "id": 1648,
        "question": "Coal-to-liquid projects in South Africa convert coal into:",
        "options": ["Synthetic fuels for transport", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Coal-to-liquid projects provide liquid fuel where crude oil is imported."
    },
    {
        "id": 1649,
        "question": "Uranium-rich ores in South Africa can be used for:",
        "options": ["Nuclear energy and medical isotopes", "Fertilizer", "Road paving"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Uranium-rich ores are used for electricity and cancer treatment."
    },
    {
        "id": 1650,
        "question": "Titanium slag from mining is used for:",
        "options": ["Paint pigments and aerospace alloys", "Jewelry", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Titanium slag is used for durable coatings and structural components."
    },
    {
        "id": 1651,
        "question": "Cobalt from DRC-Zambia border is critical for:",
        "options": ["High-performance batteries", "Road construction", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Cobalt is critical for EVs and energy storage systems."
    },
    {
        "id": 1652,
        "question": "Diamond-rich kimberlite pipes in Botswana and South Africa are used for:",
        "options": ["Cutting tools and jewelry", "Fertilizer", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kimberlite pipes are used for industrial and luxury applications."
    },
    {
        "id": 1653,
        "question": "Gold reefs in Zimbabwe are processed into:",
        "options": ["Electronics, coins, and jewelry", "Fertilizer", "Steel"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Gold reefs in Zimbabwe are processed for electronics, coins, and jewelry."
    },
    {
        "id": 1654,
        "question": "Magnetite in South Africa is used for:",
        "options": ["Steel alloys and vanadium extraction", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Magnetite is critical for construction and energy storage."
    },
    {
        "id": 1655,
        "question": "Chromium ore in South Africa is used for:",
        "options": ["Stainless steel production and aerospace alloys", "Road paving", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Chromium ore provides corrosion resistance and strength."
    },
    {
        "id": 1656,
        "question": "Coal exported from South Africa is primarily used in:",
        "options": ["Power plants and metallurgical industries", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Coal is the energy backbone and used in steel production."
    },
    {
        "id": 1657,
        "question": "Lithium in Zimbabwe is increasingly mined for:",
        "options": ["EV batteries and energy storage", "Road paving", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lithium is mined for batteries and energy storage."
    },
    {
        "id": 1658,
        "question": "The Bushveld Igneous Complex in South Africa is unique because it contains:",
        "options": ["The largest concentration of platinum group metals (PGMs) on Earth", "Only iron deposits", "Mostly sand"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Bushveld Complex contains the largest concentration of PGMs, essential for catalytic converters and fuel cells."
    },
    {
        "id": 1659,
        "question": "Chromium mined in the Bushveld Complex is used in:",
        "options": ["Stainless steel, aerospace alloys, and hard coatings", "Jewelry", "Road surfacing"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Chromium from the Bushveld Complex enables corrosion-resistant steel."
    },
    {
        "id": 1660,
        "question": "Vanadium from South Africa is increasingly used in:",
        "options": ["Grid-scale redox flow batteries", "Fertilizers", "Glass production"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Vanadium is used for grid-scale redox flow batteries, storing renewable energy."
    },
    {
        "id": 1661,
        "question": "The Vredefort Dome is the world's largest confirmed impact crater and is geologically important because:",
        "options": ["It exposed deep mineral-rich rocks, including gold and platinum", "It contains fossil fuels only", "It has no economic minerals"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "The Vredefort Dome exposed mineral-rich rocks, providing high-grade PGM and gold deposits."
    },
    {
        "id": 1662,
        "question": "Titanium-bearing ilmenite sands along the KwaZulu-Natal coast are used for:",
        "options": ["Paint pigments, aerospace alloys, and titanium metal", "Jewelry only", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Ilmenite sands are used for paint pigments, aerospace alloys, and titanium metal."
    },
    {
        "id": 1663,
        "question": "Coal seams in Mpumalanga are high-grade bituminous, used for:",
        "options": ["Electricity generation, steel, and synthetic fuels", "Jewelry", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Mpumalanga coal seams are used for electricity, steel, and synthetic fuels."
    },
    {
        "id": 1664,
        "question": "Uranium in the Witwatersrand Basin historically powered:",
        "options": ["Early nuclear programs and medical isotopes", "Fertilizer", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Uranium from Witwatersrand powered early nuclear programs and medical isotopes."
    },
    {
        "id": 1665,
        "question": "Cobalt in the Zambian Copperbelt is critical for:",
        "options": ["Lithium-ion battery cathodes", "Steel production only", "Glass"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Cobalt from the Copperbelt enables EV and grid storage technologies."
    },
    {
        "id": 1666,
        "question": "Platinum from South Africa's Eastern Limb is used in:",
        "options": ["Fuel cells, catalytic converters, and electronics", "Cement", "Jewelry only"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Platinum from the Eastern Limb is used in fuel cells, catalytic converters, and electronics."
    },
    {
        "id": 1667,
        "question": "Manganese from the Kalahari Basin is used in:",
        "options": ["Steel alloys and lithium-ion battery cathodes", "Jewelry", "Plastics only"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Manganese from the Kalahari Basin strengthens steel and is critical in EV battery tech."
    },
    {
        "id": 1668,
        "question": "Gold tailings in Johannesburg are now reprocessed to recover:",
        "options": ["Uranium and residual PGMs", "Diamonds", "Phosphate"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Gold tailings in Johannesburg are reprocessed to extract uranium and residual PGMs."
    },
    {
        "id": 1669,
        "question": "Kimberlite pipes in Botswana are primarily exploited for:",
        "options": ["Gem-quality and industrial diamonds", "Gold only", "Coal"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Kimberlite pipes in Botswana are exploited for gem-quality and industrial diamonds."
    },
    {
        "id": 1670,
        "question": "Lithium pegmatites in Zimbabwe are critical because they:",
        "options": ["Feed the EV battery industry globally", "Are used for road surfacing", "Produce fertilizers"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lithium pegmatites in Zimbabwe feed the global EV battery industry."
    },
    {
        "id": 1671,
        "question": "Vanadium-titanium magnetite is used in:",
        "options": ["High-strength steel and grid batteries", "Glass", "Road surfacing"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Vanadium-titanium magnetite is used for high-strength steel and grid batteries."
    },
    {
        "id": 1672,
        "question": "Rare earth oxides in Southern Africa are used for:",
        "options": ["Magnets, EV motors, and aerospace electronics", "Cement", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Rare earth oxides are used for magnets, EV motors, and aerospace electronics."
    },
    {
        "id": 1673,
        "question": "Coal-to-liquid facilities in South Africa convert coal into:",
        "options": ["Synthetic diesel and jet fuel", "Electricity only", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Coal-to-liquid facilities produce synthetic diesel and jet fuel."
    },
    {
        "id": 1674,
        "question": "PGMs in Rustenburg are essential for:",
        "options": ["Green hydrogen production and emission reduction catalysts", "Jewelry only", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "PGMs in Rustenburg are key for clean-tech and industrial catalysts."
    },
    {
        "id": 1675,
        "question": "Tantalum from Zimbabwe is critical in:",
        "options": ["Smartphone capacitors and aerospace electronics", "Steel production", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tantalum from Zimbabwe is used in miniaturized, heat-resistant electronics."
    },
    {
        "id": 1676,
        "question": "Copper-nickel alloys from Southern Africa are used in:",
        "options": ["Marine engineering and aerospace components", "Cement", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Copper-nickel alloys are used for corrosion-resistant infrastructure and high-tech applications."
    },
    {
        "id": 1677,
        "question": "Magnetite ore from South Africa is processed into:",
        "options": ["High-grade iron and vanadium alloys", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Magnetite ore is processed into high-grade iron and vanadium alloys."
    },
    {
        "id": 1678,
        "question": "Cobalt by-products from the Copperbelt are increasingly used in:",
        "options": ["EV batteries and aerospace alloys", "Jewelry", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Cobalt by-products are used in EV batteries and aerospace alloys."
    },
    {
        "id": 1679,
        "question": "Industrial diamond dust from Kimberley is used for:",
        "options": ["Precision machining and oil rig drilling", "Jewelry only", "Steel"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Industrial diamond dust is used for precision machining and oil rig drilling."
    },
    {
        "id": 1680,
        "question": "Titanium dioxide pigment from South Africa is used in:",
        "options": ["Paint, sunscreen, and aerospace coatings", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Titanium dioxide pigment is used in paint, sunscreen, and aerospace coatings."
    },
    {
        "id": 1681,
        "question": "Coal ash residues are now reprocessed to extract:",
        "options": ["Rare earth elements", "Diamonds", "Iron"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Coal ash residues are reprocessed to extract rare earth elements."
    },
    {
        "id": 1682,
        "question": "Gold mined in South Africa is processed for:",
        "options": ["Electronics, medical devices, and high-value reserves", "Road surfacing", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Gold mined in South Africa is processed for electronics, medical devices, and reserves."
    },
    {
        "id": 1683,
        "question": "Chromite from the Bushveld Complex is used to produce:",
        "options": ["Stainless steel and aerospace alloys", "Glass", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Chromite from the Bushveld Complex is used for stainless steel and aerospace alloys."
    },
    {
        "id": 1684,
        "question": "Coalbed methane from Mpumalanga is used for:",
        "options": ["Electricity generation and synthetic gas", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Coalbed methane from Mpumalanga is used for electricity generation and synthetic gas."
    },
    {
        "id": 1685,
        "question": "Nickel-cobalt laterite ores in Zimbabwe are primarily processed into:",
        "options": ["Battery-grade cathodes for EVs", "Jewelry", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Nickel-cobalt laterite ores in Zimbabwe are processed into battery-grade cathodes for EVs."
    },
    {
        "id": 1686,
        "question": "Platinum group metals mined in South Africa support:",
        "options": ["Industrial catalysts, hydrogen production, and emission control", "Jewelry only", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Platinum group metals mined in South Africa are core to green tech and automotive emissions reduction."
    },
    {
        "id": 1687,
        "question": "Southern Africa's minerals are critical globally because they supply:",
        "options": ["EVs, renewable energy, aerospace, industrial steel, and electronics", "Only jewelry", "Fertilizer exclusively"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Southern Africa powers the global industrial and green transition with its minerals."
    },
    {
        "id": 1688,
        "question": "Phosphate in Morocco (Western Sahara region) is primarily used for:",
        "options": ["Fertilizer production and food security", "Jewelry", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Morocco holds ~70% of the world's phosphate reserves, critical for global agriculture."
    },
    {
        "id": 1689,
        "question": "Oil in Algeria is mainly used for:",
        "options": ["Transport fuels, petrochemicals, and industrial feedstock", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Oil in Algeria powers the national economy and is exported to Europe and beyond."
    },
    {
        "id": 1690,
        "question": "Natural gas from Egypt's Nile Delta and offshore Mediterranean is used for:",
        "options": ["Electricity generation, fertilizer, and LNG exports", "Jewelry", "Steel production"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Natural gas from Egypt is key for energy and industrial development."
    },
    {
        "id": 1691,
        "question": "Iron ore in Morocco's Bou Craa region is used for:",
        "options": ["Steel production and construction", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Iron ore in Bou Craa supplies local and regional steel industry."
    },
    {
        "id": 1692,
        "question": "Gold in Egypt's Eastern Desert is used for:",
        "options": ["Electronics, jewelry, and investment reserves", "Fertilizer", "Road paving"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Gold in Egypt is a strategic metal for wealth storage and industry."
    },
    {
        "id": 1693,
        "question": "Copper in the Central Sahara region is used for:",
        "options": ["Electrical wiring, electronics, and renewable energy", "Cement", "Jewelry"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Copper in the Central Sahara is used for electrification and industrial machinery."
    },
    {
        "id": 1694,
        "question": "Silver in Morocco and Egypt is used for:",
        "options": ["Electronics, jewelry, and solar panels", "Fertilizer", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Silver in Morocco and Egypt is used for electronics, jewelry, and solar panels."
    },
    {
        "id": 1695,
        "question": "Zinc mined in Morocco is used for:",
        "options": ["Galvanized steel and batteries", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Zinc in Morocco is used for corrosion resistance and energy storage."
    },
    {
        "id": 1696,
        "question": "Lead in Morocco and Tunisia is primarily used for:",
        "options": ["Batteries and radiation shielding", "Jewelry", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Lead in Morocco and Tunisia is used for automotive batteries and industrial safety."
    },
    {
        "id": 1697,
        "question": "Uranium in Niger is used for:",
        "options": ["Nuclear energy and medical isotopes", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Uranium in Niger is used for electricity and cancer treatment."
    },
    {
        "id": 1698,
        "question": "Oil shale deposits in Morocco are used for:",
        "options": ["Synthetic fuels and energy", "Jewelry", "Road construction"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Oil shale in Morocco is an alternative hydrocarbon source."
    },
    {
        "id": 1699,
        "question": "Salt flats (Sebkhas) in Algeria and Tunisia are used for:",
        "options": ["Chemical industry and chlorine production", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Salt flats in Algeria and Tunisia are used for chlorine and industrial chemicals."
    },
    {
        "id": 1700,
        "question": "Gypsum from Egypt is used for:",
        "options": ["Cement, plaster, and construction materials", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Gypsum from Egypt is used for construction and infrastructure."
    },
    {
        "id": 1701,
        "question": "Petroleum gas liquids (LPG, condensate) from Libya are used for:",
        "options": ["Cooking fuel, petrochemicals, and energy", "Jewelry", "Cement"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Petroleum gas liquids from Libya are used for domestic energy and industrial feedstock."
    },
    {
        "id": 1702,
        "question": "Tantalum and niobium in Algeria and Egypt are used for:",
        "options": ["Electronics, capacitors, and aerospace alloys", "Jewelry", "Fertilizer"],
        "answer_index": 0,
        "image_url": "",
        "explanation": "Tantalum and niobium in Algeria and Egypt are used for high-performance electronics and aerospace."
    }
]

